/* assets/configurator-house-lib.js — MASTER HOUSE configurator.
   Cloned from the shelters engine; timber posts/ring-beam replaced by
   closed perimeter walls (default). Single storey for now; floors,
   floorplans and openings build on top of this. */
(function (global) {
  'use strict';

  try {
    var _LOG0 = (global.Configurator && global.Configurator.log) ? global.Configurator.log : global.console;
    if (_LOG0 && _LOG0.log) _LOG0.log('[shelter-lib] eval START v=shelter-v1');
    global.__SHELTER_LIB_EVAL_START = true;
  } catch (e) {}

  var VERSION = 'house-v207-map-ui';

  var FT = 0.3048;
  function _defaultPoolPolygon() {
    var LONG = 20 * FT, SHORT = 12 * FT;

    var isDesktop = (typeof window !== 'undefined' && window.matchMedia &&
                     window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches);
    var halfX, halfZ;
    if (isDesktop) { halfX = LONG / 2; halfZ = SHORT / 2; }
    else           { halfX = SHORT / 2; halfZ = LONG / 2; }
    return [
      [-halfX, -halfZ],
      [ halfX, -halfZ],
      [ halfX,  halfZ],
      [-halfX,  halfZ]
    ];
  }
  var DEFAULT_POLYGON = _defaultPoolPolygon();

  var STATE = {
    variant: 1,
    lvl: 1,
    isMetric: false,
    view: '2d',
    opacity2D: 0.15,
    vizStage: 0,
    slopeDeg: 0,
    slopeActive: false,
    mapLocked: false,
    shelterShape: 'I',
    shelterRoofType: 'sedlo',
    shelterFoundation: 'slab',
    structureVariant: 'masonry',
    floors: 1,
    openings: [],
    polygon: JSON.parse(JSON.stringify(DEFAULT_POLYGON)),

    depth: null,

    edgeType: 'skimmer',

    infiniteEdges: [],

    wallMaterial: 'concrete',

    surface: 'liner',

    shaft: null,

    tank: null,

    skimmers: null,
    jets: null,

    lightStage: 0,
    lightPos: 'A',
    lights: null,

    panel: null,

    stairsMode: 'none',
    stairsSlot: 0
  };
  var DEFAULTS = JSON.parse(JSON.stringify(STATE));

  var MIN_DIM = 1.0;
  var MAX_COORD = 30.0;
  var SNAP_M = 0.050;
  var _gridUnitM = -1;   /* masonry block module as footprint snap step (m); -1 = unloaded, 0 = none */

  var VARIANT_DEFAULTS = {};

  var VARIANT_LVL_OVERRIDES = {};

  var IN = 0.0254;

  var STAIRS_CYCLE = ['none', 'ladder', 'corner1', 'corner2', 'full'];



  function _dbg(msg) {
    if (global.Configurator && global.Configurator.log && global.Configurator.log.log) {
      global.Configurator.log.log('[base-lib] ' + msg);
    }
  }

  var SNAP_IMP = 2 * IN;
  function _activeSnapStep() {
    if (_gridUnitM === -1) {
      _gridUnitM = 0;
      try { var g = JSON.parse(localStorage.getItem('mc:grid') || 'null'); if (g && g.unit > 0) _gridUnitM = g.unit / 1000; } catch (e) {}
    }
    /* whole-block stepping only for masonry (the block grid is masonry's) */
    if (_gridUnitM > 0 && (STATE.structureVariant || 'masonry') === 'masonry') return _gridUnitM;
    return STATE.isMetric ? SNAP_M : SNAP_IMP;
  }
  function snap(v) {
    var s = _activeSnapStep();
    return Math.round(v / s) * s;
  }

  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }

  function fmtLen(meters, opts) {
    opts = opts || {};
    var precision = (opts.precision == null) ? 2 : opts.precision;
    if (STATE.isMetric) {
      return meters.toFixed(precision);
    }

    var factor = opts.area ? 10.7639 : 3.28084;
    return (meters * factor).toFixed(precision);
  }

  function fmtDim(meters) {
    if (STATE.isMetric) {
      var mm = Math.round(meters * 1000);
      return mm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' mm';
    }
    var tot = Math.round(meters / IN), ft = Math.floor(tot / 12), inch = tot - ft * 12;
    return ft + "'-" + inch + '"';
  }

  function resnapModelToGrid() {
    if (Array.isArray(STATE.polygon)) {
      STATE.polygon = STATE.polygon.map(function (p) { return [snap(p[0]), snap(p[1])]; });
    }
  }

  function areaUnitLabel() { return STATE.isMetric ? 'm²' : 'ft²'; }

  function volUnitLabel() { return STATE.isMetric ? 'm³' : 'ft³'; }

  function unitLabel() {
    return STATE.isMetric ? 'm' : 'ft';
  }

  /* Broadcast the master-house footprint + placement to a single shared key
     so any LOCKED sub-config (different projectId) can follow it live. */
  function _broadcastHouse() {
    try {
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) return;
      var mapData = null;
      if (_MapManager && _MapManager.center) {
        mapData = {
          center:  _MapManager.center.slice(),
          bearing: _MapManager.bearing || 0,
          address: _MapManager.address || null
        };
      }
      var _fl = Math.max(1, (STATE.floors | 0) || 1);
      localStorage.setItem('mc:house:footprint', JSON.stringify({
        polygon: poly, map: mapData,
        roofType: (STATE.shelterRoofType || 'sedlo'),
        structureVariant: (STATE.structureVariant || 'masonry'),
        floors: _fl,
        wallHeight: _wallHeightM(),
        storeyH: _storeyHM(),
        baseClear: _baseClearM(),
        floorClear: (STATE.floorClear || []).slice(0, _fl),
        balconies: (function () {
          var out = [], bf, cs, j, br;
          try {
            for (bf = 0; bf < _fl; bf++) {
              cs = (typeof _Balcony !== 'undefined' && _Balcony && _Balcony._activeCuts) ? _Balcony._activeCuts(bf) : [];
              var arr = [];
              for (j = 0; j < cs.length; j++) { br = cs[j]; arr.push({ cx: br.cx, cz: br.cz, w: br.w, d: br.d, mode: br.mode || 'floor' }); }   /* each cut carries its own scope: 'floor' | 'all1' | 'all2' (all2 also cuts the slab) */
              out.push(arr.length ? arr : null);
            }
          } catch (eB) {}
          return out;
        })(),
        updatedAt: new Date().toISOString()
      }));
    } catch (e) {}
  }

  function getFootprintPolygon() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return [];
    var out = new Array(poly.length);
    for (var i = 0; i < poly.length; i++) {
      out[i] = [poly[i][0], poly[i][1]];
    }
    return out;
  }

  function getBBox() {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return { L: 0, W: 0 };
    var xMin =  Infinity, xMax = -Infinity;
    var zMin =  Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var x = poly[i][0], z = poly[i][1];
      if (x < xMin) xMin = x;
      if (x > xMax) xMax = x;
      if (z < zMin) zMin = z;
      if (z > zMax) zMax = z;
    }
    return { L: xMax - xMin, W: zMax - zMin };
  }

  function computeArea() {
    var poly = getFootprintPolygon();
    var a = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      a += poly[i][0] * poly[j][1];
      a -= poly[j][0] * poly[i][1];
    }
    return Math.abs(a) / 2;
  }

  function computePerimeter() {
    var poly = getFootprintPolygon();
    var p = 0;
    for (var i = 0; i < poly.length; i++) {
      var j = (i + 1) % poly.length;
      var dx = poly[j][0] - poly[i][0];
      var dy = poly[j][1] - poly[i][1];
      p += Math.sqrt(dx*dx + dy*dy);
    }
    return p;
  }

  function _pointInPolygonOrBoundary(x, z, poly) {
    var n = poly.length;
    var EPS = 0.001;
    for (var i = 0; i < n; i++) {
      var a = poly[i], b = poly[(i + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      var lenSq = dx * dx + dz * dz;
      if (lenSq < 1e-9) continue;
      var t = ((x - a[0]) * dx + (z - a[1]) * dz) / lenSq;
      var tc = t < 0 ? 0 : (t > 1 ? 1 : t);
      var px = a[0] + tc * dx;
      var pz = a[1] + tc * dz;
      if (Math.hypot(x - px, z - pz) < EPS) return true;
    }
    var inside = false;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = poly[i][0], zi = poly[i][1];
      var xj = poly[j][0], zj = poly[j][1];
      if ((zi > z) !== (zj > z) &&
          x < (xj - xi) * (z - zi) / (zj - zi) + xi) {
        inside = !inside;
      }
    }
    return inside;
  }


  var POOL_VARIANT_KEYS = ['concrete_block', 'gunite'];
  function variantKey() {
    var base = POOL_VARIANT_KEYS[STATE.variant - 1] || 'concrete_block';

    if (base === 'concrete_block' && STATE.wallMaterial === 'eps') return 'eps_block';
    return base;
  }

  var EDGE_TYPES = ['skimmer', 'overflow', 'infinite'];

  var SURFACES = ['liner', 'plaster', 'tiles', 'pebble', 'inox'];

  var _DIA_OD = { d15: 0.048, d20: 0.060, d25: 0.073, d40: 0.110 };

  var PIPE_CODES = {
    d15: { pipe: 'PPP00501', elbow90: 'PPE00502', elbow30: 'PPE00501', tee: 'PPT00501', valve: 'PPP00502', reducerTo15: null,        reducer2015: null },
    d20: { pipe: 'PPE00634', elbow90: 'PPE00632', elbow30: 'PPE00631', tee: 'PPE00633', valve: 'PPP00632', reducerTo15: 'PPE06350', reducer2015: 'PPE06350' },
    d25: { pipe: 'PPE00754', elbow90: 'PPE00752', elbow30: 'PPE00751', tee: 'PPE00753', valve: 'PPP00752', reducerTo15: 'PPE07550', reducer2015: 'PPE07563' },
    d40: { pipe: 'PPE01004', elbow90: 'PPE01002', elbow30: 'PPE01001', tee: 'PPE01003', valve: null,        reducerTo15: 'PPE10075', reducer2015: 'PPE10075' }
  };




  var BLOCK_FILL_FRAC = 0.65;

  var MESH_SHEET_L = 3.0, MESH_SHEET_W = 2.0, MESH_SHEET_A = 6.0;
  var MESH_LAP = 0.25;
  var MESH_CODES = { g6: 'FFR30002', g8: 'FFR30001', g10: 'FFR30003' };

  var _FT  = 3.28084, _FT3 = 35.3147;
  function _rowM (code, q) { return [code, q, q * _FT];  }
  function _rowM3(code, q) { return [code, q, q * _FT3]; }

  var SHELTER_FALLBACK_NAMES = ['Shelter'];

  var SHELTER_SPECS = {
    carport: {
      clearHeight: 2.40,
      pitchDeg:    22, pultPitchDeg: 10,
      overhangM:   0.35,
      post:    { w: 0.16, h: 0.16, code: 'KVH16160' },
      beam:    { w: 0.16, h: 0.24, code: 'KVH16240' },
      ridge:   { w: 0.16, h: 0.24, code: 'KVH16240' },
      rafter:  { w: 0.06, h: 0.16, code: 'KVH60160', spacing: 0.90 },
      batten:  { w: 0.05, h: 0.03, code: 'KVR50031', spacing: 0.35 },
      footing: { dia: 0.40, depth: 0.80, code: 'PBW00001' }
    }
  };

  function _isCarport() { return true; }

  function _carportBBox(poly) {
    var xMin = Infinity, xMax = -Infinity, zMin = Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      var x = poly[i][0], z = poly[i][1];
      if (x < xMin) xMin = x; if (x > xMax) xMax = x;
      if (z < zMin) zMin = z; if (z > zMax) zMax = z;
    }
    return { xMin: xMin, xMax: xMax, zMin: zMin, zMax: zMax,
             cx: (xMin + xMax) / 2, cz: (zMin + zMax) / 2,
             L: xMax - xMin, W: zMax - zMin };
  }


  var _shapeOrder = ['I', 'L', 'U', 'T', 'H'];
  var _shapeBtnOrigHTML = null;
  function _isGableShelter() { return (STATE.variant | 0) === 1; }
  function _shelterShapePoly(shape, x0, x1, z0, z1) {
    var W = x1 - x0, D = z1 - z0;
    if (W <= 0 || D <= 0 || shape === 'I') return [[x0, z0], [x1, z0], [x1, z1], [x0, z1]];
    var t = Math.min(W, D) * 0.45; t = Math.max(1.2, Math.min(t, Math.min(W, D) - 0.4));
    var xc = (x0 + x1) / 2;
    if (shape === 'L') return [[x0, z0], [x1, z0], [x1, z0 + t], [x0 + t, z0 + t], [x0 + t, z1], [x0, z1]];
    if (shape === 'U') return [[x0, z0], [x1, z0], [x1, z1], [x1 - t, z1], [x1 - t, z0 + t], [x0 + t, z0 + t], [x0 + t, z1], [x0, z1]];
    if (shape === 'T') return [[x0, z0], [x1, z0], [x1, z0 + t], [xc + t / 2, z0 + t], [xc + t / 2, z1], [xc - t / 2, z1], [xc - t / 2, z0 + t], [x0, z0 + t]];
    if (shape === 'H') {
      var zc = (z0 + z1) / 2;
      return [[x0, z0], [x0 + t, z0], [x0 + t, zc - t / 2], [x1 - t, zc - t / 2], [x1 - t, z0], [x1, z0], [x1, z1], [x1 - t, z1], [x1 - t, zc + t / 2], [x0 + t, zc + t / 2], [x0 + t, z1], [x0, z1]];
    }
    return [[x0, z0], [x1, z0], [x1, z1], [x0, z1]];
  }
  function _applyShelterShape(shape) {
    STATE.shelterShape = shape;
    var bb = _carportBBox(getFootprintPolygon());
    if (!isFinite(bb.xMin)) return;
    STATE.polygon = _shelterShapePoly(shape, bb.xMin, bb.xMax, bb.zMin, bb.zMax);
  }
  var _roofOrder = ['atika', 'pult', 'sedlo', 'valba'];
  var _roofKeys = { atika: 'shelters_roof_flat', pult: 'shelters_roof_mono', sedlo: 'shelters_roof_gable', valba: 'shelters_roof_hip' };
  var _roofFallback = { atika: 'Flat roof', pult: 'Mono-pitch', sedlo: 'Gable roof', valba: 'Hip roof' };
  var _foundOrder = ['slab', 'screws', 'pads', 'precast'];
  var _foundKeys = { slab: 'base_v1', screws: 'base_v5', pads: 'base_v3', precast: 'base_v4' };
  var _foundFallback = { slab: 'Concrete slab', screws: 'Ground screws', pads: 'Pad foundation', precast: 'Precast pier blocks' };
  /* Structure system — master-level switch. Order + i18n keys mirror the
     structure sub-config variants (structure_v1..v5). The chosen variant is
     persisted to localStorage 'mc:structureVariant' so the structure config
     reads it; masonry additionally drives the footprint snap grid (next step). */
  var _structOrder = ['masonry', 'timber', 'clt', 'steel', 'icf'];
  var _structKeys = { masonry: 'structure_v1', timber: 'structure_v2', clt: 'structure_v3', steel: 'structure_v4', icf: 'structure_v5' };
  var _structFallback = { masonry: 'Masonry', timber: 'Timber frame', clt: 'CLT', steel: 'Steel frame', icf: 'ICF' };
  /* Inter-storey floor slab as a SOLID per structure system — modelled here in the
     master only (correct size + position); the real build-up is detailed in the
     structure config. Thickness ≈ the most common US floor for that system, and a
     distinct colour per system. masonry slab sits ON the ring beam (the beam is
     shortened by t below). t in metres. */
  var _floorSlabM = {
    masonry: { t: 0.20, color: 0xc2beb4 },   /* precast hollow-core plank on the ring beam */
    timber:  { t: 0.25, color: 0xc69a62 },   /* dimensional / I-joists + plywood subfloor */
    clt:     { t: 0.18, color: 0xd8c197 },   /* CLT floor panel */
    steel:   { t: 0.30, color: 0x9ba4ab },   /* steel joists + composite metal deck */
    icf:     { t: 0.25, color: 0xaaa69d }    /* concrete deck / joists */
  };
  function _floorSlabSpec() { return _floorSlabM[STATE.structureVariant || 'masonry'] || _floorSlabM.masonry; }
  /* miter-offset a (rectilinear) polygon outward by d; winding-agnostic — picks
     whichever sign grows the area, so the result always expands. Used to push the
     floor-slab outline from the wall centreline out to the outer wall/ring-beam face. */
  function _offsetPolyOut(poly, d) {
    if (!poly || poly.length < 3 || !(d > 0)) return poly;
    function build(dd) {
      var n = poly.length, out = [];
      for (var i = 0; i < n; i++) {
        var p0 = poly[(i - 1 + n) % n], p1 = poly[i], p2 = poly[(i + 1) % n];
        var e1x = p1[0] - p0[0], e1z = p1[1] - p0[1], l1 = Math.hypot(e1x, e1z) || 1;
        var e2x = p2[0] - p1[0], e2z = p2[1] - p1[1], l2 = Math.hypot(e2x, e2z) || 1;
        e1x /= l1; e1z /= l1; e2x /= l2; e2z /= l2;
        var n1x = e1z, n1z = -e1x, n2x = e2z, n2z = -e2x;
        var mx = n1x + n2x, mz = n1z + n2z, denom = 1 + (n1x * n2x + n1z * n2z);
        if (Math.abs(denom) < 1e-6) out.push([p1[0] + dd * n1x, p1[1] + dd * n1z]);
        else out.push([p1[0] + dd * mx / denom, p1[1] + dd * mz / denom]);
      }
      return out;
    }
    function area(pg) {
      var s = 0;
      for (var i = 0; i < pg.length; i++) { var a = pg[i], b = pg[(i + 1) % pg.length]; s += a[0] * b[1] - b[0] * a[1]; }
      return Math.abs(s) / 2;
    }
    var pos = build(d), neg = build(-d);
    return (area(pos) >= area(neg)) ? pos : neg;
  }
  var _shapeKeys = { I: 'base_shape_rect', L: 'base_shape_l', U: 'base_shape_u', T: 'base_shape_t', H: 'base_shape_h' };
  var _shapeFallback = { I: 'Rectangle', L: 'L shape', U: 'U shape', T: 'T shape', H: 'H shape' };
  function _cycleShelterShape() {
    var i = _shapeOrder.indexOf(STATE.shelterShape || 'I');
    var next = _shapeOrder[(i + 1) % _shapeOrder.length];
    var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
    _applyShelterShape(next);
    _clearAllOpenings();                 /* new shape → different walls, drop all windows/doors */
    try { _UndoHistory.pushIfChanged(prevPoly, STATE.variant); } catch (_) {}
    try { rebuildDragHandles(); } catch (_) {}
    try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (_) {}
    refreshUI();
    _updateShapeBtn();
    _forceRender3DFlush(2);
  }
  function _cycleRoofType() {
    var i = _roofOrder.indexOf(STATE.shelterRoofType || 'sedlo');
    STATE.shelterRoofType = _roofOrder[(i + 1) % _roofOrder.length];
    try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (_) {}
    _broadcastHouse();
    refreshUI();
    _updateShapeBtn();
    _forceRender3DFlush(2);
  }
  function _cycleFoundation() {
    var i = _foundOrder.indexOf(STATE.shelterFoundation || 'slab');
    STATE.shelterFoundation = _foundOrder[(i + 1) % _foundOrder.length];
    refreshUI();
    _updateShapeBtn();
  }
  function _onStructureVariantChange(v) {
    if (v === 'masonry') { try { _openBlockModal(); } catch (_) {} }
    /* rebuild the 3D so masonry blocks appear/disappear with the type, and
       broadcast so the structure config follows live */
    try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (_) {}
    try { _broadcastHouse(); } catch (_) {}
  }

  /* Nominal (coordinating) block sizes — joint already included, so the
     wall module = length and numbers stay round. Metric default = a common
     concrete/aerated perimeter block; imperial default = US CMU 16x8x8. */
  var _BLOCK_DEF_M = { l: 400, w: 300, h: 200 };   /* mm */
  var _BLOCK_DEF_I = { l: 16,  w: 8,   h: 8 };     /* in */
  function _blockMetric() { return STATE.isMetric !== false; }

  function _readBlockGrid(metric) {
    try {
      var raw = localStorage.getItem('mc:grid');
      if (raw) {
        var g = JSON.parse(raw);
        if (g && g.brick && (!!g.metric === !!metric)) return g.brick;
      }
    } catch (e) {}
    return metric ? { l: _BLOCK_DEF_M.l, w: _BLOCK_DEF_M.w, h: _BLOCK_DEF_M.h }
                  : { l: _BLOCK_DEF_I.l, w: _BLOCK_DEF_I.w, h: _BLOCK_DEF_I.h };
  }

  /* Isometric SVG of the block — cheap, deterministic, no extra WebGL context. */


  /* Snap a rectangular footprint so both sides are whole-block multiples (unit in mm). */
  /* Re-fit the footprint side lengths to whole blocks. Works for any
     4-vertex quad (incl. a rotated rectangle): snaps both edge lengths to the
     nearest whole-block multiple, keeping the centroid fixed. L/T shapes
     (>4 vertices) are left as-is. */
  function _snapFootprintToUnit(unitMm) {
    var u = unitMm / 1000;
    if (!(u > 0)) return false;
    var poly = STATE.polygon;
    if (!poly || poly.length !== 4) return false;
    var v0 = poly[0], v1 = poly[1], v2 = poly[2], v3 = poly[3];
    var e1x = v1[0] - v0[0], e1z = v1[1] - v0[1], L1 = Math.hypot(e1x, e1z);
    var e2x = v3[0] - v0[0], e2z = v3[1] - v0[1], L2 = Math.hypot(e2x, e2z);
    if (L1 < 0.05 || L2 < 0.05) return false;
    var u1x = e1x / L1, u1z = e1z / L1, u2x = e2x / L2, u2z = e2z / L2;
    var nL1 = Math.max(u, Math.round(L1 / u) * u);
    var nL2 = Math.max(u, Math.round(L2 / u) * u);
    var cx = (v0[0] + v1[0] + v2[0] + v3[0]) / 4;
    var cz = (v0[1] + v1[1] + v2[1] + v3[1]) / 4;
    var ox = cx - u1x * nL1 / 2 - u2x * nL2 / 2;
    var oz = cz - u1z * nL1 / 2 - u2z * nL2 / 2;
    STATE.polygon = [
      [ox, oz],
      [ox + u1x * nL1, oz + u1z * nL1],
      [ox + u1x * nL1 + u2x * nL2, oz + u1z * nL1 + u2z * nL2],
      [ox + u2x * nL2, oz + u2z * nL2]
    ];
    return true;
  }

  function _applyBlockGrid(l, w, h, metric) {
    var toMm = metric ? 1 : 25.4;
    var unit = Math.round(l * toMm), course = Math.round(h * toMm), half = Math.round(unit / 2);
    try {
      localStorage.setItem('mc:grid', JSON.stringify({
        brick: { l: l, w: w, h: h }, metric: !!metric,
        unit: unit, half: half, course: course
      }));
    } catch (e) {}
    _gridUnitM = unit / 1000;   /* footprint now steps by this block module */
    try { _snapFootprintToUnit(unit); } catch (e) {}
    try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
    try { rebuildDragHandles(); } catch (e) {}
    try { _broadcastHouse(); } catch (e) {}
    try { refreshUI(); } catch (e) {}
  }

  var _blockModalEl = null;
  function _closeBlockModal() {
    if (_blockModalEl && _blockModalEl.parentNode) _blockModalEl.parentNode.removeChild(_blockModalEl);
    _blockModalEl = null;
  }
  function _openBlockModal() {
    _closeBlockModal();
    var T = (global.BASE_BOOT || {}).i18n || {};
    function tt(k, f) { var v = T[k]; return (typeof v === 'string' && v && v.indexOf('Translation missing') === -1) ? v : f; }
    var metric = _blockMetric();
    var U = metric ? 'mm' : '\u2033';
    var step = metric ? 5 : 1;
    var rng = metric ? { l: [100, 600], w: [50, 500], h: [50, 300] }
                     : { l: [4, 24], w: [4, 16], h: [4, 12] };
    var b = _readBlockGrid(metric);
    var L = b.l, W = b.w, H = b.h;

    var ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:16px;';
    var card = document.createElement('div');
    card.style.cssText = 'background:#fff;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.3);width:100%;max-width:360px;padding:18px 18px 14px;font-family:Montserrat,system-ui,sans-serif;box-sizing:border-box;';
    card.addEventListener('click', function (e) { e.stopPropagation(); });
    ov.addEventListener('click', function () { _closeBlockModal(); });

    var title = document.createElement('div');
    title.textContent = tt('mcBlockTitle', 'Masonry block');
    title.style.cssText = 'font:700 15px Montserrat,sans-serif;color:#222;margin:0 0 2px;';
    var sub = document.createElement('div');
    sub.style.cssText = 'font:500 11px Montserrat,sans-serif;color:#888;margin:0 0 6px;';
    var hint = document.createElement('div');
    hint.textContent = tt('mcBlockDrag', 'Drag the corners to size the block');
    hint.style.cssText = 'font:500 10px Montserrat,sans-serif;color:#b9a07f;margin:0 0 8px;';

    /* ---- interactive isometric block (SVG, no extra WebGL context) ---- */
    var NS = 'http://www.w3.org/2000/svg';
    function el(n) { return document.createElementNS(NS, n); }
    var VW = 320, VH = 210;
    var maxR = Math.max(rng.l[1], rng.w[1], rng.h[1]);
    var sc = 95 / maxR;                 /* constant px-per-unit → linear drag */
    var C = 0.866, Sx = 0.5, B = [134, 150];
    var stage = document.createElement('div');
    stage.style.cssText = 'background:#f6f4f0;border-radius:12px;padding:4px;margin:0 0 12px;';
    var svg = el('svg');
    svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);
    svg.setAttribute('width', '100%'); svg.setAttribute('height', '186');
    svg.style.cssText = 'display:block;touch-action:none;';

    var fLeft = el('path'), fRight = el('path'), fTop = el('path');
    fLeft.setAttribute('fill', '#7d5a36'); fLeft.setAttribute('stroke', '#3a2a18'); fLeft.setAttribute('stroke-width', '1.5'); fLeft.setAttribute('stroke-linejoin', 'round');
    fRight.setAttribute('fill', '#9a6f44'); fRight.setAttribute('stroke', '#3a2a18'); fRight.setAttribute('stroke-width', '1.5'); fRight.setAttribute('stroke-linejoin', 'round');
    fTop.setAttribute('fill', '#b98a55'); fTop.setAttribute('stroke', '#3a2a18'); fTop.setAttribute('stroke-width', '1.5'); fTop.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(fLeft); svg.appendChild(fRight); svg.appendChild(fTop);

    function mkPill() {
      var g = el('g');
      var r = el('rect'); r.setAttribute('rx', '8'); r.setAttribute('height', '18'); r.setAttribute('fill', '#3a3f45');
      var t = el('text'); t.setAttribute('fill', '#fff'); t.setAttribute('font-size', '11'); t.setAttribute('font-weight', '700');
      t.setAttribute('font-family', 'Montserrat,sans-serif'); t.setAttribute('text-anchor', 'middle'); t.setAttribute('dominant-baseline', 'central');
      g.appendChild(r); g.appendChild(t); svg.appendChild(g);
      return { r: r, t: t };
    }
    function setPill(p, cx, cy, txt) {
      p.t.textContent = txt;
      var w = txt.length * 6.4 + 16;
      p.r.setAttribute('width', w.toFixed(0)); p.r.setAttribute('x', (cx - w / 2).toFixed(1)); p.r.setAttribute('y', (cy - 9).toFixed(1));
      p.t.setAttribute('x', cx.toFixed(1)); p.t.setAttribute('y', cy.toFixed(1));
    }
    var pL = mkPill(), pW = mkPill(), pH = mkPill();

    function mkHandle() {
      var c = el('circle'); c.setAttribute('r', '10'); c.setAttribute('fill', '#D2A878'); c.setAttribute('stroke', '#fff'); c.setAttribute('stroke-width', '2.5');
      c.style.cursor = 'grab'; svg.appendChild(c); return c;
    }
    var hL = mkHandle(), hW = mkHandle(), hH = mkHandle();

    function geom(l, w, h) {
      var Rx = C * l * sc, Ry = Sx * l * sc, Lx = -C * w * sc, Ly = Sx * w * sc, Uy = -h * sc;
      return {
        bF: [B[0], B[1]], bR: [B[0] + Rx, B[1] + Ry], bL: [B[0] + Lx, B[1] + Ly],
        tF: [B[0], B[1] + Uy], tR: [B[0] + Rx, B[1] + Ry + Uy], tL: [B[0] + Lx, B[1] + Ly + Uy], tB: [B[0] + Rx + Lx, B[1] + Ry + Ly + Uy]
      };
    }
    function dpt(p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }
    function mid(a, c) { return [(a[0] + c[0]) / 2, (a[1] + c[1]) / 2]; }
    function fmtVal(v) { return v + ' ' + U; }

    function redraw() {
      var g = geom(L, W, H);
      fTop.setAttribute('d', 'M' + dpt(g.tF) + ' L' + dpt(g.tR) + ' L' + dpt(g.tB) + ' L' + dpt(g.tL) + ' Z');
      fRight.setAttribute('d', 'M' + dpt(g.bF) + ' L' + dpt(g.bR) + ' L' + dpt(g.tR) + ' L' + dpt(g.tF) + ' Z');
      fLeft.setAttribute('d', 'M' + dpt(g.bF) + ' L' + dpt(g.bL) + ' L' + dpt(g.tL) + ' L' + dpt(g.tF) + ' Z');
      hL.setAttribute('cx', g.bR[0]); hL.setAttribute('cy', g.bR[1]);
      hW.setAttribute('cx', g.bL[0]); hW.setAttribute('cy', g.bL[1]);
      hH.setAttribute('cx', g.tF[0]); hH.setAttribute('cy', g.tF[1]);
      var mL = mid(g.bF, g.bR), mW = mid(g.bF, g.bL), mH = mid(g.bF, g.tF);
      setPill(pL, mL[0] + 6, mL[1] + 12, fmtVal(L));
      setPill(pW, mW[0] - 6, mW[1] + 12, fmtVal(W));
      setPill(pH, mH[0] - 20, mH[1], fmtVal(H));
      sub.textContent = tt('mcBlockModule', 'Module') + ': ' + L + ' ' + U + ' \u00b7 \u00bd ' + (L / 2) + ' ' + U;
    }

    /* drag a corner along its axis → that dimension (screen-delta projected) */
    function bindDrag(handle, axis, getV, setV, rngv) {
      var active = false, sx0 = 0, sy0 = 0, v0 = 0, ratio = 1;
      function move(ev) {
        if (!active) return;
        var dx = (ev.clientX - sx0) / ratio, dy = (ev.clientY - sy0) / ratio;
        var dmm = (dx * axis[0] + dy * axis[1]) / sc;              /* px → units */
        var nv = Math.round((v0 + dmm) / step) * step;
        nv = Math.max(rngv[0], Math.min(rngv[1], nv));
        setV(nv); redraw();
        ev.preventDefault();
      }
      function up(ev) {
        active = false; handle.style.cursor = 'grab';
        try { handle.releasePointerCapture(ev.pointerId); } catch (e) {}
        window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); window.removeEventListener('pointercancel', up);
      }
      handle.addEventListener('pointerdown', function (ev) {
        active = true; v0 = getV(); sx0 = ev.clientX; sy0 = ev.clientY;
        var rb = svg.getBoundingClientRect(); ratio = rb.width / VW || 1;
        handle.style.cursor = 'grabbing';
        try { handle.setPointerCapture(ev.pointerId); } catch (e) {}
        window.addEventListener('pointermove', move); window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
        ev.preventDefault(); ev.stopPropagation();
      });
    }
    bindDrag(hL, [C, Sx], function () { return L; }, function (v) { L = v; }, rng.l);
    bindDrag(hW, [-C, Sx], function () { return W; }, function (v) { W = v; }, rng.w);
    bindDrag(hH, [0, -1], function () { return H; }, function (v) { H = v; }, rng.h);

    stage.appendChild(svg);

    var btns = document.createElement('div');
    btns.style.cssText = 'display:flex;gap:8px;margin-top:2px;';
    var cancel = document.createElement('button');
    cancel.textContent = tt('mcBlockCancel', 'Cancel');
    cancel.style.cssText = 'flex:1;padding:11px;border:1px solid #ddd;background:#fff;border-radius:10px;font:600 12px Montserrat,sans-serif;color:#555;cursor:pointer;';
    cancel.addEventListener('click', function () { _closeBlockModal(); });
    var apply = document.createElement('button');
    apply.textContent = tt('mcBlockApply', 'Apply');
    apply.style.cssText = 'flex:2;padding:11px;border:none;background:#9a6f44;border-radius:10px;font:700 12px Montserrat,sans-serif;color:#fff;cursor:pointer;';
    apply.addEventListener('click', function () { _applyBlockGrid(L, W, H, metric); _closeBlockModal(); });
    btns.appendChild(cancel); btns.appendChild(apply);

    card.appendChild(title); card.appendChild(sub); card.appendChild(hint); card.appendChild(stage); card.appendChild(btns);
    ov.appendChild(card);
    document.body.appendChild(ov);
    _blockModalEl = ov;
    redraw();
  }
  /* ----- editable wall height (per storey) ---------------------------------
     STATE.wallClear = clear wall height of one storey (m), persisted to
     localStorage 'mc:wallClear'. The floor-to-floor height keeps the original
     0.40 m deck allowance on top of it. Lazy load so any early build uses the
     persisted value too. */
  var _wallClearLoaded = false;
  function _baseClearM() {
    if (!_wallClearLoaded) {
      _wallClearLoaded = true;
      try {
        var s = parseFloat(localStorage.getItem('mc:wallClear'));
        if (s >= 2.0 && s <= 5.0) STATE.wallClear = s;
        var fc = JSON.parse(localStorage.getItem('mc:floorClear') || 'null');
        if (fc && fc.length) STATE.floorClear = fc.map(function (x) { var n = parseFloat(x); return (n >= 2.0 && n <= 5.0) ? n : null; });
      } catch (e) {}
    }
    var v = +STATE.wallClear;
    return (v >= 2.0 && v <= 5.0) ? v : HOUSE_BASE_CLEAR;
  }
  function _storeyHM() { return _baseClearM() + (HOUSE_STOREY_H - HOUSE_BASE_CLEAR); }
  /* ---- per-floor clear heights -------------------------------------------
     STATE.floorClear[s] = clear wall height of storey s (m). Missing entries
     fall back to the single STATE.wallClear, so legacy one-height projects keep
     working until a per-floor slider writes that storey's entry. */
  function _clearForFloor(s) {
    s = s | 0; var a = STATE.floorClear;
    if (a && a[s] != null && isFinite(a[s]) && +a[s] >= 2.0 && +a[s] <= 5.0) return +a[s];
    return _baseClearM();
  }
  function _storeyHForFloor(s) { return _clearForFloor(s) + (HOUSE_STOREY_H - HOUSE_BASE_CLEAR); }
  function _storeyBaseY(s) { var y = 0, n = s | 0, k; for (k = 0; k < n; k++) y += _storeyHForFloor(k); return y; }
  function _storeyTopY(s) { return _storeyBaseY(s) + _storeyHForFloor(s); }
  function _floorOfY(y) {
    var fl = Math.max(1, STATE.floors | 0), acc = 0, k;
    for (k = 0; k < fl; k++) { acc += _storeyHForFloor(k); if ((+y) < acc - 1e-6) return k; }
    return fl - 1;
  }
  /* keep every opening pinned to its floor + local offset across a height change
     so raising/lowering one storey slides the floors above without orphaning
     their windows. applyChange() mutates STATE.floorClear. */
  function _reanchorOpenings(applyChange) {
    var ops = (STATE.openings || []), anchors = [], i;
    for (i = 0; i < ops.length; i++) { var f = _floorOfY(ops[i].sill || 0); anchors.push({ f: f, lo: (ops[i].sill || 0) - _storeyBaseY(f) }); }
    applyChange();
    var eave = _wallHeightM() + ((SHELTER_SPECS.carport && SHELTER_SPECS.carport.beam) ? SHELTER_SPECS.carport.beam.h : 0);
    for (i = 0; i < ops.length; i++) { var a = anchors[i]; ops[i].sill = Math.max(0, Math.min(eave - ops[i].h - 0.02, _storeyBaseY(a.f) + a.lo)); }
  }
  function _wallHeightM() { var fl = Math.max(1, STATE.floors | 0); return _storeyBaseY(fl - 1) + _clearForFloor(fl - 1); }

  /* When the floor count drops, openings on floors that no longer exist are
     removed outright (per request) — together with their wall treatment, so no
     orphan parapet/header segments are left behind. */
  function _pruneOpeningsAboveFloors() {
    var flN = Math.max(1, STATE.floors | 0);
    if (!STATE.openings || !STATE.openings.length) return false;
    var before = STATE.openings.length;
    STATE.openings = STATE.openings.filter(function (o) {
      return ((o.sill || 0) + 1e-3) < _storeyBaseY(flN);          /* keep openings on a built floor */
    });
    if (STATE.openings.length === before) return false;
    try { _Openings._broadcastSafe(); } catch (e) {}
    return true;
  }
  /* changing the footprint shape gives a different wall layout, so openings keyed
     to the old shape's wall indices no longer apply — drop them all. */
  function _clearAllOpenings() {
    if (!STATE.openings || !STATE.openings.length) return false;
    STATE.openings = [];
    try { _Openings._broadcastSafe(); } catch (e) {}              /* refresh mc:openings + boq */
    return true;
  }
  function _fmtWallHFor(floor) {
    var v = _clearForFloor(floor);
    if (STATE.isMetric) return (Math.round(v * 100) / 100) + ' M';
    var tot = Math.round(v / IN), ft = Math.floor(tot / 12), inch = tot - ft * 12;
    return ft + "'" + (inch ? inch + '\u2033' : '');
  }

  /* ----- floating per-floor wall-height sliders ---------------------------
     One horizontal slider per storey, stacked above the WALL HEIGHT tab
     (floor 0 lowest, upper floors offset up), each tinted with that floor's
     overlay colour. Dragging rebuilds the 3D live (rAF-throttled) and keeps
     every window anchored to its floor; releasing persists + broadcasts. */
  var _hTabEl = null, _hCssDone = false, _hRaf = 0, _hRows = [], _hRoot = null, _hResizeBound = false;
  var _FLOOR_CSS = ['#9a6f44', '#2a78a0', '#7856a8', '#b07828'];   /* per-storey colours (match _Openings._BAND_RGB) */
  function _floorColorCss(i) { return _FLOOR_CSS[(i | 0) % _FLOOR_CSS.length]; }
  function _injectHSliderCss() {
    if (_hCssDone) return;
    _hCssDone = true;
    var st = document.createElement('style');
    st.textContent =
      '.cf-house-wallh-slider{-webkit-appearance:none;appearance:none;width:100%;height:4px;border-radius:2px;outline:none;cursor:pointer;}' +
      '.cf-house-wallh-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:var(--wh-c,#9a6f44);border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.25);cursor:grab;}' +
      '.cf-house-wallh-slider::-moz-range-thumb{width:16px;height:16px;border-radius:50%;background:var(--wh-c,#9a6f44);border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.25);cursor:grab;}';
    document.head.appendChild(st);
  }
  function _paintSlider(sl) {
    if (!sl) return;
    var min = parseFloat(sl.min) || 0, max = parseFloat(sl.max) || 100;
    var p = ((parseFloat(sl.value) - min) / (max - min)) * 100;
    var c = sl.style.getPropertyValue('--wh-c') || '#9a6f44';
    sl.style.background = 'linear-gradient(to right,' + c + ' 0%,' + c + ' ' + p +
      '%,rgba(0,0,0,0.12) ' + p + '%,rgba(0,0,0,0.12) 100%)';
  }
  function _sliderValM(sl) {
    return (sl.getAttribute('data-unit') === 'imp') ? parseFloat(sl.value) * IN : parseFloat(sl.value);
  }
  function _writeFloorClear(floor, v) {
    _reanchorOpenings(function () {
      STATE.floorClear = STATE.floorClear || [];
      STATE.floorClear[floor] = v;
      if (floor === 0) STATE.wallClear = v;             /* keep the legacy single value in sync */
    });
  }
  function _persistFloorClear() {
    var fl = Math.max(1, STATE.floors | 0);
    try { localStorage.setItem('mc:floorClear', JSON.stringify((STATE.floorClear || []).slice(0, fl))); } catch (e) {}
    try { localStorage.setItem('mc:wallClear', String(_clearForFloor(0))); } catch (e) {}
  }
  function _syncSliderCfg(e) {
    var sl = e.slider, floor = e.floor;
    var metric = STATE.isMetric !== false;
    var want = metric ? 'm' : 'imp';
    var dragging = (document.activeElement === sl);
    var cv = _clearForFloor(floor);
    if (sl.getAttribute('data-unit') !== want) {
      sl.setAttribute('data-unit', want);
      if (metric) { sl.min = '2.2'; sl.max = '4.0'; sl.step = '0.05'; }
      else { sl.min = '87'; sl.max = '157'; sl.step = '1'; }
      sl.value = metric ? String(cv) : String(Math.round(cv / IN));
    } else if (!dragging) {
      sl.value = metric ? String(cv) : String(Math.round(cv / IN));
    }
    if (e.val) e.val.textContent = _fmtWallHFor(floor);
    _paintSlider(sl);
  }
  function _syncHeightSliderCfg() {
    for (var i = 0; i < _hRows.length; i++) _syncSliderCfg(_hRows[i]);
    _positionHeightSlider();
  }
  /* Anchor the slider stack INTO the banner's own pinned container so the
     compositor moves it together with the banner during scroll. On mobile the
     main thread's getBoundingClientRect doesn't update mid-scroll, so any JS
     "follow" (scroll events or rAF) always lags and only catches up at
     scroll-end. As a DOM child of the banner root it tracks natively, no JS. */
  function _bannerRoot() {
    if (_hRoot && _hRoot.parentNode) return _hRoot;
    var el = _hTabEl, fixed = null, cs;
    while (el && el !== document.body) {
      cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (cs && (cs.position === 'fixed' || cs.position === 'sticky')) { fixed = el; break; }
      el = el.parentElement;
    }
    if (!fixed) { el = _hTabEl; while (el && el.parentElement && el.parentElement !== document.body) el = el.parentElement; fixed = el; }
    _hRoot = fixed || (_hTabEl && _hTabEl.parentElement) || document.body;
    try {
      var rcs = window.getComputedStyle ? window.getComputedStyle(_hRoot) : null;
      if (rcs && rcs.position === 'static') _hRoot.style.position = 'relative';   /* positioning context for the rows */
      _hRoot.style.overflow = 'visible';                                          /* let the rows escape its top edge */
    } catch (e) {}
    return _hRoot;
  }
  function _positionHeightSlider() {
    if (!_hRows.length) return;
    /* horizontal: centred over the real WALL HEIGHT tab; vertical: floor-0 row
       just above the tab, each upper floor stacked further up. All offsets are
       measured RELATIVE to the banner root, so they stay valid as the root (and
       its slider children) move together — recomputed only on layout changes. */
    var nameEl = document.getElementById('cf-stat-wallh-name');
    if (!nameEl || !nameEl.getBoundingClientRect) return;
    var root = _bannerRoot();
    if (!root || !root.getBoundingClientRect) return;
    var nr = nameEl.getBoundingClientRect();
    if (!nr.width && !nr.height) return;             /* hidden → keep last */
    var rr = root.getBoundingClientRect();
    var left = (nr.left - rr.left) + nr.width / 2;    /* tab centre within the root */
    /* uniform empty gap G between the banner and floor 0 AND between every pair
       of stacked rows. With the row height measured live, GAP = rowH + G makes
       all gaps visually identical regardless of the rendered row height. */
    var G = 10;
    var rowH = (_hRows[0] && _hRows[0].row.offsetHeight) || 22;
    /* climb to the banner bar's true visual top: the highest top among
       bar-sized ancestors (height ≤ 90px), stopping before any tall /
       full-screen container — so floor 0 clears the whole bar, not just the
       label, and a fixed app root can never push it off-screen. */
    var bannerTop = nr.top, _e = _hTabEl, _r;
    while (_e && _e !== document.body) {
      _r = _e.getBoundingClientRect();
      if (_r.height > 90) break;
      if (_r.height > 0 && _r.top < bannerTop) bannerTop = _r.top;
      _e = _e.parentElement;
    }
    var base = (rr.bottom - bannerTop) + G;          /* floor-0 row sits G above the banner bar top */
    var GAP = rowH + G;
    for (var i = 0; i < _hRows.length; i++) {
      var e = _hRows[i];
      e.row.style.left = left + 'px';
      e.row.style.transform = 'translateX(-50%)';
      e.row.style.bottom = (base + e.floor * GAP) + 'px';
    }
  }
  function _makeSliderRow(floor) {
    var row = document.createElement('div');
    row.style.cssText = 'position:absolute;z-index:9000;display:flex;flex-direction:row;align-items:center;gap:6px;width:172px;pointer-events:auto;';
    var val = document.createElement('span');
    val.style.cssText = 'font:700 10px Montserrat,system-ui,sans-serif;color:#fff;background:' + _floorColorCss(floor) +
      ';padding:2px 6px;border-radius:7px;box-shadow:0 1px 4px rgba(0,0,0,.22);white-space:nowrap;min-width:48px;text-align:center;';
    var sl = document.createElement('input');
    sl.type = 'range';
    sl.className = 'cf-house-wallh-slider';
    sl.style.flex = '1';
    sl.style.setProperty('--wh-c', _floorColorCss(floor));        /* each floor in its overlay colour */
    row.appendChild(val); row.appendChild(sl);
    _bannerRoot().appendChild(row);                              /* DOM child of the banner → moves with it natively */
    var entry = { row: row, slider: sl, val: val, floor: floor };
    sl.addEventListener('input', function () {
      _writeFloorClear(floor, Math.round(_sliderValM(sl) * 100) / 100);
      if (entry.val) entry.val.textContent = _fmtWallHFor(floor);
      _paintSlider(sl);
      if (_hRaf) return;
      _hRaf = requestAnimationFrame(function () {
        _hRaf = 0;
        try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
      });
    });
    sl.addEventListener('change', function () {
      _writeFloorClear(floor, Math.round(_sliderValM(sl) * 100) / 100);
      _persistFloorClear();
      try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
      try { _broadcastHouse(); } catch (e) {}
      try { _ShelterBanner.sync(); } catch (e) {}
    });
    return entry;
  }
  function _ensureHeightSlider() {
    if (!_hTabEl) return;
    _injectHSliderCss();
    var fl = Math.max(1, STATE.floors | 0), changed = false;
    while (_hRows.length > fl) { var ex = _hRows.pop(); if (ex.row && ex.row.parentNode) ex.row.parentNode.removeChild(ex.row); changed = true; }
    while (_hRows.length < fl) { _hRows.push(_makeSliderRow(_hRows.length)); changed = true; }
    if (!_hResizeBound) {
      _hResizeBound = true;
      /* offsets are root-relative (stable during scroll) → re-measure only on
         layout changes, never on scroll. */
      window.addEventListener('resize', _positionHeightSlider);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', _positionHeightSlider);
    }
    _syncHeightSliderCfg();
    if (changed) { setTimeout(_positionHeightSlider, 60); setTimeout(_positionHeightSlider, 300); setTimeout(_positionHeightSlider, 1000); }
  }

  /* Wall-height banner row, cloned like the structure row and inserted right
     after the shape row's divider — i.e. into the empty slot between the
     first and second tab (which also removes the doubled divider there). */
  function _ensureHeightRow() {
    var existing = document.getElementById('cf-stat-wallh-name');
    if (existing) {
      if (!_hTabEl) {
        var t = existing.parentElement;
        var ta = document.getElementById('cf-btn-wallh') || document.getElementById('cf-info-wallh') || existing;
        while (t && t !== document.body && !t.contains(ta)) t = t.parentElement;
        _hTabEl = t || existing.parentElement;
      }
      _ensureHeightSlider();
      return true;
    }
    var nameEl = document.getElementById('cf-stat-edge-name');
    if (!nameEl) return false;
    var anchor = document.getElementById('cf-btn-edge') || document.getElementById('cf-info-edge') || nameEl;
    var row = nameEl.parentElement;
    while (row && anchor && row !== document.body && !row.contains(anchor)) row = row.parentElement;
    if (!row || !row.parentElement) row = nameEl.parentElement;
    if (!row || !row.parentElement) return false;
    var clone = row.cloneNode(true);
    var ided = clone.querySelectorAll ? clone.querySelectorAll('[id]') : [];
    Array.prototype.forEach.call(ided, function (el) {
      if (el.id && el.id.indexOf('edge') !== -1) el.id = el.id.replace(/edge/g, 'wallh');
      el.removeAttribute('data-cf-shelter-bound');
    });
    if (clone.id && clone.id.indexOf('edge') !== -1) clone.id = clone.id.replace(/edge/g, 'wallh');
    var after = row.nextElementSibling;
    if (after && !_bannerIsRow(after)) {
      row.parentElement.insertBefore(clone, after.nextSibling);
    } else {
      row.parentElement.insertBefore(clone, row.nextSibling);
    }
    _hTabEl = clone;
    _ensureHeightSlider();
    return true;
  }

  function _cycleStructure() {
    var i = _structOrder.indexOf(STATE.structureVariant || 'masonry');
    STATE.structureVariant = _structOrder[(i + 1) % _structOrder.length];
    try { localStorage.setItem('mc:structureVariant', STATE.structureVariant); } catch (e) {}
    _ShelterBanner.sync();
    _onStructureVariantChange(STATE.structureVariant);
  }
  /* Markup for the banner rows lives in a shared snippet; if a structure row
     isn't present we clone the foundation row at runtime (ids material->structure)
     so the switch works without editing the shared markup. */
  function _bannerIsRow(el) {
    return !!(el && el.querySelector && el.querySelector('[id$="-name"]')) ||
           !!(el && el.id && /-name$/.test(el.id));
  }
  /* Collapse two adjacent identical dividers (same tag + class, no stat label)
     into one, wherever in the banner they ended up. */
  function _dedupBannerDividers(container) {
    if (!container || !container.children) return;
    var i = 1;
    while (i < container.children.length) {
      var a = container.children[i - 1], b = container.children[i];
      if (!_bannerIsRow(a) && !_bannerIsRow(b) &&
          a.tagName === b.tagName && a.className === b.className) {
        container.removeChild(b);
        continue;   /* re-check the same index */
      }
      i++;
    }
  }
  function _ensureStructureRow() {
    var done = !!document.getElementById('cf-stat-structure-name');
    var nameEl = document.getElementById('cf-stat-material-name');
    if (!nameEl) return done;
    var anchor = document.getElementById('cf-btn-material') || document.getElementById('cf-info-material') || nameEl;
    var row = nameEl.parentElement;
    while (row && anchor && row !== document.body && !row.contains(anchor)) row = row.parentElement;
    if (!row || !row.parentElement) row = nameEl.parentElement;
    if (!row || !row.parentElement) return done;
    if (!done) {
      var clone = row.cloneNode(true);
      var ided = clone.querySelectorAll ? clone.querySelectorAll('[id]') : [];
      Array.prototype.forEach.call(ided, function (el) {
        if (el.id && el.id.indexOf('material') !== -1) el.id = el.id.replace(/material/g, 'structure');
        el.removeAttribute('data-cf-shelter-bound');
      });
      if (clone.id && clone.id.indexOf('material') !== -1) clone.id = clone.id.replace(/material/g, 'structure');
      row.parentElement.insertBefore(clone, row.nextSibling);
      /* Divider between foundation and structure, matching the other rows. The
         element just before the foundation row is the inter-row divider when it
         carries no stat label; clone it (ids stripped) and place it before the
         new structure row. If rows are separated by CSS borders instead, the
         cloned row already carries them, so this is a no-op. */
      var prev = row.previousElementSibling;
      var prevIsDivider = prev && !_bannerIsRow(prev);
      if (prevIsDivider) {
        var divClone = prev.cloneNode(true);
        var dids = divClone.querySelectorAll ? divClone.querySelectorAll('[id]') : [];
        Array.prototype.forEach.call(dids, function (el) { el.removeAttribute('id'); });
        if (divClone.id) divClone.removeAttribute('id');
        divClone.removeAttribute('data-cf-shelter-bound');
        row.parentElement.insertBefore(divClone, clone);
      }
      /* Bind cycling on the whole cloned row — robust regardless of the inner
         markup / ids (cloneNode does not copy listeners, so a single handler
         on the row is the only binding and cannot double-fire). */
      if (!clone.getAttribute('data-cf-structure-bound')) {
        clone.setAttribute('data-cf-structure-bound', '1');
        clone.style.cursor = 'pointer';
        clone.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          _cycleStructure();
        });
      }
    }
    _dedupBannerDividers(row.parentElement);
    return true;
  }
  var _FLOORS = [1, 2, 3];
  function _cycleFloors() {
    var i = _FLOORS.indexOf(STATE.floors || 1);
    STATE.floors = _FLOORS[(i + 1) % _FLOORS.length];
    _pruneOpeningsAboveFloors();          /* drop windows/doors on floors that no longer exist */
    try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (_) {}
    if (typeof refreshUI === 'function') { try { refreshUI(); } catch (e) {} }
    _ShelterBanner.sync();
    if (typeof _forceRender3DFlush === 'function') { try { _forceRender3DFlush(2); } catch (e) {} }
  }

  var _ShelterBanner = {
    _els: null,
    _bound: false,
    init: function () {
      var self = this, tries = 0;
      function attempt() {
        tries++;
        self._bind();
        if (!self._bound && tries < 12) { setTimeout(attempt, 500); return; }
        self.sync();
      }
      attempt();
    },
    _bind: function () {
      if (this._bound) return;
      var sh = document.getElementById('cf-stat-edge-name');
      var rf = document.getElementById('cf-stat-surface-name');
      var fd = document.getElementById('cf-stat-material-name');
      var fl = document.getElementById('cf-stat-floors-name');
      if (!sh || !rf || !fd) return;
      this._els = { shape: sh, roof: rf, found: fd, floors: fl };
      function hook(ids, fn) {
        ids.forEach(function (id) {
          var el = document.getElementById(id);
          if (!el || el.getAttribute('data-cf-shelter-bound')) return;
          el.setAttribute('data-cf-shelter-bound', '1');
          el.style.cursor = 'pointer';
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            fn();
          });
        });
      }
      hook(['cf-info-edge', 'cf-btn-edge'], _cycleShelterShape);
      hook(['cf-info-surface', 'cf-btn-surface'], _cycleRoofType);
      hook(['cf-info-material', 'cf-btn-material'], _cycleFoundation);
      _ensureStructureRow();
      _ensureHeightRow();
      var whEl = document.getElementById('cf-stat-wallh-name');
      if (whEl) this._els.wallh = whEl;
      var stEl = document.getElementById('cf-stat-structure-name');
      if (stEl) {
        this._els.structure = stEl;
        try { var _sv = localStorage.getItem('mc:structureVariant'); if (_sv && _structOrder.indexOf(_sv) !== -1) STATE.structureVariant = _sv; } catch (e) {}
      }
      hook(['cf-info-floors-h', 'cf-btn-floors-h'], _cycleFloors);
      this._bound = true;
    },
    sync: function () {
      if (!this._bound || !this._els) return;
      var T = (global.BASE_BOOT || {}).i18n || {};
      function tt(k, f) {
        var v = T[k];
        if (typeof v !== 'string' || !v || /translation missing/i.test(v)) return f;
        return v;
      }
      var sh = STATE.shelterShape || 'I';
      this._els.shape.textContent = tt(_shapeKeys[sh], _shapeFallback[sh] || sh);
      var rt = STATE.shelterRoofType || 'sedlo';
      this._els.roof.textContent = tt(_roofKeys[rt], _roofFallback[rt] || rt);
      var fnd = STATE.shelterFoundation || 'slab';
      this._els.found.textContent = tt(_foundKeys[fnd], _foundFallback[fnd] || fnd);
      if (this._els.structure) {
        var stv = STATE.structureVariant || 'masonry';
        this._els.structure.textContent = tt(_structKeys[stv], _structFallback[stv] || stv);
      }
      if (this._els.floors) {
        var fc = STATE.floors || 1;
        this._els.floors.textContent = fc + (fc === 1 ? ' Floor' : ' Floors');
      }
      if (this._els.wallh) {
        this._els.wallh.textContent = tt('mcWallHeight', 'Wall height').toUpperCase();
        try { _ensureHeightSlider(); } catch (e) {}
      }
    }
  };
  function _updateShapeBtn() {
    var roofBtn = document.getElementById('cf-btn-roof-type');
    if (roofBtn && roofBtn.parentNode) roofBtn.parentNode.removeChild(roofBtn);
    var btn = document.getElementById('cf-btn-insert-corner');
    if (btn) {
      if (_shapeBtnOrigHTML === null) _shapeBtnOrigHTML = btn.innerHTML;
      if (_isGableShelter()) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
        if (_shapeBtnOrigHTML !== null) {
          btn.innerHTML = _shapeBtnOrigHTML;
          btn.title = 'Vlo\u017eit roh';
        }
      }
    }
    _ShelterBanner.sync();
  }

  function _carportRotPt(x, z, ang) {
    var c = Math.cos(ang), s = Math.sin(ang);
    return [x * c - z * s, x * s + z * c];
  }

  function _carportPrincipalAngle(poly) {
    var best = -1, bi = 0;
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (L > best) { best = L; bi = i; }
    }
    var a = poly[bi], b = poly[(bi + 1) % poly.length];
    return Math.atan2(b[1] - a[1], b[0] - a[0]);
  }

  function _carportPtInPoly(x, z, poly) {
    var inside = false, nn = poly.length;
    for (var i = 0, j = nn - 1; i < nn; j = i++) {
      var xi = poly[i][0], zi = poly[i][1], xj = poly[j][0], zj = poly[j][1];
      if (((zi > z) !== (zj > z)) && (x < (xj - xi) * (z - zi) / ((zj - zi) || 1e-9) + xi)) inside = !inside;
    }
    return inside;
  }

  function _carportMakeWing(s, eaveY, ov, u0, u1, v0, v1, th, Hforce, forceAlong) {
    var du = u1 - u0, dv = v1 - v0;
    var alongU = (forceAlong === 'u') ? true : (forceAlong === 'v') ? false : (du >= dv);
    var width = alongU ? dv : du;
    var coreLen = alongU ? du : dv;
    var half = width / 2 + ov;
    var rise = (Hforce != null) ? Hforce : half * Math.tan(s.pitchDeg * Math.PI / 180);
    var ridgeY = eaveY + rise;
    var rafterSlope = Math.hypot(half, rise);
    var aL, bL, dU, dV;
    if (alongU) { var vm = (v0 + v1) / 2; aL = [u0, vm]; bL = [u1, vm]; dU = [1, 0]; dV = [0, 1]; }
    else        { var um = (u0 + u1) / 2; aL = [um, v0]; bL = [um, v1]; dU = [0, 1]; dV = [1, 0]; }
    var A = _carportRotPt(aL[0], aL[1], th), B = _carportRotPt(bL[0], bL[1], th);
    var DU = _carportRotPt(dU[0], dU[1], th), DV = _carportRotPt(dV[0], dV[1], th);
    return {
      ax: { x: A[0], z: A[1] }, bx: { x: B[0], z: B[1] },
      dirU: { x: DU[0], z: DU[1] }, dirV: { x: DV[0], z: DV[1] },
      half: half, coreLen: coreLen, rise: rise, rafterSlope: rafterSlope,
      eaveY: eaveY, ridgeY: ridgeY, overhang: ov,
      rafterPairs: Math.max(2, Math.ceil(coreLen / s.rafter.spacing) + 1),
      battenRuns:  Math.max(2, Math.ceil(rafterSlope / s.batten.spacing) + 1)
    };
  }

  function _carportWings(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    var th = _carportPrincipalAngle(poly);

    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }

    var specs = null;
    var tol = 0.08, recti = (n === 4 || n === 6);
    if (recti) {
      for (var e = 0; e < n; e++) {
        var p = lp[e], r = lp[(e + 1) % n];
        if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) { recti = false; break; }
      }
    }
    if (recti && n === 4) specs = [{ r: [luMin, luMax, lvMin, lvMax], along: null }];
    else if (recti && n === 6) {
      var area = 0;
      for (var k = 0; k < n; k++) { var a1 = lp[k], a2 = lp[(k + 1) % n]; area += a1[0] * a2[1] - a2[0] * a1[1]; }
      var ccw = area > 0, reflex = -1;
      for (var k2 = 0; k2 < n; k2++) {
        var pa = lp[(k2 + n - 1) % n], pb = lp[k2], pc = lp[(k2 + 1) % n];
        var cr = (pb[0] - pa[0]) * (pc[1] - pb[1]) - (pb[1] - pa[1]) * (pc[0] - pb[0]);
        if (!(ccw ? (cr > 0) : (cr < 0))) { reflex = k2; break; }
      }
      if (reflex >= 0) {
        var rfx = lp[reflex][0], rfz = lp[reflex][1];
        var eps = Math.min(luMax - luMin, lvMax - lvMin) * 0.05 + 0.02;
        var corners = [[luMin, lvMin], [luMax, lvMin], [luMax, lvMax], [luMin, lvMax]];
        var nU = null, nV = null;
        for (var c2 = 0; c2 < 4; c2++) {
          var cu = corners[c2][0], cv = corners[c2][1];
          var tx = cu + (cu === luMin ? eps : -eps), tz = cv + (cv === lvMin ? eps : -eps);
          var wpt = _carportRotPt(tx, tz, th);
          if (!_carportPtInPoly(wpt[0], wpt[1], poly)) { nU = cu; nV = cv; break; }
        }
        if (nU !== null) {
          
          var aV0 = (nV === lvMax) ? lvMin : rfz;
          var aV1 = (nV === lvMax) ? rfz   : lvMax;
          var cvA = (aV0 + aV1) / 2;
          var bU0 = (nU === luMax) ? luMin : rfx;
          var bU1 = (nU === luMax) ? rfx   : luMax;
          var bV0 = (nV === lvMax) ? cvA : lvMin;
          var bV1 = (nV === lvMax) ? lvMax : cvA;
          specs = [
            { r: [luMin, luMax, aV0, aV1], along: 'u' },
            { r: [bU0, bU1, bV0, bV1],     along: 'v' }
          ];
        }
      }
    }
    if (!specs) specs = [{ r: [luMin, luMax, lvMin, lvMax], along: null }];

    var maxHalf = 0;
    for (var si = 0; si < specs.length; si++) {
      var sp = specs[si], du2 = sp.r[1] - sp.r[0], dv2 = sp.r[3] - sp.r[2];
      var aU = (sp.along === 'u') ? true : (sp.along === 'v') ? false : (du2 >= dv2);
      var hh = (aU ? dv2 : du2) / 2 + ov;
      if (hh > maxHalf) maxHalf = hh;
    }
    var H = maxHalf * Math.tan(pitch0);

    var wings = [];
    for (var sj = 0; sj < specs.length; sj++) {
      var sc = specs[sj];
      wings.push(_carportMakeWing(s, eaveY, ov, sc.r[0], sc.r[1], sc.r[2], sc.r[3], th, H, sc.along));
    }
    return wings;
  }

  function _carportLParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 6) return null;
    var th = _carportPrincipalAngle(poly);

    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }

    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }

    var area = 0;
    for (var k = 0; k < n; k++) { var a1 = lp[k], a2 = lp[(k + 1) % n]; area += a1[0] * a2[1] - a2[0] * a1[1]; }
    var ccw = area > 0, reflex = -1;
    for (var k2 = 0; k2 < n; k2++) {
      var pa = lp[(k2 + n - 1) % n], pb = lp[k2], pc = lp[(k2 + 1) % n];
      var cr = (pb[0] - pa[0]) * (pc[1] - pb[1]) - (pb[1] - pa[1]) * (pc[0] - pb[0]);
      if (!(ccw ? (cr > 0) : (cr < 0))) { reflex = k2; break; }
    }
    if (reflex < 0) return null;

    var rfx = lp[reflex][0], rfz = lp[reflex][1];
    var eps = Math.min(luMax - luMin, lvMax - lvMin) * 0.05 + 0.02;
    var corners = [[luMin, lvMin], [luMax, lvMin], [luMax, lvMax], [luMin, lvMax]];
    var nU = null, nV = null;
    for (var c2 = 0; c2 < 4; c2++) {
      var cu = corners[c2][0], cv = corners[c2][1];
      var tx = cu + (cu === luMin ? eps : -eps), tz = cv + (cv === lvMin ? eps : -eps);
      var wpt = _carportRotPt(tx, tz, th);
      if (!_carportPtInPoly(wpt[0], wpt[1], poly)) { nU = cu; nV = cv; break; }
    }
    if (nU === null) return null;

    var U = luMax - luMin, V = lvMax - lvMin;
    var a = (nU === luMax) ? (rfx - luMin) : (luMax - rfx);
    var b = (nV === lvMax) ? (rfz - lvMin) : (lvMax - rfz);
    if (a < 0.2 || b < 0.2 || a > U - 0.2 || b > V - 0.2) return null;

    var halfH = b / 2 + ov, halfV = a / 2 + ov;
    var H = Math.max(halfH, halfV) * Math.tan(pitch0);
    var yR = eaveY + H, yE = eaveY;

    function toW(cu, cv, y) {
      var lu = (nU === luMax) ? (luMin + cu) : (luMax - cu);
      var lv = (nV === lvMax) ? (lvMin + cv) : (lvMax - cv);
      var w = _carportRotPt(lu, lv, th);
      return [w[0], y, w[1]];
    }

    return { U: U, V: V, a: a, b: b, ov: ov, yR: yR, yE: yE, eaveY: eaveY, toW: toW };
  }

  function _carportTeeParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 8) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [], luMin = Infinity, luMax = -Infinity, lvMin = Infinity, lvMax = -Infinity;
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push(q);
      if (q[0] < luMin) luMin = q[0]; if (q[0] > luMax) luMax = q[0];
      if (q[1] < lvMin) lvMin = q[1]; if (q[1] > lvMax) lvMax = q[1];
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    var W = luMax - luMin, V = lvMax - lvMin;
    if (W < 1 || V < 1) return null;
    function inL(lu, lv) { var w = _carportRotPt(lu, lv, th); return _carportPtInPoly(w[0], w[1], poly); }
    function widthAtV(lv) {
      var lo = Infinity, hi = -Infinity, steps = 80;
      for (var k = 0; k <= steps; k++) { var lu = luMin + W * k / steps; if (inL(lu, lv)) { if (lu < lo) lo = lu; if (lu > hi) hi = lu; } }
      return hi > lo ? (hi - lo) : 0;
    }
    var eps = Math.min(W, V) * 0.04 + 0.02;
    var wMin = widthAtV(lvMin + eps), wMax = widthAtV(lvMax - eps);
    var frontAtMin = wMin >= wMax;
    var frontLV = frontAtMin ? lvMin : lvMax;
    var dir = frontAtMin ? 1 : -1;
    var frontW = frontAtMin ? wMin : wMax;
    if (frontW < W * 0.9) return null;
    function depthAt(lu) {
      var steps = 140, dmax = 0;
      for (var k = 0; k <= steps; k++) { var d = V * k / steps; if (inL(lu, frontLV + dir * d)) dmax = d; }
      return dmax;
    }
    var su = 90, prof = [];
    for (var k = 0; k <= su; k++) { var lu2 = luMin + W * k / su; prof.push([lu2, depthAt(lu2)]); }
    var dmaxAll = 0; for (var k2 = 0; k2 < prof.length; k2++) dmaxAll = Math.max(dmaxAll, prof[k2][1]);
    if (dmaxAll < 0.5) return null;
    var thr = dmaxAll - Math.min(W, V) * 0.06 - 0.05;
    var su0 = null, su1 = null;
    for (var k3 = 0; k3 < prof.length; k3++) { if (prof[k3][1] >= thr) { if (su0 === null) su0 = prof[k3][0]; su1 = prof[k3][0]; } }
    if (su0 === null) return null;
    if (su0 <= luMin + 0.15 || su1 >= luMax - 0.15) return null;
    function runDepth(uLo, uHi) {
      var vals = [];
      for (var k = 0; k < prof.length; k++) if (prof[k][0] > uLo + 0.05 && prof[k][0] < uHi - 0.05) vals.push(prof[k][1]);
      if (!vals.length) return 0;
      vals.sort(function (a, b) { return a - b; });
      return vals[Math.floor(vals.length / 2)];
    }
    var DL = runDepth(luMin, su0), DR = runDepth(su1, luMax), DS = dmaxAll;
    if (DL < 0.2 || DR < 0.2) return null;
    if (DS < Math.max(DL, DR) + 0.2) return null;
    var Dn = Math.min(DL, DR), R = Dn / 2;
    if (R < 0.2) return null;
    var H = eaveY + (R + ov) * Math.tan(pitch0);
    var cx = (su0 + su1) / 2;
    function P(lu, d, y) { var w = _carportRotPt(lu, frontLV + dir * d, th); return [w[0], y, w[1]]; }
    return { P: P, eaveY: eaveY, H: H, R: R, ov: ov, luMin: luMin, luMax: luMax, su0: su0, su1: su1, cx: cx, DL: DL, DR: DR, DS: DS };
  }

  function _carportUParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 8) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push([q[0], q[1]]);
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    function attempt(sw) {
      var pts = lp.map(function (p) { return sw ? [p[1], p[0]] : [p[0], p[1]]; });
      var xs = pts.map(function (p) { return p[0]; }), zs = pts.map(function (p) { return p[1]; });
      var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
      var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
      var W = xmax - xmin, V = zmax - zmin;
      if (W < 1 || V < 0.6) return null;
      function inLoc(x, z) {
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return _carportPtInPoly(w[0], w[1], poly);
      }
      var eps = Math.min(W, V) * 0.04 + 0.02;
      function fullRow(zc) {
        for (var t2 = 0; t2 < 20; t2++) {
          var x = xmin + W * (t2 + 0.5) / 20;
          if (!inLoc(x, zc)) return false;
        }
        return true;
      }
      var frontAtMin = fullRow(zmin + eps), frontAtMax = fullRow(zmax - eps);
      if (!frontAtMin && !frontAtMax) return null;
      var dir = frontAtMin ? 1 : -1;
      var frontZ = frontAtMin ? zmin : zmax;
      function depthAt(u) {
        var steps = 140, dm = 0;
        for (var k = 0; k <= steps; k++) {
          var d = V * k / steps;
          if (inLoc(xmin + u, frontZ + dir * d)) dm = d;
        }
        return dm;
      }
      var su = 110, prof = [], insU = Math.min(0.06, W * 0.005);
      for (var k2 = 0; k2 <= su; k2++) {
        var uu = insU + (W - 2 * insU) * k2 / su;
        prof.push([uu, depthAt(uu)]);
      }
      var dmin = Infinity, dmax = 0;
      for (var k3 = 1; k3 < prof.length - 1; k3++) {
        if (prof[k3][1] < dmin) dmin = prof[k3][1];
        if (prof[k3][1] > dmax) dmax = prof[k3][1];
      }
      if (!(dmax > dmin + 0.1)) return null;
      var thr = dmin + Math.min(0.3, (dmax - dmin) * 0.5);
      if (prof[0][1] < thr || prof[prof.length - 1][1] < thr) return null;
      var li = 0;
      while (li < prof.length && prof[li][1] >= thr) li++;
      var ri = prof.length - 1;
      while (ri >= 0 && prof[ri][1] >= thr) ri--;
      if (li <= 0 || ri >= prof.length - 1 || li > ri) return null;
      var AL = prof[li - 1][0], ARu = prof[ri + 1][0];
      var AR = W - ARu;
      function med(vals) {
        if (!vals.length) return 0;
        vals.sort(function (a, b) { return a - b; });
        return vals[Math.floor(vals.length / 2)];
      }
      var midVals = [], lVals = [], rVals = [];
      for (var k4 = 0; k4 < prof.length; k4++) {
        var u4 = prof[k4][0], d4 = prof[k4][1];
        if (u4 > AL + 0.05 && u4 < ARu - 0.05) midVals.push(d4);
        if (u4 < AL - 0.05) lVals.push(d4);
        if (u4 > ARu + 0.05) rVals.push(d4);
      }
      var B = med(midVals), VL = med(lVals), VR = med(rVals);
      function snapTo(v, arr, maxd) {
        var best = v, bd = maxd;
        for (var si = 0; si < arr.length; si++) {
          var dd = Math.abs(arr[si] - v);
          if (dd < bd) { bd = dd; best = arr[si]; }
        }
        return best;
      }
      var uCoords = xs.map(function (x) { return x - xmin; });
      var dCoords = zs.map(function (z) { return dir > 0 ? (z - zmin) : (zmax - z); });
      AL = snapTo(AL, uCoords, 0.25);
      ARu = snapTo(ARu, uCoords, 0.25);
      AR = W - ARu;
      B = snapTo(B, dCoords, 0.25);
      VL = snapTo(VL, dCoords, 0.25);
      VR = snapTo(VR, dCoords, 0.25);
      if (AL < 0.2 || AR < 0.2 || AL + AR > W - 0.3) return null;
      if (B < 0.2 || VL < 0.2 || VR < 0.2) return null;
      var half = Math.min(B / 2, AL / 2, AR / 2);
      var yR = eaveY + (half + ov) * Math.tan(pitch0);
      function P(u, d, y) {
        var x = xmin + u, z = frontZ + dir * d;
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return [w[0], y, w[1]];
      }
      return { P: P, eaveY: eaveY, yR: yR, ov: ov, W: W, B: B, AL: AL, AR: AR, VL: VL, VR: VR };
    }
    return attempt(false) || attempt(true);
  }

  function _carportHParams(poly) {
    var s = SHELTER_SPECS.carport;
    var pitch0 = s.pitchDeg * Math.PI / 180;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    var n = poly.length;
    if (n !== 12) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < n; i++) {
      var q = _carportRotPt(poly[i][0], poly[i][1], -th);
      lp.push([q[0], q[1]]);
    }
    var tol = 0.08;
    for (var e = 0; e < n; e++) {
      var p = lp[e], r = lp[(e + 1) % n];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    function attempt(sw) {
      var pts = lp.map(function (p) { return sw ? [p[1], p[0]] : [p[0], p[1]]; });
      var xs = pts.map(function (p) { return p[0]; }), zs = pts.map(function (p) { return p[1]; });
      var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
      var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
      var W = xmax - xmin, V = zmax - zmin;
      if (W < 1 || V < 1) return null;
      function inLoc(x, z) {
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return _carportPtInPoly(w[0], w[1], poly);
      }
      var su = 110, sv = 160, insU = Math.min(0.06, W * 0.005), insV = Math.min(0.05, V * 0.004);
      var cols = [];
      for (var k = 0; k <= su; k++) {
        var u = insU + (W - 2 * insU) * k / su;
        var lo = null, hi = null;
        for (var j = 0; j <= sv; j++) {
          var d = insV + (V - 2 * insV) * j / sv;
          if (inLoc(xmin + u, zmin + d)) {
            if (lo === null) lo = d;
            hi = d;
          }
        }
        if (lo === null) return null;
        cols.push([u, lo, hi]);
      }
      var simTol = 0.3;
      function sim(a, b) { return Math.abs(a[1] - b[1]) <= simTol && Math.abs(a[2] - b[2]) <= simTol; }
      var li = 1;
      while (li < cols.length && sim(cols[li], cols[0])) li++;
      var ri = cols.length - 2;
      while (ri >= 0 && sim(cols[ri], cols[cols.length - 1])) ri--;
      if (li > ri) return null;
      function med(vals) {
        if (!vals.length) return null;
        vals.sort(function (a, b) { return a - b; });
        return vals[Math.floor(vals.length / 2)];
      }
      var uLB = cols[li - 1][0], uRB = cols[ri + 1][0];
      var L0a = [], L1a = [], R0a = [], R1a = [], c0a = [], c1a = [];
      for (var k2 = 0; k2 < cols.length; k2++) {
        var cu = cols[k2][0];
        if (cu < uLB - 0.05) { L0a.push(cols[k2][1]); L1a.push(cols[k2][2]); }
        else if (cu > uRB + 0.05) { R0a.push(cols[k2][1]); R1a.push(cols[k2][2]); }
      }
      var L0 = med(L0a), L1 = med(L1a), R0 = med(R0a), R1 = med(R1a);
      if (L0 === null || R0 === null) return null;
      for (var k3 = 0; k3 < cols.length; k3++) {
        var cu3 = cols[k3][0];
        if (cu3 > uLB + 0.05 && cu3 < uRB - 0.05) {
          if (cols[k3][1] <= Math.max(L0, R0) + 0.1 && cols[k3][2] >= Math.min(L1, R1) - 0.1) continue;
          c0a.push(cols[k3][1]);
          c1a.push(cols[k3][2]);
        }
      }
      var c0 = med(c0a), c1 = med(c1a);
      if (c0 === null || c1 === null) return null;
      function rowFromLeft(zp) {
        var last = null;
        for (var kk = 0; kk <= su; kk++) {
          var xx = insU + (W - 2 * insU) * kk / su;
          if (inLoc(xmin + xx, zmin + zp)) last = xx;
          else if (last !== null) break;
        }
        return last;
      }
      function rowFromRight(zp) {
        var first = null;
        for (var kk = su; kk >= 0; kk--) {
          var xx = insU + (W - 2 * insU) * kk / su;
          if (inLoc(xmin + xx, zmin + zp)) first = xx;
          else if (first !== null) break;
        }
        return first;
      }
      var zLn = (L0 + c0) / 2, zLs = (c1 + L1) / 2;
      var zRn = (R0 + c0) / 2, zRs = (c1 + R1) / 2;
      var ALn = rowFromLeft(zLn), ALs = rowFromLeft(zLs);
      var ARnX = rowFromRight(zRn), ARsX = rowFromRight(zRs);
      if (ALn === null || ALs === null || ARnX === null || ARsX === null) return null;

      function snapTo(v, arr, maxd) {
        var best = v, bd = maxd;
        for (var si = 0; si < arr.length; si++) {
          var dd = Math.abs(arr[si] - v);
          if (dd < bd) { bd = dd; best = arr[si]; }
        }
        return best;
      }
      var uCoords = xs.map(function (x) { return x - xmin; });
      var dCoords = zs.map(function (z) { return z - zmin; });
      ALn = snapTo(ALn, uCoords, 0.25); ALs = snapTo(ALs, uCoords, 0.25);
      ARnX = snapTo(ARnX, uCoords, 0.25); ARsX = snapTo(ARsX, uCoords, 0.25);
      var ARn = W - ARnX, ARs = W - ARsX;
      L0 = snapTo(L0, dCoords, 0.25); L1 = snapTo(L1, dCoords, 0.25);
      R0 = snapTo(R0, dCoords, 0.25); R1 = snapTo(R1, dCoords, 0.25);
      c0 = snapTo(c0, dCoords, 0.25); c1 = snapTo(c1, dCoords, 0.25);
      if (ALn < 0.2 || ALs < 0.2 || ARn < 0.2 || ARs < 0.2) return null;
      if (Math.max(ALn, ALs) + Math.max(ARn, ARs) > W - 0.3) return null;
      if (!(L1 > L0 + 0.15) || !(R1 > R0 + 0.15) || !(c1 > c0 + 0.15)) return null;
      if (c0 < Math.max(L0, R0) + 0.05 || c1 > Math.min(L1, R1) - 0.05) return null;
      var tanP = Math.tan(pitch0);
      var minL = Math.min(ALn, ALs), minR = Math.min(ARn, ARs);
      var minAll = Math.min(minL, minR);
      var cxL = minL / 2, cxR = W - minR / 2;
      var yC = eaveY + (minAll / 2 + ov) * tanP;
      var yRL = yC, yRR = yC;
      function P(u, d, y) {
        var x = xmin + u, z = zmin + d;
        var lx = sw ? z : x, lz = sw ? x : z;
        var w = _carportRotPt(lx, lz, th);
        return [w[0], y, w[1]];
      }
      return { P: P, eaveY: eaveY, ov: ov, W: W, L0: L0, L1: L1, R0: R0, R1: R1, c0: c0, c1: c1, ALn: ALn, ALs: ALs, ARn: ARn, ARs: ARs, cxL: cxL, cxR: cxR, yRL: yRL, yRR: yRR };
    }
    return attempt(false) || attempt(true);
  }

  function _carportRectParams(poly) {
    var s = SHELTER_SPECS.carport;
    var eaveY = s.clearHeight + s.beam.h;
    var ov = s.overhangM;
    if (poly.length !== 4) return null;
    var th = _carportPrincipalAngle(poly);
    var lp = [];
    for (var i = 0; i < 4; i++) lp.push(_carportRotPt(poly[i][0], poly[i][1], -th));
    var tol = 0.08;
    for (var e = 0; e < 4; e++) {
      var p = lp[e], r = lp[(e + 1) % 4];
      if (Math.abs(p[0] - r[0]) > tol && Math.abs(p[1] - r[1]) > tol) return null;
    }
    var xs = lp.map(function (q) { return q[0]; }), zs = lp.map(function (q) { return q[1]; });
    var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs);
    var zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
    var W = xmax - xmin, D = zmax - zmin;
    if (W < 0.6 || D < 0.6) return null;
    var swap2 = D > W;
    var L = swap2 ? D : W, S = swap2 ? W : D;
    function P(u, v, y) {
      var lx = swap2 ? (xmin + v) : (xmin + u);
      var lz = swap2 ? (zmin + u) : (zmin + v);
      var w = _carportRotPt(lx, lz, th);
      return [w[0], y, w[1]];
    }
    return { P: P, eaveY: eaveY, ov: ov, L: L, S: S };
  }

  /* Outward edge-offset of a simple (convex or rectilinear-concave) polygon by
     d metres: each edge slides out along its outward normal and consecutive
     offset lines are intersected. Used to give roof skins an eave overhang
     past the footprint. */
  function _offsetPolyOut(poly, d) {
    var n = poly.length;
    if (n < 3 || !(d > 0)) return poly.map(function (p) { return [p[0], p[1]]; });
    var a2 = 0;
    for (var i = 0; i < n; i++) { var q = poly[i], r = poly[(i + 1) % n]; a2 += q[0] * r[1] - r[0] * q[1]; }
    var ccw = a2 > 0;
    var lines = [];
    for (var e = 0; e < n; e++) {
      var a = poly[e], b = poly[(e + 1) % n];
      var dx = b[0] - a[0], dz = b[1] - a[1], L = Math.hypot(dx, dz) || 1;
      var ux = dx / L, uz = dz / L;
      var nx = ccw ? uz : -uz, nz = ccw ? -ux : ux;   /* outward normal */
      lines.push({ px: a[0] + nx * d, pz: a[1] + nz * d, ux: ux, uz: uz });
    }
    var out = [];
    for (var k = 0; k < n; k++) {
      var l1 = lines[(k + n - 1) % n], l2 = lines[k];
      var den = l1.ux * (-l2.uz) - l1.uz * (-l2.ux);
      if (Math.abs(den) < 1e-9) { out.push([l2.px, l2.pz]); continue; }
      var bx = l2.px - l1.px, bz = l2.pz - l1.pz;
      var tt = (bx * (-l2.uz) - bz * (-l2.ux)) / den;
      out.push([l1.px + l1.ux * tt, l1.pz + l1.uz * tt]);
    }
    return out;
  }

  function _carportPolyTris(poly) {
    var pts = poly.map(function (p) { return [p[0], p[1]]; });
    var a2 = 0;
    for (var i = 0; i < pts.length; i++) { var q = pts[i], r = pts[(i + 1) % pts.length]; a2 += q[0] * r[1] - r[0] * q[1]; }
    if (a2 < 0) pts.reverse();
    var idx = []; for (var k = 0; k < pts.length; k++) idx.push(k);
    var tris = [], guard = 0;
    while (idx.length > 3 && guard++ < 999) {
      var done = false;
      for (var ii = 0; ii < idx.length; ii++) {
        var i0 = idx[(ii + idx.length - 1) % idx.length], i1 = idx[ii], i2 = idx[(ii + 1) % idx.length];
        var ax = pts[i0][0], ay = pts[i0][1], bx = pts[i1][0], by = pts[i1][1], cx = pts[i2][0], cy = pts[i2][1];
        var cr = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax);
        if (cr <= 1e-9) continue;
        var ok = true;
        for (var jj = 0; jj < idx.length; jj++) {
          var ij = idx[jj];
          if (ij === i0 || ij === i1 || ij === i2) continue;
          var px = pts[ij][0], py = pts[ij][1];
          var d1 = (bx - ax) * (py - ay) - (by - ay) * (px - ax);
          var d2 = (cx - bx) * (py - by) - (cy - by) * (px - bx);
          var d3 = (ax - cx) * (py - cy) - (ay - cy) * (px - cx);
          if (d1 >= 0 && d2 >= 0 && d3 >= 0) { ok = false; break; }
        }
        if (!ok) continue;
        tris.push([pts[i0], pts[i1], pts[i2]]);
        idx.splice(ii, 1); done = true; break;
      }
      if (!done) break;
    }
    if (idx.length === 3) tris.push([pts[idx[0]], pts[idx[1]], pts[idx[2]]]);
    return tris;
  }




  function _carportRoofComb(poly) {
    var s = SHELTER_SPECS.carport, pitch = s.pitchDeg * Math.PI / 180, eaveY = s.clearHeight + s.beam.h, ov = s.overhangM;
    function area(p){var a=0;for(var i=0;i<p.length;i++){var q=p[i],r=p[(i+1)%p.length];a+=q[0]*r[1]-r[0]*q[1];}return a/2;}
    function pin(x,z,pp){var c=false,N=pp.length;for(var i=0,j=N-1;i<N;j=i++){var A=pp[i],B=pp[j];if(((A[1]>z)!=(B[1]>z))&&(x<(B[0]-A[0])*(z-A[1])/(B[1]-A[1])+A[0]))c=!c;}return c;}
    function uniq(a){a=a.slice().sort(function(x,y){return x-y;});var u=[a[0]];for(var i=1;i<a.length;i++)if(a[i]-a[i-1]>1e-6)u.push(a[i]);return u;}
    function band(U,full){var bw=-1,ba=null,bb=null,ca=null;for(var i=0;i+1<U.length;i++){var mid=(U[i]+U[i+1])/2;if(full(mid)){if(ca===null)ca=U[i];}else{if(ca!==null){var w=U[i]-ca;if(w>bw){bw=w;ba=ca;bb=U[i];}ca=null;}}}if(ca!==null){var w2=U[U.length-1]-ca;if(w2>bw){bw=w2;ba=ca;bb=U[U.length-1];}}return bw<0?null:{a:ba,b:bb,w:bw};}
    var n = poly.length, th = _carportPrincipalAngle(poly), tol = 0.08;
    var lp = []; for (var i = 0; i < n; i++) { var q = _carportRotPt(poly[i][0], poly[i][1], -th); lp.push([q[0], q[1]]); }
    for (var e = 0; e < n; e++) { var P = lp[e], Q = lp[(e + 1) % n]; if (Math.abs(P[0] - Q[0]) > tol && Math.abs(P[1] - Q[1]) > tol) return null; }
    if (area(lp) < 0) lp.reverse();
    var xs = lp.map(function (p) { return p[0]; }), zs = lp.map(function (p) { return p[1]; });
    var xmin = Math.min.apply(0, xs), xmax = Math.max.apply(0, xs), zmin = Math.min.apply(0, zs), zmax = Math.max.apply(0, zs);
    var UX = uniq(xs), UZ = uniq(zs);
    function rowF(zc){for(var t=0;t<20;t++){var x=xmin+(xmax-xmin)*(t+0.5)/20;if(!pin(x,zc,lp))return false;}return true;}
    function colF(xc){for(var t=0;t<20;t++){var z=zmin+(zmax-zmin)*(t+0.5)/20;if(!pin(xc,z,lp))return false;}return true;}
    var hBand = band(UZ, rowF), vBand = band(UX, colF);
    if (!hBand && !vBand) return null;
    var hw = hBand ? hBand.w : -1, vw = vBand ? vBand.w : -1;
    var hBr = hBand && (hBand.w < (zmax - zmin) - tol), vBr = vBand && (vBand.w < (xmax - xmin) - tol);
    var swap;
    if (!hBr && !vBr) swap = ((xmax - xmin) >= (zmax - zmin)) ? false : true;
    else if (hBr && !vBr) swap = false;
    else if (vBr && !hBr) swap = true;
    else swap = (Math.abs(hw - vw) <= tol) ? (((xmax - xmin) >= (zmax - zmin)) ? false : true) : ((hw >= vw) ? false : true);
    var wp = lp.map(function (p) { return swap ? [p[1], p[0]] : [p[0], p[1]]; });
    if (area(wp) < 0) wp.reverse();
    var wxs = wp.map(function (p) { return p[0]; }), wzs = wp.map(function (p) { return p[1]; });
    var Wxmin = Math.min.apply(0, wxs), Wxmax = Math.max.apply(0, wxs), Wzmin = Math.min.apply(0, wzs), Wzmax = Math.max.apply(0, wzs);
    var WUX = uniq(wxs), WUZ = uniq(wzs);
    function wIn(x, z) { return pin(x, z, wp); }
    function wrowF(zc){for(var t=0;t<20;t++){var x=Wxmin+(Wxmax-Wxmin)*(t+0.5)/20;if(!pin(x,zc,wp))return false;}return true;}
    var mb = band(WUZ, wrowF); if (!mb) return null;
    var mz0 = mb.a, mz1 = mb.b, zm = (mz0 + mz1) / 2, halfMain = (mz1 - mz0) / 2;
    var H = (halfMain + ov) * Math.tan(pitch), yR = eaveY + H, X0 = Wxmin, X1 = Wxmax;
    function findBr(side) {
      var brs = [], ca = null;
      for (var i = 0; i + 1 < WUX.length; i++) { var xmid = (WUX[i] + WUX[i + 1]) / 2; var probe = side < 0 ? mz0 - 1e-3 : mz1 + 1e-3; if (wIn(xmid, probe)) { if (ca === null) ca = WUX[i]; } else { if (ca !== null) { brs.push([ca, WUX[i]]); ca = null; } } }
      if (ca !== null) brs.push([ca, WUX[WUX.length - 1]]);
      return brs.map(function (b) { var xmid = (b[0] + b[1]) / 2, far; if (side < 0) { far = mz0; for (var z = mz0; z > Wzmin - 1; z -= 0.05) { if (wIn(xmid, z - 1e-3)) far = z - 0.05; else break; } far = Math.max(far, Wzmin); } else { far = mz1; for (var z = mz1; z < Wzmax + 1; z += 0.05) { if (wIn(xmid, z + 1e-3)) far = z + 0.05; else break; } far = Math.min(far, Wzmax); } var best = far, bd = 1e9; WUZ.forEach(function (zz) { if (Math.abs(zz - far) < bd) { bd = Math.abs(zz - far); best = zz; } }); return { x0: b[0], x1: b[1], side: side, far: best }; });
    }
    var branches = findBr(-1).concat(findBr(1));
    var rateM = H / (halfMain + ov);
    function toW(x, z, y) { var lx = swap ? z : x, lz = swap ? x : z; var w = _carportRotPt(lx, lz, th); return [w[0], y, w[1]]; }
    var faces = [], beams = [];
    function FACE(pp) { faces.push(pp.map(function (p) { return toW(p[0], p[1], p[2]); })); }
    function BEAM(a, b, ridge) { beams.push({ a: toW(a[0], a[1], a[2]), b: toW(b[0], b[1], b[2]), ridge: !!ridge }); }
    var south = branches.filter(function (b) { return b.side < 0; }).sort(function (a, b) { return a.x0 - b.x0; });
    var north = branches.filter(function (b) { return b.side > 0; }).sort(function (a, b) { return a.x0 - b.x0; });
    BEAM([X0 - ov, zm, yR], [X1 + ov, zm, yR], true);
    (function () { var pts = []; pts.push([X0 - ov, zm, yR]); pts.push([X0 - ov, mz0 - ov, eaveY]); for (var i = 0; i < south.length; i++) { var b = south[i], xm = (b.x0 + b.x1) / 2; pts.push([b.x0 - ov, mz0 - ov, eaveY]); pts.push([xm, zm, yR]); pts.push([b.x1 + ov, mz0 - ov, eaveY]); } pts.push([X1 + ov, mz0 - ov, eaveY]); pts.push([X1 + ov, zm, yR]); FACE(pts); })();
    (function () { var pts = []; pts.push([X1 + ov, zm, yR]); pts.push([X1 + ov, mz1 + ov, eaveY]); for (var i = north.length - 1; i >= 0; i--) { var b = north[i], xm = (b.x0 + b.x1) / 2; pts.push([b.x1 + ov, mz1 + ov, eaveY]); pts.push([xm, zm, yR]); pts.push([b.x0 - ov, mz1 + ov, eaveY]); } pts.push([X0 - ov, mz1 + ov, eaveY]); pts.push([X0 - ov, zm, yR]); FACE(pts); })();
    branches.forEach(function (b) {
      var xm = (b.x0 + b.x1) / 2, hb = (b.x1 - b.x0) / 2, n_ = b.side > 0;
      var zEaveEdge = n_ ? mz1 + ov : mz0 - ov, zGable = n_ ? b.far + ov : b.far - ov;
      var wEave = b.x0 - ov, eEave = b.x1 + ov;
      var westInterior = (b.x0 > X0 + 1e-3), eastInterior = (b.x1 < X1 - 1e-3);
      BEAM([xm, zGable, yR], [xm, zm, yR], true);
      if (westInterior) BEAM([xm, zm, yR], [wEave, zEaveEdge, eaveY], true);
      if (eastInterior) BEAM([xm, zm, yR], [eEave, zEaveEdge, eaveY], true);
      FACE([[wEave, zGable, eaveY], [xm, zGable, yR], [xm, zm, yR], [wEave, zEaveEdge, eaveY]]);
      FACE([[eEave, zGable, eaveY], [xm, zGable, yR], [xm, zm, yR], [eEave, zEaveEdge, eaveY]]);
    });
    var hsp = s.rafter.spacing, nM = Math.max(1, Math.round((X1 - X0) / hsp));
    for (var i2 = 0; i2 <= nM; i2++) { var x = X0 + (X1 - X0) * i2 / nM; BEAM([x, mz0 - ov, eaveY], [x, zm, yR], false); BEAM([x, mz1 + ov, eaveY], [x, zm, yR], false); }
    branches.forEach(function (b) { var xm = (b.x0 + b.x1) / 2, n_ = b.side > 0; var zJ = zm, zG = (n_ ? b.far + ov : b.far - ov); var z0 = Math.min(zJ, zG), z1 = Math.max(zJ, zG); var nb = Math.max(1, Math.round((z1 - z0) / hsp)); var wEave = b.x0 - ov, eEave = b.x1 + ov; for (var i = 0; i <= nb; i++) { var z = z0 + (z1 - z0) * i / nb; BEAM([wEave, z, eaveY], [xm, z, yR], false); BEAM([eEave, z, eaveY], [xm, z, yR], false); } });
    var skin = [];
    for (var fi = 0; fi < faces.length; fi++) { var f = faces[fi]; var A = f[0], B = f[1], C = f[2]; var ux = B[0] - A[0], uy = B[1] - A[1], uz = B[2] - A[2], vx = C[0] - A[0], vy = C[1] - A[1], vz = C[2] - A[2]; var nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx, NL = Math.hypot(nx, ny, nz); nx /= NL; ny /= NL; nz /= NL; var ex = ux, ey = uy, ez = uz, EL = Math.hypot(ex, ey, ez); ex /= EL; ey /= EL; ez /= EL; var gx = ny * ez - nz * ey, gy = nz * ex - nx * ez, gz = nx * ey - ny * ex; var p2 = f.map(function (p) { return [(p[0] - A[0]) * ex + (p[1] - A[1]) * ey + (p[2] - A[2]) * ez, (p[0] - A[0]) * gx + (p[1] - A[1]) * gy + (p[2] - A[2]) * gz]; }); var idx = []; for (var k = 0; k < p2.length; k++) idx.push(k); var a2 = 0; for (var k2 = 0; k2 < p2.length; k2++) { var q1 = p2[k2], q2 = p2[(k2 + 1) % p2.length]; a2 += q1[0] * q2[1] - q2[0] * q1[1]; } if (a2 < 0) idx.reverse(); var guard = 0; while (idx.length > 3 && guard++ < 999) { var done = false; for (var ii = 0; ii < idx.length; ii++) { var i0 = idx[(ii + idx.length - 1) % idx.length], i1 = idx[ii], iq = idx[(ii + 1) % idx.length]; var ax = p2[i0][0], ay = p2[i0][1], bx = p2[i1][0], by = p2[i1][1], cx = p2[iq][0], cy = p2[iq][1]; var cr = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax); if (cr <= 1e-9) continue; var ok = true; for (var jj = 0; jj < idx.length; jj++) { var ij = idx[jj]; if (ij === i0 || ij === i1 || ij === iq) continue; var px = p2[ij][0], py = p2[ij][1]; var d1 = (bx - ax) * (py - ay) - (by - ay) * (px - ax); var d2 = (cx - bx) * (py - by) - (cy - by) * (px - bx); var d3 = (ax - cx) * (py - cy) - (ay - cy) * (px - cx); if (d1 >= 0 && d2 >= 0 && d3 >= 0) { ok = false; break; } } if (!ok) continue; skin.push([f[i0], f[i1], f[iq]]); idx.splice(ii, 1); done = true; break; } if (!done) break; } if (idx.length === 3) skin.push([f[idx[0]], f[idx[1]], f[idx[2]]]); }
    return { skin: skin, beams: beams };
  }

  /* Live 3D shows the roof as a plain shape representative (skin only); the
     full timber construction is rebuilt only for the AR/GLB export. */
  var _roofDetailExport = false;
  /* AR per-storey selection: -1 = whole house, 0..floors-1 = a single storey */
  var _arFloorSel = -1;
  var HOUSE_BASE_CLEAR = 2.40;   /* base eave height (single storey) */
  var HOUSE_STOREY_H   = 2.80;   /* added wall height per extra storey */

  function _carportGeom() {
    var s    = SHELTER_SPECS.carport;
    var poly = getFootprintPolygon();
    var n = poly.length, perim = 0;
    for (var i = 0; i < n; i++) { var a = poly[i], b = poly[(i + 1) % n]; perim += Math.hypot(b[0] - a[0], b[1] - a[1]); }
    var eaveY = s.clearHeight + s.beam.h;
    var wings = [];
    try { wings = _carportWings(poly); } catch (e) { wings = []; }
    if (!wings || !wings.length) {
      var bb = _carportBBox(poly), ax = (bb.L >= bb.W);
      var half = (ax ? bb.W : bb.L) / 2 + s.overhangM;
      var pitch = s.pitchDeg * Math.PI / 180, rise = half * Math.tan(pitch);
      wings = [{
        ax: { x: ax ? bb.xMin : bb.cx, z: ax ? bb.cz : bb.zMin },
        bx: { x: ax ? bb.xMax : bb.cx, z: ax ? bb.cz : bb.zMax },
        dirU: { x: ax ? 1 : 0, z: ax ? 0 : 1 }, dirV: { x: ax ? 0 : 1, z: ax ? 1 : 0 },
        half: half, coreLen: (ax ? bb.L : bb.W), rise: rise, rafterSlope: Math.hypot(half, rise),
        eaveY: eaveY, ridgeY: eaveY + rise, overhang: s.overhangM,
        rafterPairs: Math.max(2, Math.ceil((ax ? bb.L : bb.W) / s.rafter.spacing) + 1),
        battenRuns:  Math.max(2, Math.ceil(Math.hypot(half, rise) / s.batten.spacing) + 1)
      }];
    }
    var ridgeLen = 0, roofArea = 0, rafterTotal = 0, battenTotal = 0, ridgeYmax = eaveY;
    for (var w = 0; w < wings.length; w++) {
      var wg = wings[w];
      ridgeLen    += wg.coreLen;
      roofArea    += 2 * (wg.coreLen + 2 * wg.overhang) * wg.rafterSlope;
      rafterTotal += wg.rafterPairs * 2 * wg.rafterSlope;
      battenTotal += wg.battenRuns * (wg.coreLen + 2 * wg.overhang);
      if (wg.ridgeY > ridgeYmax) ridgeYmax = wg.ridgeY;
    }
    return {
      s: s, poly: poly, corners: n, perim: perim, wings: wings,
      ridgeLen: ridgeLen, roofAreaM2: roofArea, rafterTotalLen: rafterTotal,
      battenTotalLen: battenTotal, eaveY: eaveY, ridgeY: ridgeYmax
    };
  }

  function _computeCarportBoQ() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];
    var g = _carportGeom(), s = g.s, rows = [];
    rows.push(_rowM(s.post.code,   g.corners * s.clearHeight));
    rows.push(_rowM(s.beam.code,   g.perim));
    rows.push(_rowM(s.ridge.code,  g.ridgeLen));
    rows.push(_rowM(s.rafter.code, g.rafterTotalLen));
    rows.push(_rowM(s.batten.code, g.battenTotalLen));
    var footVol = g.corners * Math.PI * (s.footing.dia / 2) * (s.footing.dia / 2) * s.footing.depth;
    rows.push(_rowM3(s.footing.code, footVol));

    return rows;
  }

  function computeBoQ() {
    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];
    var rows = _isCarport() ? (_computeCarportBoQ() || []) : [];
    /* windows + doors are placed in the main house, so their cost belongs to
       the main-house budget. Append one row per opening SKU, counted in pieces
       (metric === imperial), joining the Central BoQ by the SKU code. */
    try {
      var ob = _Openings._boqRows();
      for (var oi = 0; oi < ob.length; oi++) {
        if (ob[oi] && ob[oi].boq) rows.push([ob[oi].boq, ob[oi].qty, ob[oi].qty]);
      }
    } catch (e) {}
    return rows;
  }

  var _publishTimer = null;

  function _round2(v) {
    if (typeof v !== 'number' || !isFinite(v)) return v;
    return Math.round(v * 100) / 100;
  }

  function publishBoQToBudget() {
    var rows = computeBoQ();

    var variantData = [['id', 'metric', 'imperial'], ['', '', '']];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      variantData.push([r[0], _round2(r[1]).toFixed(3), _round2(r[2]).toFixed(3)]);
    }
    global.ConfiguratorBoQ = {
      source: 'shelters',
      variantData: variantData,
      dimensions: {}
    };
    global._poolVariantData = variantData;
    if (typeof global.loadVariantCSV === 'function') {
      try { global.loadVariantCSV('synthetic://pool'); } catch (e) {}
    }
  }

  function _debouncedPublishBoQ() {
    if (_publishTimer) clearTimeout(_publishTimer);
    _publishTimer = setTimeout(publishBoQToBudget, 400);
  }

  function getCountForInfoBar() {
    try { return _carportGeom().corners; } catch (_) { return 0; }
  }

  function getCountLabel() {
    var i18n = (global.BASE_BOOT || {}).i18n || {};
    return i18n.mcFloorArea || 'FLOOR AREA';
  }

  function getBlockCount() { return 0; }

  function refreshInfoBar() {
    var area = computeArea();
    function setTxt(id, v) { var el = document.getElementById(id); if (el) el.textContent = v; }
    setTxt('cf-stat-area', fmtLen(area, { area: true, precision: 1 }));
    setTxt('cf-stat-area-unit', areaUnitLabel());

    ['cf-info-height', 'cf-info-blocks', 'cf-info-blocks-sep', 'cf-info-style',
     'cf-stat-spacing-sep', 'cf-stat-spacing-item'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.style.display = 'none';
    });

    var _floorA = 0; try { _floorA = _Partitions._netFloorAreaAllFloors(); } catch (e) { _floorA = 0; }
    setTxt('cf-stat-count', fmtLen(_floorA, { area: true, precision: 1 }));
    setTxt('cf-stat-count-unit', areaUnitLabel());
    var cLabel = document.getElementById('cf-stat-count-label');
    if (cLabel) cLabel.textContent = getCountLabel();
    var cItem = document.getElementById('cf-stat-count-item');
    if (cItem) cItem.style.visibility = 'visible';
    var cSep = document.getElementById('cf-stat-count-item-sep');
    if (cSep) cSep.style.display = '';
  }

  function refreshUI(skipPublish) {
    refreshInfoBar();
    if (global.BaseRenderer && typeof global.BaseRenderer.build === 'function') {
      global.BaseRenderer.build();
    }
    if (typeof _applyAssemblyStep === 'function') _applyAssemblyStep();

    try {
      if (!_anyHandleDragging) {
        var poly = getFootprintPolygon();
        var want = (poly ? poly.length * 2 : 0);
        if (want !== _handleEls.length) rebuildDragHandles();
      }
    } catch (_) {}
    try { _updateShapeBtn(); } catch (_) {}
    positionDragHandles();
    if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
    if (!skipPublish) _debouncedPublishBoQ();
    if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
  }

  var _UndoHistory = {
    _stack: [],
    _MAX:   50,

    push: function () {
      var snap = {
        polygon: JSON.parse(JSON.stringify(STATE.polygon)),
        variant: STATE.variant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    pop: function () {
      if (!this._stack.length) return null;
      var snap = this._stack.pop();
      this._updateButton();
      return snap;
    },

    canUndo: function () {
      return this._stack.length > 0;
    },

    isResetMode: function () {
      return this._stack.length === 0;
    },

    pushIfChanged: function (prevPolygon, prevVariant) {
      var sameVariant = (prevVariant === STATE.variant);
      var samePoly = JSON.stringify(prevPolygon) === JSON.stringify(STATE.polygon);
      if (sameVariant && samePoly) return;
      var snap = {
        polygon: JSON.parse(JSON.stringify(prevPolygon)),
        variant: prevVariant
      };
      this._stack.push(snap);
      if (this._stack.length > this._MAX) this._stack.shift();
      this._updateButton();
    },

    clear: function () {
      this._stack = [];
      this._updateButton();
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-undo');
      if (!btn) return;
      var resetMode = this.isResetMode();

      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor  = 'pointer';
      btn.title         = resetMode ? 'Reset to default' : 'Undo';
      btn.setAttribute('aria-label', resetMode ? 'Reset to default' : 'Undo');
      btn.classList.toggle('cf-undo-reset-mode', resetMode);
    }
  };

  function undo() {

    if (_UndoHistory.isResetMode()) {
      reset();
      return;
    }
    var snap = _UndoHistory.pop();
    if (!snap) return;
    STATE.polygon = snap.polygon;
    if (typeof snap.variant === 'number') STATE.variant = snap.variant;
    if (typeof snap.lvl === 'number') STATE.lvl = snap.lvl;
    rebuildDragHandles();
    _updateLvlButton();
    selectVariant(STATE.variant, true);
    refreshUI();
  }

  function reset() {
    var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
    var prevVariant = STATE.variant;
    var prevLvl = STATE.lvl;
    var fresh = JSON.parse(JSON.stringify(DEFAULTS));
    for (var k in fresh) {
      if (fresh.hasOwnProperty(k)) STATE[k] = fresh[k];
    }
    _UndoHistory._stack.push({
      polygon: prevPoly, variant: prevVariant, lvl: prevLvl
    });
    _UndoHistory._updateButton();
    _updateLvlButton();

    selectVariant(STATE.variant);
    STATE.skimmers = null; STATE.jets = null; STATE.lights = null;
    STATE.shaft = null; STATE.panel = null; STATE.tank = null;
    rebuildDragHandles();
    refreshUI();
  }

  function cycleLvl() {
    _UndoHistory._stack.push({
      polygon: JSON.parse(JSON.stringify(STATE.polygon)),
      variant: STATE.variant,
      lvl: STATE.lvl
    });
    _UndoHistory._updateButton();
    STATE.lvl = (STATE.lvl >= 3) ? 1 : (STATE.lvl + 1);
    _updateLvlButton();
    _showLvlAvatar();
    refreshUI();
  }

  function _showLvlAvatar() {
    var img = document.getElementById('cf-lvl-avatar');
    if (!img) return;
    var boot = global.BASE_BOOT || {};
    var url = boot.lvlAvatars && boot.lvlAvatars[STATE.lvl];
    if (!url) return;
    img.classList.remove('cf-lvl-avatar-show');
    img.style.display = 'none';
    if (img.src !== url) {
      img.src = url;
    }
    void img.offsetWidth;
    img.style.display = '';
    img.classList.add('cf-lvl-avatar-show');
  }

  function _preloadLvlAvatars() {
    var boot = global.BASE_BOOT || {};
    var avatars = boot.lvlAvatars || {};
    for (var k in avatars) {
      if (avatars.hasOwnProperty(k)) {
        var preImg = new Image();
        preImg.src = avatars[k];
      }
    }
  }

  function _updateLvlButton() {
    var btn = document.getElementById('cf-btn-lvl');
    if (!btn) return;
    btn.classList.toggle('active', STATE.lvl !== 1);
    btn.setAttribute('data-lvl', String(STATE.lvl));
    btn.setAttribute('aria-pressed', STATE.lvl !== 1 ? 'true' : 'false');
    var needle = document.getElementById('cf-lvl-needle');
    if (needle) {
      var deg = (STATE.lvl === 1) ? -60 : (STATE.lvl === 2) ? 0 : 60;
      needle.style.transform = 'rotate(' + deg + 'deg)';
    }
  }



  var _SlopeManager = {
    init: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.toggle(); });
      this._wireSlider();
      this._injectArrow();
      this._updateAll();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-slope-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 15;
      var self = this;
      var updateFill = function (val) {
        var fillPct = 100 - (val / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var v = parseInt(slider.value, 10) || 0;
        STATE.slopeDeg = v;
        updateFill(v);
        var lbl = document.getElementById('cf-slope-value');
        if (lbl) lbl.textContent = v + '\u00b0';
        self._updateArrow();
        if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        refreshUI();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      slider.value = STATE.slopeDeg;
      updateFill(STATE.slopeDeg);
      var lbl = document.getElementById('cf-slope-value');
      if (lbl) lbl.textContent = STATE.slopeDeg + '\u00b0';
    },

    _injectArrow: function () {
      if (document.getElementById('cf-slope-arrow')) return;
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
      var slopeLabel = TT.slopeArrowLabel || 'SLOPE';
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.id = 'cf-slope-arrow';
      svg.setAttribute('viewBox', '0 0 100 36');
      svg.style.cssText = [
        'position:absolute', 'left:15%', 'top:50%',
        'transform:translate(-50%, -50%)',
        'width:100px', 'height:36px',
        'pointer-events:none', 'display:none', 'z-index:9'
      ].join(';');
      svg.innerHTML = [
        '<line x1="6" y1="18" x2="86" y2="18" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round"/>',
        '<polyline points="78,10 90,18 78,26" fill="none" stroke="#D2A878" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>',
        '<text x="48" y="34" text-anchor="middle" font-family="Montserrat, system-ui, sans-serif" font-size="9" font-weight="700" fill="#D2A878" id="cf-slope-arrow-label">' + slopeLabel + '</text>'
      ].join('');
      wrap.appendChild(svg);
    },

    _updateArrow: function () {
      var svg = document.getElementById('cf-slope-arrow');
      if (!svg) return;
      var visible = STATE.slopeActive && STATE.view === '2d';
      svg.style.display = visible ? 'block' : 'none';
      var lbl = document.getElementById('cf-slope-arrow-label');
      if (lbl) {
        var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
        lbl.textContent = TT.slopeArrowLabel || 'SLOPE';
      }
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-slope');
      if (!btn) return;
      btn.classList.toggle('active', STATE.slopeActive);
      btn.setAttribute('aria-pressed', STATE.slopeActive ? 'true' : 'false');
    },

    _updateSlider: function () {
      var wrap = document.getElementById('cf-slope-slider-wrap');
      if (!wrap) return;
      var visible = STATE.slopeActive && STATE.view === '2d' && STATE.vizStage !== 1;
      wrap.classList.toggle('cf-slope-visible', visible);
    },

    _updateAll: function () {
      this._updateButton();
      this._updateSlider();
      this._updateArrow();
    },

    toggle: function () {
      STATE.slopeActive = !STATE.slopeActive;
      if (STATE.slopeActive && STATE.view !== '2d') {
        if (global.BaseEngine && global.BaseEngine.toggleView) {
          global.BaseEngine.toggleView();
        }
      }
      this._updateAll();
      if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      refreshUI();
    }
  };

  function _updateMapLockButton() {
    var btn = document.getElementById('cf-map-lock');
    if (!btn) return;
    btn.classList.toggle('locked', !!STATE.mapLocked);
    btn.setAttribute('aria-pressed', STATE.mapLocked ? 'true' : 'false');
    btn.title = STATE.mapLocked ? 'Unlock map position' : 'Lock map position';
    var shackle = document.getElementById('cf-map-lock-shackle');
    if (shackle) {
      shackle.setAttribute('d', STATE.mapLocked
        ? 'M8 11V7a4 4 0 0 1 8 0v4'
        : 'M8 11V7a4 4 0 0 1 7-2.65');
    }
    _applyMapLockState();
  }

  function _applyMapLockState() {
    if (!_MapManager || !_MapManager.map) return;
    var m = _MapManager.map;
    var locked = !!STATE.mapLocked;
    try {
      if (locked) {
        m.dragPan.disable();
        m.scrollZoom.disable();
        m.boxZoom.disable();
        m.dragRotate.disable();
        m.doubleClickZoom.disable();
        m.touchZoomRotate.disable();
      } else {
        m.dragPan.enable();
        m.scrollZoom.enable();
        m.boxZoom.enable();
        m.dragRotate.enable();
        m.doubleClickZoom.enable();
        m.touchZoomRotate.enable();
      }
    } catch (e) {}
    var rotateInput = document.getElementById('cf-map-rotate');
    if (rotateInput) {
      rotateInput.disabled = locked;
      rotateInput.style.opacity = locked ? '0.4' : '';
      rotateInput.style.pointerEvents = locked ? 'none' : '';
    }
  }








  function _forceRender3DFlush(level) {
    if (STATE.view !== '3d') return;
    var eng = global.BaseEngine;
    if (!eng) return;

    var lvl = (level === true) ? 2 : (level === false ? 0 : (level | 0));

    function _doRender() {
      try {
        if (STATE.view === '3d' && eng.renderer && eng.scene && eng.camera) {
          eng.renderer.render(eng.scene, eng.camera);
        }
      } catch (e) {}
    }

    _doRender();
    if (global.requestAnimationFrame) global.requestAnimationFrame(_doRender);

    if (lvl >= 1) {
      try {
        var canvas = eng.renderer && eng.renderer.domElement;
        if (canvas && global.requestAnimationFrame) {
          var prev = canvas.style.opacity;
          canvas.style.opacity = '0.999';
          global.requestAnimationFrame(function () {
            canvas.style.opacity = prev || '';
            _doRender();
          });
        }
      } catch (e) {}
    }

    if (lvl >= 2 && eng.toggleView) {
      try {
        var savedStage = STATE.vizStage;
        eng.toggleView();
        eng.toggleView();

        var changed = false;
        if (savedStage && savedStage !== STATE.vizStage) {
          STATE.vizStage = savedStage; changed = true;
        }
        if (changed) {
          if (_VisualizationManager && _VisualizationManager.apply) {
            _VisualizationManager.apply();
          }

        }
      } catch (e) {}
    }
  }

  function toggleUnits() {
    STATE.isMetric = !STATE.isMetric;
    resnapModelToGrid();
    if (global.BaseEngine) _rebuildGrid(global.BaseEngine);
    if (STATE.view === '3d' && global.BaseRenderer && global.BaseRenderer.build) {
      global.BaseRenderer.build();
    }
    refreshUI(true);
    _forceRender3DFlush(2);
    _broadcastUnitToBudget();
  }

  function _broadcastUnitToBudget() {
    var sel = document.getElementById('unitSelector');
    if (sel) {
      sel.setAttribute('data-current-unit', STATE.isMetric ? 'metric' : 'imperial');
      sel.dispatchEvent(new CustomEvent('unitChange', {
        detail: { unit: STATE.isMetric ? 'metric' : 'imperial' }, bubbles: true
      }));
    }
  }

  function _syncFromBudgetUnit() {
    var sel = document.getElementById('unitSelector');
    if (!sel) return;
    var u = sel.getAttribute('data-current-unit');
    var nextMetric = (u !== 'imperial');
    if (STATE.isMetric !== nextMetric) {
      STATE.isMetric = nextMetric;
      resnapModelToGrid();
      if (global.BaseEngine) _rebuildGrid(global.BaseEngine);

      if (STATE.view === '3d' && global.BaseRenderer && global.BaseRenderer.build) {
        global.BaseRenderer.build();
      }
      refreshUI(true);
      _forceRender3DFlush(2);
    }
  }

  var POOL_VARIANT_COUNT = 1;

  var _variantSwitchTs = 0;
  function selectVariant(n, silent) {
    if (n < 1 || n > POOL_VARIANT_COUNT) return;
    if (!silent) {
      if (n === STATE.variant) return;
      var nowTs = Date.now();
      if (nowTs - _variantSwitchTs < 250) return;
      _variantSwitchTs = nowTs;
      _UndoHistory.pushIfChanged(STATE.polygon, STATE.variant);
    }
    STATE.variant = n;
    STATE.depth = null;
    if (_VisualizationManager && _VisualizationManager.reset) _VisualizationManager.reset();
    _syncVariantNameDisplay();
    if (!silent) _syncShopifyVariant(n);
    refreshUI();
    _forceRender3DFlush(2);
  }

  function nextVariant() {
    var n = STATE.variant + 1;
    if (n > POOL_VARIANT_COUNT) n = 1;
    selectVariant(n);
  }

  function prevVariant() {
    var n = STATE.variant - 1;
    if (n < 1) n = POOL_VARIANT_COUNT;
    selectVariant(n);
  }

  var POOL_VARIANT_FALLBACK_NAMES = ['Block Pool', 'Gunite Pool'];

  function _syncVariantNameDisplay() {
    var nameEl = document.getElementById('cf-base-variant-name');
    if (!nameEl) return;
    var banner = nameEl.closest ? nameEl.closest('.cf-base-variant-banner') : null;
    if (!banner) banner = nameEl.parentElement;
    if (banner) banner.style.display = 'none';
    _syncWipWatermark();
  }

  var POOL_WIP_VARIANTS = { gunite: true };
  function _syncWipWatermark() {
    var el = document.getElementById('cf-wip-watermark');
    if (!el) return;
    el.classList.toggle('cf-wip-active', false);
  }

  function _syncShopifyVariant(n) {
    var boot = global.BASE_BOOT;
    if (!boot || !boot.variants || !boot.variants[n - 1]) return;
    var v = boot.variants[n - 1];
    if (!v || !v.id) return;
    try {
      var url = new URL(global.location.href);
      url.searchParams.set('variant', String(v.id));
      global.history.replaceState({}, '', url.toString());
    } catch (e) {}

    var selectors = document.querySelectorAll('select[name="id"], input[name="id"]');
    selectors.forEach(function (sel) {
      if (sel.tagName === 'SELECT') {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === String(v.id)) { sel.selectedIndex = i; break; }
        }
      } else {
        sel.value = String(v.id);
      }
    });

    document.dispatchEvent(new CustomEvent('base:variantChanged', {
      detail: { variant: n, shopifyVariantId: v.id }, bubbles: true
    }));
  }

  function _readShopifyVariantFromURL() {
    var boot = global.BASE_BOOT;
    if (!boot || !boot.variants) return;
    try {
      var url = new URL(global.location.href);
      var vid = url.searchParams.get('variant');
      if (!vid) return;
      for (var i = 0; i < boot.variants.length; i++) {
        if (String(boot.variants[i].id) === String(vid)) {
          STATE.variant = i + 1;
          return;
        }
      }
    } catch (e) {}
  }

  var _handleEls = [];
  var _anyHandleDragging = false;
  var _shaftDragStart = null;
  var _tankDragStart = null;
  var _panelDragStart = null;
  var _fittingDragStart = null;
  var _fittingsResizeStart = null;

  function rebuildDragHandles() {
    var container = document.getElementById('cf-base-handles');
    if (!container) return;
    container.innerHTML = '';
    _handleEls = [];

    var poly = getFootprintPolygon();
    var defs = _buildHandleDefs(poly);

    for (var i = 0; i < defs.length; i++) {
      var def = defs[i];
      var el = document.createElement('div');
      el.className = 'cf-base-handle cf-base-handle-' + def.type;
      el.setAttribute('data-handle-index', String(i));
      if (def.type === 'shaft') {
        el.title = 'Technology shaft — drag to move';
        el.style.position = 'absolute';
        el.style.width = '14px';
        el.style.height = '14px';
        el.style.borderRadius = '3px';
        el.style.background = '#3a3a3a';
        el.style.border = '2px solid #fff';
        el.style.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'tank') {
        el.title = 'Overflow balance tank — drag to move';
        el.style.position = 'absolute';
        el.style.width = '16px';
        el.style.height = '16px';
        el.style.borderRadius = '3px';
        el.style.background = '#2f6fb0';
        el.style.border = '2px solid #fff';
        el.style.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'panel') {
        el.title = 'Electrical panel — drag to move';
        el.style.position = 'absolute';
        el.style.width = '14px';
        el.style.height = '14px';
        el.style.borderRadius = '3px';
        el.style.background = '#f2f2f2';
        el.style.border = '2px solid #555';
        el.style.boxShadow = '0 1px 3px rgba(0,0,0,.4)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'skimmer' || def.type === 'jet') {
        el.title = (def.type === 'skimmer' ? 'Skimmer' : 'Return jet') + ' — drag to move';
        el.style.position = 'absolute';
        if (def.type === 'skimmer') {
          el.style.width = '30px';
          el.style.height = '5px';
        } else {
          el.style.width = '10px';
          el.style.height = '5px';
        }
        el.style.background = (def.type === 'jet') ? '#000000' : '#ffffff';
        el.style.border = 'none';
        el.style.boxShadow = '0 0 0 1px rgba(0,0,0,.25)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'light') {
        el.title = 'Pool light — drag to move';
        el.style.position = 'absolute';
        el.style.width = '12px';
        el.style.height = '12px';
        el.style.borderRadius = '50%';
        el.style.background = '#ffd11a';
        el.style.border = 'none';
        el.style.boxShadow = '0 0 4px 1px rgba(255,200,20,.8)';
        el.style.cursor = 'grab';
        el.style.zIndex = '30';
        el.style.touchAction = 'none';
        el.style.pointerEvents = 'auto';
      } else if (def.type === 'corner') {

        el.style.background = '#5A6B47';
        el.style.borderColor = '#5A6B47';
        el.style.width = '6px';
        el.style.height = '6px';
        el.style.boxSizing = 'border-box';
        el.style.marginLeft = '3px';
        el.style.marginTop = '3px';
      }
      el.style.display = 'none';
      container.appendChild(el);
      _attachHandleDrag(el, def);
      _handleEls.push({ el: el, def: def });
    }
    positionDragHandles();
  }

  function _buildHandleDefs(poly) {
    var defs = [];
    var n = poly ? poly.length : 0;
    /* master house always exposes corner handles so the footprint shape can be
       dragged at the vertices (the gable-only suppression from the shelter
       clone hid them and left only mid-edge handles) */
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'corner', vertexIndex: i });
    }
    for (var i = 0; i < n; i++) {
      defs.push({ type: 'edge', edgeIndex: i });
    }
    return defs;
  }

  function _clampCoord(v) {
    if (v >  MAX_COORD) return  MAX_COORD;
    if (v < -MAX_COORD) return -MAX_COORD;
    return v;
  }

  function _worldToScreen(x, z) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var v = new T.Vector3(x, 0, z);
    v.project(eng.camera);
    var canvasRect = eng.renderer.domElement.getBoundingClientRect();
    var parent = document.getElementById('cf-wrap-base');
    var parentRect = parent ? parent.getBoundingClientRect() : { left: 0, top: 0 };
    return {
      left: (canvasRect.left - parentRect.left) + ((v.x + 1) / 2) * canvasRect.width,
      top:  (canvasRect.top  - parentRect.top)  + ((1 - (v.y + 1) / 2)) * canvasRect.height,
      depth: v.z
    };
  }

  function _screenToWorld(clientX, clientY) {
    var eng = global.BaseEngine;
    if (!eng || !eng.camera || !eng.renderer) return null;
    var T = global.THREE;
    if (!T) return null;
    var rect = eng.renderer.domElement.getBoundingClientRect();
    var ndc = new T.Vector2(
      ((clientX - rect.left) / rect.width)  * 2 - 1,
      -((clientY - rect.top)  / rect.height) * 2 + 1
    );
    var ray = new T.Raycaster();
    ray.setFromCamera(ndc, eng.camera);
    var plane = new T.Plane(new T.Vector3(0, 1, 0), 0);
    var p = new T.Vector3();
    ray.ray.intersectPlane(plane, p);
    return p ? { x: p.x, z: p.z } : null;
  }

  function positionDragHandles() {
    if (STATE.view !== '2d') {
      for (var i = 0; i < _handleEls.length; i++) {
        _handleEls[i].el.style.display = 'none';
      }
      return;
    }
    var poly = getFootprintPolygon();
    var n = poly.length;
    for (var i = 0; i < _handleEls.length; i++) {
      var h = _handleEls[i];
      var def = h.def;
      var wx = 0, wz = 0;
      if (def.type === 'corner') {
        wx = poly[def.vertexIndex][0];
        wz = poly[def.vertexIndex][1];
      } else if (def.type === 'edge') {
        var a = poly[def.edgeIndex];
        var b = poly[(def.edgeIndex + 1) % n];
        wx = (a[0] + b[0]) / 2;
        wz = (a[1] + b[1]) / 2;
      } else if (def.type === 'shaft') {
        try { var sp = getShaftPos(); wx = sp.x; wz = sp.z; } catch (_) { continue; }
      } else if (def.type === 'tank') {
        if (getEdgeType() !== 'overflow') { h.el.style.display = 'none'; continue; }
        try { var tp = getTankPos(); wx = tp.x; wz = tp.z; } catch (_) { continue; }
      } else if (def.type === 'panel') {
        try { var pp = getPanelPos(); wx = pp.x; wz = pp.z; } catch (_) { continue; }
      } else if (def.type === 'skimmer') {
        try { var sks = getSkimmerPositions(); if (!sks[def.idx]) { h.el.style.display = 'none'; continue; } wx = sks[def.idx].x; wz = sks[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      } else if (def.type === 'jet') {
        try { var jts = getJetPositions(); if (!jts[def.idx]) { h.el.style.display = 'none'; continue; } wx = jts[def.idx].x; wz = jts[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      } else if (def.type === 'light') {
        try { var lts = getLightPositions(); if (!lts[def.idx]) { h.el.style.display = 'none'; continue; } wx = lts[def.idx].x; wz = lts[def.idx].z; } catch (_) { h.el.style.display = 'none'; continue; }
      }
      var s = _worldToScreen(wx, wz);
      if (!s) continue;
      h.el.style.left = (s.left - 6) + 'px';
      h.el.style.top  = (s.top  - 6) + 'px';

      if (def.type === 'skimmer' || def.type === 'jet') {
        try {

          var hw = (def.type === 'skimmer') ? 30 : 10, hh = 5;
          h.el.style.left = (s.left - hw / 2) + 'px';
          h.el.style.top  = (s.top  - hh / 2) + 'px';
          var ring = _innerRing();
          if (ring && ring.length >= 2) {
            var pe = _projectToInnerEdge(wx, wz).edge;
            var A = ring[pe], B = ring[(pe + 1) % ring.length];
            var sa = _worldToScreen(A[0], A[1]), sb = _worldToScreen(B[0], B[1]);
            if (sa && sb) {
              var ang = Math.atan2(sb.top - sa.top, sb.left - sa.left) * 180 / Math.PI;
              h.el.style.transformOrigin = 'center center';
              h.el.style.transform = 'rotate(' + ang + 'deg)';
            }
          }
        } catch (_) {}
      } else if (def.type === 'light') {
        h.el.style.left = (s.left - 6) + 'px';
        h.el.style.top  = (s.top  - 6) + 'px';
      }
      h.el.style.display = 'block';
    }
  }

  function _attachHandleDrag(el, def) {
    var dragging = false;
    var startWorld = null;
    var startState = null;
    var startPoly = null;

    el.addEventListener('pointerdown', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault();
      dragging = true;
      _anyHandleDragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      el.style.cursor = 'grabbing';
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = false;
      startWorld = _screenToWorld(e.clientX, e.clientY);
      startState = JSON.parse(JSON.stringify(STATE.polygon));
      startPoly = getFootprintPolygon();
      _shaftDragStart = (def.type === 'shaft') ? getShaftPos() : null;
      _tankDragStart  = (def.type === 'tank')  ? getTankPos()  : null;
      _panelDragStart = (def.type === 'panel') ? getPanelPos() : null;
      _fittingDragStart = null;
      if (def.type === 'skimmer') { var sks = getSkimmerPositions(); if (sks[def.idx]) _fittingDragStart = { x: sks[def.idx].x, z: sks[def.idx].z }; }
      if (def.type === 'jet')     { var jts = getJetPositions();     if (jts[def.idx]) _fittingDragStart = { x: jts[def.idx].x, z: jts[def.idx].z }; }
      if (def.type === 'light')   { var lts = getLightPositions();   if (lts[def.idx]) _fittingDragStart = { x: lts[def.idx].x, z: lts[def.idx].z }; }

      if (def.type === 'corner' || def.type === 'edge') {
        _fittingsResizeStart = {
          poly: JSON.parse(JSON.stringify(getFootprintPolygon())),
          skimmers: Array.isArray(STATE.skimmers) ? JSON.parse(JSON.stringify(STATE.skimmers)) : null,
          jets:     Array.isArray(STATE.jets)     ? JSON.parse(JSON.stringify(STATE.jets))     : null,
          lights:   Array.isArray(STATE.lights)   ? JSON.parse(JSON.stringify(STATE.lights))   : null
        };
      } else {
        _fittingsResizeStart = null;
      }
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging || !startWorld) return;
      if (STATE.view !== '2d') { dragging = false; return; }
      var p = _screenToWorld(e.clientX, e.clientY);
      if (!p) return;
      var dx = p.x - startWorld.x;
      var dz = p.z - startWorld.z;
      _applyHandleDelta(def, dx, dz, startState);
      if (def.type === 'shaft' || def.type === 'tank' || def.type === 'panel' || def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {

        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
        positionDragHandles();
      } else {

        refreshUI();
        var nowPoly = getFootprintPolygon();
        _showEdgeDimensionLabels(_changingEdges(nowPoly, startPoly));
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      _anyHandleDragging = false;
      try { if (e) el.releasePointerCapture(e.pointerId); } catch (_) {}
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
      _fittingsResizeStart = null;
      if (def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {

        var arr = (def.type === 'skimmer') ? STATE.skimmers : (def.type === 'jet') ? STATE.jets : STATE.lights;
        if (arr && arr[def.idx]) {
          var c = _clampAwayFromCorners(arr[def.idx].x, arr[def.idx].z, 0.5);
          arr[def.idx].x = c.x; arr[def.idx].z = c.z;
        }
        el.style.cursor = 'grab';
        refreshUI();
        if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
      } else if (def.type === 'shaft' || def.type === 'tank' || def.type === 'panel') {
        el.style.cursor = 'grab';
        if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
      } else {

        try {
          if (Array.isArray(STATE.skimmers)) STATE.skimmers = STATE.skimmers.map(function (p) { return _clampAwayFromCorners(p.x, p.z, 0.5); });
          if (Array.isArray(STATE.jets))     STATE.jets     = STATE.jets.map(function (p) { return _clampAwayFromCorners(p.x, p.z, 0.5); });
        } catch (_) {}
        try { rebuildDragHandles(); } catch (_) {}
        refreshUI();
      }
    }
    el.addEventListener('pointerup',     endDrag);
    el.addEventListener('pointercancel', endDrag);
    el._forceEndDrag = function () {
      if (!dragging) return;
      dragging = false;
      _anyHandleDragging = false;
      var eng = global.BaseEngine;
      if (eng && eng.controls) eng.controls.enabled = true;
      _hideAllEdgeLabels();
      if (startState) _UndoHistory.pushIfChanged(startState, STATE.variant);
      startState = null;
    };
  }

  function _resetAllHandleDrags() {
    for (var i = 0; i < _handleEls.length; i++) {
      var hel = _handleEls[i] && _handleEls[i].el;
      if (hel && hel._forceEndDrag) hel._forceEndDrag();
    }
    var widget = document.getElementById('cf-budget-widget');
    if (widget && widget._forceEndDrag) widget._forceEndDrag();
  }

  function _changingEdges(currentPoly, startPoly) {
    if (!currentPoly || !startPoly) return [];
    if (currentPoly.length !== startPoly.length) return [];
    var changed = [];
    var n = currentPoly.length;
    for (var i = 0; i < n; i++) {
      var ca = currentPoly[i], cb = currentPoly[(i + 1) % n];
      var sa = startPoly[i],   sb = startPoly[(i + 1) % n];
      var clen = Math.hypot(cb[0] - ca[0], cb[1] - ca[1]);
      var slen = Math.hypot(sb[0] - sa[0], sb[1] - sa[1]);
      if (Math.abs(clen - slen) > 0.0001) changed.push(i);
    }
    return changed;
  }

  function _applyHandleDelta(def, dx, dz, s0) {
    var poly = STATE.polygon;
    if (!poly || !poly.length) return;
    var n = s0.length;
    if (def.type === 'corner') {
      var i = def.vertexIndex;
      if (i < 0 || i >= n) return;
      var nx = snap(s0[i][0] + dx);
      var nz = snap(s0[i][1] + dz);
      poly[i][0] = _clampCoord(nx);
      poly[i][1] = _clampCoord(nz);
    } else if (def.type === 'edge') {
      var ei = def.edgeIndex;
      if (ei < 0 || ei >= n) return;
      var a = s0[ei];
      var b = s0[(ei + 1) % n];
      var edx = b[0] - a[0], edz = b[1] - a[1];
      var len = Math.hypot(edx, edz);
      if (len < 1e-6) return;
      var nrmX = -edz / len, nrmZ = edx / len;

      var proj = snap(dx * nrmX + dz * nrmZ);
      poly[ei][0] = _clampCoord(a[0] + proj * nrmX);
      poly[ei][1] = _clampCoord(a[1] + proj * nrmZ);
      poly[(ei + 1) % n][0] = _clampCoord(b[0] + proj * nrmX);
      poly[(ei + 1) % n][1] = _clampCoord(b[1] + proj * nrmZ);
    } else if (def.type === 'shaft') {
      var st = _shaftDragStart || getShaftPos();
      setShaftPos(_clampCoord(snap(st.x + dx)), _clampCoord(snap(st.z + dz)));
    } else if (def.type === 'tank') {
      var tst = _tankDragStart || getTankPos();
      setTankPos(_clampCoord(snap(tst.x + dx)), _clampCoord(snap(tst.z + dz)));
    } else if (def.type === 'panel') {
      var pst = _panelDragStart || getPanelPos();
      setPanelPos(_clampCoord(snap(pst.x + dx)), _clampCoord(snap(pst.z + dz)));
    } else if (def.type === 'skimmer' || def.type === 'jet' || def.type === 'light') {
      var fs = _fittingDragStart;
      if (!fs) return;
      var rawX = _clampCoord(fs.x + dx), rawZ = _clampCoord(fs.z + dz);
      var locked = _projectToInnerEdge(rawX, rawZ);
      var safe = _clampAwayFromStairs(locked.x, locked.z, 0.10, locked.edge);
      var arr = (def.type === 'skimmer') ? STATE.skimmers : (def.type === 'jet') ? STATE.jets : STATE.lights;
      if (arr && arr[def.idx]) { arr[def.idx].x = safe.x; arr[def.idx].z = safe.z; }
    }
  }

  var _edgeLabels = [];
  var _edgeLabelCssInjected = false;

  function _injectEdgeLabelCSS() {
    if (_edgeLabelCssInjected) return;
    _edgeLabelCssInjected = true;
    var css = '#cf-wrap-base .cf-base-dim-label {' +
              '  position: absolute; z-index: 12;' +
              '  background: rgba(20,20,20,0.92); color: #fff;' +
              '  font: 700 11px/1.2 Montserrat, -apple-system, sans-serif;' +
              '  padding: 4px 8px; border-radius: 6px;' +
              '  letter-spacing: 0.02em; white-space: nowrap;' +
              '  pointer-events: none;' +
              '  transform: translate(-50%, -50%);' +
              '  box-shadow: 0 2px 6px rgba(0,0,0,0.25);' +
              '}';
    var style = document.createElement('style');
    style.id = 'cf-base-dim-label-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _ensureEdgeLabelPool(n) {
    _injectEdgeLabelCSS();
    var parent = document.getElementById('cf-wrap-base');
    if (!parent) return;
    while (_edgeLabels.length < n) {
      var el = document.createElement('div');
      el.className = 'cf-base-dim-label';
      el.style.display = 'none';
      parent.appendChild(el);
      _edgeLabels.push(el);
    }
  }

  function _hideAllEdgeLabels() {
    for (var i = 0; i < _edgeLabels.length; i++) {
      _edgeLabels[i].style.display = 'none';
    }
  }

  function _showEdgeDimensionLabels(activeEdgeIndices) {
    var poly = getFootprintPolygon();
    if (!poly || !poly.length) { _hideAllEdgeLabels(); return; }
    var n = poly.length;
    _ensureEdgeLabelPool(n);

    for (var i = 0; i < n; i++) {
      var label = _edgeLabels[i];
      if (activeEdgeIndices.indexOf(i) === -1) {
        label.style.display = 'none';
        continue;
      }
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var mx = (a[0] + b[0]) / 2;
      var mz = (a[1] + b[1]) / 2;
      var dx = b[0] - a[0];
      var dz = b[1] - a[1];
      var lenWorld = Math.sqrt(dx * dx + dz * dz);
      label.textContent = fmtDim(lenWorld);

      var ms = _worldToScreen(mx, mz);
      if (!ms) { label.style.display = 'none'; continue; }

      var nlen = Math.sqrt(dx * dx + dz * dz);
      var nxW, nzW;
      if (nlen < 1e-6) {
        nxW = 0; nzW = -1;
      } else {
        nxW = -dz / nlen;
        nzW =  dx / nlen;
      }
      var probe = 0.02;
      if (_pointInPolygonOrBoundary(mx + nxW * probe, mz + nzW * probe, poly)) {
        nxW = -nxW; nzW = -nzW;
      }
      var probeS = _worldToScreen(mx + nxW * probe, mz + nzW * probe);
      var sx, sy, slen;
      if (probeS) {
        sx = probeS.left - ms.left;
        sy = probeS.top  - ms.top;
        slen = Math.sqrt(sx * sx + sy * sy);
        if (slen < 0.001) { sx = 0; sy = -1; slen = 1; }
      } else {
        sx = 0; sy = -1; slen = 1;
      }
      var off = 26;
      var lx = ms.left + (sx / slen) * off;
      var ly = ms.top  + (sy / slen) * off;

      label.style.display = 'block';
      label.style.left = lx + 'px';
      label.style.top  = ly + 'px';
    }
  }

  function _startBudgetWidgetSync() {
    var dstTotal    = document.getElementById('cf-bw-total');
    var dstMaterial = document.getElementById('cf-bw-material');
    var dstExec     = document.getElementById('cf-bw-execution');
    var dstTime     = document.getElementById('cf-bw-time');
    var dstCapacity = document.getElementById('cf-bw-capacity');

    function refresh() {
      var srcTotal    = document.querySelector('[data-budget-total-cost]');
      var srcMaterial = document.querySelector('[data-budget-total-material]');
      var srcExec     = document.querySelector('[data-budget-total-execution]');
      var srcTime     = document.querySelector('[data-budget-total-time]');

      var totalText    = (srcTotal    && srcTotal.textContent)    ? srcTotal.textContent.trim()    : '';
      var materialText = (srcMaterial && srcMaterial.textContent) ? srcMaterial.textContent.trim() : '';
      var execText     = (srcExec     && srcExec.textContent)     ? srcExec.textContent.trim()     : '';
      var timeText     = (srcTime     && srcTime.textContent)     ? srcTime.textContent.trim()     : '';

      var needFallback = (!totalText || totalText === '—' || !materialText || materialText === '—');
      if (needFallback) {
        var matVal  = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : null;
        var execVal = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : null;
        if (matVal !== null || execVal !== null) {
          var fmt = (typeof global.formatPrice === 'function')
            ? global.formatPrice
            : function (n) { return '$' + Math.round(n || 0); };
          var m = matVal  || 0;
          var e = execVal || 0;
          if (!totalText    || totalText    === '—') totalText    = fmt(m + e);
          if (!materialText || materialText === '—') materialText = fmt(m);
          if (!execText     || execText     === '—') execText     = fmt(e);
        }
      }

      if (dstTotal    && totalText)    dstTotal.textContent    = totalText;
      if (dstMaterial && materialText) dstMaterial.textContent = materialText;
      if (dstExec     && execText)     dstExec.textContent     = execText;
      if (dstTime     && timeText)     dstTime.textContent     = timeText;

      if (dstCapacity) {
        var rows = computeBoQ();
        var excavM3 = 0;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] && rows[i][0] === 'FEE00001') {
            excavM3 = rows[i][1] || 0;
            break;
          }
        }
        dstCapacity.textContent = STATE.isMetric
          ? excavM3.toFixed(1) + ' m³'
          : (excavM3 * 35.3147).toFixed(1) + ' ft³';
      }
    }
    refresh();
    setInterval(refresh, 500);

    setTimeout(function () {
      if (typeof global.updateTotal !== 'function') return;
      var srcTotal = document.querySelector('[data-budget-total-cost]');
      var t = (srcTotal && srcTotal.textContent) ? srcTotal.textContent.trim() : '';
      var stillEmpty = (t === '' || t === '—' || typeof global.lastMaterialsTotal !== 'number');
      if (!stillEmpty) return;
      try { global.updateTotal(); } catch (err) {}
    }, 2500);
  }

  function _initBudgetWidgetDrag() {
    var widget = document.getElementById('cf-budget-widget');
    var toggle = document.getElementById('cf-budget-widget-toggle');
    if (!widget) return;
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var collapsed = widget.getAttribute('data-collapsed') === 'true';
        widget.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      });
      toggle.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    }

    var dragging = false, startX = 0, startY = 0, startLeft = 0, startTop = 0;
    widget.addEventListener('pointerdown', function (e) {
      if (e.target.closest('#cf-budget-widget-toggle')) return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      var r = widget.getBoundingClientRect();
      var pr = (widget.offsetParent || document.body).getBoundingClientRect();
      startLeft = r.left - pr.left;
      startTop  = r.top  - pr.top;
      try { widget.setPointerCapture(e.pointerId); } catch (_) {}
    });
    widget.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      var parent = widget.offsetParent || document.body;
      var pr = parent.getBoundingClientRect();
      var nx = Math.max(0, Math.min(pr.width  - widget.offsetWidth,  startLeft + dx));
      var ny = Math.max(0, Math.min(pr.height - widget.offsetHeight, startTop  + dy));
      widget.style.left = nx + 'px';
      widget.style.top  = ny + 'px';
      widget.style.right = 'auto';
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { if (e) widget.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    widget.addEventListener('pointerup',     endDrag);
    widget.addEventListener('pointercancel', endDrag);
    widget._forceEndDrag = function () { dragging = false; };
  }

  function share() {
    if (global.ConfiguratorShare && typeof global.ConfiguratorShare.open === 'function') {
      try { global.ConfiguratorShare.open(); return; }
      catch (err) { _dbg('ConfiguratorShare.open threw: ' + (err && err.message ? err.message : err)); }
    }
    var TT = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    var txt = TT.shareFallbackText || 'Foundation configuration from LEVA';
    var title = TT.shareFallbackTitle || 'Configuration';
    if (navigator.share) {
      navigator.share({ title: title, text: txt }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(txt);
      alert(TT.shareCopied || 'Copied to clipboard');
    }
  }

  function openBudgetDrawer() {

    try {
      var BOOT = global.BASE_BOOT || {};
      global.__cfBudgetUserTouched = true;
      if (BOOT.productId) {
        localStorage.setItem('cf-budget-touched-' + BOOT.productId, String(Date.now()));
      }
      _onboardMarkSeen();
    } catch (_) {}
    if (typeof global.openShareBudgetDrawer === 'function') {
      global.openShareBudgetDrawer('data');
    } else if (typeof global.openRefreshDrawer === 'function') {
      global.openRefreshDrawer();
    } else {
      _dbg('no budget drawer opener on window');
    }
  }

  function _fitPerspToModel() {
    var eng = global.BaseEngine, T = global.THREE;
    if (!eng || !eng.cameraPersp || !T) return;
    var poly = getFootprintPolygon();
    var n = poly ? poly.length : 0;
    if (!n) return;
    var minx = 1e9, maxx = -1e9, minz = 1e9, maxz = -1e9;
    for (var i = 0; i < n; i++) {
      var px = poly[i][0], pz = poly[i][1];
      if (px < minx) minx = px; if (px > maxx) maxx = px;
      if (pz < minz) minz = pz; if (pz > maxz) maxz = pz;
    }
    var cx = (minx + maxx) / 2, cz = (minz + maxz) / 2;
    var r = Math.max(Math.hypot(maxx - minx, maxz - minz) / 2, 3);
    var fov = (eng.cameraPersp.fov || 40) * Math.PI / 180;
    var dist = (r / Math.tan(fov / 2)) * 1.5 + ((STATE.floors || 1) * 1.6);
    var dir = new T.Vector3(1, 0.85, 1).normalize();
    eng.cameraPersp.position.set(cx + dir.x * dist, dir.y * dist, cz + dir.z * dist);
    eng.cameraPersp.lookAt(cx, 0, cz);
    eng.cameraPersp.updateProjectionMatrix();
    if (eng.controls && eng.controls.target) {
      eng.controls.target.set(cx, 0, cz);
      try { eng.controls.update(); } catch (_) {}
    }
  }
  function toggleView() {
    if (global.BaseEngine && typeof global.BaseEngine.toggleView === 'function') {
      global.BaseEngine.toggleView();

      _forceRender3DFlush(2);
    }
  }

  var PDF_BTN_RED = '#D8232A';

  function _initPdfButtonState() {
    var btn = document.getElementById('cf-btn-pdf');
    if (!btn) return;

    if (!document.getElementById('cf-pdf-btn-style')) {
      var st = document.createElement('style');
      st.id = 'cf-pdf-btn-style';
      st.textContent =
        '#cf-btn-pdf.cf-pdf-loading{opacity:.4;pointer-events:none;cursor:default;filter:grayscale(1);}' +
        '#cf-btn-pdf.cf-pdf-ready{background:' + PDF_BTN_RED + ' !important;border-color:' + PDF_BTN_RED + ' !important;color:#fff !important;}' +

        '#cf-btn-pdf.cf-pdf-ready > *{filter:brightness(0) invert(1) !important;}';
      document.head.appendChild(st);
    }

    var bridge = global.ConfiguratorBudgetBridge || null;
    function isReady() {
      return !(bridge && typeof bridge.isReady === 'function') || bridge.isReady();
    }
    function promote() {
      btn.classList.remove('cf-pdf-loading');
      btn.classList.add('cf-pdf-ready');
    }

    if (isReady()) { promote(); return; }

    btn.classList.add('cf-pdf-loading');
    if (bridge && typeof bridge.onReady === 'function') {
      try { bridge.onReady(promote); } catch (e) {}
    }
    var waited = 0;
    var iv = setInterval(function () {
      if (isReady()) { clearInterval(iv); promote(); }
      else if ((waited += 300) >= 30000) { clearInterval(iv); promote(); }
    }, 300);
  }

  function wireSidebar() {
    var on = function (id, fn) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', fn);
    };
    on('cf-btn-view',     toggleView);
    on('cf-btn-undo',     undo);
    on('cf-btn-lvl',      cycleLvl);
    _SlopeManager.init();
    on('cf-btn-unit',     toggleUnits);
    on('cf-btn-budget',   openBudgetDrawer);
    on('cf-btn-share',    share);
    on('cf-btn-pdf',      function () { _openPdfSocialModal(); });
    on('cf-btn-ar',       function () { _openArModal(); });

    var prevBtn = document.getElementById('cf-base-variant-prev');
    var nextBtn = document.getElementById('cf-base-variant-next');
    if (prevBtn) prevBtn.addEventListener('click', prevVariant);
    if (nextBtn) nextBtn.addEventListener('click', nextVariant);

    _syncVariantNameDisplay();
    _initPdfButtonState();

    var opacitySlider = document.getElementById('cf-2d-opacity-slider');
    if (opacitySlider) {
      opacitySlider.addEventListener('input', function (e) {
        var sv = parseInt(e.target.value, 10);
        STATE.opacity2D = (100 - sv) / 100;
        if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      });
    }

    _startBudgetWidgetSync();
    _initBudgetWidgetDrag();
    _init2DZoom();
    _init2DMapPan();
    _bindIconTooltips();
    _VisualizationManager.init();
    _CornerInserter.init();
    _ShelterBanner.init();
    _UndoHistory._updateButton();
    _updateLvlButton();
    _preloadLvlAvatars();

    var _bridgeRetry = 0;
    var _bridgeTimer = setInterval(function () {
      _bridgeRetry++;
      var bridge = global.ConfiguratorBudgetBridge;
      if (bridge && bridge.isReady && bridge.isReady()) {
        refreshUI();
        clearInterval(_bridgeTimer);
      } else if (_bridgeRetry > 150) {
        clearInterval(_bridgeTimer);
      }
    }, 200);

    global.addEventListener('prices-updated', function () {
      refreshUI();
    });

    global.addEventListener('unitChange', _syncFromBudgetUnit);
    setTimeout(_syncFromBudgetUnit, 50);
  }

  var _CORE_CSS_INJECTED = false;
  function _injectCoreCSS() {
    if (_CORE_CSS_INJECTED) return;
    if (document.getElementById('cf-core-css-inline')) { _CORE_CSS_INJECTED = true; return; }
    var css = [
      ':root { --cfg-color-primary: #D2A878; }',
      '.cfg-slider-vert-wrap {',
      '  display: inline-flex; flex-direction: column; align-items: center;',
      '  background: transparent; padding: 0; user-select: none;',
      '}',
      '.cfg-slider-vert {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 4px; height: 130px;',
      '  background: linear-gradient(to top,',
      '    var(--cfg-color-primary, #D2A878) 0%,',
      '    var(--cfg-color-primary, #D2A878) var(--cfg-fill, 50%),',
      '    #e0e0e0 var(--cfg-fill, 50%),',
      '    #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer; touch-action: none;',
      '  writing-mode: tb-lr; -webkit-writing-mode: vertical-lr;',
      '}',
      '.cfg-slider-vert::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cfg-slider-vert::-moz-range-thumb {',
      '  width: 12px; height: 12px;',
      '  background: var(--cfg-color-primary, #D2A878);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-dim-chip {',
      '  position: absolute; transform: translate(-50%, -50%);',
      '  background: #ffffff; border-radius: 8px; padding: 6px 10px;',
      '  font-family: Montserrat, system-ui, sans-serif;',
      '  font-size: 12px; font-weight: 700; color: #1a1a1a;',
      '  box-shadow: 0 2px 8px rgba(0,0,0,0.12);',
      '  display: inline-flex; align-items: center; gap: 6px;',
      '  white-space: nowrap; pointer-events: none; touch-action: none;',
      '  user-select: none; z-index: 8;',
      '}'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'cf-core-css-inline';
    s.textContent = css;
    document.head.appendChild(s);
    _CORE_CSS_INJECTED = true;
  }

  var _BaseDimensions = {
    svgEl: null,
    chipLayer: null,
    chipEls: [],
    SVG_NS: 'http://www.w3.org/2000/svg',

    init: function () {
      var root = document.getElementById('cf-wrap-base');
      if (!root) return;
      if (!this.svgEl) {
        var svg = document.createElementNS(this.SVG_NS, 'svg');
        svg.id = 'cf-base-dims-svg';
        svg.style.cssText = [
          'position:absolute', 'top:0', 'left:0',
          'width:100%', 'height:100%',
          'pointer-events:none', 'display:none', 'z-index:6'
        ].join(';');
        root.appendChild(svg);
        this.svgEl = svg;
        var self = this;
        global.addEventListener('resize', function () { self.refresh(); });
      }
      if (!this.chipLayer) {
        var existing = document.getElementById('cf-base-dim-chips');
        if (existing) {
          this.chipLayer = existing;
        } else {
          var layer = document.createElement('div');
          layer.id = 'cf-base-dim-chips';
          layer.style.cssText = [
            'position:absolute', 'top:0', 'left:0',
            'width:100%', 'height:100%',
            'pointer-events:none', 'z-index:7'
          ].join(';');
          root.appendChild(layer);
          this.chipLayer = layer;
        }
      }
    },

    _clearChips: function () {
      for (var i = 0; i < this.chipEls.length; i++) {
        if (this.chipEls[i] && this.chipEls[i].parentNode) {
          this.chipEls[i].parentNode.removeChild(this.chipEls[i]);
        }
      }
      this.chipEls = [];
    },

    hide: function () {
      this.init();
      if (this.svgEl) { this.svgEl.style.display = 'none'; this.svgEl.innerHTML = ''; }
      if (this.chipLayer) this.chipLayer.style.display = 'none';
      this._clearChips();
    },

    refresh: function () {
      this.init();
      if (!this.svgEl) return;
      var show = (STATE.view === '2d' && STATE.vizStage === 1);
      if (!show) { this.hide(); return; }

      this.svgEl.style.display = '';
      this.svgEl.innerHTML = '';
      this.chipLayer.style.display = '';
      this._clearChips();

      var eng = global.BaseEngine;
      if (!eng || !eng.cameraOrtho || !eng.renderer) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var w = rect.width, h = rect.height;
      if (w < 10 || h < 10) return;
      this.svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + h);

      var T = global.THREE;
      var cam = eng.cameraOrtho;
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;

      function proj(x, z) {
        var v = new T.Vector3(x, 0, z).project(cam);
        return {
          x: (v.x * 0.5 + 0.5) * w,
          y: (1 - (v.y * 0.5 + 0.5)) * h
        };
      }

      var cx = 0, cz = 0;
      for (var i = 0; i < poly.length; i++) { cx += poly[i][0]; cz += poly[i][1]; }
      cx /= poly.length; cz /= poly.length;

      var GRAY = '#888', DARK = '#1a1a1a';
      var DIM_OFFSET = 32;
      var EXT_GAP = 4, EXT_OVER = 6, ARROW = 6;
      var unit = STATE.isMetric ? 'm' : 'ft';

      for (var i = 0; i < poly.length; i++) {
        var a = poly[i];
        var b = poly[(i + 1) % poly.length];
        var lenM = Math.hypot(b[0] - a[0], b[1] - a[1]);
        if (lenM < 0.05) continue;

        var label = fmtDim(lenM);

        var pA = proj(a[0], a[1]);
        var pB = proj(b[0], b[1]);
        var mid = proj((a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
        var cs  = proj(cx, cz);

        var ex = pB.x - pA.x, ey = pB.y - pA.y;
        var elen = Math.hypot(ex, ey);
        if (elen < 1) continue;

        var nxs = -ey / elen, nys = ex / elen;
        var dot = (mid.x - cs.x) * nxs + (mid.y - cs.y) * nys;
        if (dot < 0) { nxs = -nxs; nys = -nys; }

        var oxA = pA.x + nxs * DIM_OFFSET;
        var oyA = pA.y + nys * DIM_OFFSET;
        var oxB = pB.x + nxs * DIM_OFFSET;
        var oyB = pB.y + nys * DIM_OFFSET;

        var exAx = pA.x + nxs * EXT_GAP;
        var exAy = pA.y + nys * EXT_GAP;
        var exAend_x = pA.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exAend_y = pA.y + nys * (DIM_OFFSET + EXT_OVER);

        var exBx = pB.x + nxs * EXT_GAP;
        var exBy = pB.y + nys * EXT_GAP;
        var exBend_x = pB.x + nxs * (DIM_OFFSET + EXT_OVER);
        var exBend_y = pB.y + nys * (DIM_OFFSET + EXT_OVER);

        this._addLine(exAx, exAy, exAend_x, exAend_y, GRAY, 0.4);
        this._addLine(exBx, exBy, exBend_x, exBend_y, GRAY, 0.4);
        this._addLine(oxA, oyA, oxB, oyB, DARK, 0.5);

        var tx = -ex / elen, ty = -ey / elen;
        this._addLine(oxA, oyA, oxA + tx * ARROW + nxs * (ARROW * 0.5), oyA + ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxA, oyA, oxA + tx * ARROW - nxs * (ARROW * 0.5), oyA + ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW + nxs * (ARROW * 0.5), oyB - ty * ARROW + nys * (ARROW * 0.5), DARK, 0.5);
        this._addLine(oxB, oyB, oxB - tx * ARROW - nxs * (ARROW * 0.5), oyB - ty * ARROW - nys * (ARROW * 0.5), DARK, 0.5);

        var chipX = (oxA + oxB) / 2 + nxs * 14;
        var chipY = (oyA + oyB) / 2 + nys * 14;
        this._addChip(chipX, chipY, label);
      }
    },

    _addLine: function (x1, y1, x2, y2, color, width) {
      var line = document.createElementNS(this.SVG_NS, 'line');
      line.setAttribute('x1', x1); line.setAttribute('y1', y1);
      line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      line.setAttribute('stroke', color);
      line.setAttribute('stroke-width', width);
      line.setAttribute('stroke-linecap', 'round');
      this.svgEl.appendChild(line);
    },

    _addChip: function (x, y, text) {
      var chip = document.createElement('div');
      chip.className = 'cf-dim-chip cf-dim-chip--label-only';
      chip.style.left = x + 'px';
      chip.style.top  = y + 'px';
      chip.textContent = text;
      this.chipLayer.appendChild(chip);
      this.chipEls.push(chip);
    }
  };

  var _VisualizationManager = {
    DISABLED: false,

    init: function () {
      _injectCoreCSS();
      var btn = document.getElementById('cf-btn-viz');
      if (this.DISABLED) {
        if (btn) btn.style.display = 'none';
        STATE.vizStage = 0;
        var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
        if (wrap) wrap.classList.remove('cf-2d-visible');
        return;
      }
      STATE.vizStage = 0;
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () { self.cycle(); });
      this._wireSlider();
      this.apply();
    },

    _wireSlider: function () {
      var slider = document.getElementById('cf-2d-opacity-slider');
      if (!slider) return;
      var maxV = parseInt(slider.max, 10) || 100;
      var self = this;
      var updateFill = function (pct) {
        var fillPct = 100 - (pct / maxV) * 100;
        slider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onChange = function () {
        var sv = parseInt(slider.value, 10) || 0;
        STATE.opacity2D = (100 - sv) / 100;
        updateFill(sv);
        self._applyOpacityToMaterials();
      };
      slider.addEventListener('input',  onChange);
      slider.addEventListener('change', onChange);
      var initSliderVal = Math.round((1 - STATE.opacity2D) * 100);
      slider.value = initSliderVal;
      updateFill(initSliderVal);
    },

    _order: function () {
      if (typeof _isCarport === 'function' && _isCarport()) {
        if (STATE.view === '3d') {
          var _masonry = ((STATE.structureVariant || 'masonry') === 'masonry');
          return _masonry ? [0, 1, 4] : [0, 1];
        }
        return [0, 3, 1];
      }
      return (STATE.view === '3d') ? [0, 3, 1, 2] : [0, 3, 1];
    },

    cycle: function () {
      if (this.DISABLED) return;

      var order = this._order();
      var i = order.indexOf(STATE.vizStage);
      if (i < 0) i = 0;
      STATE.vizStage = order[(i + 1) % order.length];
      _dbg('[viz-cycle] vizStage=' + STATE.vizStage + ' view=' + STATE.view);
      this.apply();
    },

    reset: function () {
      STATE.vizStage = 0;
      if (this.DISABLED) return;
      this.apply();
    },

    apply: function () {
      if (this.DISABLED) return;
      var _ord = this._order();
      if (_ord.indexOf(STATE.vizStage) < 0) STATE.vizStage = 0;   /* stage left the order (e.g. structure changed) */
      this._applyOpacityToMaterials();
      if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
      this._updateButton();
      this._updateSliderVisibility();
      this._updateStageOverlays();
      if (_SlopeManager && _SlopeManager._updateSlider) _SlopeManager._updateSlider();
      _BaseDimensions.refresh();

    },

    refreshDimensions: function () {
      if (this.DISABLED) return;
      _BaseDimensions.refresh();
    },

    _applyOpacityToMaterials: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.sceneGroup) return;

      var in2DStage = (STATE.view === '2d' && STATE.vizStage === 1);
      var in3DStage = (STATE.view === '3d' && STATE.vizStage === 1);
      var isCarport = (typeof _isCarport === 'function') && _isCarport();
      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.material) return;
        if (node.userData && node.userData.balconyFill) { node.visible = (STATE.view === '2d'); return; }   /* editing ghost: 2D plan only, never over the 3D model */
        if (node.userData && node.userData.kind === 'glass') return;   /* window glass keeps its authored transparency */
        var ud = (node.parent && node.parent.userData) || node.userData || {};
        if (node.userData && node.userData.partType === 'roofSkin') {
          node.visible = (STATE.vizStage !== 1 && STATE.vizStage !== 4);
        }
        var isMeshWire = (ud.assetType === 'mesh');
        var isRebar    = (ud.assetType === 'rebar');
        var isStairFill = (ud.assetType === 'pool-stairs-fill' || (node.userData && node.userData.assetType === 'pool-stairs-fill'));
        var isWater    = (ud.assetType === 'water' || (node.userData && node.userData.assetType === 'water'));

        if (isWater) {
          var wm = node.material;
          var wlist = Array.isArray(wm) ? wm : [wm];
          for (var wi = 0; wi < wlist.length; wi++) {
            wlist[wi].transparent = true;
            wlist[wi].opacity = 0.25;
            wlist[wi].depthWrite = false;
            wlist[wi].needsUpdate = true;
          }
          return;
        }
        var op;
        if (isCarport || isMeshWire || isRebar || isStairFill) {
          op = 1.0;
        } else if (in3DStage) {
          op = STATE.opacity2D;
        } else if (in2DStage) {
          op = STATE.opacity2D;
        } else {
          op = 1.0;
        }
        var m = node.material;
        if (Array.isArray(m)) {
          for (var i = 0; i < m.length; i++) {
            m[i].transparent = op < 1;
            m[i].opacity = op;
            m[i].depthWrite = (op > 0.99);
            m[i].needsUpdate = true;
          }
        } else {
          m.transparent = op < 1;
          m.opacity = op;
          m.depthWrite = (op > 0.99);
          m.needsUpdate = true;
        }
      });
    },

    _updateButton: function () {
      var btn = document.getElementById('cf-btn-viz');
      if (!btn) return;
      var stage = STATE.vizStage;
      btn.classList.toggle('active', stage !== 0);
      btn.setAttribute('data-stage', String(stage));
      btn.setAttribute('aria-pressed', stage !== 0 ? 'true' : 'false');
      var lbl = document.getElementById('cf-stat-viz') || btn.querySelector('.cf-viz-label');
      if (lbl) {

        var order = this._order();
        var pos = order.indexOf(stage);
        lbl.textContent = (stage === 0 || pos <= 0) ? 'off' : (pos + '/' + (order.length - 1));
      }
    },

    _updateSliderVisibility: function () {
      var wrap = document.getElementById('cf-2d-opacity-slider-wrap');
      if (!wrap) return;
      var carport = (typeof _isCarport === 'function') && _isCarport();
      var visible = (STATE.vizStage === 1) && !carport;
      wrap.classList.toggle('cf-2d-visible', visible);
    },

    _updateStageOverlays: function () {
      var wrap = document.getElementById('cf-wrap-base');
      if (!wrap) return;
      var inStageView = (STATE.vizStage === 1);
      wrap.classList.toggle('cf-stage-view', inStageView);
      if (inStageView) {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan) _MapManager.map.dragPan.disable();
      } else {
        if (_MapManager && _MapManager.map && _MapManager.map.dragPan && STATE.view === '2d') _MapManager.map.dragPan.enable();
      }
    }
  };

  function _snapToNearestPolygonEdge(x, z) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 2) return null;
    var n = poly.length;
    var best = null;
    for (var i = 0; i < n; i++) {
      var a = poly[i];
      var b = poly[(i + 1) % n];
      var ax = a[0], az = a[1];
      var bx = b[0], bz = b[1];
      var ex = bx - ax, ez = bz - az;
      var lenSq = ex * ex + ez * ez;
      if (lenSq < 1e-6) continue;
      var t = ((x - ax) * ex + (z - az) * ez) / lenSq;
      if (t < 0) t = 0;
      if (t > 1) t = 1;
      var px = ax + t * ex;
      var pz = az + t * ez;
      var d = Math.hypot(x - px, z - pz);
      if (!best || d < best.dist) {
        best = { edgeIdx: i, tFrac: t, x: px, z: pz, dist: d };
      }
    }
    return best;
  }

  function _insertCornerOnEdge(edgeIdx, tFrac) {
    var poly = STATE.polygon;
    if (!poly || poly.length < 3) return false;
    var n = poly.length;
    if (edgeIdx < 0 || edgeIdx >= n) return false;

    var a = poly[edgeIdx];
    var b = poly[(edgeIdx + 1) % n];
    var ax = a[0], az = a[1];
    var bx = b[0], bz = b[1];

    var px = ax + tFrac * (bx - ax);
    var pz = az + tFrac * (bz - az);

    var distA = Math.hypot(px - ax, pz - az);
    var distB = Math.hypot(px - bx, pz - bz);

    var sharedIdx, sharedV, otherEndOnE, adjOtherIdx;
    if (distA <= distB) {
      sharedIdx     = edgeIdx;
      sharedV       = a;
      otherEndOnE   = b;
      adjOtherIdx   = (edgeIdx - 1 + n) % n;
    } else {
      sharedIdx     = (edgeIdx + 1) % n;
      sharedV       = b;
      otherEndOnE   = a;
      adjOtherIdx   = (edgeIdx + 2) % n;
    }
    var adjOther = poly[adjOtherIdx];

    var lenE   = Math.hypot(otherEndOnE[0] - sharedV[0], otherEndOnE[1] - sharedV[1]);
    var lenAdj = Math.hypot(adjOther[0]    - sharedV[0], adjOther[1]    - sharedV[1]);
    if (lenE < 0.2 || lenAdj < 0.2) return false;

    var d = Math.min(distA, distB);
    d = Math.min(d, lenE * 0.49, lenAdj * 0.49);
    if (d < 0.15) return false;

    var v1x = snap(sharedV[0] + (d / lenE)   * (otherEndOnE[0] - sharedV[0]));
    var v1z = snap(sharedV[1] + (d / lenE)   * (otherEndOnE[1] - sharedV[1]));
    var v2x = snap(sharedV[0] + (d / lenAdj) * (adjOther[0]    - sharedV[0]));
    var v2z = snap(sharedV[1] + (d / lenAdj) * (adjOther[1]    - sharedV[1]));
    var v3x = snap(v1x + v2x - sharedV[0]);
    var v3z = snap(v1z + v2z - sharedV[1]);

    var v1 = [_clampCoord(v1x), _clampCoord(v1z)];
    var v2 = [_clampCoord(v2x), _clampCoord(v2z)];
    var v3 = [_clampCoord(v3x), _clampCoord(v3z)];

    if (distA <= distB) {
      poly.splice(sharedIdx, 1, v2, v3, v1);
    } else {
      poly.splice(sharedIdx, 1, v1, v3, v2);
    }
    return true;
  }

  var _CornerInserter = {
    pendingPlacement: false,
    _setPending: function (on) {
      if (_isGableShelter()) on = false;
      this.pendingPlacement = !!on;
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) canvas.style.cursor = on ? 'crosshair' : '';
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.classList.toggle('active', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    },
    init: function () {
      var self = this;
      var btn = document.getElementById('cf-btn-insert-corner');
      if (btn) {
        btn.addEventListener('click', function () {
          if (_isGableShelter()) { _cycleShelterShape(); return; }
          if (STATE.view !== '2d') return;
          self._setPending(!self.pendingPlacement);
        });
      }
      var canvas = document.getElementById('cf-canvas-base');
      if (canvas) {
        canvas.addEventListener('click', function (e) {
          if (!self.pendingPlacement) return;
          if (STATE.view !== '2d') { self._setPending(false); return; }
          var p = _screenToWorld(e.clientX, e.clientY);
          if (!p) return;
          var snapped = _snapToNearestPolygonEdge(p.x, p.z);
          if (!snapped) return;
          var prevPoly = JSON.parse(JSON.stringify(STATE.polygon));
          var ok = _insertCornerOnEdge(snapped.edgeIdx, snapped.tFrac);
          self._setPending(false);
          if (!ok) return;
          _UndoHistory.pushIfChanged(prevPoly, STATE.variant);
          rebuildDragHandles();
          if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
          refreshUI();
        });
      }
    }
  };

  var _AssetDrawer = {
    _ready: false,
    _raycaster: null,
    _mouse: null,
    _selectedMesh: null,
    _origMaterial: null,

    _HIGHLIGHT_HEX: 0xff8c42,

    _findBoQRow: function (boqCode) {
      var rows = computeBoQ();
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (Array.isArray(r) && r[0] === boqCode) {
          return { code: r[0], qty: r[1] || 0, qtyAlt: r[2] || 0 };
        }
        if (r && r.code === boqCode) return r;
      }
      return null;
    },

    _buildInstance: function (mesh) {
      if (!mesh || !mesh.userData || !mesh.userData.boqCode) return null;
      var ud = mesh.userData;
      var bridge = global.ConfiguratorBudgetBridge || null;

      var boqItem = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(ud.boqCode) : null;
      var name     = (boqItem && boqItem.name)     || ud.boqCode;
      var category = (boqItem && boqItem.category) || ud.category || ud.assetType;
      var unit     = boqItem
        ? (STATE.isMetric ? boqItem.unitMetric : boqItem.unitImperial)
        : null;
      if (!unit) unit = STATE.isMetric ? 'pcs' : 'pcs';

      var userPrice = (bridge && bridge.getUserPrice) ? bridge.getUserPrice(ud.boqCode) : null;
      var product = userPrice ? {
        title:    userPrice.title,
        url:      userPrice.url,
        image:    userPrice.image,
        source:   userPrice.source,
        price:    userPrice.price,
        currency: userPrice.currency,
        unit:     unit
      } : null;

      var row = this._findBoQRow(ud.boqCode);
      var qty = (row && typeof row.qty === 'number') ? row.qty : 0;
      var unitPrice = userPrice ? userPrice.price : 0;
      var totalPrice = qty * unitPrice;

      var pos = mesh.getWorldPosition ? mesh.getWorldPosition(new global.THREE.Vector3()) : { x: 0, y: 0, z: 0 };
      var inst = {
        id:                 ud.assetType + ':' + (ud.index != null ? ud.index : 0),
        name:               name,
        type:               name,
        boqCode:            ud.boqCode,
        category:           category,
        unit:               unit,
        projectQuantity:    qty,
        projectUnitPrice:   unitPrice,
        projectTotalPrice:  totalPrice,
        position:           { x: pos.x, y: pos.y, z: pos.z }
      };
      if (typeof ud.length === 'number') inst.length = ud.length;
      if (product) inst.product = product;
      return inst;
    },

    _i18nLabels: function () {
      var boot = global.BASE_BOOT || {};
      var i18n = boot.i18n || {};
      var ad = i18n.assetDrawer || {};
      var labels = {};
      for (var k in ad) { if (ad.hasOwnProperty(k)) labels[k] = ad[k]; }
      return labels;
    },

    _highlight: function (mesh) {
      this._clearHighlight();
      if (!mesh || !mesh.material) return;
      this._selectedMesh = mesh;
      this._origMaterial = mesh.material;
      try {
        var T = global.THREE;
        mesh.material = new T.MeshLambertMaterial({ color: this._HIGHLIGHT_HEX });
      } catch (_) {}
    },

    _clearHighlight: function () {
      if (this._selectedMesh && this._origMaterial) {
        try { this._selectedMesh.material = this._origMaterial; } catch (_) {}
      }
      this._selectedMesh = null;
      this._origMaterial = null;
    },

    init: function () {
      if (this._ready) return;
      if (!global.ConfiguratorAssetDrawer) {
        _dbg('AssetDrawer: ConfiguratorAssetDrawer global not loaded yet');
        var self = this;
        setTimeout(function () { self.init(); }, 200);
        return;
      }
      var T = global.THREE;
      if (!T) return;
      this._raycaster = new T.Raycaster();
      this._mouse = new T.Vector2();

      var self = this;
      global.ConfiguratorAssetDrawer.init({
        registry: function (id) {
          if (!self._selectedMesh) return null;
          return self._buildInstance(self._selectedMesh);
        },
        onClose: function () { self._clearHighlight(); },
        labels: this._i18nLabels(),
        drawerScopeClass: 'base-asset-drawer'
      });

      this._bindCanvas();
      this._ready = true;
      _dbg('AssetDrawer initialised');
    },

    _bindCanvas: function () {
      var self = this;
      var eng = global.BaseEngine;
      if (!eng || !eng.renderer || !eng.renderer.domElement) {
        setTimeout(function () { self._bindCanvas(); }, 100);
        return;
      }
      var canvas = eng.renderer.domElement;
      var pressStart = { x: 0, y: 0, t: 0 };

      canvas.addEventListener('pointerdown', function (e) {
        pressStart.x = e.clientX;
        pressStart.y = e.clientY;
        pressStart.t = Date.now();
      });

      canvas.addEventListener('pointerup', function (e) {
        if (STATE.view !== '3d') return;
        if (_CornerInserter && _CornerInserter.pendingPlacement) return;
        var dx = e.clientX - pressStart.x;
        var dy = e.clientY - pressStart.y;
        var dt = Date.now() - pressStart.t;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) return;
        if (dt > 500) return;
        self._handleCanvasClick(e);
      });
    },

    _handleCanvasClick: function (e) {
      var eng = global.BaseEngine;
      if (!eng || !eng.scene || !eng.cameraPersp || !eng.sceneGroup) return;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      this._mouse.x =  ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      this._mouse.y = -((e.clientY - rect.top)  / rect.height) * 2 + 1;
      this._raycaster.setFromCamera(this._mouse, eng.cameraPersp);
      var hits = this._raycaster.intersectObjects(eng.sceneGroup.children, true);
      if (!hits || !hits.length) {
        if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.isOpen && global.ConfiguratorAssetDrawer.isOpen()) {
          global.ConfiguratorAssetDrawer.close();
        }
        return;
      }
      var mesh = null;
      for (var i = 0; i < hits.length; i++) {
        var h = hits[i].object;
        if (h && h.userData && h.userData.boqCode) { mesh = h; break; }
      }
      if (!mesh) return;
      this._highlight(mesh);
      var instance = this._buildInstance(mesh);
      if (!instance) return;
      global.ConfiguratorAssetDrawer.open(instance.id);
    }
  };

  var _ProjectStore = {
    SCHEMA_VERSION:  1,
    MASTER_PAGE_URL: 'https://www.theleva.com/pages/my',
    CONFIG_KEY:      'shelters',

    _projectId:   null,
    _saveTimer:   null,
    _subscribers: {},
    _initialized: false,

    init: function () {
      if (this._initialized) return;
      var boot = global.BASE_BOOT || {};
      var pid = boot.linkedMainProjectId || null;
      var activeKey = this._activeKey();
      if (!pid) {
        try { pid = localStorage.getItem(activeKey); } catch (_) {}
      }
      if (!pid) {
        pid = this._generateUuid();
        try { localStorage.setItem(activeKey, pid); } catch (_) {}
      }
      this._projectId = pid;

      var self = this;
      global.addEventListener('storage', function (e) { self._onStorageEvent(e); });
      global.addEventListener('pagehide', function () { self.publishNow(); });

      this._initialized = true;
      _dbg('ProjectStore: project=' + pid + ' customer=' + this.getCustomerId());
    },

    getProjectId:  function () { return this._projectId; },
    getCustomerId: function () {
      var boot = global.BASE_BOOT || {};
      return (boot.customerId != null) ? String(boot.customerId) : 'anon';
    },

    _activeKey: function () {
      return 'levaActiveProject:c' + this.getCustomerId();
    },
    _payloadKey: function (configKey) {
      return 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':' + configKey;
    },

    _generateUuid: function () {
      if (global.crypto && global.crypto.randomUUID) {
        try { return global.crypto.randomUUID(); } catch (_) {}
      }
      return 'p-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    },

    _readTotalsFromWidget: function () {
      function parseNum(id) {
        var el = document.getElementById(id);
        if (!el) return 0;
        var t = (el.textContent || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
        return parseFloat(t) || 0;
      }
      return {
        materialKc:  parseNum('cf-bw-material'),
        executionKc: parseNum('cf-bw-execution'),
        totalKc:     parseNum('cf-bw-total'),
        hours:       parseNum('cf-bw-time')
      };
    },

    serialize: function () {
      var boot = global.BASE_BOOT || {};
      var poly = getFootprintPolygon();
      var bb   = getBBox();
      var area = computeArea();
      var per  = computePerimeter();
      var mapData = null;
      if (_MapManager && _MapManager.center) {
        mapData = {
          address: _MapManager.address || null,
          center:  _MapManager.center  || null,
          bearing: _MapManager.bearing || 0
        };
      }
      return {
        v:             this.SCHEMA_VERSION,
        configKey:     this.CONFIG_KEY,
        productHandle: boot.productHandle || null,
        productId:     boot.productId     || null,
        productTitle:  boot.productTitle  || null,
        variant:       STATE.variant,
        variantKey:    'shelters',
        lvl:           STATE.lvl,
        depth:         STATE.depth,
        edgeType:      STATE.edgeType,
        infiniteEdges: Array.isArray(STATE.infiniteEdges) ? STATE.infiniteEdges.slice() : [],
        wallMaterial:  STATE.wallMaterial,
        surface:       STATE.surface,
        shelterShape:  STATE.shelterShape,
        shelterRoofType: STATE.shelterRoofType,
        shelterFoundation: STATE.shelterFoundation,
        floors:        Math.max(1, STATE.floors | 0),
        stairsMode:    STATE.stairsMode,
        stairsSlot:    STATE.stairsSlot,
        shaft:         STATE.shaft,
        tank:          STATE.tank,
        panel:         STATE.panel,
        skimmers:      STATE.skimmers,
        jets:          STATE.jets,
        lights:        STATE.lights,
        lightStage:    STATE.lightStage,
        lightPos:      STATE.lightPos,
        slope:         { active: STATE.slopeActive, deg: STATE.slopeDeg },
        mapLocked:     STATE.mapLocked,
        vizStage:      STATE.vizStage,
        openings:      Array.isArray(STATE.openings) ? STATE.openings.slice() : [],
        units:         STATE.isMetric ? 'm' : 'ft',
        shape: {
          polygon:     poly,
          bboxL:       bb.L,
          bboxW:       bb.W,
          area:        area,
          perimeter:   per,
          cornerCount: poly.length
        },
        totals:        this._readTotalsFromWidget(),
        map:           mapData,
        updatedAt:     new Date().toISOString()
      };
    },

    publish: function () {
      _broadcastHouse();   /* real-time broadcast for locked sub-configs */
      var self = this;
      if (this._saveTimer) clearTimeout(this._saveTimer);
      this._saveTimer = setTimeout(function () { self.publishNow(); }, 500);
    },

    publishNow: function () {
      if (!this._initialized || !this._projectId) return;
      _broadcastHouse();
      try {
        var payload = this.serialize();
        localStorage.setItem(this._payloadKey(this.CONFIG_KEY), JSON.stringify(payload));
      } catch (e) {
        _dbg('ProjectStore publish error: ' + (e && e.message ? e.message : e));
      }
    },

    /* generic per-project sub-key write (partitions, floor-plan underlay …) — same
       project+customer scheme, so it rides along when ProjectStore later syncs to Firestore */
    writeKey: function (configKey, payload) {
      if (!this._initialized || !this._projectId || !configKey) return false;
      try { localStorage.setItem(this._payloadKey(configKey), JSON.stringify(payload)); return true; }
      catch (e) { _dbg('ProjectStore writeKey(' + configKey + ') error: ' + (e && e.message ? e.message : e)); return false; }
    },

    read: function (configKey) {
      if (!this._projectId || !configKey) return null;
      try {
        var raw = localStorage.getItem(this._payloadKey(configKey));
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || data.v !== this.SCHEMA_VERSION) return null;
        return data;
      } catch (e) { return null; }
    },

    list: function () {
      if (!this._projectId) return [];
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      var keys = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf(prefix) === 0) {
            keys.push(k.substring(prefix.length));
          }
        }
      } catch (e) {}
      return keys;
    },

    clear: function () {
      if (!this._projectId) return;
      try { localStorage.removeItem(this._payloadKey(this.CONFIG_KEY)); } catch (e) {}
    },

    subscribe: function (configKey, callback) {
      if (typeof callback !== 'function') return;
      if (!this._subscribers[configKey]) this._subscribers[configKey] = [];
      this._subscribers[configKey].push(callback);
    },

    unsubscribe: function (configKey, callback) {
      var arr = this._subscribers[configKey];
      if (!arr) return;
      for (var i = arr.length - 1; i >= 0; i--) {
        if (arr[i] === callback) arr.splice(i, 1);
      }
    },

    _onStorageEvent: function (e) {
      if (!this._projectId || !e || !e.key) return;
      var prefix = 'levaProject:p' + this._projectId + ':c' + this.getCustomerId() + ':';
      if (e.key.indexOf(prefix) !== 0) return;
      var configKey = e.key.substring(prefix.length);
      if (configKey === this.CONFIG_KEY) return;
      var arr = this._subscribers[configKey];
      if (!arr || !arr.length) return;
      var data = null;
      try { if (e.newValue) data = JSON.parse(e.newValue); } catch (_) {}
      for (var i = 0; i < arr.length; i++) {
        try { arr[i](data); } catch (_) {}
      }
    }
  };

  function _restoreFromProjectStore() {
    var data = _ProjectStore.read(_ProjectStore.CONFIG_KEY);
    if (!data) return false;
    var sh = data.shape || {};
    if (Array.isArray(sh.polygon) && sh.polygon.length >= 3) {
      var newPoly = [];
      for (var i = 0; i < sh.polygon.length; i++) {
        var p = sh.polygon[i];
        if (Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number') {
          newPoly.push([_clampCoord(p[0]), _clampCoord(p[1])]);
        }
      }
      if (newPoly.length >= 3) STATE.polygon = newPoly;
    }
    if (typeof data.variant === 'number' && data.variant >= 1 && data.variant <= 5) {
      STATE.variant = data.variant;
    }
    if (typeof data.lvl === 'number' && data.lvl >= 1 && data.lvl <= 3) {
      STATE.lvl = data.lvl;
    }
    if (typeof data.depth === 'number' && isFinite(data.depth)) {
      STATE.depth = data.depth;
    } else if (data.depth === null) {
      STATE.depth = null;
    }
    if (data.edgeType === 'overflow' || data.edgeType === 'skimmer' || data.edgeType === 'infinite') {
      STATE.edgeType = data.edgeType;
    }
    if (Array.isArray(data.infiniteEdges)) {
      STATE.infiniteEdges = data.infiniteEdges.filter(function (v) { return typeof v === 'number' && v >= 0; });
    }
    if (data.wallMaterial === 'eps' || data.wallMaterial === 'concrete') {
      STATE.wallMaterial = data.wallMaterial;
    }
    if (typeof data.surface === 'string' && SURFACES.indexOf(data.surface) >= 0) {
      STATE.surface = data.surface;
    }
    if (typeof data.shelterShape === 'string' && _shapeOrder.indexOf(data.shelterShape) >= 0) {
      STATE.shelterShape = data.shelterShape;
    }
    if (typeof data.shelterRoofType === 'string' && _roofOrder.indexOf(data.shelterRoofType) >= 0) {
      STATE.shelterRoofType = data.shelterRoofType;
    }
    if (typeof data.shelterFoundation === 'string' && _foundOrder.indexOf(data.shelterFoundation) >= 0) {
      STATE.shelterFoundation = data.shelterFoundation;
    }
    if (typeof data.floors === 'number' && _FLOORS.indexOf(data.floors | 0) !== -1) {
      STATE.floors = data.floors | 0;
    }
    if (typeof data.stairsMode === 'string' && STAIRS_CYCLE.indexOf(data.stairsMode) >= 0) {
      STATE.stairsMode = data.stairsMode;
    }
    if (typeof data.stairsSlot === 'number' && data.stairsSlot >= 0) {
      STATE.stairsSlot = data.stairsSlot | 0;
    }
    if (data.shaft && isFinite(data.shaft.x) && isFinite(data.shaft.z)) {
      STATE.shaft = { x: data.shaft.x, z: data.shaft.z };
    }
    if (data.tank && isFinite(data.tank.x) && isFinite(data.tank.z)) {
      STATE.tank = { x: data.tank.x, z: data.tank.z };
    }
    if (data.panel && isFinite(data.panel.x) && isFinite(data.panel.z)) {
      STATE.panel = { x: data.panel.x, z: data.panel.z };
    }
    if (Array.isArray(data.skimmers)) STATE.skimmers = data.skimmers.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (Array.isArray(data.jets))     STATE.jets     = data.jets.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (Array.isArray(data.lights))   STATE.lights   = data.lights.filter(function (p) { return p && isFinite(p.x) && isFinite(p.z); });
    if (typeof data.lightStage === 'number') STATE.lightStage = Math.max(0, Math.min(5, data.lightStage | 0));
    if (data.lightPos === 'A' || data.lightPos === 'B' || data.lightPos === 'C') STATE.lightPos = data.lightPos;
    if (data.slope && typeof data.slope.deg === 'number') {
      STATE.slopeDeg = Math.max(0, Math.min(15, data.slope.deg | 0));
      STATE.slopeActive = !!data.slope.active;
    }
    if (data.units === 'ft') STATE.isMetric = false;
    if (data.units === 'm')  STATE.isMetric = true;
    STATE.mapLocked = !!data.mapLocked;
    if (data.map && Array.isArray(data.map.center) && data.map.center.length === 2) {
      _pendingMapRestore = {
        center:  data.map.center,
        address: data.map.address || '',
        bearing: typeof data.map.bearing === 'number' ? data.map.bearing : 0
      };
    }
    if (typeof data.vizStage === 'number') STATE.vizStage = data.vizStage | 0;
    /* Restore the placed windows/doors. Primary source is this project's
       payload; fall back to the live mc:openings broadcast so work in
       progress survives the first refresh after this build shipped. The
       visualization manager clamps an out-of-range vizStage back to 0. */
    var _ops = Array.isArray(data.openings) ? data.openings : null;
    if (!_ops) {
      try { var _mo = JSON.parse(localStorage.getItem('mc:openings') || 'null'); if (Array.isArray(_mo)) _ops = _mo; } catch (e) {}
    }
    if (_ops) {
      STATE.openings = _ops.filter(function (o) {
        return o && typeof o.wallIdx === 'number' && typeof o.u === 'number' && o.sku;
      });
    }
    _pruneOpeningsAboveFloors();   /* drop any openings left on floors above the restored count */
    _dbg('ProjectStore: state restored from storage');
    return true;
  }

  var _pendingMapRestore = null;

  function _applyPendingMapRestore() {
    if (!_pendingMapRestore) return;
    if (!global.mapboxgl || !_MapManager || !_MapManager._loadMap) {
      setTimeout(_applyPendingMapRestore, 200);
      return;
    }
    var data = _pendingMapRestore;
    _pendingMapRestore = null;
    if (typeof data.bearing === 'number') _MapManager.bearing = data.bearing;
    try {
      _MapManager._loadMap(data.center, data.address);
      try { _MapManager.persist(); } catch (ep) {}
      _dbg('Map restored from storage: ' + JSON.stringify(data.center));
    } catch (e) {
      _dbg('Map restore failed: ' + e.message);
    }
  }

  function _init2DZoom() {
    function getCanvas() {
      return global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    }
    function getOrtho() {
      return global.BaseEngine && global.BaseEngine.cameraOrtho;
    }
    function render() {
      var eng = global.BaseEngine;
      if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
    }
    function applyZoom(factor) {
      var cam = getOrtho();
      if (!cam) return;
      cam.zoom = Math.max(0.05, Math.min(40, cam.zoom * factor));
      cam.updateProjectionMatrix();
      render();
      if (typeof positionDragHandles === 'function') positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.refreshDimensions) _VisualizationManager.refreshDimensions();
      _orthoEventEmitter.fire();
    }

    var canvas = getCanvas();
    if (!canvas) { setTimeout(_init2DZoom, 100); return; }

    canvas.addEventListener('wheel', function (e) {
      if (STATE.view !== '2d') return;
      e.preventDefault();
      var factor = e.deltaY > 0 ? (1 / 1.1) : 1.1;
      applyZoom(factor);
    }, { passive: false });

    var pinch = { active: false, lastDist: 0 };
    canvas.addEventListener('touchstart', function (e) {
      if (STATE.view !== '2d') return;
      if (e.touches.length === 2) {
        pinch.active = true;
        pinch.lastDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      }
    }, { passive: true });
    canvas.addEventListener('touchmove', function (e) {
      if (STATE.view !== '2d' || !pinch.active || e.touches.length !== 2) return;
      e.preventDefault();
      var dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      if (pinch.lastDist > 0) applyZoom(dist / pinch.lastDist);
      pinch.lastDist = dist;
    }, { passive: false });
    function endPinch(e) {
      if (!e.touches || e.touches.length < 2) pinch.active = false;
    }
    canvas.addEventListener('touchend',    endPinch);
    canvas.addEventListener('touchcancel', endPinch);
  }

  function _init2DMapPan() {
    var canvas = global.BaseEngine && global.BaseEngine.renderer && global.BaseEngine.renderer.domElement;
    if (!canvas) { setTimeout(_init2DMapPan, 100); return; }
    var drag = { active: false, lastX: 0, lastY: 0, pointerId: null };

    function canPan() {
      if (STATE.view !== '2d') return false;
      if (!_MapManager || !_MapManager.map) return false;
      if (_CornerInserter && _CornerInserter.pendingPlacement) return false;
      var mapDiv = document.getElementById('cf-mapbox');
      if (!mapDiv || !mapDiv.classList.contains('cf-map-visible')) return false;
      return true;
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (!canPan()) return;
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      drag.active = true;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      drag.pointerId = e.pointerId;
      try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
    });

    canvas.addEventListener('pointermove', function (e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      if (!canPan()) { drag.active = false; return; }
      var dx = e.clientX - drag.lastX;
      var dy = e.clientY - drag.lastY;
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      if (_MapManager.map && (dx !== 0 || dy !== 0)) {
        _MapManager.map.panBy([-dx, -dy], { animate: false });
      }
    });

    function endDrag(e) {
      if (!drag.active) return;
      drag.active = false;
      try { if (e) canvas.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    canvas.addEventListener('pointerup',     endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('pointerleave',  endDrag);
  }

  function _injectTooltipCSS() {
    if (document.getElementById('cf-tooltip-runtime-css-base')) return;
    var css = [
      '#cf-wrap-base .cf-icon-btn { position: relative !important; overflow: visible !important; }',
      '#cf-wrap-base .cf-sidebar { overflow: visible !important; }',
      '#cf-wrap-base .cf-icon-btn::after {',
      '  content: attr(title) !important;',
      '  position: absolute !important;',
      '  right: calc(100% + 8px) !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  background: rgba(20, 20, 20, 0.92) !important;',
      '  color: #fff !important;',
      '  padding: 6px 10px !important;',
      '  border-radius: 6px !important;',
      '  font: 600 11px/1.2 Montserrat, -apple-system, sans-serif !important;',
      '  letter-spacing: 0.02em !important;',
      '  white-space: nowrap !important;',
      '  pointer-events: none !important;',
      '  opacity: 0 !important;',
      '  transition: opacity 0.15s ease !important;',
      '  z-index: 9999 !important;',
      '  display: block !important;',
      '  visibility: visible !important;',
      '}',
      '#cf-wrap-base .cf-icon-btn:hover::after,',
      '#cf-wrap-base .cf-icon-btn:active::after,',
      '#cf-wrap-base .cf-icon-btn.show-tip::after { opacity: 1 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-tooltip-runtime-css-base';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _bindIconTooltips() {
    _injectTooltipCSS();
    var btns = document.querySelectorAll('#cf-wrap-base .cf-icon-btn');
    var tipTimer = null;
    btns.forEach(function (btn) {
      btn.addEventListener('touchstart', function () {
        if (tipTimer) clearTimeout(tipTimer);
        document.querySelectorAll('#cf-wrap-base .cf-icon-btn.show-tip').forEach(function (b) {
          b.classList.remove('show-tip');
        });
        btn.classList.add('show-tip');
        tipTimer = setTimeout(function () { btn.classList.remove('show-tip'); }, 1500);
      }, { passive: true });
    });
  }

  function _rebuildGrid(eng) {
    var T = global.THREE;
    if (!T || !eng || !eng.scene) return;
    if (eng._gridHelper) {
      eng.scene.remove(eng._gridHelper);
      if (eng._gridHelper.geometry) eng._gridHelper.geometry.dispose();
      if (eng._gridHelper.material) eng._gridHelper.material.dispose();
      eng._gridHelper = null;
    }
    var step = STATE.isMetric ? 1.0 : 0.3048;

    var BASE_SIZE = 30;
    var maxDim = 0;
    var poly = getFootprintPolygon();
    if (poly && poly.length >= 3) {
      var xmn = Infinity, xmx = -Infinity, zmn = Infinity, zmx = -Infinity;
      for (var gi = 0; gi < poly.length; gi++) {
        var gx = poly[gi][0], gz = poly[gi][1];
        if (gx < xmn) xmn = gx; if (gx > xmx) xmx = gx;
        if (gz < zmn) zmn = gz; if (gz > zmx) zmx = gz;
      }
      maxDim = Math.max(xmx - xmn, zmx - zmn);
    }
    var size = Math.max(BASE_SIZE, Math.ceil((maxDim * 1.2) / step) * step);
    var divisions = Math.round(size / step);
    eng._gridHelper = new T.GridHelper(size, divisions, 0xcccccc, 0xe5e5e5);

    eng._gridHelper.rotation.set(0, 0, 0);
    if (STATE.slopeActive && STATE.slopeDeg > 0) {

      eng._gridHelper.visible = false;
      eng.scene.add(eng._gridHelper);
      return;
    }
    eng._gridHelper.visible = true;
    eng.scene.add(eng._gridHelper);
  }

  function _applyGridVisibility(eng) {
    if (!eng || !eng._gridHelper) return;
    var slope = STATE.slopeActive && STATE.slopeDeg > 0;
    eng._gridHelper.visible = !slope;
  }

  var _orthoEventEmitter = {
    _listeners: [],
    addEventListener: function (name, cb) {
      if (name === 'change' && typeof cb === 'function') this._listeners.push(cb);
    },
    fire: function () {
      for (var i = 0; i < this._listeners.length; i++) {
        try { this._listeners[i](); } catch (e) {}
      }
    }
  };

  function _loadMapboxSDK() {
    if (global.mapboxgl) return Promise.resolve();
    if (global.__cfBaseMapSDKPromise) return global.__cfBaseMapSDKPromise;
    global.__cfBaseMapSDKPromise = new Promise(function (resolve, reject) {
      if (!document.getElementById('cf-mapbox-gl-css')) {
        var css = document.createElement('link');
        css.id = 'cf-mapbox-gl-css';
        css.rel = 'stylesheet';
        css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.css';
        document.head.appendChild(css);
      }
      var existing = document.getElementById('cf-mapbox-gl-js');
      if (existing) {
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', function () { reject(new Error('Mapbox SDK load failed')); });
        return;
      }
      var script = document.createElement('script');
      script.id = 'cf-mapbox-gl-js';
      script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.0.1/mapbox-gl.js';
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Mapbox SDK load failed')); };
      document.head.appendChild(script);
    });
    return global.__cfBaseMapSDKPromise;
  }

  function _injectMapCSS() {
    if (document.getElementById('cf-base-map-css')) return;
    var css = [
      '#cf-mapbox {',
      '  position: absolute !important; inset: 0;',
      '  width: 100% !important; height: 100% !important;',
      '  z-index: 0; background-color: #f5f5f5;',
      '  transition: opacity 0.35s ease; display: none;',
      '}',
      '#cf-mapbox.cf-map-visible { display: block; }',
      '#cf-wrap-base .cf-map-fade {',
      '  position: absolute; inset: 0; z-index: 1;',
      '  pointer-events: none; display: none;',
      '  background:',
      '    linear-gradient(to right,  rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) left   / 100% 100% no-repeat,',
      '    linear-gradient(to left,   rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) right  / 100% 100% no-repeat,',
      '    linear-gradient(to bottom, rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) top    / 100% 100% no-repeat,',
      '    linear-gradient(to top,    rgba(245,245,245,1) 0%, rgba(245,245,245,0.85) 4%, rgba(245,245,245,0.50) 8%, rgba(245,245,245,0) 14%) bottom / 100% 100% no-repeat;',
      '}',
      '#cf-wrap-base .cf-map-fade.cf-map-visible { display: block; }',
      '#cf-mapbox .mapboxgl-ctrl-attrib, #cf-mapbox .mapboxgl-ctrl-logo { display: none !important; }',
      '#cf-wrap-base .cf-map-credit {',
      '  position: absolute; left: 10px; bottom: 10px; z-index: 150;',
      '  font: 9px/1 system-ui, sans-serif; color: rgba(0,0,0,0.5);',
      '  background: rgba(255,255,255,0.7); padding: 3px 6px; border-radius: 4px;',
      '  pointer-events: none; display: none;',
      '}',
      '#cf-wrap-base .cf-map-credit.cf-map-visible { display: block; }',
      '#cf-wrap-base.cf-has-map .cf-canvas { background-color: transparent !important; }',
      '#cf-wrap-base.cf-has-map { background: #f5f5f5; }',
      '.cf-map-modal-backdrop {',
      '  position: fixed; inset: 0; z-index: 9999;',
      '  background: rgba(0,0,0,0.45); display: none;',
      '  align-items: center; justify-content: center;',
      '}',
      '.cf-map-modal-backdrop.open { display: flex; }',
      '.cf-map-modal {',
      '  background: #fff; border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,0.30);',
      '  padding: 18px 18px 14px; width: min(380px, calc(100vw - 32px));',
      '  font-family: Montserrat, -apple-system, sans-serif;',
      '}',
      '.cf-map-modal h3 {',
      '  margin: 0 0 12px; font-size: 14px; font-weight: 700; color: #111;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-input-wrap { position: relative; }',
      '.cf-map-modal input {',
      '  width: 100%; padding: 10px 12px; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  font: 13px/1.3 Montserrat, sans-serif; outline: none; box-sizing: border-box;',
      '}',
      '.cf-map-modal input:focus { border-color: #5A6B47; }',
      '.cf-map-modal-suggestions {',
      '  position: absolute; top: 100%; left: 0; right: 0; margin-top: 4px;',
      '  background: #fff; border: 1px solid #e0e0e0; border-radius: 8px;',
      '  box-shadow: 0 6px 20px rgba(0,0,0,0.10);',
      '  max-height: 220px; overflow-y: auto; display: none; z-index: 10;',
      '}',
      '.cf-map-modal-suggestions.open { display: block; }',
      '.cf-map-modal-sugg-item {',
      '  padding: 9px 12px; font: 12px/1.35 Montserrat, sans-serif; color: #333;',
      '  cursor: pointer; border-bottom: 1px solid #f0f0f0;',
      '}',
      '.cf-map-modal-sugg-item:last-child { border-bottom: none; }',
      '.cf-map-modal-sugg-item:hover { background: #f5f5f0; }',
      '.cf-map-modal-buttons { display: flex; gap: 8px; margin-top: 12px; }',
      '.cf-map-modal-btn {',
      '  flex: 1; padding: 9px 14px; border: none; border-radius: 8px;',
      '  font: 700 12px Montserrat, sans-serif; cursor: pointer;',
      '  letter-spacing: 0.02em;',
      '}',
      '.cf-map-modal-btn-cancel { background: #f0f0f0; color: #555; }',
      '.cf-map-modal-btn-cancel:hover { background: #e6e6e6; }',
      '.cf-map-modal-btn-ok { background: #5A6B47; color: #fff; }',
      '.cf-map-modal-btn-ok:hover { background: #4a5a3b; }',
      '.cf-map-modal-btn-ok:disabled { opacity: 0.4; cursor: not-allowed; }',
      '#cf-wrap-base .cf-map-controls.open { display: flex; }',
      '#cf-wrap-base .cf-map-controls > * { pointer-events: auto; }',
      '.cf-map-rotate-vert {',
      '  display: flex; flex-direction: column; align-items: center; gap: 8px;',
      '}',
      '.cf-map-rotate-slider {',
      '  -webkit-appearance: none; appearance: none;',
      '  accent-color: var(--cf-accent, #5A6B47);',
      '  writing-mode: vertical-lr; direction: rtl;',
      '  width: 4px; height: 320px;',
      '  background: linear-gradient(to top, var(--cf-accent, #5A6B47) 0%, var(--cf-accent, #5A6B47) var(--cf-fill, 0%), #e0e0e0 var(--cf-fill, 0%), #e0e0e0 100%);',
      '  border-radius: 10px; outline: none; cursor: pointer;',
      '}',
      '.cf-map-rotate-slider::-webkit-slider-thumb {',
      '  -webkit-appearance: none; appearance: none;',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-rotate-slider::-moz-range-thumb {',
      '  width: 12px; height: 12px; background: var(--cf-accent, #5A6B47);',
      '  border: none; border-radius: 50%; cursor: pointer;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.20);',
      '}',
      '.cf-map-right-col { display: flex; flex-direction: column; gap: 10px; }',
      '.cf-map-style-row { display: flex; gap: 6px; align-items: center; }',
      '.cf-map-style-btn {',
      '  width: 42px; height: 32px; border: none; border-radius: 8px; cursor: pointer;',
      '  background: rgba(255,255,255,0.92); color: #333; font: 700 10px sans-serif;',
      '  box-shadow: 0 2px 6px rgba(0,0,0,0.08);',
      '  display: flex; align-items: center; justify-content: center;',
      '  transition: all 0.15s;',
      '}',
      '.cf-map-style-btn.active { background: #111; color: #fff; }',
      '.cf-map-lock-btn { color: #888; }',
      '.cf-map-lock-btn.locked { background: #c44; color: #fff; }',
      '.cf-map-lock-btn.locked svg { stroke: #fff; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active { background: #5A6B47 !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active img,',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active svg { filter: brightness(0) invert(1) !important; }',
      '#cf-wrap-base .cf-icon-btn.cf-map-btn-active:hover { background: #5A6B47 !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-base-map-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _injectMapDOM() {
    var wrap = document.getElementById('cf-wrap-base');
    if (!wrap) return;
    var canvas = document.getElementById('cf-canvas-base');

    if (!document.getElementById('cf-mapbox')) {
      var mapDiv = document.createElement('div');
      mapDiv.id = 'cf-mapbox';
      if (canvas) wrap.insertBefore(mapDiv, canvas); else wrap.appendChild(mapDiv);
    }
    if (!wrap.querySelector('.cf-map-fade')) {
      var fade = document.createElement('div');
      fade.className = 'cf-map-fade';
      if (canvas) wrap.insertBefore(fade, canvas); else wrap.appendChild(fade);
    }
    if (!document.getElementById('cf-map-credit')) {
      var credit = document.createElement('div');
      credit.id = 'cf-map-credit';
      credit.className = 'cf-map-credit';
      credit.textContent = '© Mapbox © OpenStreetMap';
      wrap.appendChild(credit);
    }
    if (!document.getElementById('cf-map-controls')) {
      var ctrls = document.createElement('div');
      ctrls.id = 'cf-map-controls';
      ctrls.className = 'cf-map-controls cf-map-stacked';
      ctrls.innerHTML =
        '<div class="cf-map-rotate-vert">' +
        '  <input type="range" id="cf-map-rotate" class="cf-map-rotate-slider" min="0" max="360" step="1" value="0" aria-label="Rotation">' +
        '</div>' +
        '<div class="cf-map-right-col">' +
        '  <div class="cf-map-style-row">' +
        '    <button id="cf-map-style-streets" class="cf-map-style-btn active" type="button">MAP</button>' +
        '    <button id="cf-map-style-satellite" class="cf-map-style-btn" type="button">SAT</button>' +
        '    <button id="cf-map-lock" class="cf-map-style-btn cf-map-lock-btn" type="button" title="Lock map position" aria-pressed="false">' +
        '      <svg id="cf-map-lock-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '        <rect x="5" y="11" width="14" height="9" rx="2"/>' +
        '        <path d="M8 11V7a4 4 0 0 1 8 0v4" id="cf-map-lock-shackle"/>' +
        '      </svg>' +
        '    </button>' +
        '  </div>' +
        '</div>';
      wrap.appendChild(ctrls);
    }
    if (!document.getElementById('cf-map-modal-backdrop')) {
      var modal = document.createElement('div');
      modal.id = 'cf-map-modal-backdrop';
      modal.className = 'cf-map-modal-backdrop';
      modal.innerHTML =
        '<div class="cf-map-modal" role="dialog" aria-modal="true">' +
        '  <h3>Map location</h3>' +
        '  <div class="cf-map-modal-input-wrap">' +
        '    <input id="cf-map-address-input" type="text" placeholder="Address, city or place..." autocomplete="off">' +
        '    <div id="cf-map-suggestions" class="cf-map-modal-suggestions"></div>' +
        '  </div>' +
        '  <div class="cf-map-modal-buttons">' +
        '    <button id="cf-map-modal-cancel" type="button" class="cf-map-modal-btn cf-map-modal-btn-cancel">Cancel</button>' +
        '    <button id="cf-map-modal-ok" type="button" class="cf-map-modal-btn cf-map-modal-btn-ok" disabled>Load</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(modal);
    }
    var sidebar = wrap.querySelector('.cf-sidebar');
    if (sidebar && !document.getElementById('cf-btn-map')) {
      var btn = document.createElement('button');
      btn.id = 'cf-btn-map';
      btn.className = 'cf-icon-btn';
      btn.type = 'button';
      var _mapI18n = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
      btn.title = _mapI18n.fence_map || _mapI18n.addBackground || 'Add map background';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z"/><path d="M9 4v16"/><path d="M15 6v16"/></svg>';
      var shareBtn = document.getElementById('cf-btn-share');
      if (shareBtn && shareBtn.parentNode === sidebar) {
        sidebar.insertBefore(btn, shareBtn.nextSibling);
      } else {
        sidebar.appendChild(btn);
      }
    }
  }

  var _MapManager = (function () {
    var I18N_DEFAULTS = {
      rotation:           'Rotation',
      streets:            'Roadmap',
      satellite:          'Satellite',
      addressPlaceholder: 'Address, city or place…',
      load:               'Load',
      cancel:             'Cancel',
      modalTitle:         'Map location',
      addBackground:      'Add map background',
      changeLocation:     'Change map location'
    };

    var MM = {
      _deps: null,
      _i18n: I18N_DEFAULTS,
      _storageKey: null,
      MAPBOX_TOKEN: null,
      STYLE_STREETS:   'mapbox://styles/mapbox/light-v11',
      STYLE_SATELLITE: 'mapbox://styles/mapbox/satellite-streets-v12',

      map: null,
      currentStyle: 'streets',
      center: null,
      zoomLevel: null,
      bearing: 0,
      address: '',
      _geocodeAbort: null,
      _suggestionItems: [],
      _suppressStorageEvent: false,

      _bindUI: function () {
        var self = this;
        if (!global.mapboxgl) return;
        global.mapboxgl.accessToken = this.MAPBOX_TOKEN;

        var btn = document.getElementById('cf-btn-map');
        if (btn) btn.addEventListener('click', function () {
          var mapDiv = document.getElementById('cf-mapbox');
          var visible = mapDiv && mapDiv.classList.contains('cf-map-visible');
          if (self.map && visible) self._hideMap();
          else self._openModal();
        });

        var backdrop = document.getElementById('cf-map-modal-backdrop');
        var input    = document.getElementById('cf-map-address-input');
        var okBtn    = document.getElementById('cf-map-modal-ok');
        var cancelBtn= document.getElementById('cf-map-modal-cancel');
        var sugg     = document.getElementById('cf-map-suggestions');
        if (!backdrop || !input || !okBtn || !cancelBtn || !sugg) return;

        backdrop.addEventListener('click', function (e) {
          if (e.target === backdrop) self._closeModal();
        });
        cancelBtn.addEventListener('click', function () { self._closeModal(); });

        var debounceT = null;
        input.addEventListener('input', function () {
          clearTimeout(debounceT);
          var q = input.value.trim();
          if (q.length < 3) {
            sugg.classList.remove('open');
            okBtn.disabled = true;
            return;
          }
          debounceT = setTimeout(function () { self._geocode(q); }, 300);
        });

        okBtn.addEventListener('click', function () {
          var selected = null;
          for (var i = 0; i < self._suggestionItems.length; i++) {
            if (self._suggestionItems[i].selected) { selected = self._suggestionItems[i]; break; }
          }
          if (!selected) selected = self._suggestionItems[0];
          if (!selected) return;
          self._loadMap(selected.center, selected.label);
          self._closeModal();
        });

        var btnS  = document.getElementById('cf-map-style-streets');
        var btnSa = document.getElementById('cf-map-style-satellite');
        if (btnS)  btnS.addEventListener('click',  function () { self._setStyle('streets'); });
        if (btnSa) btnSa.addEventListener('click', function () { self._setStyle('satellite'); });

        var btnLock = document.getElementById('cf-map-lock');
        if (btnLock) {
          btnLock.addEventListener('click', function () {
            STATE.mapLocked = !STATE.mapLocked;
            _updateMapLockButton();
            if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
          });
        }

        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          var updateRotateFill = function () {
            var pct = (parseFloat(rotateInput.value) / 360) * 100;
            rotateInput.style.setProperty('--cf-fill', pct + '%');
          };
          rotateInput.addEventListener('input', function () {
            var deg = parseInt(rotateInput.value, 10);
            self.bearing = deg;
            if (self.map) {
              if (self._deps.getView() === '3d') {
                self._syncMapTo3D(false);
              } else {
                self.map.setBearing(deg);
              }
            }
            updateRotateFill();
            if (STATE.slopeActive && STATE.slopeDeg > 0) {
              if (self._slopeRefreshTimer) clearTimeout(self._slopeRefreshTimer);
              self._slopeRefreshTimer = setTimeout(function () {
                self._slopeRefreshTimer = null;
                if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
                refreshUI();
              }, 1000);
            }
          });
          updateRotateFill();
        }

        this._updateSidebarButton();
      },

      _openModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var input = document.getElementById('cf-map-address-input');
        if (bd) bd.classList.add('open');
        if (input) { input.value = this.address || ''; setTimeout(function () { input.focus(); }, 50); }
      },
      _closeModal: function () {
        var bd = document.getElementById('cf-map-modal-backdrop');
        var sugg = document.getElementById('cf-map-suggestions');
        if (bd) bd.classList.remove('open');
        if (sugg) sugg.classList.remove('open');
      },

      _geocode: function (query) {
        var self = this;
        if (this._geocodeAbort) this._geocodeAbort.abort();
        this._geocodeAbort = new AbortController();
        var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                  encodeURIComponent(query) + '.json?access_token=' + this.MAPBOX_TOKEN +
                  '&autocomplete=true&limit=5&types=address,place,locality,neighborhood,region';
        fetch(url, { signal: this._geocodeAbort.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var sugg = document.getElementById('cf-map-suggestions');
            var okBtn = document.getElementById('cf-map-modal-ok');
            if (!sugg || !okBtn) return;
            sugg.innerHTML = '';
            var feats = (data && data.features) || [];
            self._suggestionItems = feats.map(function (f, i) {
              return { label: f.place_name, center: f.center, selected: i === 0 };
            });
            if (!self._suggestionItems.length) {
              sugg.classList.remove('open');
              okBtn.disabled = true;
              return;
            }
            self._suggestionItems.forEach(function (s) {
              var div = document.createElement('div');
              div.className = 'cf-map-modal-sugg-item';
              div.textContent = s.label;
              div.addEventListener('click', function () {
                self._suggestionItems.forEach(function (it) { it.selected = false; });
                s.selected = true;
                var input = document.getElementById('cf-map-address-input');
                if (input) input.value = s.label;
                sugg.classList.remove('open');
                okBtn.disabled = false;
              });
              sugg.appendChild(div);
            });
            sugg.classList.add('open');
            okBtn.disabled = false;
          })
          .catch(function (e) {
            if (e && e.name !== 'AbortError') _dbg('geocode failed: ' + e.message);
          });
      },

      _computeZoomForLat: function (lat) {
        var wrap = document.getElementById('cf-wrap-base');
        if (!wrap) return 18;
        var canvasW = wrap.clientWidth;
        var cam = this._deps.orthoCamera;
        if (!cam) return 18;
        var frustumW = (cam.right - cam.left) / (cam.zoom || 1);
        var ourMpp = frustumW / canvasW;
        return Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / ourMpp);
      },

      _loadMap: function (center, label) {
        var self = this;
        this.center = center;
        this.address = label;
        this.zoomLevel = this._computeZoomForLat(center[1]);

        var mapDiv = document.getElementById('cf-mapbox');
        var creditEl = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        if (mapDiv) mapDiv.classList.add('cf-map-visible');
        if (creditEl) creditEl.classList.add('cf-map-visible');
        if (wrap) wrap.classList.add('cf-has-map');
        if (fade) fade.classList.add('cf-map-visible');

        if (global.BaseEngine && global.BaseEngine.scene) {
          global.BaseEngine.scene.background = null;
          if (global.BaseEngine.renderer && global.BaseEngine.renderer.setClearAlpha) {
            global.BaseEngine.renderer.setClearAlpha(0);
          }
        }

        if (this.map) {
          this.map.jumpTo({ center: center, zoom: this.zoomLevel, bearing: this.bearing });
        } else {
          this.map = new global.mapboxgl.Map({
            container: 'cf-mapbox',
            style: this.STYLE_STREETS,
            center: center,
            zoom: this.zoomLevel,
            bearing: this.bearing,
            pitch: 0,
            attributionControl: false,
            interactive: false,
            preserveDrawingBuffer: true
          });
          this.map.dragPan.disable();
          this.map.scrollZoom.disable();
          this.map.boxZoom.disable();
          this.map.dragRotate.disable();
          this.map.keyboard.disable();
          this.map.doubleClickZoom.disable();
          this.map.touchZoomRotate.disable();

          this._updateSidebarButton();

          var canvas = document.getElementById('cf-canvas-base');
          if (canvas) canvas.style.pointerEvents = 'auto';

          var syncZoom = function () {
            if (!self.map || !self.center) return;
            if (self._deps.getView() !== '2d-top') return;
            var z = self._computeZoomForLat(self.center[1]);
            if (Math.abs(z - self.zoomLevel) > 0.005) {
              self.zoomLevel = z;
              self.map.setZoom(z);
            }
          };
          if (this._deps.orthoControls && this._deps.orthoControls.addEventListener) {
            this._deps.orthoControls.addEventListener('change', syncZoom);
          }
          window.addEventListener('resize', function () { setTimeout(syncZoom, 50); });
          setTimeout(syncZoom, 100);

          if (this._deps.controls && this._deps.controls.addEventListener) {
            var _syncPending = false;
            this._deps.controls.addEventListener('change', function () {
              if (self._deps.getView() !== '3d' || !self.map || !self.center) return;
              if (_syncPending) return;
              _syncPending = true;
              requestAnimationFrame(function () {
                _syncPending = false;
                if (self._deps.getView() === '3d' && self.map && self.center) self._syncMapTo3D(false);
              });
            });
          }

          this.map.on('style.load', function () {
            self._install3DLayers();
            if (self._deps.getView() === '3d') self._syncMapTo3D(false);
            try { _MasterFP.start(); } catch (e) {}
          });

          this.map.on('moveend', function () {
            if (!self.map) return;
            var c = self.map.getCenter();
            self.center = [c.lng, c.lat];
            self.zoomLevel = self.map.getZoom();
            if (self._deps.getView() !== '3d') {
              self.bearing = self.map.getBearing();
            }

            self.persist();
            _broadcastHouse();
            if (_ProjectStore && _ProjectStore._initialized) _ProjectStore.publish();
          });

          _applyMapLockState();

          if (typeof ResizeObserver !== 'undefined' && mapDiv) {
            new ResizeObserver(function () {
              if (self.map) { self.map.resize(); syncZoom(); }
            }).observe(mapDiv);
          }
        }

        var ctrls = document.getElementById('cf-map-controls');
        if (ctrls) ctrls.classList.add('open');
        this._deps.onChange();
      },

      _hideMap: function () {
        var mapDiv = document.getElementById('cf-mapbox');
        var credit = document.getElementById('cf-map-credit');
        var wrap = document.getElementById('cf-wrap-base');
        var fade = document.querySelector('#cf-wrap-base .cf-map-fade');
        var ctrls = document.getElementById('cf-map-controls');
        if (mapDiv) mapDiv.classList.remove('cf-map-visible');
        if (credit) credit.classList.remove('cf-map-visible');
        if (fade)   fade.classList.remove('cf-map-visible');
        if (wrap)   wrap.classList.remove('cf-has-map');
        if (ctrls)  ctrls.classList.remove('open');
        if (global.BaseEngine && global.BaseEngine.scene && global.THREE) {
          global.BaseEngine.scene.background = new global.THREE.Color(0xf5f5f5);
          if (global.BaseEngine.renderer && global.BaseEngine.renderer.setClearAlpha) {
            global.BaseEngine.renderer.setClearAlpha(1);
          }
        }
      },

      _setStyle: function (s) {
        if (!this.map) return;
        this.currentStyle = s;
        var url = s === 'satellite' ? this.STYLE_SATELLITE : this.STYLE_STREETS;
        this.map.setStyle(url);
        var b1 = document.getElementById('cf-map-style-streets');
        var b2 = document.getElementById('cf-map-style-satellite');
        if (b1) b1.classList.toggle('active', s === 'streets');
        if (b2) b2.classList.toggle('active', s === 'satellite');
        this._deps.onChange();
      },

      _install3DLayers: function () {
        if (!this.map) return;
        var m = this.map;
        try {
          if (!m.getLayer('cf-sky')) {
            m.addLayer({
              id: 'cf-sky', type: 'sky',
              paint: { 'sky-type': 'atmosphere', 'sky-atmosphere-sun-intensity': 5 }
            });
          }
        } catch (e) {}
        try {
          if (!m.getLayer('cf-3d-buildings') && m.getSource('composite')) {
            m.addLayer({
              id: 'cf-3d-buildings',
              source: 'composite',
              'source-layer': 'building',
              filter: ['==', 'extrude', 'true'],
              type: 'fill-extrusion',
              minzoom: 14,
              paint: {
                'fill-extrusion-color': '#d6cfc2',
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'min_height'],
                'fill-extrusion-opacity': 0.85
              }
            });
          }
        } catch (e) {}
        this._set3DLayerVisibility(this._deps.getView() === '3d');
      },

      _computeMapStateFor3D: function () {
        if (!this._deps.camera || !this._deps.controls || !this.center) return null;
        var target = this._deps.controls.target;
        var pos = this._deps.camera.position;
        var offX = pos.x - target.x;
        var offY = pos.y - target.y;
        var offZ = pos.z - target.z;
        var horiz = Math.sqrt(offX*offX + offZ*offZ);
        var dist = Math.sqrt(horiz*horiz + offY*offY);
        if (dist < 0.01) return null;
        var elev = Math.atan2(offY, horiz);
        var pitch = Math.max(0, Math.min(85, 90 - elev * 180 / Math.PI));
        var sceneBearingDeg = Math.atan2(-offX, offZ) * 180 / Math.PI;
        var bearing = (this.bearing || 0) + sceneBearingDeg;
        var wrap = document.getElementById('cf-wrap-base');
        var canvasH = wrap ? wrap.clientHeight : 600;
        var fovRad = this._deps.camera.fov * Math.PI / 180;
        var heightAtTarget = 2 * dist * Math.tan(fovRad / 2);
        var mpp = heightAtTarget / canvasH;
        var lat = this.center[1];
        var zoom = Math.log2(78271.51696 * Math.cos(lat * Math.PI / 180) / mpp);
        return { pitch: pitch, bearing: bearing, zoom: zoom };
      },

      _syncMapTo3D: function (animate) {
        if (!this.map || !this.center) return;
        var s = this._computeMapStateFor3D();
        if (!s) return;
        if (animate) this.map.easeTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom, duration: 400 });
        else         this.map.jumpTo({ pitch: s.pitch, bearing: s.bearing, zoom: s.zoom });
      },

      _syncMapTo2D: function (animate) {
        if (!this.map || !this.center) return;
        var z = this._computeZoomForLat(this.center[1]);
        this.zoomLevel = z;
        if (animate) this.map.easeTo({ pitch: 0, bearing: this.bearing || 0, zoom: z, duration: 400 });
        else         this.map.jumpTo({ pitch: 0, bearing: this.bearing || 0, zoom: z });
      },

      _set3DLayerVisibility: function (visible) {
        if (!this.map) return;
        var v = visible ? 'visible' : 'none';
        var ids = ['cf-3d-buildings', 'cf-sky'];
        for (var i = 0; i < ids.length; i++) {
          try {
            if (this.map.getLayer(ids[i])) this.map.setLayoutProperty(ids[i], 'visibility', v);
          } catch (e) {}
        }
      },

      _updateSidebarButton: function () {
        var btn = document.getElementById('cf-btn-map');
        if (!btn) return;
        if (this.map) {
          btn.classList.add('cf-map-btn-active');
          btn.title = this._i18n.changeLocation;
        } else {
          btn.classList.remove('cf-map-btn-active');
          btn.title = this._i18n.addBackground;
        }
      },

      _panMeters: function (dirX, dirZ) {
        if (!this.map) return;
        var lat = this.center[1];
        var zoom = this.map.getZoom();
        var mpp = 78271.51696 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
        var dx = dirX / mpp;
        var dy = dirZ / mpp;
        this.map.panBy([dx, dy], { animate: false });
        var c = this.map.getCenter();
        this.center = [c.lng, c.lat];
        this._deps.onChange();
      },

      serialize: function () {
        if (!this.map || !this.center) return null;
        return {
          center: this.center,
          bearing: this.bearing || 0,
          style: this.currentStyle,
          address: this.address
        };
      },
      restore: function (data) {
        if (!data || !data.center) return;
        this.bearing = data.bearing || 0;
        var rotateInput = document.getElementById('cf-map-rotate');
        if (rotateInput) {
          rotateInput.value = Math.round(this.bearing);
          rotateInput.style.setProperty('--cf-fill', (this.bearing / 360 * 100) + '%');
        }
        this._loadMap(data.center, data.address || '');
        if (data.style === 'satellite') this._setStyle('satellite');
      },

      persist: function () {
        if (!this._storageKey) return;
        var data = this.serialize();
        if (!data) return;
        try {
          this._suppressStorageEvent = true;
          localStorage.setItem(this._storageKey, JSON.stringify(data));
          var self = this;
          setTimeout(function () { self._suppressStorageEvent = false; }, 0);
        } catch (e) {}
      },
      loadFromStorage: function () {
        if (!this._storageKey) return false;
        try {
          var raw = localStorage.getItem(this._storageKey);
          if (!raw) return false;
          var data = JSON.parse(raw);
          this.restore(data);
          return true;
        } catch (e) { return false; }
      },

      _onStorageEvent: function (e) {
        if (this._suppressStorageEvent) return;
        if (!this._storageKey || e.key !== this._storageKey) return;
        if (!e.newValue) return;
        try {
          var data = JSON.parse(e.newValue);
          var oldCenter = this.center;
          if (!oldCenter || data.center[0] !== oldCenter[0] || data.center[1] !== oldCenter[1]) {
            this.restore(data);
          } else {
            if (typeof data.bearing === 'number') {
              this.bearing = data.bearing;
              if (this.map) this.map.setBearing(data.bearing);
              var ri = document.getElementById('cf-map-rotate');
              if (ri) {
                ri.value = Math.round(data.bearing);
                ri.style.setProperty('--cf-fill', (data.bearing / 360 * 100) + '%');
              }
            }
            if (data.style && data.style !== this.currentStyle) this._setStyle(data.style);
          }
        } catch (err) {}
      }
    };

    var _initialized = false;
    MM.init = function (opts) {
      opts = opts || {};
      var hostOnChange = opts.onChange || function () {};
      MM._deps = opts.engine ? Object.assign({}, opts.engine, {
        getView:       opts.getView       || function () { return '2d-top'; },
        getRootSize:   opts.getRootSize   || function () { return { w: window.innerWidth, h: window.innerHeight }; },
        getPadStep:    opts.getPadStep    || function () { return 2; },
        onChange:      function () { MM.persist(); hostOnChange(); },
        requestRender: opts.requestRender || function () {}
      }) : null;

      var _bi = opts.i18n || {};
      var _mapped = {
        rotation:           _bi.fence_map_rotate     || _bi.map_rotate,
        streets:            _bi.fence_map_streets     || _bi.map_streets,
        satellite:          _bi.fence_map_satellite,
        addressPlaceholder: _bi.fence_map_address_placeholder || _bi.map_address_placeholder,
        load:               _bi.fence_map_load        || _bi.map_load,
        modalTitle:         _bi.fence_map_modal_title || _bi.map_modal_title,
        addBackground:      _bi.fence_map,
        changeLocation:     _bi.fence_map_change      || _bi.map_change
      };
      Object.keys(_mapped).forEach(function (k) { if (_mapped[k] == null) delete _mapped[k]; });
      MM._i18n = Object.assign({}, I18N_DEFAULTS, _bi, _mapped);
      MM._storageKey = opts.storageKey || 'levaMap:default';
      MM.MAPBOX_TOKEN = opts.token || MM.MAPBOX_TOKEN;
      if (_initialized) return;
      _initialized = true;
      window.addEventListener('storage', function (e) { MM._onStorageEvent(e); });
      MM._bindUI();
    };

    return MM;
  })();

  function _initMap() {
    var token = (global.BASE_BOOT && global.BASE_BOOT.mapboxToken) || global.MAPBOX_TOKEN;
    if (!token) {
      _dbg('map: no MAPBOX_TOKEN — map feature disabled');
      return;
    }
    _injectMapCSS();
    _injectMapDOM();
    _loadMapboxSDK().then(function () {
      var boot = global.BASE_BOOT || {};
      var storageKey = 'levaMap:p' + (boot.productId || '0') + ':c' + (boot.customerId || 'anon');
      _MapManager.init({
        token: token,
        storageKey: storageKey,
        i18n: boot.i18n || {},
        engine: {
          camera:        global.BaseEngine.cameraPersp,
          controls:      global.BaseEngine.controls,
          orthoCamera:   global.BaseEngine.cameraOrtho,
          orthoControls: _orthoEventEmitter
        },
        getView: function () { return STATE.view === '2d' ? '2d-top' : '3d'; },
        getRootSize: function () {
          var w = document.getElementById('cf-wrap-base');
          return { w: w ? w.clientWidth : 0, h: w ? w.clientHeight : 0 };
        },
        getPadStep: function () {
          var bb = (typeof getBBox === 'function') ? getBBox() : null;
          if (!bb) return 2;
          return Math.max(1, Math.min(20, (bb.L + bb.W) * 0.025));
        },
        onChange: function () {},
        requestRender: function () {
          var eng = global.BaseEngine;
          if (eng && eng.renderer && eng.camera) eng.renderer.render(eng.scene, eng.camera);
        }
      });
      if (_pendingMapRestore) {
        _applyPendingMapRestore();
      } else {
        _MapManager.loadFromStorage();
      }
    }).catch(function (err) {
      _dbg('map: ' + (err && err.message ? err.message : err));
    });
  }

  /* ===================================================================
     MASTER FOOTPRINTS — other projects' footprints + title pills on the
     house map. Reads every mc:representation:* the sub-configurators saved
     (single source of truth), projects each footprint to scale, labels it
     with a pill. The house's own module is skipped. Merged into the lib so
     there is no extra asset file.
     ================================================================== */
  var _MasterFP = (function () {
    var SELF_HANDLE = 'main-house';
    var SRC = 'lmf-fp';
    var PILL_COLORS = ['#D8232A', '#5A6B47', '#7b5fc9', '#3C7A8C', '#B5803C', '#C2185B', '#2E7D32', '#262626'];
    var _pills = {};
    var _parseCache = {};
    var _colorMap = {};
    var _started = false;
    var _ring = null;
    var _busy = false;   /* true while dragging/rotating on the master */
    var _override = {};    /* handle -> { center?, bearing?, t } live drag/rotate
                              on the master; wins until a fresher live placement
                              (from the configurator) arrives. */
    var _livePlace = {};   /* handle -> { center, bearing, t } from the
                              configurator's OWN live levaProject payload,
                              which is fresher than the synthesized repr */

    function readLivePlacements() {
      var out = {};
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!k || k.indexOf('levaProject:') !== 0) continue;
          var raw = localStorage.getItem(k); if (!raw) continue;
          var p; try { p = JSON.parse(raw); } catch (e) { continue; }
          if (!p || !p.productHandle || !p.map) continue;
          var c = p.map.center;
          if (!Array.isArray(c) || !isFinite(+c[0]) || !isFinite(+c[1])) continue;
          var t = Date.parse(p.updatedAt || '') || 0;
          var prev = out[p.productHandle];
          if (!prev || t >= prev.t) {
            out[p.productHandle] = { center: [+c[0], +c[1]], bearing: +p.map.bearing || 0, t: t, masterLinked: !!p.masterLinked };
          }
        }
      } catch (e) {}
      _livePlace = out;
      /* drop a master override once the configurator's own live placement
         is newer than it (so a later config edit wins) */
      Object.keys(_override).forEach(function (h) {
        var live = out[h];
        if (live && live.t > (_override[h].t || 0)) delete _override[h];
      });
    }

    function map() { return (_MapManager && _MapManager.map) || null; }

    function readRepresentations() {
      var out = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!k || k.indexOf('mc:representation:') !== 0) continue;
          var handle = k.slice('mc:representation:'.length);
          if (!handle || handle === SELF_HANDLE) continue;
          var raw = localStorage.getItem(k);
          if (!raw) continue;
          var r; try { r = JSON.parse(raw); } catch (e) { continue; }
          if (r && typeof r === 'object') out.push({ handle: handle, repr: r });
        }
      } catch (e) {}
      return out;
    }

    function parsePoly(repr) {
      if (!repr || !repr.footprint2D || !repr.bbox) return null;
      var svg = repr.footprint2D;
      var vb = /viewBox=["']\s*0\s+0\s+([\d.]+)\s+([\d.]+)/.exec(svg);
      var pts = /points=["']([^"']+)["']/.exec(svg);
      if (!vb || !pts) return null;
      var vbW = parseFloat(vb[1]), vbH = parseFloat(vb[2]);
      if (!(vbW > 0) || !(vbH > 0)) return null;
      var mPerPxX = (repr.bbox.length || vbW / 100) / vbW;
      var mPerPxY = (repr.bbox.width || vbH / 100) / vbH;
      var cx = vbW / 2, cy = vbH / 2;
      var nums = pts[1].trim().split(/[\s,]+/).map(parseFloat);
      var poly = [];
      for (var i = 0; i + 1 < nums.length; i += 2) {
        if (!isFinite(nums[i]) || !isFinite(nums[i + 1])) return null;
        poly.push([(nums[i] - cx) * mPerPxX, (nums[i + 1] - cy) * mPerPxY]);
      }
      return poly.length >= 3 ? poly : null;
    }

    function polyFor(entry) {
      var repr = entry.repr;
      var stamp = String(repr.updatedAt || '') + ':' + String((repr.footprint2D || '').length);
      var c = _parseCache[entry.handle];
      if (c && c.stamp === stamp) return c.poly;
      var poly = parsePoly(repr);
      _parseCache[entry.handle] = { stamp: stamp, poly: poly };
      return poly;
    }

    function liveFresher(handle, repr) {
      var live = _livePlace[handle];
      if (!live) return null;
      var rt = (repr && Date.parse(repr.updatedAt || '')) || 0;
      /* live payload is the configurator's own latest; use it when it is
         at least as new as the synthesized representation */
      return (live.t >= rt) ? live : null;
    }

    function anchorFor(repr, handle) {
      var ov = handle ? _override[handle] : null;
      if (ov && ov.center) return ov.center.slice();
      var live = handle ? liveFresher(handle, repr) : null;
      if (live) return live.center.slice();
      if (repr && repr.map && Array.isArray(repr.map.center) &&
          isFinite(+repr.map.center[0]) && isFinite(+repr.map.center[1])) {
        return [+repr.map.center[0], +repr.map.center[1]];
      }
      if (repr && repr.location && isFinite(+repr.location.lng) && isFinite(+repr.location.lat)) {
        return [+repr.location.lng, +repr.location.lat];
      }
      return null;
    }

    function rotationFor(repr, handle) {
      var ov = handle ? _override[handle] : null;
      if (ov && isFinite(ov.bearing)) return ov.bearing;
      var live = handle ? liveFresher(handle, repr) : null;
      if (live && isFinite(live.bearing)) return live.bearing;
      if (repr && repr.map && isFinite(+repr.map.bearing)) return +repr.map.bearing;
      return 0;
    }

    function setOverride(handle, key, val) {
      var o = _override[handle] || {};
      o[key] = val;
      o.t = Date.now();
      _override[handle] = o;
    }

    function labelFor(entry) {
      var r = entry.repr;
      var t = r.productTitle || r.title || entry.handle;
      return String(t).replace(/[-_]/g, ' ').toUpperCase();
    }

    /* ---- COLOURS: FIXED per product type (no order-based assignment) so a
       module wears the SAME colour everywhere — footprint, nearby pills,
       budget overview. Keyed by canonical typeKey (handles normalised &
       aliased: foundations→base, fences→fence, carport/shelter→shelters). -- */
    var _TYPE_ALIASES = { foundations: 'base', fences: 'fence', shelter: 'shelters', carport: 'shelters' };

    function _typeKey(key) {
      return String(key || '').replace(/^repr_/, '').toLowerCase();
    }
    function _canonType(key) {
      var k = _typeKey(key);
      return _TYPE_ALIASES[k] || k;
    }

    /* Fixed product → colour map. Confirmed: foundations(base)=green,
       pool=blue. Others assigned distinct palette colours; adjust here only. */
    var _FIXED_COLORS = {
      base:       '#5A6B47',  /* foundations — green   */
      structure:  '#E08A2B',  /* structure   — amber   */
      roof:       '#6D4C41',  /* roof        — tile-brown*/
      pool:       '#3C7A8C',  /* pool        — blue    */
      shelters:   '#D8232A',  /* shelter/carport — red */
      fence:      '#7b5fc9',  /* fences      — purple  */
      bench:      '#B5803C',
      rack:       '#C2185B',
      swings:     '#2E7D32',
      aframe:     '#262626'
    };

    function buildColorMap() { /* fixed map → nothing to build */ }

    function colorForHandle(handle) {
      var k = _canonType(handle);
      if (_FIXED_COLORS[k]) return _FIXED_COLORS[k];
      /* deterministic (NOT order-based) fallback for any unmapped type */
      var h = 0;
      for (var i = 0; i < k.length; i++) h = ((h << 5) - h + k.charCodeAt(i)) | 0;
      return PILL_COLORS[Math.abs(h) % PILL_COLORS.length];
    }

    function feature(entry) {
      var poly = polyFor(entry), anchor = anchorFor(entry.repr, entry.handle);
      if (!poly || !anchor) return null;
      var rot = (rotationFor(entry.repr, entry.handle) || 0) * Math.PI / 180;
      var cosR = Math.cos(rot), sinR = Math.sin(rot);
      var lat0 = anchor[1], lng0 = anchor[0];
      var mPerDegLat = 111320, mPerDegLng = 111320 * Math.cos(lat0 * Math.PI / 180) || 1;
      var ring = poly.map(function (p) {
        var x = p[0] * cosR - p[1] * sinR;
        var y = p[0] * sinR + p[1] * cosR;
        return [lng0 + x / mPerDegLng, lat0 - y / mPerDegLat];
      });
      ring.push(ring[0]);
      return { type: 'Feature', properties: { handle: entry.handle, label: labelFor(entry), color: colorForHandle(entry.handle) },
               geometry: { type: 'Polygon', coordinates: [ring] } };
    }

    function ensureLayers() {
      var m = map();
      if (!m || !m.getSource) return;
      try {
        if (!m.getSource(SRC)) m.addSource(SRC, { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
        if (!m.getLayer('lmf-fp-fill')) m.addLayer({ id: 'lmf-fp-fill', type: 'fill', source: SRC,
          paint: { 'fill-color': ['get', 'color'], 'fill-opacity': 0.22 } });
        if (!m.getLayer('lmf-fp-line')) m.addLayer({ id: 'lmf-fp-line', type: 'line', source: SRC,
          paint: { 'line-color': ['get', 'color'], 'line-width': 2 } });
      } catch (e) {}
    }

    /* persist a moved/rotated footprint back to its representation AND the
       module's levaProject payload(s) so the change survives + syncs to the
       configurator and the cloud (last-write-wins via updatedAt). */
    function persistPlacement(handle, lng, lat, bearing) {
      var nowIso = new Date().toISOString();
      try {
        var rk = 'mc:representation:' + handle;
        var rraw = localStorage.getItem(rk);
        if (rraw) {
          var r = JSON.parse(rraw);
          if (r && typeof r === 'object') {
            r.map = r.map || {};
            r.map.center = [lng, lat];
            if (isFinite(bearing)) r.map.bearing = bearing;
            r.updatedAt = nowIso;
            localStorage.setItem(rk, JSON.stringify(r));
          }
        }
      } catch (e) {}
      var productIds = {};
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!k || k.indexOf('levaProject:') !== 0) continue;
          var raw = localStorage.getItem(k); if (!raw) continue;
          var p; try { p = JSON.parse(raw); } catch (e2) { continue; }
          if (!p || p.productHandle !== handle) continue;
          if (p.productId) productIds[String(p.productId)] = true;
          p.map = p.map || {};
          p.map.center = [lng, lat];
          if (isFinite(bearing)) p.map.bearing = bearing;
          p.updatedAt = nowIso;
          try { localStorage.setItem(k, JSON.stringify(p)); } catch (e3) {}
        }
      } catch (e4) {}
      /* The LIVE cross-surface bridge: an already-open configurator listens
         on its levaMap:p<productId>:c<cid> key and moves its map the moment
         that key changes. Without this the move/rotate only shows on the
         master. Update every matching levaMap key. */
      try {
        var mapKeys = [];
        for (var j = 0; j < localStorage.length; j++) {
          var mk = localStorage.key(j);
          if (!mk || mk.indexOf('levaMap:p') !== 0) continue;
          var sep = mk.indexOf(':', 9);
          var pid = mk.slice(9, sep > 0 ? sep : mk.length);
          if (productIds[pid]) mapKeys.push(mk);
        }
        for (var mi = 0; mi < mapKeys.length; mi++) {
          var mraw = localStorage.getItem(mapKeys[mi]);
          var md; try { md = mraw ? JSON.parse(mraw) : null; } catch (e5) { md = null; }
          md = (md && typeof md === 'object') ? md : {};
          md.center = [lng, lat];
          if (isFinite(bearing)) md.bearing = bearing;
          try { localStorage.setItem(mapKeys[mi], JSON.stringify(md)); } catch (e6) {}
        }
      } catch (e7) {}
    }

    /* ---- interaction overlay (ABOVE the Three.js canvas) ------------
       The configurator's 3D canvas sits over the map with pointer-events,
       so mapbox markers underneath never receive drags. We render pills and
       the rotation ring into our own overlay placed above the canvas and
       position them with map.project(); drags convert back via unproject. */
    var _overlay = null;
    var _entries = [];

    function ensureOverlay() {
      if (_overlay && document.body.contains(_overlay)) return _overlay;
      var host = document.getElementById('cf-wrap-base') || document.body;
      _overlay = document.createElement('div');
      _overlay.id = 'lmf-overlay';
      _overlay.style.cssText = 'position:absolute;inset:0;z-index:60;pointer-events:none;overflow:hidden;';
      host.appendChild(_overlay);
      return _overlay;
    }

    function project(lngLat) {
      var m = map();
      if (!m) return null;
      var p = m.project({ lng: lngLat[0], lat: lngLat[1] });
      return p;
    }

    function clearPills() {
      if (_overlay) _overlay.innerHTML = '';
      _pills = {};
      _ring = null;
    }

    function renderPills(entries) {
      var m = map();
      if (!m) return;
      _entries = entries;
      ensureOverlay();
      _overlay.innerHTML = '';
      _pills = {};
      entries.forEach(function (entry) {
        var anchor = anchorFor(entry.repr, entry.handle), poly = polyFor(entry);
        if (!anchor || !poly) return;
        var label = labelFor(entry), color = colorForHandle(entry.handle);
        var el = document.createElement('div');
        el.className = 'lmf-pill';
        el.textContent = label;
        el.style.background = color;
        el.style.color = '#fff';
        el.style.position = 'absolute';
        el.style.pointerEvents = 'auto';
        el.style.transform = 'translate(-50%, -50%)';
        _overlay.appendChild(el);
        _pills[entry.handle] = { el: el, entry: entry };

        /* tap = open this module's configurator (same as reaching foundation
           from the main house); drag (beyond the slop) = move the footprint. */
        var dragging = false, moved = false, sx = 0, sy = 0;
        var TAP_SLOP = 6;
        function evXY(ev) {
          if (ev.touches && ev.touches[0]) return [ev.touches[0].clientX, ev.touches[0].clientY];
          if (ev.changedTouches && ev.changedTouches[0]) return [ev.changedTouches[0].clientX, ev.changedTouches[0].clientY];
          return [ev.clientX, ev.clientY];
        }
        function down(ev) {
          ev.preventDefault(); ev.stopPropagation();
          dragging = true; moved = false; _busy = true;
          var p0 = evXY(ev); sx = p0[0]; sy = p0[1];
          document.addEventListener('mousemove', move);
          document.addEventListener('touchmove', move, { passive: false });
          document.addEventListener('mouseup', up);
          document.addEventListener('touchend', up);
        }
        function move(ev) {
          if (!dragging) return;
          var p = evXY(ev);
          if (!moved && Math.abs(p[0] - sx) < TAP_SLOP && Math.abs(p[1] - sy) < TAP_SLOP) return;
          ev.preventDefault();
          moved = true;
          var rect = (map().getCanvas()).getBoundingClientRect();
          var ll = map().unproject([p[0] - rect.left, p[1] - rect.top]);
          setOverride(entry.handle, 'center', [ll.lng, ll.lat]);
          liveUpdate();
          reposition();
        }
        function up() {
          if (!dragging) return;
          dragging = false; _busy = false;
          document.removeEventListener('mousemove', move);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('mouseup', up);
          document.removeEventListener('touchend', up);
          if (!moved) { openConfigurator(entry); return; }   /* tap → open configurator */
          var a = anchorFor(entry.repr, entry.handle);
          if (a) persistPlacement(entry.handle, a[0], a[1], rotationFor(entry.repr, entry.handle));
          showRing(entry);
        }
        el.addEventListener('mousedown', down);
        el.addEventListener('touchstart', down, { passive: false });
        el.style.cursor = 'pointer';
        el.title = label;
      });
      renderLaunchers();   /* re-add launcher column wiped by innerHTML reset */
      reposition();
    }

    function reposition() {
      if (!_overlay) return;
      Object.keys(_pills).forEach(function (h) {
        var pill = _pills[h];
        var a = anchorFor(pill.entry.repr, pill.entry.handle);
        if (!a) return;
        var p = project(a);
        if (p) { pill.el.style.left = p.x + 'px'; pill.el.style.top = p.y + 'px'; }
      });
      if (_ring) {
        var a = anchorFor(_ring.entry.repr, _ring.entry.handle);
        var p = a ? project(a) : null;
        if (p) { _ring.wrap.style.left = p.x + 'px'; _ring.wrap.style.top = p.y + 'px'; }
      }
      repositionLaunchers();
    }

    /* =================================================================
       SUB-CONFIG LAUNCHERS — a column of pills next to the main house.
       For now only Foundation (the one sub-module tied to the house).
       Tapping seeds the foundations config with the house footprint +
       placement, then opens it in a new window. No config change needed:
       foundations restores STATE.polygon from its own levaProject:base
       payload (v1) on load.
       ================================================================= */
    var _launchCol = null;

    function houseAnchor() {
      if (_MapManager && Array.isArray(_MapManager.center) &&
          isFinite(+_MapManager.center[0]) && isFinite(+_MapManager.center[1])) {
        return [+_MapManager.center[0], +_MapManager.center[1]];
      }
      return null;
    }

    var FOUNDATION_HANDLE = 'foundations';
    var STRUCTURE_HANDLE  = 'structure';
    var ROOF_HANDLE       = 'roof';

    /* Each product page has its OWN projectId, so there are several
       levaProject:...:base payloads (one per base-clone product). We must
       target the one whose productHandle is the foundations product, not the
       first :base key we stumble on. Pick the most recent match. */
    function findKeyByHandle(targetHandle) {
      var best = null, bestT = -1;
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!k || k.indexOf('levaProject:') !== 0) continue;
          var raw = localStorage.getItem(k); if (!raw) continue;
          var pj; try { pj = JSON.parse(raw); } catch (e) { continue; }
          if (!pj || pj.productHandle !== targetHandle) continue;
          var t = Date.parse(pj.updatedAt || '') || 0;
          if (t > bestT) { bestT = t; best = k; }
        }
      } catch (e2) {}
      return best;
    }
    function findFoundationsKey() { return findKeyByHandle(FOUNDATION_HANDLE); }

    function houseBBox(poly) {
      var xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        var x = poly[i][0], y = poly[i][1];
        if (x < xMin) xMin = x; if (x > xMax) xMax = x;
        if (y < yMin) yMin = y; if (y > yMax) yMax = y;
      }
      return { L: xMax - xMin, W: yMax - yMin };
    }

    /* On-screen diagnostic (no DevTools on tablet): list every levaProject
       payload with its configKey + productHandle so we can see exactly which
       key/handle the foundations seed should target. */
    function listLevaProjects() {
      var rows = [];
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (!k || k.indexOf('levaProject:') !== 0) continue;
          var seg = k.split(':');
          var ck = seg[seg.length - 1];
          var ph = '?', up = '?';
          try { var pj = JSON.parse(localStorage.getItem(k) || '{}'); ph = pj.productHandle || '(none)'; up = pj.updatedAt || '?'; } catch (e) {}
          rows.push({ key: k, configKey: ck, handle: ph, updatedAt: up });
        }
      } catch (e) {}
      return rows;
    }

    function showSeedDebug() {
      var rows = listLevaProjects();
      var bk = findFoundationsKey();
      var bh = '(none)';
      if (bk) { try { bh = (JSON.parse(localStorage.getItem(bk) || '{}').productHandle) || '(none)'; } catch (e) {} }
      var poly = (global.BaseLib && global.BaseLib.getFootprintPolygon) ? global.BaseLib.getFootprintPolygon() : [];

      var old = document.getElementById('lmf-seed-dbg');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var box = document.createElement('div');
      box.id = 'lmf-seed-dbg';
      box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;background:#111;color:#eee;font:11px/1.4 monospace;padding:10px;border-radius:8px;max-height:55vh;overflow:auto;box-shadow:0 4px 24px rgba(0,0,0,.5);';
      var html = '<b>SEED DEBUG</b>  baseKey=' + (bk || 'NONE') + '  baseHandle=' + bh + '  housePolyPts=' + (poly ? poly.length : 0) + '<br>';
      rows.forEach(function (r) {
        html += '• ' + r.configKey + '  handle=' + r.handle + '  @' + String(r.updatedAt).slice(11, 19) + '<br>';
      });
      html += '<br>';
      box.innerHTML = html;
      var go = document.createElement('button');
      go.textContent = 'Seed + open foundations';
      go.style.cssText = 'margin-right:8px;padding:7px 12px;background:#C9A227;color:#111;border:none;border-radius:6px;font:700 12px sans-serif;';
      go.onclick = function () { seedFoundations(); };
      var cl = document.createElement('button');
      cl.textContent = 'Close';
      cl.style.cssText = 'padding:7px 12px;background:#444;color:#fff;border:none;border-radius:6px;font:700 12px sans-serif;';
      cl.onclick = function () { if (box.parentNode) box.parentNode.removeChild(box); };
      box.appendChild(go); box.appendChild(cl);
      document.body.appendChild(box);
    }

    /* Open the configurator/product page for an existing footprint module.
       The module already carries its own placement, so this just navigates —
       no re-seed (unlike the foundation launcher which links a fresh one). */
    function openConfigurator(entry) {
      if (!entry || !entry.handle) return;
      var url = '/products/' + entry.handle;
      try {
        var w = global.open(url, '_blank');
        if (!w) global.location.href = url;
      } catch (e) { global.location.href = url; }
    }

    /* Seed a sub-module (foundation, structure, ...) with the main-house
       footprint + placement and flag it masterLinked, then open it. Both
       modules behave identically — foundation uses configKey 'base', the
       structure clone uses configKey 'structure'; the only real difference
       between them is the structural-type switcher inside the config. */
    function seedModule(handle, configKey) {
      var poly = (global.BaseLib && global.BaseLib.getFootprintPolygon)
        ? global.BaseLib.getFootprintPolygon() : [];
      var center = houseAnchor();
      var bearing = (_MapManager && isFinite(+_MapManager.bearing)) ? +_MapManager.bearing : 0;
      var address = (_MapManager && _MapManager.address) || null;

      var key = findKeyByHandle(handle);
      var base = null;
      if (key) { try { base = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {} }

      if (key && poly && poly.length >= 3) {
        var bb = houseBBox(poly);
        var payload = (base && typeof base === 'object') ? base : { v: 1, configKey: configKey };
        payload.v = 1;
        payload.configKey = configKey;
        payload.shape = payload.shape || {};
        payload.shape.polygon = poly;
        payload.shape.bboxL = bb.L;
        payload.shape.bboxW = bb.W;
        payload.shape.cornerCount = poly.length;
        payload.map = { address: address, center: center, bearing: bearing };
        payload.masterLinked = true;
        payload.updatedAt = new Date().toISOString();
        try { localStorage.setItem(key, JSON.stringify(payload)); } catch (e) {}
        /* same-tab write fires no storage event — refresh now so the linked
           footprint hides immediately on the master */
        try { rebuild(); } catch (e) {}
      }

      var url = '/products/' + handle;
      try {
        var w = global.open(url, '_blank');
        if (!w) global.location.href = url;
      } catch (e) { global.location.href = url; }
    }

    function seedFoundations() { seedModule(FOUNDATION_HANDLE, 'base'); }
    function seedStructure()   { seedModule(STRUCTURE_HANDLE, 'structure'); }
    function seedRoof()        { seedModule(ROOF_HANDLE, 'roof'); }

    function renderLaunchers() {
      /* In-scene launcher pills (FOUNDATION / STRUCTURE / ROOF) removed — these
         subsystems are now reached from the asset drawer, so the house view
         stays clean. Just clear any column that was already mounted. */
      if (_launchCol && _launchCol.parentNode) _launchCol.parentNode.removeChild(_launchCol);
      _launchCol = null;
    }
    /* eslint-disable no-unused-vars */
    function renderLaunchers_DISABLED() {
      ensureOverlay();
      if (_launchCol && _launchCol.parentNode) _launchCol.parentNode.removeChild(_launchCol);
      _launchCol = document.createElement('div');
      _launchCol.className = 'lmf-launch-col';
      _launchCol.style.position = 'absolute';
      _launchCol.style.pointerEvents = 'none';

      function makeLauncher(text, fn) {
        var pill = document.createElement('div');
        pill.className = 'lmf-launch';
        pill.textContent = text;
        pill.style.pointerEvents = 'auto';
        pill.addEventListener('click', function (ev) { ev.stopPropagation(); fn(); });
        _launchCol.appendChild(pill);
      }
      var _li18n = (global.BASE_BOOT || {}).i18n || {};
      makeLauncher(_li18n.mcLaunchFoundation || 'FOUNDATION', seedFoundations);
      makeLauncher(_li18n.mcLaunchStructure  || 'STRUCTURE',  seedStructure);
      makeLauncher(_li18n.mcLaunchRoof       || 'ROOF',       seedRoof);
      _overlay.appendChild(_launchCol);
      repositionLaunchers();
    }

    function repositionLaunchers() {
      if (!_launchCol) return;
      var m = map();
      var a = houseAnchor();
      var poly = (typeof getFootprintPolygon === 'function') ? getFootprintPolygon() : null;
      /* Anchor the launcher column just to the RIGHT of the house footprint's
         on-screen bounding box, vertically centred — so the pills sit beside
         the floorplan (out of the way of it and the drag handles) but stay
         close enough to find. Projecting the real vertices gives the true
         screen bbox regardless of rotation. */
      if (m && m.project && a && poly && poly.length) {
        var lat0 = a[1], lng0 = a[0];
        var mPerDegLat = 111320, mPerDegLng = 111320 * Math.cos(lat0 * Math.PI / 180) || 1;
        var minX = 1e9, maxX = -1e9, minY = 1e9, maxY = -1e9, ok = false;
        for (var i = 0; i < poly.length; i++) {
          var lng = lng0 + poly[i][0] / mPerDegLng;
          var lat = lat0 - poly[i][1] / mPerDegLat;
          var pp;
          try { pp = m.project({ lng: lng, lat: lat }); } catch (e) { pp = null; }
          if (!pp || !isFinite(pp.x) || !isFinite(pp.y)) continue;
          ok = true;
          if (pp.x < minX) minX = pp.x; if (pp.x > maxX) maxX = pp.x;
          if (pp.y < minY) minY = pp.y; if (pp.y > maxY) maxY = pp.y;
        }
        if (ok) {
          _launchCol.style.left = Math.round(maxX + 24) + 'px';
          _launchCol.style.top = Math.round((minY + maxY) / 2) + 'px';
          _launchCol.style.transform = 'translateY(-50%)';
          return;
        }
      }
      var pt = a ? project(a) : null;
      if (pt) {
        _launchCol.style.left = pt.x + 'px';
        _launchCol.style.top = pt.y + 'px';
        _launchCol.style.transform = '';
      }
    }

    function rebuildGeometryOnly(entries) {
      var m = map(); if (!m || !m.getSource) return;
      var feats = [];
      entries.forEach(function (e) { var f = feature(e); if (f) feats.push(f); });
      var src = m.getSource(SRC);
      if (src) { try { src.setData({ type: 'FeatureCollection', features: feats }); } catch (e) {} }
    }

    /* rAF-throttled live update during drag/rotate — never re-reads
       localStorage (uses the in-memory _entries) and coalesces to one
       setData per frame, so dragging the rotate knob stays snappy. */
    var _liveRaf = 0;
    function liveUpdate() {
      if (_liveRaf) return;
      _liveRaf = (global.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(function () {
        _liveRaf = 0;
        rebuildGeometryOnly(_entries);
      });
    }

    /* ---- rotation ring (drag knob to rotate) ------------------------ */
    function hideRing() {
      if (!_ring) return;
      if (_ring.wrap && _ring.wrap.parentNode) _ring.wrap.parentNode.removeChild(_ring.wrap);
      _ring = null;
    }
    function ringRadiusPx(entry) {
      var m = map();
      var anchor = anchorFor(entry.repr, entry.handle), poly = polyFor(entry);
      if (!m || !anchor || !poly) return 80;
      var maxR = 0;
      for (var i = 0; i < poly.length; i++) { var d = Math.hypot(poly[i][0], poly[i][1]); if (d > maxR) maxR = d; }
      var mpp = 78271.51696 * Math.cos(anchor[1] * Math.PI / 180) / Math.pow(2, m.getZoom());
      return Math.max(56, Math.min(220, Math.round((mpp > 0 ? maxR / mpp : 0) + 28)));
    }
    function showRing(entry) {
      var m = map();
      if (!m) return;
      hideRing();
      ensureOverlay();
      var r = ringRadiusPx(entry);
      var wrap = document.createElement('div');
      wrap.className = 'lmf-ring';
      wrap.style.position = 'absolute';
      wrap.style.width = (2 * r) + 'px'; wrap.style.height = (2 * r) + 'px';
      wrap.style.transform = 'translate(-50%, -50%)';
      wrap.style.pointerEvents = 'none';
      var knob = document.createElement('div');
      knob.className = 'lmf-ring-knob';
      knob.style.pointerEvents = 'auto';
      wrap.appendChild(knob);
      _overlay.appendChild(wrap);
      _ring = { wrap: wrap, knob: knob, entry: entry, radius: r };
      placeKnob(rotationFor(entry.repr, entry.handle) || 0);
      reposition();

      var dragging = false;
      function angleFromEvent(ev) {
        var rect = wrap.getBoundingClientRect();
        var cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
        var px = (ev.touches ? ev.touches[0].clientX : ev.clientX);
        var py = (ev.touches ? ev.touches[0].clientY : ev.clientY);
        return Math.round(Math.atan2(px - cx, -(py - cy)) * 180 / Math.PI / 5) * 5;
      }
      function onMove(ev) {
        if (!dragging) return;
        ev.preventDefault();
        var deg = angleFromEvent(ev);
        setOverride(entry.handle, 'bearing', deg);
        placeKnob(deg);
        liveUpdate();
      }
      function onUp() {
        if (!dragging) return;
        dragging = false; _busy = false;
        var a = anchorFor(entry.repr, entry.handle);
        if (a) persistPlacement(entry.handle, a[0], a[1], rotationFor(entry.repr, entry.handle));
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchend', onUp);
      }
      knob.addEventListener('mousedown', function (ev) { ev.stopPropagation(); dragging = true; _busy = true; document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp); });
      knob.addEventListener('touchstart', function (ev) { ev.stopPropagation(); dragging = true; _busy = true; document.addEventListener('touchmove', onMove, { passive: false }); document.addEventListener('touchend', onUp); }, { passive: false });
    }
    function placeKnob(deg) {
      if (!_ring) return;
      var r = _ring.radius, th = deg * Math.PI / 180;
      var cx = r + r * Math.sin(th), cy = r - r * Math.cos(th);
      _ring.knob.style.left = Math.round(cx - 17) + 'px';
      _ring.knob.style.top = Math.round(cy - 17) + 'px';
    }

    var _pillSig = '';

    /* Full rebuild only recreates the pill DOM when the SET of modules
       changes (added/removed). For mere placement/geometry changes it just
       refreshes the geojson + repositions the existing pills, so the drag
       handlers survive and interaction never "freezes". */
    function rebuild() {
      var m = map();
      if (!m || !m.getSource) return;
      if (_busy) return;
      ensureLayers();
      readLivePlacements();
      /* colour map is built from ALL modules (even hidden/locked ones) so a
         module keeps the SAME colour regardless of what is currently shown —
         hiding the foundation must NOT shift pool onto foundation's colour */
      var allEntries = readRepresentations();
      var entries = allEntries.filter(function (e) {
        var lp = _livePlace[e.handle];
        return !(lp && lp.masterLinked);   /* locked-to-house modules are drawn by the house itself */
      });

      var feats = [];
      entries.forEach(function (e) { var f = feature(e); if (f) feats.push(f); });
      var src = m.getSource(SRC);
      if (src) { try { src.setData({ type: 'FeatureCollection', features: feats }); } catch (e) {} }

      var sig = entries.map(labelFor).sort().join('|');
      if (sig !== _pillSig || !_overlay || !Object.keys(_pills).length) {
        _pillSig = sig;
        renderPills(entries);   /* structure changed → rebuild DOM */
      } else {
        /* same modules: keep DOM + handlers, just refresh refs + positions */
        _entries = entries;
        Object.keys(_pills).forEach(function (h) {
          var match = null;
          for (var i = 0; i < entries.length; i++) { if (entries[i].handle === h) { match = entries[i]; break; } }
          if (match) _pills[h].entry = match;
        });
        reposition();
      }
    }

    var _rebuildTimer = 0;
    function rebuildSoon() {
      if (_rebuildTimer) return;
      _rebuildTimer = setTimeout(function () { _rebuildTimer = 0; rebuild(); }, 250);
    }

    function start() {
      if (_started) { rebuild(); return; }
      _started = true;
      ensureOverlay();
      ensureLayers();
      rebuild();
      renderLaunchers();
      var m = map();
      if (m) {
        /* keep pills + ring glued to the map as it pans/zooms/rotates */
        try { m.on('render', reposition); } catch (e) {}
        try { m.on('move', reposition); } catch (e) {}
      }
      try {
        global.addEventListener('storage', function (ev) {
          if (!ev || !ev.key) return;
          if (ev.key.indexOf('mc:representation:') === 0 ||
              ev.key.indexOf('levaProject:') === 0 ||
              ev.key.indexOf('levaMap:') === 0) rebuildSoon();
        });
      } catch (e) {}
      setInterval(rebuild, 5000);
    }

    return { start: start, rebuild: rebuild };
  })();

  global.BaseEngine = {
    scene: null,
    camera: null,
    cameraPersp: null,
    cameraOrtho: null,
    renderer: null,
    controls: null,
    sceneGroup: null,
    _gridHelper: null,
    _animating: false,

    getState: function () { return STATE; },
    getPolygon: function () {
      return STATE.polygon ? JSON.parse(JSON.stringify(STATE.polygon)) : null;
    },
    setPolygon: function (newPoly) {
      if (!Array.isArray(newPoly) || newPoly.length < 3) return false;
      STATE.polygon = JSON.parse(JSON.stringify(newPoly));
      try { rebuildDragHandles(); } catch (e) { _dbg('rebuildDragHandles after setPolygon failed', e); }
      if (global.BaseRenderer && global.BaseRenderer.build) {
        try { global.BaseRenderer.build(); } catch (e) { _dbg('build after setPolygon failed', e); }
      }
      if (_MapManager && _MapManager.map && _MapManager.center) {
        try {
          if (STATE.view === '2d') _MapManager._syncMapTo2D(true);
          else _MapManager._syncMapTo3D(true);
        } catch (e) {}
      }
      if (_SlopeManager && _SlopeManager._updateAll) {
        try { _SlopeManager._updateAll(); } catch (e) {}
      }
      return true;
    },

    worldToScreen: function (x, z) { return _worldToScreen(x, z); },

    screenToWorld: function (clientX, clientY) { return _screenToWorld(clientX, clientY); },

    setFoundationsHandlesVisible: function (visible) {
      var container = document.getElementById('cf-base-handles');
      if (!container) return;
      container.style.display = visible ? '' : 'none';
    },

    init: function () {
      var T = global.THREE;
      if (!T) { _dbg('init: THREE missing'); return; }
      var canvas = document.getElementById('cf-canvas-base');
      if (!canvas) { _dbg('init: canvas missing'); return; }

      this.scene = new T.Scene();
      this.scene.background = new T.Color(0xf5f5f5);

      var w = canvas.clientWidth || 800;
      var h = canvas.clientHeight || 600;

      this.cameraPersp = new T.PerspectiveCamera(40, w / h, 0.1, 200);
      this.cameraPersp.position.set(14, 12, 14);
      this.cameraPersp.lookAt(0, 0, 0);

      var d = 12;
      this.cameraOrtho = new T.OrthographicCamera(-d * w / h, d * w / h, d, -d, 0.1, 200);
      this.cameraOrtho.position.set(0, 30, 0);
      this.cameraOrtho.up.set(0, 0, -1);
      this.cameraOrtho.lookAt(0, 0, 0);

      this.camera = (STATE.view === '2d') ? this.cameraOrtho : this.cameraPersp;

      this.renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, preserveDrawingBuffer: true, stencil: true });
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      this.renderer.setSize(w, h, false);

      this.renderer.localClippingEnabled = true;

      var amb = new T.AmbientLight(0xffffff, 0.7);
      var dir = new T.DirectionalLight(0xffffff, 0.6);
      dir.position.set(10, 20, 8);
      this.scene.add(amb);
      this.scene.add(dir);

      _rebuildGrid(this);

      this.sceneGroup = new T.Group();
      this.scene.add(this.sceneGroup);

      var OC = T.OrbitControls || global.OrbitControls;
      if (OC) {
        this.controls = new OC(this.cameraPersp, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.08;
        this.controls.target.set(0, 0, 0);
        this.controls.maxPolarAngle = Math.PI * 0.49;
        this.controls.update();
      }

      var self = this;
      window.addEventListener('resize', function () { self._onResize(); });
      this._onResize();

      this._animating = true;
      this._animate();
    },

    _onResize: function () {
      var canvas = this.renderer && this.renderer.domElement;
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      this.renderer.setSize(w, h, false);
      this.cameraPersp.aspect = w / h;
      this.cameraPersp.updateProjectionMatrix();
      var d = this._currentOrthoD || 12;
      this.cameraOrtho.left   = -d * w / h;
      this.cameraOrtho.right  =  d * w / h;
      this.cameraOrtho.top    =  d;
      this.cameraOrtho.bottom = -d;
      this.cameraOrtho.updateProjectionMatrix();
      positionDragHandles();
    },

    fitCameraToFootprint: function () {
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 2) return;
      var canvas = this.renderer && this.renderer.domElement;
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;

      var xMin =  Infinity, xMax = -Infinity;
      var zMin =  Infinity, zMax = -Infinity;
      for (var i = 0; i < poly.length; i++) {
        if (poly[i][0] < xMin) xMin = poly[i][0];
        if (poly[i][0] > xMax) xMax = poly[i][0];
        if (poly[i][1] < zMin) zMin = poly[i][1];
        if (poly[i][1] > zMax) zMax = poly[i][1];
      }
      var bbL = xMax - xMin;
      var bbW = zMax - zMin;
      if (bbL < 0.5 && bbW < 0.5) return;

      var aspect = w / h;

      var FILL = 0.60;
      var d = Math.max(bbW / (2 * FILL), bbL / (2 * aspect * FILL));
      d = Math.max(d, 3);
      this._currentOrthoD = d;

      this.cameraOrtho.left   = -d * aspect;
      this.cameraOrtho.right  =  d * aspect;
      this.cameraOrtho.top    =  d;
      this.cameraOrtho.bottom = -d;
      this.cameraOrtho.updateProjectionMatrix();

      var cx = (xMin + xMax) / 2;
      var cz = (zMin + zMax) / 2;

      var fovRad = (this.cameraPersp.fov || 50) * Math.PI / 180;
      var halfV = Math.tan(fovRad / 2);
      var distV = (bbW / 2) / (FILL * halfV);
      var distH = (bbL / 2) / (FILL * halfV * aspect);
      var dist = Math.max(distV, distH, 6);
      this.cameraPersp.position.set(cx + dist * 0.6, dist * 0.6, cz + dist * 0.6);
      this.cameraPersp.lookAt(cx, 0, cz);
      if (this.controls) {
        this.controls.target.set(cx, 0, cz);
        this.controls.update();
      }
      this.cameraOrtho.position.set(cx, 30, cz);
      this.cameraOrtho.lookAt(cx, 0, cz);
      positionDragHandles();
    },

    _animate: function () {
      if (!this._animating) return;
      var self = this;
      requestAnimationFrame(function () { self._animate(); });
      if (this.controls && this.camera === this.cameraPersp) this.controls.update();
      if (this.renderer && this.camera) this.renderer.render(this.scene, this.camera);

      if (global.FloorplanLib && typeof global.FloorplanLib._onFrame === 'function') {
        global.FloorplanLib._onFrame();
      }
    },

    toggleView: function () {
      _resetAllHandleDrags();
      if (_CornerInserter && _CornerInserter.pendingPlacement) {
        _CornerInserter._setPending(false);
      }
      STATE.view = (STATE.view === '2d') ? '3d' : '2d';
      STATE.vizStage = 0;
      this.camera = (STATE.view === '2d') ? this.cameraOrtho : this.cameraPersp;
      if (STATE.view === '3d') { try { _fitPerspToModel(); } catch (_) {} }
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) {
        wrap.classList.toggle('cf-view-2d', STATE.view === '2d');
        wrap.classList.toggle('cf-view-3d', STATE.view === '3d');
      }
      if (this._gridHelper) _applyGridVisibility(this);
      var viewIcon = document.getElementById('cf-view-icon');
      if (viewIcon) {
        viewIcon.src = (STATE.view === '2d')
          ? 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/3d.png?v=1772625064'
          : 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/2d.png?v=1772625064';
      }
      positionDragHandles();
      if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
      if (_MapManager && _MapManager.map && _MapManager.center) {
        if (STATE.view === '2d') {
          _MapManager._set3DLayerVisibility(false);
          _MapManager._syncMapTo2D(true);
        } else {
          _MapManager._set3DLayerVisibility(true);
          _MapManager._syncMapTo3D(true);
        }
      }
      if (_SlopeManager && _SlopeManager._updateAll) _SlopeManager._updateAll();

    }
  };

  global.BaseRenderer = {
    _materials: null,

    _gravelTexture: null,

    _ensureMaterials: function () {
      var T = global.THREE;
      if (this._materials) return this._materials;
      this._materials = {
        fill2D:   new T.MeshBasicMaterial({ color: 0xb8b8b8, transparent: true, opacity: 0.45, side: T.DoubleSide }),
        edge2D:   new T.LineBasicMaterial({ color: 0x222222 }),

        shelterTimber:   new T.MeshLambertMaterial({ color: 0xb5895a }),
        shelterRoof:     new T.MeshLambertMaterial({ color: 0x6f7e87, side: T.DoubleSide }),
        shelterFooting:  new T.MeshLambertMaterial({ color: 0x9a9a9a }),
        houseWall:       new T.MeshLambertMaterial({ color: 0xe8e2d6 }),
        houseGable:      new T.MeshLambertMaterial({ color: 0xe8e2d6, side: T.DoubleSide }),
        houseFoundation: new T.MeshLambertMaterial({ color: 0x9a948a }),
        shelterTimber2D: new T.MeshBasicMaterial({ color: 0xb5895a, transparent: true, opacity: 0.90, side: T.DoubleSide })
      };
      return this._materials;
    },

    build: function () {
      var T = global.THREE;
      var eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      var G = eng.sceneGroup;
      while (G.children.length) {
        var c = G.children[0];
        G.remove(c);
        if (c.geometry && c.geometry.dispose) c.geometry.dispose();
      }
      var poly = getFootprintPolygon();
      if (!poly.length) return;
      /* MASTER HOUSE: lift the eave height by the number of storeys so the
         walls and the roof rise together (single chokepoint for floors). */
      SHELTER_SPECS.carport.clearHeight = _wallHeightM();
      if (eng._gridHelper) eng._gridHelper.visible = true;
      if (STATE.view === '2d') { this._build2D_Carport(poly); }
      else {
        this._masonryDrawn = false;
        try { this._masonryDrawn = !!this._buildMasonryBlocksMaster(poly); } catch (e) { this._masonryDrawn = false; }
        this._build3D_Carport(poly);
        try { this._buildFloorSlabs(poly); } catch (eFs) {}   /* solid inter-storey floor slabs, per structure system */
      }
      try { _Floorplan.render(); } catch (eFp) {}    /* underlay survives rebuilds in both 2D and 3D */
      try { _Partitions.render(); } catch (ePt) {}   /* partitions re-render with the floor plan */
      try { _Balcony.render(); } catch (eBc) {}      /* balcony ghost (floor-plan stage 4) */
      try { _Balcony.buildWalls(); } catch (eBc2) {} /* balcony perimeter wall (3D, all floors) */
      /* belt-and-braces: the 2D cut-editing ghost (translucent fill/outline)
         must never linger over the 3D model or the block view */
      try {
        if ((STATE.view !== '2d' || STATE.vizStage === 4) && _Balcony._grp) {
          if (_Balcony._grp.parent) _Balcony._grp.parent.remove(_Balcony._grp);
          _Balcony._grp = null;
        }
      } catch (eBg) {}
      _rebuildGrid(eng);
    },

    /* Solid inter-storey floor slabs (ceilings) — one per gap between storeys,
       NONE under the roof (that becomes a timber structure handled separately).
       Master-house solid only: an extruded footprint sitting just below the
       floor level of the storey above. Thickness + colour come from the chosen
       structure system (_floorSlabM); for masonry the ring beam is shortened by
       the same thickness so the slab reads as bearing ON the beam. Detailing
       (joists / plank / poured deck) is deferred to the structure config. */
    _buildFloorSlabs: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      if (STATE.view === '2d') return;
      var flN = Math.max(1, STATE.floors | 0);
      if (flN < 2) return;                       /* floors only BETWEEN storeys */
      var spec = _floorSlabSpec(), th = spec.t;
      /* push the slab out to the OUTER face it must flush with. For masonry that
         is the ring beam / block, whose half-width comes from the same grid the
         blocks use (NOT wallThickness, which can differ); other systems flush
         with the wall face. */
      var offHalf;
      if ((STATE.structureVariant || 'masonry') === 'masonry') {
        var g = null; try { g = JSON.parse(localStorage.getItem('mc:grid') || 'null'); } catch (eg) {}
        var bw = (g && g.brick && g.brick.w) || ((g && g.metric === false) ? 12 : 300);
        var bt = (g && g.metric === false) ? (bw * 0.0254) : (bw / 1000);
        offHalf = (bt > 0 ? bt : 0.30) / 2;
      } else {
        offHalf = ((global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30) / 2;
      }
      /* outline: cut out every active ALL-2 niche (slab then copies the perimeter
         walls, no strip at the balcony). Floor / all1 cuts keep the slab whole. */
      var base = poly;
      try {
        var a2 = (typeof _Balcony !== 'undefined' && _Balcony && _Balcony._all2CutsAt) ? _Balcony._all2CutsAt(0) : [];
        if (a2 && a2.length) {
          var ned = _Balcony._notchedEdges(0, a2);
          if (ned && ned.length >= 3) { var np = []; for (var ki = 0; ki < ned.length; ki++) np.push([ned[ki].a[0], ned[ki].a[1]]); base = np; }
        }
      } catch (eN2) {}
      var fp = _offsetPolyOut(base, offHalf);
      var sh = new T.Shape();
      sh.moveTo(fp[0][0], -fp[0][1]);
      for (var i = 1; i < fp.length; i++) sh.lineTo(fp[i][0], -fp[i][1]);
      sh.closePath();
      var geo = new T.ExtrudeGeometry(sh, { depth: th, bevelEnabled: false });
      var mat = new T.MeshLambertMaterial({ color: spec.color });
      for (var f = 0; f < flN - 1; f++) {        /* slab under the floor of storey f+1 */
        var top = _storeyBaseY(f + 1);
        var mesh = new T.Mesh(geo, mat);
        mesh.rotation.x = -Math.PI / 2;          /* shape lies in XZ, extrude runs +Y up to top */
        mesh.position.y = top - th;
        mesh.userData.partType = 'floorSlab';
        mesh.visible = true;                     /* visible in every 3D stage incl. block view — the slab is plainly there and carries to the structure config */
        eng.sceneGroup.add(mesh);
      }
    },

    _gravelSphereGeo: null,

    _dogEarCache: null,

    /* Lay the masonry walls up from individual blocks with a real corner bond,
       drawn directly in the main-house 3D. Per course one pair of opposite
       walls runs through past the corner to the outer face (span -t/2 .. L+t/2)
       and the perpendicular pair butts against it (span t/2 .. L-t/2); the
       roles swap every course so the corners interlock with no gap. Shifted
       courses start with a half block and every wall ends with a cut closer
       block, so the bond is continuous (variable block lengths via the
       per-instance X scale). A concrete ring beam fills from the top course up
       to the eave. Returns true when the blocks were drawn (the caller then
       hides the plain wall), false otherwise. Any rectilinear footprint. */
    _buildMasonryBlocksMaster: function (poly) {
      /* Bricks are no longer drawn in the main house — masonry renders as a
         plain wall here, exactly like the other structure types. The actual
         block courses are drawn in the structure sub-config. The block size is
         still defined here (drives footprint snapping + is broadcast), only the
         visual courses move to the sub-config. */
      if (STATE.vizStage !== 4) return false;   /* blocks render only in the dedicated blocks stage */
      if ((STATE.structureVariant || 'masonry') !== 'masonry') return false;
      if (!poly || poly.length < 4) return false;
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return false;
      var g = null;
      try { g = JSON.parse(localStorage.getItem('mc:grid') || 'null'); } catch (e) {}
      if (!g || !(g.unit > 0)) g = { unit: 250, course: 250, metric: true, brick: { w: 300 } };  /* default block */

      var unitM = g.unit / 1000;
      var courseM = (g.course > 0 ? g.course : g.unit / 2) / 1000;
      if (!(unitM > 0) || !(courseM > 0)) return false;
      var bw = (g.brick && g.brick.w) || (g.metric ? 300 : 12);
      var t = g.metric ? (bw / 1000) : (bw * 0.0254);
      if (!(t > 0)) t = 0.30;
      var clearH = _wallHeightM();
      var wallTop = clearH + SHELTER_SPECS.carport.beam.h;   /* eave = top of the old plain wall */

      var mortar = 0.02;
      var blockH = Math.max(0.03, courseM - mortar);
      var lintelH = courseM, bearing = unitM / 2;   /* RC lintel over openings */
      var fl = Math.max(1, STATE.floors | 0);


      /* perimeter edges in ring order; the through/butt role at every corner
         alternates per course via the edge index parity (rectilinear
         footprints have an even edge count, so the alternation is consistent
         around the whole loop, concave corners included) */
      var edges = [];
      for (var pe = 0; pe < poly.length; pe++) {
        var pa = poly[pe], pb = poly[(pe + 1) % poly.length];
        var pdx = pb[0] - pa[0], pdz = pb[1] - pa[1];
        var pL = Math.hypot(pdx, pdz);
        if (pL < 0.01) continue;
        edges.push({ c: pa, dx: pdx / pL, dz: pdz / pL, L: pL, ang: -Math.atan2(pdz, pdx), idx: pe });
      }
      if (edges.length < 4) return false;

      /* openings grouped per edge (so courses + core can be cut around them) */
      var opsByEdge = {};
      for (var oo = 0; oo < STATE.openings.length; oo++) {
        var OO = STATE.openings[oo];
        if (!opsByEdge[OO.wallIdx]) opsByEdge[OO.wallIdx] = [];
        opsByEdge[OO.wallIdx].push(OO);
      }
      for (var ok in opsByEdge) opsByEdge[ok].sort(function (p, q) { return p.u - q.u; });

      /* each floor's wall ring as ONE notched polygon (footprint − balcony).
         The jamb is a native corner of this loop, so bond + core + ring beam
         run through it. Openings stay keyed to the footprint edge via srcEdge. */
      var notchedByFloor = [];
      for (var nfd = 0; nfd < fl; nfd++) {
        var ne = null;
        try { ne = _Balcony._notchedEdges(nfd); } catch (eNe) { ne = null; }
        notchedByFloor[nfd] = (ne && ne.length >= 3) ? ne : edges;
      }

      /* one brick section per storey, each finished with a concrete ring beam:
         between storeys the ring fills the floor-deck zone up to the next
         storey base, on the top storey it runs up to the eave. The course
         parity keeps counting across storeys so the bond is continuous. */
      var blocks = [], CAP = 18000, courseIdx = 0;
      var segs = [];
      for (var sIdx = 0; sIdx < fl; sIdx++) {
        var storeyHS = _storeyHForFloor(sIdx);
        var rowsPerS = Math.max(1, Math.floor(_clearForFloor(sIdx) / courseM + 1e-6));
        var yBase = _storeyBaseY(sIdx);
        segs.push({
          b0: yBase,
          b1: yBase + rowsPerS * courseM,
          r1: (sIdx < fl - 1) ? (yBase + storeyHS - _floorSlabM.masonry.t) : wallTop   /* between storeys the beam stops below the floor slab, which bears on it */
        });
        var stEdges = notchedByFloor[sIdx] || edges;          /* this floor's notched wall ring */
        for (var r = 0; r < rowsPerS; r++, courseIdx++) {
          var y = yBase + r * courseM + courseM / 2;
          var parity = courseIdx % 2;
          var halfShift = parity ? (unitM / 2) : 0;
          for (var e = 0; e < stEdges.length; e++) {
            var ed = stEdges[e];
            var full = (((ed.idx + parity) % 2) === 0);
            var s0 = full ? -t / 2 : t / 2;
            var s1 = full ? (ed.L + t / 2) : (ed.L - t / 2);
            if (s1 - s0 < 0.04) continue;
            /* joint grid anchored at the footprint corner (0) for every course,
               so the half-block shift between courses is a true half block on
               the wall face, independent of the t/2 corner extension */
            var cuts = [s0];
            var k0 = Math.ceil((s0 - halfShift) / unitM - 1e-9);
            for (var q = halfShift + k0 * unitM; q < s1 - 1e-6; q += unitM) {
              if (q > s0 + 1e-6) cuts.push(q);
            }
            cuts.push(s1);
            /* corner slivers merge into the neighbouring block (cut closers) */
            var sliver = unitM * 0.45;
            if (cuts.length > 2 && (cuts[1] - cuts[0]) < sliver) cuts.splice(1, 1);
            if (cuts.length > 2 && (cuts[cuts.length - 1] - cuts[cuts.length - 2]) < sliver) cuts.splice(cuts.length - 2, 1);
            /* openings on this edge whose height band contains this course →
               their jambs become hard cuts and the in-hole segments are dropped.
               Mapped from the footprint edge (srcEdge) into this fragment's local
               coordinate via u0; recess walls (srcEdge<0) carry no openings. */
            var sEdge = (ed.srcEdge == null) ? ed.idx : ed.srcEdge;
            var eU0 = ed.u0 || 0;
            var edgeOps = (sEdge >= 0 && opsByEdge[sEdge]) ? opsByEdge[sEdge] : [];
            var holes = [];
            for (var ho = 0; ho < edgeOps.length; ho++) {
              var EO = edgeOps[ho], eu = EO.u - eU0;               /* opening centre in this fragment's local u */
              if (eu < -EO.w / 2 - bearing || eu > ed.L + EO.w / 2 + bearing) continue;
              var esill = (EO.sill || 0), etop = esill + EO.h, ltop = etop + lintelH;
              if (y > esill + 1e-4 && y < etop - 1e-4) holes.push([eu - EO.w / 2, eu + EO.w / 2]);
              else if (y >= etop - 1e-4 && y < ltop - 1e-4) holes.push([eu - EO.w / 2 - bearing, eu + EO.w / 2 + bearing]);  /* lintel band */
            }
            if (holes.length) {
              for (var hh = 0; hh < holes.length; hh++) {
                if (holes[hh][0] > s0 + 1e-4 && holes[hh][0] < s1 - 1e-4) cuts.push(holes[hh][0]);
                if (holes[hh][1] > s0 + 1e-4 && holes[hh][1] < s1 - 1e-4) cuts.push(holes[hh][1]);
              }
              cuts.sort(function (a, b) { return a - b; });
            }
            for (var ci = 0; ci < cuts.length - 1; ci++) {
              var bl = cuts[ci + 1] - cuts[ci] - mortar;
              if (bl < 0.02) continue;
              var mid = (cuts[ci] + cuts[ci + 1]) / 2;
              var inHole = false;
              for (var hk = 0; hk < holes.length; hk++) { if (mid > holes[hk][0] + 1e-4 && mid < holes[hk][1] - 1e-4) { inHole = true; break; } }
              if (inHole) continue;
              blocks.push({ x: ed.c[0] + ed.dx * mid, y: y, z: ed.c[1] + ed.dz * mid, a: ed.ang, len: bl, src: (ed.srcEdge == null ? 0 : ed.srcEdge) });
              if (blocks.length > CAP) return false;
            }
          }
        }
      }
      if (!blocks.length) return false;

      var grp = new T.Group();
      /* dark mortar core kept fully inside the wall run (centerline corner to
         corner, minus a hair) so no core face is coplanar with a block face */
      var coreMat = new T.MeshLambertMaterial({ color: 0x9c9488, emissive: 0x322f2a, polygonOffset: true, polygonOffsetFactor: 2, polygonOffsetUnits: 4 });
      var coreT = Math.max(0.04, t - 0.04);
      for (var sg = 0; sg < segs.length; sg++) {
        var b0c = segs[sg].b0 + 0.01, b1c = segs[sg].b1 - 0.01;
        if (b1c - b0c < 0.02) continue;
        var sgEdges = notchedByFloor[sg] || edges;   /* core runs the whole notched ring (incl. recess walls) → continuous, like the footprint */
        for (var k2 = 0; k2 < sgEdges.length; k2++) {
          var cc = sgEdges[k2];
          var coreSeg = (function (edge) {
            return function (p0, p1, yb, yt) {
              var ln = p1 - p0, ht = yt - yb;
              if (ln < 0.04 || ht < 0.02) return;
              var mp = (p0 + p1) / 2;
              var bx = new T.Mesh(new T.BoxGeometry(ln, ht, coreT), coreMat);
              bx.position.set(edge.c[0] + edge.dx * mp, (yb + yt) / 2, edge.c[1] + edge.dz * mp);
              bx.rotation.y = edge.ang;
              grp.add(bx);
            };
          })(cc);
          var ccSrc = (cc.srcEdge == null) ? cc.idx : cc.srcEdge, ccU0 = cc.u0 || 0;
          var cRaw = (ccSrc >= 0 && opsByEdge[ccSrc]) ? opsByEdge[ccSrc] : [];
          var cOps = [];
          for (var cro = 0; cro < cRaw.length; cro++) { var CR = cRaw[cro], lu = CR.u - ccU0; if (lu > -CR.w / 2 && lu < cc.L + CR.w / 2) cOps.push({ u: lu, w: CR.w, sill: CR.sill, h: CR.h }); }
          cOps.sort(function (p, q) { return p.u - q.u; });
          var ccur = 0.01, cend = cc.L - 0.01;
          for (var co = 0; co < cOps.length; co++) {
            var CO = cOps[co];
            var oL = Math.max(ccur, Math.min(cend, CO.u - CO.w / 2));
            var oR = Math.max(ccur, Math.min(cend, CO.u + CO.w / 2));
            if (oR <= oL) continue;
            var eb = Math.max(b0c, (CO.sill || 0)), et2 = Math.min(b1c, (CO.sill || 0) + CO.h);
            coreSeg(ccur, oL, b0c, b1c);                 /* solid before opening */
            if (eb > b0c + 0.02) coreSeg(oL, oR, b0c, eb);     /* parapet under */
            if (et2 < b1c - 0.02) coreSeg(oL, oR, et2, b1c);   /* lintel over */
            ccur = Math.max(ccur, oR);
          }
          coreSeg(ccur, cend, b0c, b1c);
        }
      }

      /* RC lintel over every opening (bears on the jambs). The bricks in this
         band were dropped above, so it sits clean — the subconfig inherits the
         lintel instead of carving bricks back out. */
      var lintMat = new T.MeshLambertMaterial({ color: 0xbfbcb4, emissive: 0x3a3835 });
      for (var le = 0; le < edges.length; le++) {
        var led = edges[le], lops = opsByEdge[led.idx] || [];
        for (var lo = 0; lo < lops.length; lo++) {
          var LO = lops[lo], lspan = LO.w + 2 * bearing, ly = (LO.sill || 0) + LO.h + lintelH / 2;
          var lb = new T.Mesh(new T.BoxGeometry(lspan, lintelH, t), lintMat);
          lb.position.set(led.c[0] + led.dx * LO.u, ly, led.c[1] + led.dz * LO.u);
          lb.rotation.y = led.ang;
          grp.add(lb);
        }
      }

      /* concrete ring beam on every storey: between storeys it fills the
         floor-deck zone, on the top storey it runs from the last course up to
         the eave. Bonded like the blocks (one pair runs through the corner,
         the other butts) so the four boxes never share a coplanar face. */
      var ringMat = new T.MeshLambertMaterial({ color: 0xbfbcb4, emissive: 0x3a3835 });
      for (var sg2 = 0; sg2 < segs.length; sg2++) {
        var ringH = segs[sg2].r1 - segs[sg2].b1;
        if (ringH < 0.02) continue;
        var rgEdges = notchedByFloor[sg2] || edges;
        for (var k3 = 0; k3 < rgEdges.length; k3++) {
          var rc = rgEdges[k3];
          var rl = ((rc.idx % 2) === 0) ? (rc.L + t) : Math.max(0.05, rc.L - t);
          var ring = new T.Mesh(new T.BoxGeometry(rl, ringH, t), ringMat);
          ring.position.set(rc.c[0] + rc.dx * rc.L / 2, segs[sg2].b1 + ringH / 2, rc.c[1] + rc.dz * rc.L / 2);
          ring.rotation.y = rc.ang;
          grp.add(ring);
        }
      }

      /* unit-length geometry; per-instance X scale = real block length and a
         deterministic per-block shade jitter so the bond reads clearly */
      var geom = new T.BoxGeometry(1, blockH, t);
      var mat = new T.MeshLambertMaterial({ color: 0xffffff, emissive: 0x3a2012 });
      var im = new T.InstancedMesh(geom, mat, blocks.length);
      var dummy = new T.Object3D();
      var col = new T.Color(), base = new T.Color(0xc06a40);
      for (var bi = 0; bi < blocks.length; bi++) {
        dummy.position.set(blocks[bi].x, blocks[bi].y, blocks[bi].z);
        dummy.rotation.set(0, blocks[bi].a, 0);
        dummy.scale.set(blocks[bi].len, 1, 1);
        dummy.updateMatrix();
        im.setMatrixAt(bi, dummy.matrix);
        var hsh = (((bi + 1) * 2654435761) >>> 0) % 997;
        col.copy(base).multiplyScalar(0.78 + 0.22 * (hsh / 997));
        im.setColorAt(bi, col);
      }
      im.instanceMatrix.needsUpdate = true;
      if (im.instanceColor) im.instanceColor.needsUpdate = true;
      im.frustumCulled = false;   /* bounding sphere covers only the unit geometry, not the instances */
      grp.add(im);
      eng.sceneGroup.add(grp);
      return true;
    },

    _polyToShape: function (poly) {
      var T = global.THREE;
      var shape = new T.Shape();
      shape.moveTo(poly[0][0], poly[0][1]);
      for (var i = 1; i < poly.length; i++) shape.lineTo(poly[i][0], poly[i][1]);
      shape.closePath();
      return shape;
    },

    _build3D_Carport: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      try {
        var g = _carportGeom(), s = g.s, SG = eng.sceneGroup;

        function V(x, y, z) { return new T.Vector3(x, y, z); }

        function memberAlong(p1, p2, sectH, sectW, mat) {
          if (!_roofDetailExport && mat === mats.shelterTimber) return null;
          var dir = new T.Vector3().subVectors(p2, p1);
          var len = dir.length();
          if (len < 1e-4) return null;
          var m = new T.Mesh(new T.BoxGeometry(len, sectH, sectW), mat);
          m.position.copy(new T.Vector3().addVectors(p1, p2).multiplyScalar(0.5));
          var q = new T.Quaternion();
          q.setFromUnitVectors(new T.Vector3(1, 0, 0), dir.clone().normalize());
          m.quaternion.copy(q);
          SG.add(m);
          return m;
        }
        var roofSkinTris = [];   /* collected top-skin tris (world space) for the underside closer */
        function quad(a, b, c, d, mat) {
          var geo = new T.BufferGeometry();
          geo.setAttribute('position', new T.BufferAttribute(new Float32Array([
            a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z,
            a.x, a.y, a.z, c.x, c.y, c.z, d.x, d.y, d.z
          ]), 3));
          geo.computeVertexNormals();
          var mesh = new T.Mesh(geo, mat);
          mesh.userData.partType = 'roofSkin';
          mesh.visible = (STATE.vizStage !== 1 && STATE.vizStage !== 4);
          SG.add(mesh);
          if (mat === mats.shelterRoof) {
            roofSkinTris.push([[a.x, a.y, a.z], [b.x, b.y, b.z], [c.x, c.y, c.z]]);
            roofSkinTris.push([[a.x, a.y, a.z], [c.x, c.y, c.z], [d.x, d.y, d.z]]);
          }
        }
        function tri(a, b, c, mat) {
          var geo = new T.BufferGeometry();
          geo.setAttribute('position', new T.BufferAttribute(new Float32Array([
            a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z
          ]), 3));
          geo.computeVertexNormals();
          var mesh = new T.Mesh(geo, mat);
          mesh.userData.partType = 'roofSkin';
          mesh.visible = (STATE.vizStage !== 1 && STATE.vizStage !== 4);
          SG.add(mesh);
          if (mat === mats.shelterRoof) {
            roofSkinTris.push([[a.x, a.y, a.z], [b.x, b.y, b.z], [c.x, c.y, c.z]]);
          }
        }

        /* HOUSE wall-mode (master house): closed perimeter walls instead of
           timber posts + ring beam. Gated by a boot flag so the carport is
           unaffected (defaults to 'posts'). One storey for now. */
        var _wallMode = !(global.BASE_BOOT && global.BASE_BOOT.structureMode === 'posts');
        if (_wallMode) {
          var wallThk = (global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30;
          var wallH = s.clearHeight + s.beam.h;            /* solid up to the eave */
          var foundH = 0.4;                                 /* low foundation strip */
          var _bricksDrawn = !!this._masonryDrawn;          /* masonry blocks replace the plain wall */
          try { _Openings._wallSuppressed = _bricksDrawn || (STATE.vizStage === 4); } catch (eW) {}
          var _rect4 = (poly.length === 4);
          for (var wi = 0; wi < poly.length; wi++) {
            var wa = poly[wi], wb = poly[(wi + 1) % poly.length];
            /* close the corners without coplanar faces: on a rectangle one
               pair of walls runs through past the corner (+t/2) and the
               perpendicular pair butts against it (-t/2); other footprints
               keep the symmetric extension */
            var wdx = wb[0] - wa[0], wdz = wb[1] - wa[1];
            var wlen = Math.hypot(wdx, wdz) || 1;
            var thr = _rect4 ? (wi % 2 === 0) : true;
            var e1 = (thr ? 1 : -1) * (wallThk / 2);
            var e2 = (thr ? 1 : -1) * ((wallThk + 0.06) / 2);
            if (wlen < wallThk * 2) { e1 = 0; e2 = 0; }
            var ex1 = (wdx / wlen) * e1, ez1 = (wdz / wlen) * e1;
            var ex2 = (wdx / wlen) * e2, ez2 = (wdz / wlen) * e2;
            /* perimeter wall is built into its own group by _Openings._renderWalls()
               (segmented around openings) so it can be re-cut alone during drag. */
            /* foundation strip just under the wall, slightly thicker */
            memberAlong(V(wa[0] - ex2, -foundH / 2, wa[1] - ez2), V(wb[0] + ex2, -foundH / 2, wb[1] + ez2), foundH, wallThk + 0.06, mats.houseFoundation);
          }
          /* thin floor deck at each storey level — sitting on the ring-beam
             crown of the storey below (ground deck at grade) — so you can read
             which storey an opening belongs to; the ground deck also keeps the
             foundation hidden through the openings */
          try {
            var _fSh = new T.Shape();
            _fSh.moveTo(poly[0][0], -poly[0][1]);
            for (var _fi = 1; _fi < poly.length; _fi++) _fSh.lineTo(poly[_fi][0], -poly[_fi][1]);
            _fSh.closePath();
            var _fGeom = new T.ShapeGeometry(_fSh);
            var _fMat = new T.MeshLambertMaterial({ color: 0xf3f0ea, side: T.DoubleSide });
            /* only the ground deck — upper storeys now get the solid floor slab,
               whose top IS the floor level, so a separate thin deck is redundant.
               Ground keeps it: no slab under it and it hides the foundation through
               the openings. */
            var _fMesh = new T.Mesh(_fGeom, _fMat);
            _fMesh.rotation.x = -Math.PI / 2;
            _fMesh.position.y = 0.03;
            SG.add(_fMesh);
          } catch (eFl) {}
        } else {
          for (var i = 0; i < poly.length; i++) {
            var px = poly[i][0], pz = poly[i][1];
            var fg = new T.Mesh(
              new T.CylinderGeometry(s.footing.dia / 2, s.footing.dia / 2, s.footing.depth, 16),
              mats.shelterFooting
            );
            fg.position.set(px, -s.footing.depth / 2 + 0.02, pz);
            SG.add(fg);
            memberAlong(V(px, 0, pz), V(px, s.clearHeight, pz), s.post.h, s.post.w, mats.shelterTimber);
          }

          var beamY = s.clearHeight + s.beam.h / 2;
          for (var e = 0; e < poly.length; e++) {
            var a = poly[e], b = poly[(e + 1) % poly.length];
            memberAlong(V(a[0], beamY, a[1]), V(b[0], beamY, b[1]), s.beam.h, s.beam.w, mats.shelterTimber);
          }
        }

        var lift = 0.14;
        function WP(wg, t, p, y) {
          return new T.Vector3(
            wg.ax.x + wg.dirU.x * t + wg.dirV.x * p,
            y,
            wg.ax.z + wg.dirU.z * t + wg.dirV.z * p
          );
        }
        function Va(p) { return new T.Vector3(p[0], p[1], p[2]); }
        function quadA(p, q, r, u, mat) { quad(Va(p), Va(q), Va(r), Va(u), mat); }
        var roofType = _isGableShelter() ? (STATE.shelterRoofType || 'sedlo') : 'sedlo';
        var flatRoof = roofType === 'atika';
        var pultRoof = roofType === 'pult';
        var customRoof = flatRoof || pultRoof;
        var hipRoof = roofType === 'valba';
        var tanPitch = Math.tan(s.pitchDeg * Math.PI / 180);
        var _shp = STATE.shelterShape || 'I';
        var Lp = (!customRoof && _isGableShelter() && _shp === 'L') ? _carportLParams(poly) : null;
        var Up = (!customRoof && _isGableShelter() && _shp === 'U') ? _carportUParams(poly) : null;
        var Tp = (!customRoof && _isGableShelter() && _shp === 'T') ? _carportTeeParams(poly) : null;
        var Hp = (!customRoof && _isGableShelter() && _shp === 'H') ? _carportHParams(poly) : null;
        var RV = (!customRoof && hipRoof && _isGableShelter() && !Lp && !Up && !Tp && !Hp) ? _carportRectParams(poly) : null;
        var RC = (!customRoof && _isGableShelter() && !Lp && !Up && !Tp && !Hp && !RV) ? _carportRoofComb(poly) : null;
        if (flatRoof || pultRoof) {
          var eYc = s.clearHeight + s.beam.h;   /* building top surface = ring-beam crown */
          var thR = _carportPrincipalAngle(poly);
          if (pultRoof) {
            /* mono-pitch: skin on an outward-offset footprint so the eaves
               overhang past the walls; height extrapolates the slope outward */
            var rpoly = _offsetPolyOut(poly, s.overhangM);
            var vMinR = Infinity, vMaxR = -Infinity;
            for (var pv = 0; pv < poly.length; pv++) {
              var lq = _carportRotPt(poly[pv][0], poly[pv][1], -thR)[1];
              if (lq < vMinR) vMinR = lq; if (lq > vMaxR) vMaxR = lq;
            }
            var pultRate = Math.tan((s.pultPitchDeg || 10) * Math.PI / 180);
            var hAt = function (x, z) {
              var lv = _carportRotPt(x, z, -thR)[1];
              return eYc + (vMaxR - lv) * pultRate;
            };
            var trisR = _carportPolyTris(rpoly);
            for (var tr2 = 0; tr2 < trisR.length; tr2++) {
              var t3 = trisR[tr2];
              tri(
                new T.Vector3(t3[0][0], hAt(t3[0][0], t3[0][1]) + lift, t3[0][1]),
                new T.Vector3(t3[1][0], hAt(t3[1][0], t3[1][1]) + lift, t3[1][1]),
                new T.Vector3(t3[2][0], hAt(t3[2][0], t3[2][1]) + lift, t3[2][1]),
                mats.shelterRoof
              );
            }
          } else {
            /* flat roof: no overhang. Recessed membrane plus a perimeter attika
               (parapet) whose crown sits just below the building top surface
               (ring-beam crown), so the ring beam reads as the highest line. */
            var atTop = eYc - 0.04;          /* parapet crown, below ring-beam top */
            var memY = eYc - 0.24;           /* recessed roof membrane */
            var trisF = _carportPolyTris(poly);
            for (var tf = 0; tf < trisF.length; tf++) {
              var f3 = trisF[tf];
              tri(
                new T.Vector3(f3[0][0], memY, f3[0][1]),
                new T.Vector3(f3[1][0], memY, f3[1][1]),
                new T.Vector3(f3[2][0], memY, f3[2][1]),
                mats.shelterRoof
              );
            }
            var atH = atTop - memY, atMidY = (atTop + memY) / 2;
            for (var pe2 = 0; pe2 < poly.length; pe2++) {
              var ea2 = poly[pe2], eb2 = poly[(pe2 + 1) % poly.length];
              memberAlong(
                Va([ea2[0], atMidY, ea2[1]]),
                Va([eb2[0], atMidY, eb2[1]]),
                atH, 0.12, mats.houseWall
              );
            }
          }
        } else if (Lp) {
          var Uarm = Lp.U, Vext = Lp.V, A = Lp.a, B = Lp.b, ovL = Lp.ov;
          var yRr = Lp.yR + lift, yEe = Lp.yE + lift;
          var P = function (cu, cv, y) { return Lp.toW(cu, cv, y); };
          var ocu = -ovL, ocv = -ovL, rcu = A + ovL, rcv = B + ovL;
          var hipL = hipRoof ? (Lp.yR - Lp.eaveY) / tanPitch : 0;
          var cuE = Uarm + ovL - hipL, cvE = Vext + ovL - hipL;

          quadA(P(A / 2, B / 2, yRr), P(cuE, B / 2, yRr), P(Uarm + ovL, ocv, yEe), P(ocu, ocv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(cuE, B / 2, yRr), P(Uarm + ovL, rcv, yEe), P(rcu, rcv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(A / 2, cvE, yRr), P(ocu, Vext + ovL, yEe), P(ocu, ocv, yEe), mats.shelterRoof);
          quadA(P(A / 2, B / 2, yRr), P(A / 2, cvE, yRr), P(rcu, Vext + ovL, yEe), P(rcu, rcv, yEe), mats.shelterRoof);

          var jR = P(A / 2, B / 2, Lp.yR);
          memberAlong(Va(jR), Va(P(cuE, B / 2, Lp.yR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(jR), Va(P(A / 2, cvE, Lp.yR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(jR), Va(P(ocu, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(jR), Va(P(rcu, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(P(cuE, B / 2, yRr)), Va(P(Uarm + ovL, ocv, yEe)), Va(P(Uarm + ovL, rcv, yEe)), mats.shelterRoof);
            tri(Va(P(A / 2, cvE, yRr)), Va(P(ocu, Vext + ovL, yEe)), Va(P(rcu, Vext + ovL, yEe)), mats.shelterRoof);
            memberAlong(Va(P(cuE, B / 2, Lp.yR)), Va(P(Uarm + ovL, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(P(cuE, B / 2, Lp.yR)), Va(P(Uarm + ovL, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(P(A / 2, cvE, Lp.yR)), Va(P(ocu, Vext + ovL, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(P(A / 2, cvE, Lp.yR)), Va(P(rcu, Vext + ovL, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var hspL = s.rafter.spacing;
          var UarmT = hipRoof ? Math.max(A, Math.min(Uarm, cuE)) : Uarm;
          var hn = Math.max(1, Math.ceil((UarmT - A) / hspL));
          for (var ri = 1; ri <= hn; ri++) {
            var cuH = A + (UarmT - A) * ri / hn;
            memberAlong(Va(P(cuH, B / 2, Lp.yR)), Va(P(cuH, ocv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(P(cuH, B / 2, Lp.yR)), Va(P(cuH, rcv, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var VextT = hipRoof ? Math.max(B, Math.min(Vext, cvE)) : Vext;
          var vn = Math.max(1, Math.ceil((VextT - B) / hspL));
          for (var rj = 1; rj <= vn; rj++) {
            var cvV = B + (VextT - B) * rj / vn;
            memberAlong(Va(P(A / 2, cvV, Lp.yR)), Va(P(ocu, cvV, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(P(A / 2, cvV, Lp.yR)), Va(P(rcu, cvV, Lp.yE)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
        } else if (Up) {
          var eYu = Up.eaveY, yRu = Up.yR, ovU = Up.ov;
          var Wu = Up.W, Bu = Up.B, ALu = Up.AL, ARu2 = Up.AR, VLu = Up.VL, VRu = Up.VR;
          var PU = Up.P;
          var Bhu = Bu / 2, uJL = ALu / 2, uJR = Wu - ARu2 / 2;
          var yRl = yRu + lift, yEl = eYu + lift;
          var hipU = hipRoof ? (yRu - eYu) / tanPitch : 0;
          var dLE = VLu + ovU - hipU, dRE = VRu + ovU - hipU;

          quadA(PU(uJL, Bhu, yRl), PU(uJR, Bhu, yRl), PU(Wu + ovU, -ovU, yEl), PU(-ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJR, Bhu, yRl), PU(Wu - ARu2 - ovU, Bu + ovU, yEl), PU(ALu + ovU, Bu + ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJL, dLE, yRl), PU(-ovU, VLu + ovU, yEl), PU(-ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJL, Bhu, yRl), PU(uJL, dLE, yRl), PU(ALu + ovU, VLu + ovU, yEl), PU(ALu + ovU, Bu + ovU, yEl), mats.shelterRoof);
          quadA(PU(uJR, Bhu, yRl), PU(uJR, dRE, yRl), PU(Wu + ovU, VRu + ovU, yEl), PU(Wu + ovU, -ovU, yEl), mats.shelterRoof);
          quadA(PU(uJR, Bhu, yRl), PU(uJR, dRE, yRl), PU(Wu - ARu2 - ovU, VRu + ovU, yEl), PU(Wu - ARu2 - ovU, Bu + ovU, yEl), mats.shelterRoof);

          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(uJR, Bhu, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(uJL, dLE, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(uJR, dRE, yRu)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(-ovU, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(Wu + ovU, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJL, Bhu, yRu)), Va(PU(ALu + ovU, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PU(uJR, Bhu, yRu)), Va(PU(Wu - ARu2 - ovU, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PU(uJL, dLE, yRl)), Va(PU(-ovU, VLu + ovU, yEl)), Va(PU(ALu + ovU, VLu + ovU, yEl)), mats.shelterRoof);
            tri(Va(PU(uJR, dRE, yRl)), Va(PU(Wu + ovU, VRu + ovU, yEl)), Va(PU(Wu - ARu2 - ovU, VRu + ovU, yEl)), mats.shelterRoof);
            memberAlong(Va(PU(uJL, dLE, yRu)), Va(PU(-ovU, VLu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJL, dLE, yRu)), Va(PU(ALu + ovU, VLu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJR, dRE, yRu)), Va(PU(Wu + ovU, VRu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PU(uJR, dRE, yRu)), Va(PU(Wu - ARu2 - ovU, VRu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rspU = s.rafter.spacing;
          var nbar = Math.max(1, Math.ceil((uJR - uJL) / rspU));
          for (var rb = 0; rb <= nbar; rb++) {
            var ub = uJL + (uJR - uJL) * rb / nbar;
            memberAlong(Va(PU(ub, Bhu, yRu)), Va(PU(ub, -ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (ub > ALu && ub < Wu - ARu2) {
              memberAlong(Va(PU(ub, Bhu, yRu)), Va(PU(ub, Bu + ovU, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var dLT = hipRoof ? Math.max(Bhu, dLE) : (VLu + ovU);
          var nL2 = Math.max(1, Math.ceil((dLT - Bhu) / rspU));
          for (var rl2 = 1; rl2 <= nL2; rl2++) {
            var dl2 = Bhu + (dLT - Bhu) * rl2 / nL2;
            memberAlong(Va(PU(uJL, dl2, yRu)), Va(PU(-ovU, dl2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dl2 > Bu) {
              memberAlong(Va(PU(uJL, dl2, yRu)), Va(PU(ALu + ovU, dl2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var dRT = hipRoof ? Math.max(Bhu, dRE) : (VRu + ovU);
          var nR2 = Math.max(1, Math.ceil((dRT - Bhu) / rspU));
          for (var rr2 = 1; rr2 <= nR2; rr2++) {
            var dr2 = Bhu + (dRT - Bhu) * rr2 / nR2;
            memberAlong(Va(PU(uJR, dr2, yRu)), Va(PU(Wu + ovU, dr2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dr2 > Bu) {
              memberAlong(Va(PU(uJR, dr2, yRu)), Va(PU(Wu - ARu2 - ovU, dr2, eYu)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
        } else if (Tp) {
          var eY = Tp.eaveY, Hh = Tp.H, Rr = Tp.R, ovT = Tp.ov;
          var loT = Tp.luMin - ovT, hiT = Tp.luMax + ovT;
          var s0 = Tp.su0, s1 = Tp.su1, cxT = Tp.cx;
          var dLb = Tp.DL + ovT, dRb = Tp.DR + ovT, dSb = Tp.DS + ovT;
          var PT = Tp.P;
          var yRt = Hh + lift, yEt = eY + lift;
          var hipT = hipRoof ? (Hh - eY) / tanPitch : 0;
          var uLE = loT + hipT, uRE = hiT - hipT, dSE = dSb - hipT;

          quadA(PT(loT, -ovT, yEt), PT(hiT, -ovT, yEt), PT(uRE, Rr, yRt), PT(uLE, Rr, yRt), mats.shelterRoof);
          quadA(PT(uLE, Rr, yRt), PT(cxT, Rr, yRt), PT(s0 - ovT, dLb, yEt), PT(loT, dLb, yEt), mats.shelterRoof);
          quadA(PT(uRE, Rr, yRt), PT(cxT, Rr, yRt), PT(s1 + ovT, dRb, yEt), PT(hiT, dRb, yEt), mats.shelterRoof);
          quadA(PT(cxT, Rr, yRt), PT(s0 - ovT, dLb, yEt), PT(s0 - ovT, dSb, yEt), PT(cxT, dSE, yRt), mats.shelterRoof);
          quadA(PT(cxT, Rr, yRt), PT(s1 + ovT, dRb, yEt), PT(s1 + ovT, dSb, yEt), PT(cxT, dSE, yRt), mats.shelterRoof);

          memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(uRE, Rr, Hh)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PT(cxT, Rr, Hh)), Va(PT(cxT, hipRoof ? dSE : Tp.DS, Hh)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMin, -ovT, eY)), Va(PT(Tp.luMax, -ovT, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMin, 0, eY)), Va(PT(s0, Tp.DL, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(Tp.luMax, Tp.DR, eY)), Va(PT(s1, Tp.DR, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s0, Tp.DL, eY)), Va(PT(s0, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s1, Tp.DR, eY)), Va(PT(s1, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          memberAlong(Va(PT(s0, Tp.DS, eY)), Va(PT(s1, Tp.DS, eY)), s.beam.h, s.beam.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PT(uLE, Rr, yRt)), Va(PT(loT, -ovT, yEt)), Va(PT(loT, dLb, yEt)), mats.shelterRoof);
            tri(Va(PT(uRE, Rr, yRt)), Va(PT(hiT, -ovT, yEt)), Va(PT(hiT, dRb, yEt)), mats.shelterRoof);
            tri(Va(PT(cxT, dSE, yRt)), Va(PT(s0 - ovT, dSb, yEt)), Va(PT(s1 + ovT, dSb, yEt)), mats.shelterRoof);
            memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(loT, -ovT, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uLE, Rr, Hh)), Va(PT(loT, dLb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uRE, Rr, Hh)), Va(PT(hiT, -ovT, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(uRE, Rr, Hh)), Va(PT(hiT, dRb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(cxT, dSE, Hh)), Va(PT(s0 - ovT, dSb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PT(cxT, dSE, Hh)), Va(PT(s1 + ovT, dSb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rsp = s.rafter.spacing;
          var uF0 = hipRoof ? uLE : Tp.luMin, uF1 = hipRoof ? uRE : Tp.luMax;
          var nf = Math.max(1, Math.ceil((uF1 - uF0) / rsp));
          for (var rf = 0; rf <= nf; rf++) {
            var ufx = uF0 + (uF1 - uF0) * rf / nf;
            memberAlong(Va(PT(ufx, -ovT, eY)), Va(PT(ufx, Rr, Hh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var nbl = Math.max(1, Math.ceil((s0 - uF0) / rsp));
          for (var rl = 0; rl <= nbl; rl++) {
            var ulx = uF0 + (s0 - uF0) * rl / nbl;
            memberAlong(Va(PT(ulx, Rr, Hh)), Va(PT(ulx, dLb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var nbr = Math.max(1, Math.ceil((uF1 - s1) / rsp));
          for (var rr = 0; rr <= nbr; rr++) {
            var urx = s1 + (uF1 - s1) * rr / nbr;
            memberAlong(Va(PT(urx, Rr, Hh)), Va(PT(urx, dRb, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var dSW = hipRoof ? Math.max(dLb, dSE) : dSb;
          var nstW = Math.max(1, Math.ceil((dSW - dLb) / rsp));
          for (var rw = 0; rw <= nstW; rw++) {
            var dwx = dLb + (dSW - dLb) * rw / nstW;
            memberAlong(Va(PT(cxT, dwx, Hh)), Va(PT(s0 - ovT, dwx, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
          var dSEa = hipRoof ? Math.max(dRb, dSE) : dSb;
          var nstE = Math.max(1, Math.ceil((dSEa - dRb) / rsp));
          for (var re = 0; re <= nstE; re++) {
            var dex = dRb + (dSEa - dRb) * re / nstE;
            memberAlong(Va(PT(cxT, dex, Hh)), Va(PT(s1 + ovT, dex, eY)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
        } else if (Hp) {
          var eYh = Hp.eaveY, ovH = Hp.ov, Wh = Hp.W;
          var L0h = Hp.L0, L1h = Hp.L1, R0h = Hp.R0, R1h = Hp.R1, c0h = Hp.c0, c1h = Hp.c1;
          var ALn = Hp.ALn, ALs = Hp.ALs, ARn = Hp.ARn, ARs = Hp.ARs;
          var cxLh = Hp.cxL, cxRh = Hp.cxR, yRL = Hp.yRL, yRR = Hp.yRR;
          var PH = Hp.P;
          var zch = (c0h + c1h) / 2, zNh = c0h - ovH, zSh = c1h + ovH;
          var lf = lift;
          var runHL = hipRoof ? (yRL - eYh) / tanPitch : 0;
          var runHR = hipRoof ? (yRR - eYh) / tanPitch : 0;
          var l0E = Math.min(L0h - ovH + runHL, zch), l1E = Math.max(L1h + ovH - runHL, zch);
          var r0E = Math.min(R0h - ovH + runHR, zch), r1E = Math.max(R1h + ovH - runHR, zch);
          var uMid = (Math.max(ALn, ALs) + (Wh - Math.max(ARn, ARs))) / 2;

          quadA(PH(cxLh, l0E, yRL + lf), PH(cxLh, l1E, yRL + lf), PH(-ovH, L1h + ovH, eYh + lf), PH(-ovH, L0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, l0E, yRL + lf), PH(cxLh, zch, yRL + lf), PH(ALn + ovH, zNh, eYh + lf), PH(ALn + ovH, L0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, l1E, yRL + lf), PH(cxLh, zch, yRL + lf), PH(ALs + ovH, zSh, eYh + lf), PH(ALs + ovH, L1h + ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r0E, yRR + lf), PH(cxRh, r1E, yRR + lf), PH(Wh + ovH, R1h + ovH, eYh + lf), PH(Wh + ovH, R0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r0E, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARn - ovH, zNh, eYh + lf), PH(Wh - ARn - ovH, R0h - ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxRh, r1E, yRR + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARs - ovH, zSh, eYh + lf), PH(Wh - ARs - ovH, R1h + ovH, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, zch, yRL + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARn - ovH, zNh, eYh + lf), PH(ALn + ovH, zNh, eYh + lf), mats.shelterRoof);
          quadA(PH(cxLh, zch, yRL + lf), PH(cxRh, zch, yRR + lf), PH(Wh - ARs - ovH, zSh, eYh + lf), PH(ALs + ovH, zSh, eYh + lf), mats.shelterRoof);

          memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(cxLh, l1E, yRL)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(cxRh, r1E, yRR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(cxRh, zch, yRR)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(ALn + ovH, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxLh, zch, yRL)), Va(PH(ALs + ovH, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, zch, yRR)), Va(PH(Wh - ARn - ovH, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PH(cxRh, zch, yRR)), Va(PH(Wh - ARs - ovH, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          if (hipRoof) {
            tri(Va(PH(cxLh, l0E, yRL + lf)), Va(PH(-ovH, L0h - ovH, eYh + lf)), Va(PH(ALn + ovH, L0h - ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxLh, l1E, yRL + lf)), Va(PH(-ovH, L1h + ovH, eYh + lf)), Va(PH(ALs + ovH, L1h + ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxRh, r0E, yRR + lf)), Va(PH(Wh + ovH, R0h - ovH, eYh + lf)), Va(PH(Wh - ARn - ovH, R0h - ovH, eYh + lf)), mats.shelterRoof);
            tri(Va(PH(cxRh, r1E, yRR + lf)), Va(PH(Wh + ovH, R1h + ovH, eYh + lf)), Va(PH(Wh - ARs - ovH, R1h + ovH, eYh + lf)), mats.shelterRoof);
            memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(-ovH, L0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l0E, yRL)), Va(PH(ALn + ovH, L0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l1E, yRL)), Va(PH(-ovH, L1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxLh, l1E, yRL)), Va(PH(ALs + ovH, L1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(Wh + ovH, R0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r0E, yRR)), Va(PH(Wh - ARn - ovH, R0h - ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r1E, yRR)), Va(PH(Wh + ovH, R1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PH(cxRh, r1E, yRR)), Va(PH(Wh - ARs - ovH, R1h + ovH, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }

          var rspH = s.rafter.spacing;
          var lA = hipRoof ? l0E : (L0h - ovH), lB = hipRoof ? l1E : (L1h + ovH);
          var spanL = Math.max(0.01, lB - lA);
          var nbarL = Math.max(1, Math.ceil(spanL / rspH));
          for (var rh = 0; rh <= nbarL; rh++) {
            var dl3 = lA + spanL * rh / nbarL;
            memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(-ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dl3 < zNh) {
              memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(ALn + ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            } else if (dl3 > zSh) {
              memberAlong(Va(PH(cxLh, dl3, yRL)), Va(PH(ALs + ovH, dl3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var rA = hipRoof ? r0E : (R0h - ovH), rB = hipRoof ? r1E : (R1h + ovH);
          var spanR = Math.max(0.01, rB - rA);
          var nbarR = Math.max(1, Math.ceil(spanR / rspH));
          for (var rh2 = 0; rh2 <= nbarR; rh2++) {
            var dr3 = rA + spanR * rh2 / nbarR;
            memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh + ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            if (dr3 < zNh) {
              memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh - ARn - ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            } else if (dr3 > zSh) {
              memberAlong(Va(PH(cxRh, dr3, yRR)), Va(PH(Wh - ARs - ovH, dr3, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
          var ncrs = Math.max(1, Math.ceil((cxRh - cxLh) / rspH));
          for (var rc2 = 1; rc2 < ncrs; rc2++) {
            var fr2 = rc2 / ncrs;
            var uc = cxLh + (cxRh - cxLh) * fr2;
            var yc = uc < uMid ? yRL : yRR;
            if (uc > Math.max(ALn, ALs) && uc < Wh - Math.max(ARn, ARs)) {
              memberAlong(Va(PH(uc, zch, yc)), Va(PH(uc, zNh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(Va(PH(uc, zch, yc)), Va(PH(uc, zSh, eYh)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }
          }
        } else if (RV) {
          var eYv = RV.eaveY, ovV = RV.ov, Lv = RV.L, Sv = RV.S, PV = RV.P;
          var yRv = eYv + (Sv / 2 + ovV) * tanPitch;
          var runV = Sv / 2 + ovV;
          var u0v = -ovV + runV, u1v = Lv + ovV - runV;
          if (u1v < u0v) { u0v = (u0v + u1v) / 2; u1v = u0v; }
          var vmv = Sv / 2;
          quadA(PV(u0v, vmv, yRv + lift), PV(u1v, vmv, yRv + lift), PV(Lv + ovV, -ovV, eYv + lift), PV(-ovV, -ovV, eYv + lift), mats.shelterRoof);
          quadA(PV(u0v, vmv, yRv + lift), PV(u1v, vmv, yRv + lift), PV(Lv + ovV, Sv + ovV, eYv + lift), PV(-ovV, Sv + ovV, eYv + lift), mats.shelterRoof);
          tri(Va(PV(u0v, vmv, yRv + lift)), Va(PV(-ovV, -ovV, eYv + lift)), Va(PV(-ovV, Sv + ovV, eYv + lift)), mats.shelterRoof);
          tri(Va(PV(u1v, vmv, yRv + lift)), Va(PV(Lv + ovV, -ovV, eYv + lift)), Va(PV(Lv + ovV, Sv + ovV, eYv + lift)), mats.shelterRoof);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(u1v, vmv, yRv)), s.ridge.h, s.ridge.w, mats.shelterTimber);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(-ovV, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u0v, vmv, yRv)), Va(PV(-ovV, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u1v, vmv, yRv)), Va(PV(Lv + ovV, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          memberAlong(Va(PV(u1v, vmv, yRv)), Va(PV(Lv + ovV, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          var rspV = s.rafter.spacing;
          var nrv = Math.max(1, Math.ceil(Math.max(0.01, u1v - u0v) / rspV));
          for (var rv2 = 0; rv2 <= nrv; rv2++) {
            var uv2 = u0v + (u1v - u0v) * rv2 / nrv;
            memberAlong(Va(PV(uv2, vmv, yRv)), Va(PV(uv2, -ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
            memberAlong(Va(PV(uv2, vmv, yRv)), Va(PV(uv2, Sv + ovV, eYv)), s.rafter.h, s.rafter.w, mats.shelterTimber);
          }
        } else if (RC) {
          for (var ti = 0; ti < RC.skin.length; ti++) {
            var tf = RC.skin[ti];
            tri(
              new T.Vector3(tf[0][0], tf[0][1] + lift, tf[0][2]),
              new T.Vector3(tf[1][0], tf[1][1] + lift, tf[1][2]),
              new T.Vector3(tf[2][0], tf[2][1] + lift, tf[2][2]),
              mats.shelterRoof
            );
          }
          for (var sbi = 0; sbi < RC.beams.length; sbi++) {
            var bm = RC.beams[sbi];
            memberAlong(Va(bm.a), Va(bm.b), bm.ridge ? s.ridge.h : s.rafter.h, bm.ridge ? s.ridge.w : s.rafter.w, mats.shelterTimber);
          }
        } else {
          for (var wi = 0; wi < g.wings.length; wi++) {
            var wg = g.wings[wi];
            var ov = wg.overhang, L = wg.coreLen, h = wg.half;
            var t0 = -ov, t1 = L + ov;

            memberAlong(WP(wg, t0, 0, wg.ridgeY), WP(wg, t1, 0, wg.ridgeY), s.ridge.h, s.ridge.w, mats.shelterTimber);

            var pairs = wg.rafterPairs;
            for (var r = 0; r < pairs; r++) {
              var t = L * (pairs === 1 ? 0.5 : r / (pairs - 1));
              memberAlong(WP(wg, t,  h, wg.eaveY), WP(wg, t, 0, wg.ridgeY), s.rafter.h, s.rafter.w, mats.shelterTimber);
              memberAlong(WP(wg, t, -h, wg.eaveY), WP(wg, t, 0, wg.ridgeY), s.rafter.h, s.rafter.w, mats.shelterTimber);
            }

            quad(WP(wg, t0,  h, wg.eaveY + lift), WP(wg, t1,  h, wg.eaveY + lift),
                 WP(wg, t1, 0, wg.ridgeY + lift), WP(wg, t0, 0, wg.ridgeY + lift), mats.shelterRoof);
            quad(WP(wg, t0, -h, wg.eaveY + lift), WP(wg, t1, -h, wg.eaveY + lift),
                 WP(wg, t1, 0, wg.ridgeY + lift), WP(wg, t0, 0, wg.ridgeY + lift), mats.shelterRoof);
          }
        }

        /* Universal roof underside closer: turn the (single-sided) top skin
           into a closed slab so the house reads as complete from every angle
           and the eave sits down onto the structure with no gap. Works for any
           shape (gable/hip/mono and L/T/U/H) by cloning the collected skin tris
           downward by a fixed thickness and wrapping the open boundary edges
           with fascia. Skipped for the flat roof (which has its own attika). */
        if (!flatRoof && roofSkinTris.length) {
          var rThick = 0.22;
          var eaveLevel = s.clearHeight + s.beam.h;   /* wall top = building top surface */
          var snap = roofSkinTris.slice();
          for (var ci = 0; ci < snap.length; ci++) {
            var tt = snap[ci];
            tri(
              new T.Vector3(tt[0][0], tt[0][1] - rThick, tt[0][2]),
              new T.Vector3(tt[2][0], tt[2][1] - rThick, tt[2][2]),
              new T.Vector3(tt[1][0], tt[1][1] - rThick, tt[1][2]),
              mats.shelterRoof
            );
          }
          var emap = {};
          var ekey = function (pp, qq) {
            var ka = Math.round(pp[0] * 1000) + ',' + Math.round(pp[1] * 1000) + ',' + Math.round(pp[2] * 1000);
            var kb = Math.round(qq[0] * 1000) + ',' + Math.round(qq[1] * 1000) + ',' + Math.round(qq[2] * 1000);
            return (ka < kb) ? (ka + '|' + kb) : (kb + '|' + ka);
          };
          for (var ti2 = 0; ti2 < snap.length; ti2++) {
            var tg = snap[ti2];
            for (var ei = 0; ei < 3; ei++) {
              var pA = tg[ei], pB = tg[(ei + 1) % 3];
              var kx = ekey(pA, pB);
              if (emap[kx]) emap[kx].count++;
              else emap[kx] = { count: 1, a: pA, b: pB };
            }
          }
          for (var kk in emap) {
            if (!emap.hasOwnProperty(kk)) continue;
            var ed = emap[kk];
            if (ed.count !== 1) continue;   /* interior edge */
            var pa = ed.a, pb = ed.b;
            quad(
              new T.Vector3(pa[0], pa[1], pa[2]),
              new T.Vector3(pb[0], pb[1], pb[2]),
              new T.Vector3(pb[0], pb[1] - rThick, pb[2]),
              new T.Vector3(pa[0], pa[1] - rThick, pa[2]),
              mats.shelterRoof
            );
          }

          /* Close the gap between the structure top and the roof underside on
             every footprint edge: a vertical wall from the wall top up to the
             sampled roof underside. On eave walls this is a low upstand, on
             gable walls the full triangle — either way no gap is left to the
             structure. Sampling is nudged slightly inward so points never miss
             the skin at the footprint boundary; robust for every shape. */
          var cgx2 = 0, cgz2 = 0;
          for (var cgj = 0; cgj < poly.length; cgj++) { cgx2 += poly[cgj][0]; cgz2 += poly[cgj][1]; }
          cgx2 /= poly.length; cgz2 /= poly.length;
          /* wall thickness so the gable outline sits on the OUTER face of the
             perimeter wall; the main house always draws a plain wall now, so
             use that thickness for every type */
          var gThk = (global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30;
          var gHalf = gThk / 2;
          var roofUnderAt = function (x, z) {
            for (var pass = 0; pass < 4; pass++) {
              var f = pass * 0.12;
              var dx = cgx2 - x, dz = cgz2 - z, dl = Math.hypot(dx, dz) || 1;
              var sx = x + (dx / dl) * f, sz = z + (dz / dl) * f;
              var best = -Infinity;
              for (var i = 0; i < snap.length; i++) {
                var tg = snap[i];
                var x1 = tg[0][0], z1 = tg[0][2], x2 = tg[1][0], z2 = tg[1][2], x3 = tg[2][0], z3 = tg[2][2];
                var d = (z2 - z3) * (x1 - x3) + (x3 - x2) * (z1 - z3);
                if (Math.abs(d) < 1e-9) continue;
                var aa = ((z2 - z3) * (sx - x3) + (x3 - x2) * (sz - z3)) / d;
                var bb = ((z3 - z1) * (sx - x3) + (x1 - x3) * (sz - z3)) / d;
                var cc = 1 - aa - bb;
                if (aa >= -0.05 && bb >= -0.05 && cc >= -0.05) {
                  var yy = aa * tg[0][1] + bb * tg[1][1] + cc * tg[2][1];
                  if (yy > best) best = yy;
                }
              }
              if (best > -1e8) return best;
            }
            return -Infinity;
          };
          /* Simplest closure: take the outer outline of the ring beam
             (footprint pushed out by half the wall thickness) and extrude it
             straight up from the ring-beam top to the roof underside. One
             continuous skirt closes both gable and eave gaps and is flush with
             the perimeter wall's outer face. */
          var outline = _offsetPolyOut(poly, gHalf);
          for (var ge = 0; ge < outline.length; ge++) {
            var ga = outline[ge], gb = outline[(ge + 1) % outline.length];
            var gdx = gb[0] - ga[0], gdz = gb[1] - ga[1];
            var glen = Math.hypot(gdx, gdz);
            if (glen < 0.05) continue;
            var gsteps = Math.max(1, Math.ceil(glen / 0.4));
            var topH = [];
            for (var ps = 0; ps <= gsteps; ps++) {
              var fp = ps / gsteps;
              var hu = roofUnderAt(ga[0] + gdx * fp, ga[1] + gdz * fp);
              topH.push(Math.max((hu > -1e8 ? hu - rThick : eaveLevel), eaveLevel));
            }
            for (var gk = 0; gk < gsteps; gk++) {
              var t0 = topH[gk], t1 = topH[gk + 1];
              if (t0 <= eaveLevel + 0.02 && t1 <= eaveLevel + 0.02) continue;
              var q0x = ga[0] + gdx * (gk / gsteps), q0z = ga[1] + gdz * (gk / gsteps);
              var q1x = ga[0] + gdx * ((gk + 1) / gsteps), q1z = ga[1] + gdz * ((gk + 1) / gsteps);
              quad(
                new T.Vector3(q0x, eaveLevel, q0z),
                new T.Vector3(q1x, eaveLevel, q1z),
                new T.Vector3(q1x, t1, q1z),
                new T.Vector3(q0x, t0, q0z),
                mats.houseGable
              );
            }
          }
        }

        _dbg('[carport] 3D built, meshes=' + SG.children.length);
        try { _Openings._renderWalls(); } catch (eWg) {}
        try { _Openings.render(); } catch (eOp) {}
      } catch (err) {
        if (window.Configurator && window.Configurator.log) {
          window.Configurator.log.log('[carport] build error: ' + (err && err.message ? err.message : err));
        }
      }
    },

    _build2D_Carport: function (poly) {
      var T = global.THREE, eng = global.BaseEngine;
      var mats = this._ensureMaterials();
      if (!T || !eng || !eng.sceneGroup || !poly || poly.length < 3) return;
      try {
        var SG = eng.sceneGroup, g = _carportGeom(), s = g.s;

        /* NOTE: the translucent floor-plan fill (fill2D) is intentionally NOT
           drawn in 3D — with depthWrite:false it laid a faint dark wash over the
           paving/grid under the whole footprint (most visible around a balcony
           cut). The real floor slab (floor deck) provides the floor in 3D. */

        var pts = [];
        for (var i = 0; i <= poly.length; i++) {
          var p = poly[i % poly.length]; pts.push(new T.Vector3(p[0], 0.002, p[1]));
        }
        var _edgeLine = new T.Line(new T.BufferGeometry().setFromPoints(pts), mats.edge2D);
        _edgeLine.userData = { house2DLine: true };    /* hidden while editing the floor plan */
        SG.add(_edgeLine);

        for (var wi = 0; wi < g.wings.length; wi++) {
          var wg = g.wings[wi];
          var r1 = new T.Vector3(wg.ax.x, 0.004, wg.ax.z);
          var r2 = new T.Vector3(wg.bx.x, 0.004, wg.bx.z);
          var _ridge = new T.Line(new T.BufferGeometry().setFromPoints([r1, r2]), mats.edge2D);
          _ridge.userData = { house2DLine: true };
          SG.add(_ridge);
        }
        _dbg('[carport] 2D built, meshes=' + SG.children.length);
      } catch (err) {
        _dbg('[carport] build2D error: ' + (err && err.message ? err.message : err));
      }
    },

    _blockGeoCache: null,

  };


  /* ======================================================================
     OPENINGS (windows / doors) — phase 1
     Finite catalogue, ghost-follows-pointer placement on the walls, full
     window (frame + glass) laid on the wall outer face (no wall cut yet),
     drag to move, tap to select, sill slider + delete. Stored in
     STATE.openings and broadcast as 'mc:openings'. Block module (mc:grid half)
     drives the optional position snap. Drawn for every structure type.
     ====================================================================== */
  var _IN = 0.0254;
  /* 6 subcategories. BoQ id = 4-letter prefix + 4 digits (metric 00xx, imperial 01xx)
     → never collides with Central BoQ. Items carry only size; label + thumbnail derived. */
  var OPENING_CATS = [
    { id: 'window', pfx: 'WIND', kind: 'window', nameKey: 'mcOpWindow', nameEn: 'Windows' },
    { id: 'extd', pfx: 'EXTE', kind: 'door', nameKey: 'mcOpExteriorDoor', nameEn: 'Exterior doors' },
    { id: 'french', pfx: 'FREN', kind: 'french', nameKey: 'mcOpFrenchDoor', nameEn: 'French doors' },
    { id: 'slide', pfx: 'SLID', kind: 'slide', nameKey: 'mcOpSlidingDoor', nameEn: 'Sliding doors' },
    { id: 'roof', pfx: 'ROOF', kind: 'roof', nameKey: 'mcOpRoofWindow', nameEn: 'Roof windows' }
  ];
  var OPENING_ITEMS = (function () {
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    /* metric size sets (m). windows: same 8-step set for width & height */
    var WIN_M = [0.50, 0.75, 1.00, 1.25, 1.50, 1.75, 2.00, 2.25];
    var SLIDE_M = [1.50, 1.75, 2.00, 2.25, 2.50, 2.75, 3.00, 3.25, 3.50];
    var INT_M = [0.70, 0.80, 0.90];
    var EXT_M = [0.90, 1.00];
    var FRE_M = [1.25, 1.50, 1.75, 2.00];
    /* imperial size sets (inches → m), modular (multiples of 8″) */
    var WIN_I = [24, 32, 40, 48, 56, 64, 72, 80];
    var SLIDE_I = [60, 72, 84, 96, 108, 120, 132, 144];
    var INT_I = [28, 30, 32];
    var EXT_I = [36];
    var FRE_I = [48, 60, 72];
    function inM(a) { return a.map(function (x) { return x * _IN; }); }
    /* windows: full grid width × height; id = WIND + widthIdx + heightIdx */
    function winGrid(set, sillDef) {
      var out = [];
      for (var wi = 0; wi < set.length; wi++) for (var hi = 0; hi < set.length; hi++) {
        out.push({ id: 'WIND' + p2(wi + 1) + p2(hi + 1), w: set[wi], h: set[hi], sill: sillDef, frame: 0.06 });
      }
      return out;
    }
    /* single-height door-type rows; id = PFX + widthIdx + 01 */
    function rowList(pfx, widths, h, extra) {
      var out = [];
      for (var wi = 0; wi < widths.length; wi++) {
        var o = { id: pfx + p2(wi + 1) + '01', w: widths[wi], h: h, sill: 0, frame: 0.07 };
        if (extra) for (var k in extra) o[k] = extra[k];
        out.push(o);
      }
      return out;
    }
    return {
      window: { m: winGrid(WIN_M, 0.90), i: winGrid(inM(WIN_I), 36 * _IN) },
      intd: { m: rowList('INTE', INT_M, 1.97), i: rowList('INTE', inM(INT_I), 80 * _IN) },
      extd: { m: rowList('EXTE', EXT_M, 2.10, { glassTop: true }), i: rowList('EXTE', inM(EXT_I), 84 * _IN, { glassTop: true }) },
      french: { m: rowList('FREN', FRE_M, 2.10, { leaves: 2 }), i: rowList('FREN', inM(FRE_I), 80 * _IN, { leaves: 2 }) },
      slide: { m: rowList('SLID', SLIDE_M, 2.10, { panels: 2 }), i: rowList('SLID', inM(SLIDE_I), 80 * _IN, { panels: 2 }) },
      roof: {
        m: [
          { id: 'ROOF0101', w: 0.55, h: 0.78, sill: 0, frame: 0.05 },
          { id: 'ROOF0201', w: 0.78, h: 1.18, sill: 0, frame: 0.06 },
          { id: 'ROOF0301', w: 0.94, h: 1.40, sill: 0, frame: 0.06 }
        ],
        i: [
          { id: 'ROOF0101', w: 21 * _IN, h: 38 * _IN, sill: 0, frame: 0.05 },
          { id: 'ROOF0201', w: 30 * _IN, h: 46 * _IN, sill: 0, frame: 0.06 },
          { id: 'ROOF0301', w: 37 * _IN, h: 55 * _IN, sill: 0, frame: 0.06 }
        ]
      }
    };
  })();
  function _opList(catId) { var c = OPENING_ITEMS[catId]; if (!c) return []; return (STATE.isMetric ? c.m : c.i); }
  function _catItem(id) {
    for (var k = 0; k < OPENING_CATS.length; k++) {
      var cid = OPENING_CATS[k].id, c = OPENING_ITEMS[cid]; if (!c) continue;
      var arr = c.m.concat(c.i);
      for (var j = 0; j < arr.length; j++) if (arr[j].id === id) {
        var it = arr[j]; it.cat = cid; it.kind = OPENING_CATS[k].kind; return it;
      }
    }
    return null;
  }
  function _opLabel(it) {
    if (STATE.isMetric) return Math.round(it.w * 1000) + ' × ' + Math.round(it.h * 1000) + ' mm';
    return Math.round(it.w / _IN) + '\u2033 × ' + Math.round(it.h / _IN) + '\u2033';
  }
  /* single source of truth for window vertical division — used by both the
     3D mesh and the thumbnail so they match exactly. Dividing from ~1.5 m,
     one extra pane per ~1.2 m. */
  function _winPanes(w) { return (w < 1.45) ? 1 : Math.ceil(w / 1.2); }
  function _optt(k, f) {
    var T = (global.BASE_BOOT || {}).i18n || {};
    var v = T[k];
    return (typeof v === 'string' && v && v.indexOf('Translation missing') === -1) ? v : f;
  }
  /* generated SVG thumbnail; style per subcategory, proportioned to w/h */
  function _opThumb(it, catId) {
    var maxW = 60, maxH = 52, ar = it.w / it.h, tw, th;
    if (ar >= maxW / maxH) { tw = maxW; th = maxW / ar; } else { th = maxH; tw = maxH * ar; }
    tw = Math.max(14, Math.round(tw)); th = Math.max(20, Math.round(th));
    var st = '#3a3f45', gl = 'rgba(159,212,230,.55)', pn = '#cdbfa6';
    var s = '<svg width="' + tw + '" height="' + th + '" viewBox="0 0 ' + tw + ' ' + th + '" xmlns="http://www.w3.org/2000/svg">';
    function R(x, y, w, h, f, w2) { return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + (f || 'none') + '" stroke="' + st + '" stroke-width="' + (w2 || 1.6) + '"/>'; }
    function L(x1, y1, x2, y2) { return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + st + '" stroke-width="1.4"/>'; }
    var p = 2;
    if (catId === 'window') {
      s += R(p, p, tw - 2 * p, th - 2 * p, gl);
      var np = _winPanes(it.w), iw2 = tw - 2 * p, q2;
      for (q2 = 1; q2 < np; q2++) { var xx = p + iw2 * q2 / np; s += L(xx, p, xx, th - p); }
    } else if (catId === 'intd') {
      s += R(p, p, tw - 2 * p, th - 2 * p, pn);
      s += R(p + 4, p + 5, tw - 2 * p - 8, (th - 2 * p) / 2 - 7, 'none', 1) + '<circle cx="' + (tw - p - 5) + '" cy="' + (th / 2) + '" r="1.6" fill="' + st + '"/>';
    } else if (catId === 'extd') {
      s += R(p, p, tw - 2 * p, th - 2 * p, pn);
      s += R(p + 3, p + 3, tw - 2 * p - 6, (th - 2 * p) * 0.32, gl) + '<circle cx="' + (tw - p - 5) + '" cy="' + (th * 0.62) + '" r="1.6" fill="' + st + '"/>';
    } else if (catId === 'french') {
      var hw = (tw - 2 * p) / 2;
      s += R(p, p, hw, th - 2 * p, gl) + R(p + hw, p, hw, th - 2 * p, gl);
      s += L(p + hw / 2, p, p + hw / 2, th - p) + L(p + hw + hw / 2, p, p + hw + hw / 2, th - p);
    } else if (catId === 'slide') {
      var np = it.panels || 2, pw = (tw - 2 * p) / np, i2;
      for (i2 = 0; i2 < np; i2++) s += R(p + i2 * pw, p, pw, th - 2 * p, gl);
      s += '<path d="M' + (tw / 2 - 5) + ' ' + (th - 5) + ' h10 m-3 -3 l3 3 l-3 3" fill="none" stroke="' + st + '" stroke-width="1.2"/>';
    } else if (catId === 'roof') {
      var sk = Math.min(8, tw * 0.18);
      s += '<polygon points="' + (p + sk) + ',' + p + ' ' + (tw - p) + ',' + p + ' ' + (tw - p - sk) + ',' + (th - p) + ' ' + p + ',' + (th - p) + '" fill="' + gl + '" stroke="' + st + '" stroke-width="1.6"/>';
      s += L((p + sk + tw - p) / 2, p, (p + tw - p - sk) / 2, th - p);
    }
    s += '</svg>';
    return s;
  }
  function _esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- floor plan + partitions ------------------------------------------
     Both objects now live in assets/configurator-floorplan.js. They were lifted
     verbatim -- same code, different file -- so nothing here should behave
     differently, and if it does, the extraction is wrong rather than the plan.

     The names _Floorplan and _Partitions are kept because ~40 call sites in this
     file use them; the asset hands the same objects back. Renaming them would
     have been a second change tangled up with the first, and then a regression
     could have been either.

     The nine things the module asks for are the nine it always read straight out
     of this file's scope. Nothing new had to be invented to make it portable --
     which is the sign it was separable all along. */
  var _Floorplan = null, _Partitions = null;
  (function () {
    var FP = global.ConfiguratorFloorplan;
    if (!FP) {
      try {
        var LG = (global.Configurator && global.Configurator.log) ? global.Configurator.log : global.console;
        if (LG && LG.log) LG.log('[base] floorplan asset missing -- configurator-floorplan.js not loaded');
      } catch (e) {}
      return;
    }
    FP.init({
      getPolygon: function () { return getFootprintPolygon(); },
      getFloors:  function () { return STATE.floors; },
      getView:    function () { return STATE.view; },
      isMetric:   function () { return !!STATE.isMetric; },
      getVariant: function () { return STATE.structureVariant; },
      toggleView: function () { return toggleView(); },
      t:          function (k, f) { return _optt(k, f); },
      clearFloor: function (i) { return _clearForFloor(i); },
      flush3D:    function () { return _forceRender3DFlush(); },
      stage:      global.BaseEngine || global.ConfiguratorStage,
      boot:       global.BASE_BOOT,
      /* Read, not called -- which is why the first pass lost them. Without the
         store the underlay uploads, displays, and disappears on the next render
         without a word: its save is guarded by typeof and quietly returned. */
      store:      _ProjectStore,
      balcony:    (typeof _Balcony !== 'undefined') ? _Balcony : null,
      specs:      (typeof SHELTER_SPECS !== 'undefined') ? SHELTER_SPECS : null
    });
    _Floorplan = FP.Floorplan;
    _Partitions = FP.Partitions;
  })();


  /* ---- balcony footprints (floor-plan stage 4) --------------------------
     A draggable ghost rectangle per storey marking an under-roof balcony.
     STEP 1 — editor only: define / resize / move the footprint. Snapping to the
     main wall and the 3D perimeter wall around it come in later steps. Held in
     memory per active floor (no persistence yet). */
  var _Balcony = {
    _grp: null, _cuts: [], _bound: false, _activeIdx: -1,
    _DEF: 3.0,                                          /* default cut side (m) */
    _CUTKEY: 'mc:balconyCuts', _loaded: false,
    _LSKEY: 'mc:balconyRects', _ALLKEY: 'mc:balconyAll',   /* legacy stores, migrated once */

    /* Each cut carries its OWN scope: mode 'floor' (a single storey, floor index)
       or 'all1' (all storeys, slabs stay) or 'all2' (all storeys, slabs cut). The
       storey / ALL switcher acts on the ACTIVE cut only, so different cuts can
       behave differently. New cuts default to the first storey. */
    _normCut: function (c, mode, floor) {
      if (!c || typeof c.cx !== 'number') return null;
      var m = mode || ((c.mode === 'all1' || c.mode === 'all2') ? c.mode : 'floor');
      var fl = (floor != null) ? (floor | 0) : (c.floor | 0);
      return { cx: c.cx, cz: c.cz, w: c.w, d: c.d, mode: m, floor: fl };
    },

    _loadRects: function () {
      if (this._loaded) return; this._loaded = true;
      var i, j, k, nc;
      /* unified store */
      try { var s = localStorage.getItem(this._CUTKEY); if (s) { var o = JSON.parse(s); if (o && Array.isArray(o.cuts)) { var out = []; for (i = 0; i < o.cuts.length; i++) { nc = this._normCut(o.cuts[i]); if (nc) out.push(nc); } this._cuts = out; this._activeIdx = out.length ? Math.max(0, Math.min(o.active | 0, out.length - 1)) : -1; return; } } } catch (e) {}
      /* migrate legacy per-floor + ALL stores into one list (one time) */
      var cuts = [];
      try { var sr = localStorage.getItem(this._LSKEY); if (sr) { var rr = JSON.parse(sr); if (rr && typeof rr === 'object') { for (k in rr) { if (rr.hasOwnProperty(k)) { var arr = Array.isArray(rr[k]) ? rr[k] : ((rr[k] && typeof rr[k].cx === 'number') ? [rr[k]] : []); for (j = 0; j < arr.length; j++) { nc = this._normCut(arr[j], 'floor', k | 0); if (nc) cuts.push(nc); } } } } } } catch (e2) {}
      try { var sa = localStorage.getItem(this._ALLKEY); if (sa) { var aa = JSON.parse(sa); if (aa && typeof aa === 'object') { var am = aa.mode | 0, ac = Array.isArray(aa.cuts) ? aa.cuts : ((aa.rect && typeof aa.rect.cx === 'number') ? [aa.rect] : []); if (am > 0) { for (j = 0; j < ac.length; j++) { nc = this._normCut(ac[j], am === 1 ? 'all1' : 'all2', 0); if (nc) cuts.push(nc); } } } } } catch (e3) {}
      this._cuts = cuts; this._activeIdx = cuts.length ? 0 : -1;
    },
    _saveRects: function () {
      this._loaded = true;
      try { localStorage.setItem(this._CUTKEY, JSON.stringify({ cuts: this._cuts, active: this._activeIdx })); } catch (e) {}
    },

    /* does cut c affect floor f? ALL cuts affect every floor; a floor cut only its own. */
    _applies: function (c, f) { return (c.mode === 'all1' || c.mode === 'all2') ? true : ((c.floor | 0) === f); },
    _cutsFor: function (f) { this._loadRects(); var out = [], i; for (i = 0; i < this._cuts.length; i++) { if (this._applies(this._cuts[i], f)) out.push(this._cuts[i]); } return out; },

    /* a cut is REAL only when it reaches the perimeter (its clipped shape has an
       edge on the footprint outline). A cut wholly inside is an inert ghost. */
    _cutActive: function (r) {
      if (!r) return false;
      var cl = this._clipRectFootprint(r); if (cl.length < 3) return false;
      for (var i = 0; i < cl.length; i++) { if (this._onPerimeter(cl[i], cl[(i + 1) % cl.length])) return true; }
      return false;
    },
    _activeCuts: function (f) { var list = this._cutsFor(f), out = [], i; for (i = 0; i < list.length; i++) { if (this._cutActive(list[i])) out.push(list[i]); } return out; },
    /* active ALL-2 cuts affecting floor f — these punch the slab over floor f */
    _all2CutsAt: function (f) { this._loadRects(); var out = [], i, c; for (i = 0; i < this._cuts.length; i++) { c = this._cuts[i]; if (c.mode === 'all2' && this._applies(c, f) && this._cutActive(c)) out.push(c); } return out; },

    _floor:  function () { return (_Floorplan && (_Floorplan._activeFloor | 0)) || 0; },
    _active: function () { return STATE.view === '2d' && STATE.vizStage !== 4 && !!_Floorplan && _Floorplan._stage === 4 && !!_Floorplan._panelEl && _Floorplan._panelEl.style.display !== 'none'; },

    /* the whole cut list (drag edits this) + the active (selected) cut */
    _editList:  function () { this._loadRects(); return this._cuts; },
    _activeCut: function () { this._loadRects(); return (this._activeIdx >= 0 && this._activeIdx < this._cuts.length) ? this._cuts[this._activeIdx] : null; },


    _ensure: function () { this._loadRects(); if (this._bound) return; this._bound = true; this._bindDrag(); },

    /* the default cut shape (square straddling the front edge), used as the seed
       when a new cut is pulled out of the vault. */
    _defaultCut: function () {
      var poly = (typeof getFootprintPolygon === 'function') ? getFootprintPolygon() : null;
      var minX = -3, maxX = 3, minZ = -3, maxZ = 3, i, p;
      if (poly && poly.length >= 3) {
        minX = Infinity; maxX = -Infinity; minZ = Infinity; maxZ = -Infinity;
        for (i = 0; i < poly.length; i++) { p = poly[i]; if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; if (p[1] < minZ) minZ = p[1]; if (p[1] > maxZ) maxZ = p[1]; }
      }
      var bw = Math.max(2, maxX - minX), bd = Math.max(2, maxZ - minZ);
      var side = Math.max(1.2, Math.min(this._DEF, bw * 0.5, bd * 0.5));
      return { cx: (minX + maxX) / 2, cz: (minZ + maxZ) / 2, w: side, d: side };
    },
    /* centre of the footprint bbox — where the vault sits */
    _vaultCentre: function () {
      var poly = (typeof getFootprintPolygon === 'function') ? getFootprintPolygon() : null;
      var minX = -3, maxX = 3, minZ = -3, maxZ = 3, i, p;
      if (poly && poly.length >= 3) {
        minX = Infinity; maxX = -Infinity; minZ = Infinity; maxZ = -Infinity;
        for (i = 0; i < poly.length; i++) { p = poly[i]; if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; if (p[1] < minZ) minZ = p[1]; if (p[1] > maxZ) maxZ = p[1]; }
      }
      return { x: (minX + maxX) / 2, z: (minZ + maxZ) / 2, side: Math.max(1.2, Math.min(this._DEF, Math.max(2, maxX - minX) * 0.5, Math.max(2, maxZ - minZ) * 0.5)) };
    },

    /* the storey / ALL switcher acts on the ACTIVE (selected) cut: set its scope
       — mode 'floor' with a storey index, or 'all1' / 'all2' — then rebuild and
       re-broadcast. Other cuts keep their own scope. */
    _setActiveScope: function (mode, floor) {
      this._loadRects();
      var c = this._activeCut(); if (!c) return;
      c.mode = (mode === 'all1' || mode === 'all2') ? mode : 'floor';
      if (c.mode === 'floor' && floor != null) c.floor = floor | 0;
      this._saveRects();
      try { if (_Floorplan && _Floorplan._showPanel) _Floorplan._showPanel(); } catch (e) {}
      try { this.render(); } catch (e2) {}
      try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e3) {}
      try { if (typeof _broadcastHouse === 'function') _broadcastHouse(); } catch (e4) {}
    },
    /* mark a cut active (selected) by index */
    _setActive: function (idx) { this._loadRects(); if (idx >= 0 && idx < this._cuts.length) { this._activeIdx = idx; this._saveRects(); } },

    _corners: function (r) {
      var hw = r.w / 2, hd = r.d / 2;
      return [[r.cx - hw, r.cz - hd], [r.cx + hw, r.cz - hd], [r.cx + hw, r.cz + hd], [r.cx - hw, r.cz + hd]];
    },
    _cornerAt: function (r, g) {
      var cs = this._corners(r), rad = Math.max(0.45, Math.min(r.w, r.d) * 0.12);
      for (var k = 0; k < 4; k++) { var dx = g.x - cs[k][0], dz = g.z - cs[k][1]; if (dx * dx + dz * dz <= rad * rad) return k; }
      return -1;
    },

    render: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (this._grp) { if (this._grp.parent) this._grp.parent.remove(this._grp); this._grp = null; }
      if (!T || !eng || !eng.sceneGroup || !this._active()) return;
      this._loadRects();
      var grp = new T.Group(), k, a, b, c;

      /* VAULT — the source square at the footprint centre. Pull a new cut out of
         it; drop a cut back onto it to delete. Drawn faint so it reads as a tool,
         not a real recess. */
      var vc = this._vaultCentre();
      var vfill = new T.Mesh(new T.PlaneGeometry(vc.side, vc.side),
        new T.MeshBasicMaterial({ color: 0x8a93a0, transparent: true, opacity: 0.20, side: T.DoubleSide, depthWrite: false }));
      vfill.rotation.x = -Math.PI / 2; vfill.position.set(vc.x, 0.055, vc.z); vfill.renderOrder = 5;
      vfill.userData = { balconyVault: true };
      grp.add(vfill);
      var vcs = this._corners({ cx: vc.x, cz: vc.z, w: vc.side, d: vc.side }), vlp = [];
      for (k = 0; k < 4; k++) { a = vcs[k]; b = vcs[(k + 1) % 4]; vlp.push(a[0], 0.065, a[1], b[0], 0.065, b[1]); }
      var vlg = new T.BufferGeometry(); vlg.setAttribute('position', new T.Float32BufferAttribute(vlp, 3));
      var vline = new T.LineSegments(vlg, new T.LineBasicMaterial({ color: 0x6b7280, transparent: true, opacity: 0.7 }));
      vline.renderOrder = 7; grp.add(vline);

      /* every cut in this floor's (or shared) list — green when it actually cuts
         the perimeter, grey while it's an inert ghost sitting inside. */
      var list = this._editList();
      for (var ci = 0; ci < list.length; ci++) {
        var r = list[ci], active = this._cutActive(r), sel = (ci === this._activeIdx);
        /* colour by scope when it actually cuts: floor = green, all1 = blue,
           all2 = orange; an inert ghost is grey regardless. */
        var col = !active ? 0x9aa0a6 : (r.mode === 'all2' ? 0xf97316 : (r.mode === 'all1' ? 0x3b82f6 : 0x22c55e));
        var ocol = sel ? 0xffffff : (!active ? 0x6b7280 : (r.mode === 'all2' ? 0xc2410c : (r.mode === 'all1' ? 0x1d4ed8 : 0x15803d)));
        var fill = new T.Mesh(new T.PlaneGeometry(r.w, r.d),
          new T.MeshBasicMaterial({ color: col, transparent: true, opacity: sel ? 0.40 : (active ? 0.30 : 0.20), side: T.DoubleSide, depthWrite: false }));
        fill.rotation.x = -Math.PI / 2; fill.position.set(r.cx, 0.08, r.cz); fill.renderOrder = 8;
        fill.userData = { balconyFill: true, cutIdx: ci };
        grp.add(fill);
        var cs = this._corners(r), lp = [];
        for (k = 0; k < 4; k++) { a = cs[k]; b = cs[(k + 1) % 4]; lp.push(a[0], 0.09, a[1], b[0], 0.09, b[1]); }
        var lg = new T.BufferGeometry(); lg.setAttribute('position', new T.Float32BufferAttribute(lp, 3));
        var line = new T.LineSegments(lg, new T.LineBasicMaterial({ color: ocol, transparent: true, opacity: sel ? 1 : 0.9, linewidth: sel ? 2 : 1 }));
        line.renderOrder = sel ? 14 : 12; grp.add(line);
        var hr = Math.max(0.14, Math.min(0.28, Math.min(r.w, r.d) * 0.05)) * (sel ? 1.25 : 1);
        for (c = 0; c < 4; c++) {
          var h = new T.Mesh(new T.CircleGeometry(hr, 22),
            new T.MeshBasicMaterial({ color: sel ? 0xffffff : ocol, transparent: true, opacity: 0.98, side: T.DoubleSide, depthWrite: false, depthTest: false }));
          h.rotation.x = -Math.PI / 2; h.position.set(cs[c][0], 0.11, cs[c][1]); h.renderOrder = 16;
          h.userData = { balconyHandle: c, cutIdx: ci };
          grp.add(h);
        }
      }
      eng.sceneGroup.add(grp); this._grp = grp;
    },

    /* ---- 3D perimeter wall around the balcony (step 3) --------------------
       The rect may overhang the footprint; only the part INSIDE the footprint
       is a real recess. We clip the rect to the footprint and wall the clipped
       edges that are NOT on the footprint perimeter (those are the open /
       railing side). Per floor, at that storey's cumulative height. Works with
       no floor-plan underlay — the rect lives in memory, not in the image. */
    _wallGrp: null, _wallMat: null,

    _footprint: function () {
      var poly = (typeof getFootprintPolygon === 'function') ? getFootprintPolygon() : null;
      return (poly && poly.length >= 3) ? poly : null;
    },

    /* is (x,z) inside floor f's balcony rect (± tol)? Used by the openings hit-test
       to reject the open (balcony) side of a footprint edge on that floor. */
    _inRect: function (x, z, f, tol) {
      var cuts = this._activeCuts(f); tol = tol || 0;
      for (var i = 0; i < cuts.length; i++) {
        var r = cuts[i];
        if (Math.abs(x - r.cx) <= r.w / 2 + tol && Math.abs(z - r.cz) <= r.d / 2 + tol) return true;
      }
      return false;
    },

    /* Sutherland–Hodgman: clip the footprint polygon by the 4 half-planes of the
       axis-aligned balcony rect → the overlap polygon ([] if no overlap). cut()
       only runs when an edge crosses a plane, so its denominator is never 0. */
    _clipRectFootprint: function (r) {
      var poly = this._footprint(); if (!poly) return [];
      var minX = r.cx - r.w / 2, maxX = r.cx + r.w / 2, minZ = r.cz - r.d / 2, maxZ = r.cz + r.d / 2;
      function clip(pts, keep, cut) {
        var out = [], n = pts.length, i, A, B, ka, kb;
        for (i = 0; i < n; i++) {
          A = pts[i]; B = pts[(i + 1) % n]; ka = keep(A); kb = keep(B);
          if (ka) { out.push(A); if (!kb) out.push(cut(A, B)); }
          else if (kb) out.push(cut(A, B));
        }
        return out;
      }
      var p = poly.slice();
      p = clip(p, function (q) { return q[0] >= minX - 1e-9; }, function (a, b) { var t = (minX - a[0]) / (b[0] - a[0]); return [minX, a[1] + t * (b[1] - a[1])]; }); if (p.length < 3) return [];
      p = clip(p, function (q) { return q[0] <= maxX + 1e-9; }, function (a, b) { var t = (maxX - a[0]) / (b[0] - a[0]); return [maxX, a[1] + t * (b[1] - a[1])]; }); if (p.length < 3) return [];
      p = clip(p, function (q) { return q[1] >= minZ - 1e-9; }, function (a, b) { var t = (minZ - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), minZ]; }); if (p.length < 3) return [];
      p = clip(p, function (q) { return q[1] <= maxZ + 1e-9; }, function (a, b) { var t = (maxZ - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), maxZ]; }); if (p.length < 3) return [];
      return p;
    },

    /* does segment a–b (an edge of the overlap) lie on the footprint perimeter?
       (midpoint sits on a footprint edge) → it's the open side, so no wall. */
    _onPerimeter: function (a, b) {
      var poly = this._footprint(); if (!poly) return false;
      var mx = (a[0] + b[0]) / 2, mz = (a[1] + b[1]) / 2, EPS = 0.03, i, p, q, dx, dz, L2, t, px, pz;
      for (i = 0; i < poly.length; i++) {
        p = poly[i]; q = poly[(i + 1) % poly.length];
        dx = q[0] - p[0]; dz = q[1] - p[1]; L2 = dx * dx + dz * dz; if (L2 < 1e-9) continue;
        t = ((mx - p[0]) * dx + (mz - p[1]) * dz) / L2; if (t < -1e-6 || t > 1 + 1e-6) continue;
        px = p[0] + t * dx; pz = p[1] + t * dz;
        if (Math.hypot(mx - px, mz - pz) <= EPS) return true;
      }
      return false;
    },

    /* (re)build the per-floor balcony walls in their own group (2D + 3D). */
    buildWalls: function () {
      var T = global.THREE, eng = global.BaseEngine;
      this._loadRects();
      if (this._wallGrp) { if (this._wallGrp.parent) this._wallGrp.parent.remove(this._wallGrp); this._wallGrp.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); this._wallGrp = null; }
      if (!T || !eng || !eng.sceneGroup) return;
      if (!this._footprint()) return;
      var wallThk = (global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30;
      if (!this._wallMat) this._wallMat = new T.MeshLambertMaterial({ color: 0xf1ece3 });
      var grp = new T.Group(), mat = this._wallMat;
      function box(ax, az, bx, bz, y0, y1) {
        var dx = bx - ax, dz = bz - az, len = Math.hypot(dx, dz);
        if (len < 0.05 || y1 - y0 < 0.05) return;
        var m = new T.Mesh(new T.BoxGeometry(len, y1 - y0, wallThk), mat);
        m.position.set((ax + bx) / 2, (y0 + y1) / 2, (az + bz) / 2);
        var qn = new T.Quaternion(); qn.setFromUnitVectors(new T.Vector3(1, 0, 0), new T.Vector3(dx, 0, dz).normalize());
        m.quaternion.copy(qn); grp.add(m);
      }
      var fl = Math.max(1, STATE.floors | 0), f, cl, i, a, b, q, si;
      var blocksViz = (STATE.vizStage === 4);     /* masonry block 3D view → recess walls come from the block build, brick column shows */
      if (!blocksViz) {
        /* one pass over every cut; its height bands come from its own scope:
           a floor cut → that storey; all1 → each storey (spandrels between);
           all2 → one band the full height (no spandrels). */
        for (q = 0; q < this._cuts.length; q++) {
          var c = this._cuts[q];
          if (!this._cutActive(c)) continue;
          cl = this._clipRectFootprint(c); if (cl.length < 3) continue;
          var bands = [];
          if (c.mode === 'all2') { bands.push([0, _storeyTopY(fl - 1)]); }
          else if (c.mode === 'all1') { for (f = 0; f < fl; f++) bands.push([_storeyBaseY(f), _storeyBaseY(f) + _clearForFloor(f)]); }
          else { f = c.floor | 0; if (f >= 0 && f < fl) bands.push([_storeyBaseY(f), _storeyBaseY(f) + _clearForFloor(f)]); }
          for (si = 0; si < bands.length; si++) {
            for (i = 0; i < cl.length; i++) {
              a = cl[i]; b = cl[(i + 1) % cl.length];
              if (this._onPerimeter(a, b)) continue;                   /* open side → no wall (railing later) */
              box(a[0], a[1], b[0], b[1], bands[si][0], bands[si][1]);
            }
          }
        }
      }
      /* a brick corner column only where the recess turns a corner with BOTH
         open sides ≥ 2 m — and only in the masonry (block) 3D view. */
      var fp = blocksViz ? this._footprint() : null;
      if (fp) {
        var fpn = fp.length, vi, ep, s, sP, sQ, epL, byEdge, A, B, sp, py0, py1;
        for (f = 0; f < fl; f++) {
          if (!this._activeCuts(f).length) continue;
          py0 = _storeyBaseY(f); py1 = _storeyTopY(f);             /* full storey → supports the slab above */
          byEdge = {};                                            /* this floor's open span per footprint edge */
          for (vi = 0; vi < fpn; vi++) {
            A = fp[vi]; B = fp[(vi + 1) % fpn];
            sp = this._openSpansOnEdge(vi, A, B);
            for (s = 0; s < sp.length; s++) { if (Math.abs(sp[s].y0 - py0) < 0.02) { byEdge[vi] = sp[s]; break; } }
          }
          for (vi = 0; vi < fpn; vi++) {
            ep = (vi - 1 + fpn) % fpn;                             /* edge ending at vertex vi */
            sP = byEdge[ep]; sQ = byEdge[vi]; if (!sP || !sQ) continue;
            epL = Math.hypot(fp[(ep + 1) % fpn][0] - fp[ep][0], fp[(ep + 1) % fpn][1] - fp[ep][1]);
            if (sP.u1 < epL - 0.1 || sQ.u0 > 0.1) continue;        /* both opens must reach the shared corner */
            if ((sP.u1 - sP.u0) >= 2 && (sQ.u1 - sQ.u0) >= 2)      /* both sides ≥ 2 m */
              this._brickColumn(grp, T, fp[vi][0], fp[vi][1], py0, py1);
          }
        }
      }
      eng.sceneGroup.add(grp); this._wallGrp = grp;
    },

    /* project point p onto footprint edge (origin wa, unit dir ux/uz, length
       elen); return the along-edge parameter if p sits ON that edge (perp ≈ 0
       and within span), else null. */
    _projOnEdge: function (p, wa, ux, uz, elen) {
      var dx = p[0] - wa[0], dz = p[1] - wa[1];
      if (Math.abs(dx * (-uz) + dz * ux) > 0.04) return null;        /* off the edge line */
      var t = dx * ux + dz * uz;
      if (t < -0.04 || t > elen + 0.04) return null;                 /* past the ends */
      return Math.max(0, Math.min(elen, t));
    },
    /* for footprint edge wi (endpoints wa,wb): the along-edge spans + storey
       height bands where a balcony OPENS (its clipped edge lies on this wall).
       Fed to _Openings._renderWalls as full-height holes so the wall recedes. */
    _openSpansOnEdge: function (wi, wa, wb) {
      var out = [], ex = wb[0] - wa[0], ez = wb[1] - wa[1], elen = Math.hypot(ex, ez);
      if (elen < 1e-6) return out;
      var ux = ex / elen, uz = ez / elen, fl = Math.max(1, STATE.floors | 0), f, cuts, qi, cl, i, a, b, ta, tb, u0, u1;
      for (f = 0; f < fl; f++) {
        cuts = this._activeCuts(f);
        for (qi = 0; qi < cuts.length; qi++) {
          cl = this._clipRectFootprint(cuts[qi]); if (cl.length < 3) continue;
          for (i = 0; i < cl.length; i++) {
            a = cl[i]; b = cl[(i + 1) % cl.length];
            ta = this._projOnEdge(a, wa, ux, uz, elen); if (ta == null) continue;
            tb = this._projOnEdge(b, wa, ux, uz, elen); if (tb == null) continue;   /* edge lies on this wall */
            u0 = Math.min(ta, tb); u1 = Math.max(ta, tb);
            if (u1 - u0 < 0.05) continue;
            out.push({
              u0: u0, u1: u1, y0: _storeyBaseY(f), y1: _storeyBaseY(f) + _clearForFloor(f),
              u: (u0 + u1) / 2, w: u1 - u0, sill: _storeyBaseY(f), h: _clearForFloor(f)   /* opening-shaped, for the masonry core cut */
            });
          }
        }
      }
      return out;
    },

    /* interior (non-perimeter) edges of a floor's balcony recess, as masonry
       edge descriptors {c,dx,dz,L,ang} — fed into the block build so the recess
       walls get the same fully-bonded blocks as the footprint. */
    _recessEdges: function (f, cutsOverride) {
      var cuts = cutsOverride || this._activeCuts(f), out = [], ci;
      for (ci = 0; ci < cuts.length; ci++) {
        var cl = this._clipRectFootprint(cuts[ci]); if (cl.length < 3) continue;
        var n = cl.length, i, a, b, dx, dz, L, prevPer, nextPer;
        for (i = 0; i < n; i++) {
          a = cl[i]; b = cl[(i + 1) % n];
          if (this._onPerimeter(a, b)) continue;                     /* skip the open side */
          dx = b[0] - a[0]; dz = b[1] - a[1]; L = Math.hypot(dx, dz);
          if (L < 0.05) continue;
          prevPer = this._onPerimeter(cl[(i - 1 + n) % n], a);       /* neighbour toward the open side? */
          nextPer = this._onPerimeter(b, cl[(i + 2) % n]);
          out.push({ c: [a[0], a[1]], dx: dx / L, dz: dz / L, L: L, ang: -Math.atan2(dz, dx), openStart: prevPer, openEnd: nextPer });
        }
      }
      return out;
    },

    /* The whole wall ring of a floor as ONE polygon: the footprint with the
       balcony recess notched out (footprint − balcony). Footprint edges are
       split where the balcony opens, and the recess walls are chained in, so
       the jamb is an ordinary corner of a single closed loop — the masonry
       bond, the core and the ring beam all run through it natively, exactly
       like a T/L/U/H corner. Each edge carries srcEdge (footprint edge index,
       for the openings map; −1 for a recess wall) and u0 (its offset along that
       footprint edge, to map opening positions). idx is the consecutive ring
       position that drives the through/butt bond parity. */
    _notchedEdges: function (f, cutsOverride) {
      this._loadRects();
      var poly = this._footprint(); if (!poly) return null;
      var n = poly.length, i, a, b, dx, dz, L, ux, uz;
      function mk(pa, pb, src, u0) {
        var ddx = pb[0] - pa[0], ddz = pb[1] - pa[1], LL = Math.hypot(ddx, ddz);
        if (LL < 1e-6) return null;
        return { a: [pa[0], pa[1]], b: [pb[0], pb[1]], c: [pa[0], pa[1]], dx: ddx / LL, dz: ddz / LL, L: LL, ang: -Math.atan2(ddz, ddx), srcEdge: src, u0: u0 };
      }
      var cuts = cutsOverride || this._activeCuts(f);
      if (!cuts.length) {                                           /* no active cut on this floor → plain footprint */
        var ofp = [];
        for (i = 0; i < n; i++) { var e0 = mk(poly[i], poly[(i + 1) % n], i, 0); if (e0) { e0.idx = ofp.length; ofp.push(e0); } }
        return ofp;
      }
      /* open spans per footprint edge — UNION across all active cuts (the frag
         loop below merges overlaps), so several niches share one wall ring. */
      var spansByE = {};
      for (i = 0; i < n; i++) {
        a = poly[i]; b = poly[(i + 1) % n]; dx = b[0] - a[0]; dz = b[1] - a[1]; L = Math.hypot(dx, dz);
        if (L < 1e-6) continue; ux = dx / L; uz = dz / L;
        for (var qi = 0; qi < cuts.length; qi++) {
          var clip = this._clipRectFootprint(cuts[qi]); if (clip.length < 3) continue;
          for (var ci = 0; ci < clip.length; ci++) {
            var ca = clip[ci], cb = clip[(ci + 1) % clip.length];
            var ta = this._projOnEdge(ca, a, ux, uz, L), tb = this._projOnEdge(cb, a, ux, uz, L);
            if (ta == null || tb == null) continue;
            var su0 = Math.min(ta, tb), su1 = Math.max(ta, tb);
            if (su1 - su0 < 0.05) continue;
            (spansByE[i] = spansByE[i] || []).push({ u0: su0, u1: su1 });
          }
        }
      }
      /* a valid cut must touch the perimeter (its open side). If the rect sits
         fully inside the footprint there is no open span → it would close into a
         4-wall box in the middle of the floor. Treat it as no cut: plain
         footprint, so nothing spurious is drawn. */
      var hasOpen = false; for (var ke in spansByE) { if (spansByE.hasOwnProperty(ke)) { hasOpen = true; break; } }
      if (!hasOpen) {
        var ofp2 = [];
        for (i = 0; i < n; i++) { var e0b = mk(poly[i], poly[(i + 1) % n], i, 0); if (e0b) { e0b.idx = ofp2.length; ofp2.push(e0b); } }
        return ofp2;
      }
      /* footprint fragments (the wall that survives between open spans) */
      var frags = [];
      for (i = 0; i < n; i++) {
        a = poly[i]; b = poly[(i + 1) % n]; dx = b[0] - a[0]; dz = b[1] - a[1]; L = Math.hypot(dx, dz);
        if (L < 1e-6) continue; ux = dx / L; uz = dz / L;
        var sp = (spansByE[i] || []).slice().sort(function (p, q) { return p.u0 - q.u0; });
        var cur = 0, e1;
        for (var k = 0; k < sp.length; k++) {
          if (sp[k].u0 - cur > 0.02) { e1 = mk([a[0] + ux * cur, a[1] + uz * cur], [a[0] + ux * sp[k].u0, a[1] + uz * sp[k].u0], i, cur); if (e1) frags.push(e1); }
          cur = Math.max(cur, sp[k].u1);
        }
        if (L - cur > 0.02) { e1 = mk([a[0] + ux * cur, a[1] + uz * cur], [a[0] + ux * L, a[1] + uz * L], i, cur); if (e1) frags.push(e1); }
      }
      /* recess walls (the inner walls of the notch) */
      var rce = this._recessEdges(f, cuts);
      for (i = 0; i < rce.length; i++) {
        var rc = rce[i], e2 = mk(rc.c, [rc.c[0] + rc.dx * rc.L, rc.c[1] + rc.dz * rc.L], -1, 0);
        if (e2) frags.push(e2);
      }
      if (frags.length < 3) return null;
      /* chain fragments into one closed loop by shared endpoints (keeps the
         footprint's CCW orientation; recess walls fall in the open gap) */
      var eps = 0.06;
      function dd(p, q) { return Math.hypot(p[0] - q[0], p[1] - q[1]); }
      var used = []; for (i = 0; i < frags.length; i++) used.push(false);
      var loop = [frags[0]]; used[0] = true; var cur2 = frags[0].b, guard = 0;
      while (guard++ < frags.length + 4) {
        var fi = -1;
        for (i = 0; i < frags.length; i++) {
          if (used[i]) continue;
          if (dd(frags[i].a, cur2) < eps) { fi = i; loop.push(frags[i]); cur2 = frags[i].b; break; }
          if (dd(frags[i].b, cur2) < eps) { var fr = frags[i], rv = mk(fr.b, fr.a, fr.srcEdge, fr.u0); fi = i; if (rv) loop.push(rv); cur2 = fr.a; break; }
        }
        if (fi < 0) break;
        used[fi] = true;
        if (dd(cur2, loop[0].a) < eps) break;
      }
      if (loop.length < 3) return null;
      for (i = 0; i < loop.length; i++) loop[i].idx = i;
      /* a jamb is the junction where a footprint segment meets a recess wall
         (src type flips footprint↔recess). The corner-bond runner must stop at
         that vertex — it may not lap past it into the open balcony side. */
      for (i = 0; i < loop.length; i++) {
        var pE = loop[(i - 1 + loop.length) % loop.length];
        var nE = loop[(i + 1) % loop.length];
        var meFoot = (loop[i].srcEdge >= 0);
        loop[i].jambStart = (meFoot !== (pE.srcEdge >= 0));
        loop[i].jambEnd = (meFoot !== (nE.srcEdge >= 0));
      }
      return loop;
    },

    /* brick pier from a standard 40×20 block (length = 2×width): each course is
       two blocks side by side (→ 40×40), every course turned 90° so the joints
       interlock. A mortar core behind the bricks makes the joints read. */
    _colMat: null, _mortarMat: null,
    _brickColumn: function (grp, T, cx, cz, y0, y1) {
      var L = 0.4, W = 0.2, J = 0.015, H = y1 - y0;
      if (H < 0.05) return;
      if (!this._colMat) this._colMat = new T.MeshLambertMaterial({ color: 0xb5651d });
      if (!this._mortarMat) this._mortarMat = new T.MeshLambertMaterial({ color: 0xc9c2b4 });
      var mortar = new T.Mesh(new T.BoxGeometry(L - 2 * J, H, L - 2 * J), this._mortarMat);  /* joints show through */
      mortar.position.set(cx, (y0 + y1) / 2, cz); grp.add(mortar);
      var nC = Math.max(1, Math.round(H / (W + J))), ch = H / nC - J, c, cy, k, off, b;
      for (c = 0; c < nC; c++) {
        cy = y0 + (c + 0.5) * H / nC;
        for (k = 0; k < 2; k++) {
          off = (k - 0.5) * W;                                   /* two blocks, centres ±W/2 → joint down the middle */
          b = (c % 2 === 0) ? new T.Mesh(new T.BoxGeometry(L, ch, W - J), this._colMat)
                            : new T.Mesh(new T.BoxGeometry(W - J, ch, L), this._colMat);
          if (c % 2 === 0) b.position.set(cx, cy, cz + off); else b.position.set(cx + off, cy, cz);
          grp.add(b);
        }
      }
    },

    /* drag: grab a corner → resize; grab the body → move; grab the VAULT →
       pull out a new cut; drop a cut back on the vault → delete it. Capture
       phase + orbit disabled so it never fights pan/zoom. */
    _bindDrag: function () {
      var self = this, eng = global.BaseEngine;
      var canvas = eng && eng.renderer && eng.renderer.domElement;
      if (!canvas) { setTimeout(function () { self._bindDrag(); }, 300); return; }
      var T = global.THREE;
      var mode = null, fx = 0, fz = 0, downGx = 0, downGz = 0, baseCx = 0, baseCz = 0, dragCut = null, dragNew = false;
      function ground(cx, cy) {
        var rect = canvas.getBoundingClientRect();
        var nx = ((cx - rect.left) / rect.width) * 2 - 1;
        var ny = -((cy - rect.top) / rect.height) * 2 + 1;
        var ray = new T.Raycaster(); ray.setFromCamera({ x: nx, y: ny }, eng.camera);
        var pt = new T.Vector3();
        return ray.ray.intersectPlane(new T.Plane(new T.Vector3(0, 1, 0), -0.07), pt) ? pt : null;
      }
      function onVault(x, z) { var vc = self._vaultCentre(); return Math.abs(x - vc.x) <= vc.side / 2 && Math.abs(z - vc.z) <= vc.side / 2; }
      canvas.addEventListener('pointerdown', function (ev) {
        if (!self._active()) return;
        var g = ground(ev.clientX, ev.clientY); if (!g) return;
        var list = self._editList(), i, r;
        /* existing cut — corner (resize) first, then body (move); topmost wins.
           Grabbing a cut also makes it the ACTIVE (selected) one. */
        for (i = list.length - 1; i >= 0; i--) {
          r = list[i]; var corner = self._cornerAt(r, g);
          if (corner >= 0) { self._activeIdx = i; var cs = self._corners(r), opp = cs[(corner + 2) % 4]; fx = opp[0]; fz = opp[1]; mode = 'resize'; dragCut = r; dragNew = false; if (eng.controls) eng.controls.enabled = false; self.render(); ev.stopPropagation(); return; }
        }
        for (i = list.length - 1; i >= 0; i--) {
          r = list[i];
          if (Math.abs(g.x - r.cx) <= r.w / 2 && Math.abs(g.z - r.cz) <= r.d / 2) { self._activeIdx = i; mode = 'move'; dragCut = r; dragNew = false; downGx = g.x; downGz = g.z; baseCx = r.cx; baseCz = r.cz; if (eng.controls) eng.controls.enabled = false; self.render(); ev.stopPropagation(); return; }
        }
        /* vault — pull out a new cut (default shape + default scope = first storey, follows the finger) */
        if (onVault(g.x, g.z)) {
          var def = self._defaultCut(), nc = { cx: def.cx, cz: def.cz, w: def.w, d: def.d, mode: 'floor', floor: 0 };
          list.push(nc); self._activeIdx = list.length - 1; mode = 'move'; dragCut = nc; dragNew = true; downGx = g.x; downGz = g.z; baseCx = nc.cx; baseCz = nc.cz;
          if (eng.controls) eng.controls.enabled = false; self.render(); ev.stopPropagation();
        }
      }, true);
      canvas.addEventListener('pointermove', function (ev) {
        if (!mode || !dragCut) return;
        var g = ground(ev.clientX, ev.clientY); if (!g) return;
        var r = dragCut;
        if (mode === 'move') { r.cx = baseCx + (g.x - downGx); r.cz = baseCz + (g.z - downGz); }
        else { r.w = Math.max(0.6, Math.abs(g.x - fx)); r.d = Math.max(0.6, Math.abs(g.z - fz)); r.cx = (g.x + fx) / 2; r.cz = (g.z + fz) / 2; }
        self.render();
        try { self.buildWalls(); } catch (eBw) {}    /* live: recess walls follow the cut while dragging */
        if (typeof _forceRender3DFlush === 'function') { try { _forceRender3DFlush(0); } catch (eF) {} }
        ev.stopPropagation();
      }, true);
      function end() {
        if (!mode) return;
        var cut = dragCut; mode = null; dragCut = null; dragNew = false;
        if (eng.controls) eng.controls.enabled = true;
        if (cut) {
          var list = self._editList();
          if (onVault(cut.cx, cut.cz)) { var ix = list.indexOf(cut); if (ix >= 0) list.splice(ix, 1); }   /* dropped on the vault (or a new cut never pulled out) → delete */
        }
        if (self._activeIdx >= self._cuts.length) self._activeIdx = self._cuts.length - 1;   /* keep active index valid after a delete */
        try { self._saveRects(); } catch (e) {}
        self.render();
        try { _broadcastHouse(); } catch (e) {}                /* push cuts to locked sub-configs (structure) */
        if (global.BaseRenderer && global.BaseRenderer.build) { try { global.BaseRenderer.build(); } catch (e) { try { self.buildWalls(); } catch (e2) {} } }
        else { try { self.buildWalls(); } catch (e) {} }
        if (typeof _forceRender3DFlush === 'function') _forceRender3DFlush(0);
      }
      canvas.addEventListener('pointerup', function () { end(); }, true);
      canvas.addEventListener('pointercancel', function () { if (mode) { mode = null; dragCut = null; dragNew = false; if (eng.controls) eng.controls.enabled = true; } }, true);
    }
  };

  var _Openings = {
    _grp: null, _plusMeshes: [], _minusMeshes: [], _mode: false,
    _placingSku: null, _selIdx: -1, _snap: true,
    _drawerEl: null, _iconEl: null, _popEl: null,
    _dragging: false, _bound: false, _armed: null,

    _ensure: function () {
      if (this._bound) return;
      this._bound = true;
      this._injectIcon();
      this._bindPointer();
    },

    _wallThk: function () { return (global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30; },
    _eaveLevel: function () { return _wallHeightM() + SHELTER_SPECS.carport.beam.h; },
    /* an opening whose storey (from its absolute sill) is at/above the current
       floor count belongs to a floor that isn't built right now → hide it. It
       stays in STATE (not deleted), so raising the floor count brings it back. */
    _openingHidden: function (o) {
      var flN = Math.max(1, STATE.floors | 0);
      return ((o && o.sill) || 0) >= _storeyBaseY(flN) - 1e-3;
    },

    /* footprint edges as {a,b,dir,nrm,len} at the OUTER wall face. The outward
       direction is found by a point-in-polygon test (step a touch along the
       candidate normal — it must land OUTSIDE the footprint). This is robust for
       concave shapes (U/L/T/H): the old centroid test put the centroid outside
       the solid and flipped the normal on the re-entrant (inward-folded) walls. */
    _walls: function () {
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) return [];
      function insideP(pg, px, pz) {
        var c = false;
        for (var i = 0, j = pg.length - 1; i < pg.length; j = i++) {
          var xi = pg[i][0], zi = pg[i][1], xj = pg[j][0], zj = pg[j][1];
          if (((zi > pz) !== (zj > pz)) && (px < (xj - xi) * (pz - zi) / ((zj - zi) || 1e-9) + xi)) c = !c;
        }
        return c;
      }
      var half = this._wallThk() / 2, out = [];
      /* 1) footprint edges — STABLE indices 0..N-1, full height, every floor. An
            opening keyed to one of these survives any balcony edit. */
      for (var e = 0; e < poly.length; e++) {
        var a = poly[e], b = poly[(e + 1) % poly.length];
        var dx = b[0] - a[0], dz = b[1] - a[1], L = Math.hypot(dx, dz);
        if (L < 0.2) { out.push(null); continue; }
        var ux = dx / L, uz = dz / L, nx = -uz, nz = ux;
        var mx = (a[0] + b[0]) / 2, mz = (a[1] + b[1]) / 2;
        if (insideP(poly, mx + nx * 0.05, mz + nz * 0.05)) { nx = -nx; nz = -nz; }   /* point out */
        out.push({
          ax: a[0] + nx * half, az: a[1] + nz * half,
          ux: ux, uz: uz, nx: nx, nz: nz, len: L,
          srcEdge: e, floor: -1, y0: 0, y1: Infinity
        });
      }
      /* 2) NEW recess walls created by the cut, per floor — appended AFTER the
            footprint edges, each spanning only its own storey's height band. This
            is what an opening snaps to inside the niche; the open (balcony) side
            of the footprint edge is rejected in _hitWall, not here. */
      var fl = Math.max(1, STATE.floors | 0), f, k;
      for (f = 0; f < fl; f++) {
        var ned = null;
        try { ned = _Balcony._notchedEdges(f); } catch (eN) { ned = null; }
        if (!ned || !ned.length) continue;
        var npoly = [];
        for (k = 0; k < ned.length; k++) npoly.push(ned[k].a);   /* notched ring → normal points INTO the niche */
        var ry0 = _storeyBaseY(f), ry1 = ry0 + _clearForFloor(f);
        for (k = 0; k < ned.length; k++) {
          var ed = ned[k];
          if (ed.srcEdge >= 0) continue;                          /* footprint fragment — already an edge 0..N-1 */
          var rax = ed.a[0], raz = ed.a[1], rbx = ed.b[0], rbz = ed.b[1];
          var rdx = rbx - rax, rdz = rbz - raz, rL = Math.hypot(rdx, rdz);
          if (rL < 0.2) continue;
          var rux = rdx / rL, ruz = rdz / rL, rnx = -ruz, rnz = rux;
          var rmx = (rax + rbx) / 2, rmz = (raz + rbz) / 2;
          if (insideP(npoly, rmx + rnx * 0.05, rmz + rnz * 0.05)) { rnx = -rnx; rnz = -rnz; }
          out.push({
            ax: rax + rnx * half, az: raz + rnz * half,
            ux: rux, uz: ruz, nx: rnx, nz: rnz, len: rL,
            srcEdge: -1, floor: f, y0: ry0, y1: ry1
          });
        }
      }
      return out;
    },

    /* build one opening (frame bars + glass) into a group, local axes
       X = along wall (u), Y = up, Z = outward normal */
    _buildMesh: function (T, w, wall, o, ghost) {
      var it = _catItem(o.sku); if (!it) return null;
      var fr = it.frame || 0.06, depth = 0.10;
      var grp = new T.Group();
      var frMat = ghost
        ? new T.MeshLambertMaterial({ color: 0x9a6f44, transparent: true, opacity: 0.5 })
        : (this._frMat || (this._frMat = new T.MeshLambertMaterial({ color: 0x3a3f45 })));
      var glMat = ghost
        ? new T.MeshLambertMaterial({ color: 0xbfe2ef, transparent: true, opacity: 0.16, side: T.DoubleSide, depthWrite: false })
        : (this._glMat || (this._glMat = new T.MeshLambertMaterial({ color: 0xbfe2ef, transparent: true, opacity: 0.18, side: T.DoubleSide, depthWrite: false })));
      function bar(cx, cy, sx, sy) {
        var m = new T.Mesh(new T.BoxGeometry(sx, sy, depth), frMat);
        m.position.set(cx, cy, 0); grp.add(m);
      }
      bar(0, o.h / 2 - fr / 2, o.w, fr);          /* top */
      bar(0, -o.h / 2 + fr / 2, o.w, fr);         /* bottom */
      bar(-o.w / 2 + fr / 2, 0, fr, o.h - 2 * fr);/* left */
      bar(o.w / 2 - fr / 2, 0, fr, o.h - 2 * fr); /* right */
      var iw = o.w - 2 * fr, ih = o.h - 2 * fr;
      function glass(cx, cy, sx, sy) {
        var g = new T.Mesh(new T.PlaneGeometry(sx, sy), glMat);
        g.position.set(cx, cy, 0); g.renderOrder = 3;
        g.userData.kind = 'glass';                 /* keep its transparency in stage view */
        grp.add(g);
      }
      var cat = it.cat;
      if (cat === 'intd') {
        bar(0, -o.h / 6, iw, fr * 0.8);                 /* mid rail, solid panel */
      } else if (cat === 'extd') {
        var gh = ih * 0.32;                              /* glass only at top */
        bar(0, o.h / 2 - fr - gh - fr / 2, iw, fr * 0.8);
        glass(0, o.h / 2 - fr - gh / 2, iw, gh);
      } else if (cat === 'french' || cat === 'slide') {
        var n = (cat === 'french' ? (it.leaves || 2) : (it.panels || 2));
        var pw = iw / n, dw = fr, k2, L2, R2;
        for (k2 = 1; k2 < n; k2++) bar(-iw / 2 + k2 * pw, 0, dw, ih);     /* dividers */
        for (k2 = 0; k2 < n; k2++) {
          L2 = (k2 === 0) ? -iw / 2 : (-iw / 2 + k2 * pw + dw / 2);
          R2 = (k2 === n - 1) ? iw / 2 : (-iw / 2 + (k2 + 1) * pw - dw / 2);
          glass((L2 + R2) / 2, 0, R2 - L2, ih);
        }
      } else if (cat === 'window') {
        var nw = _winPanes(o.w), pwW = iw / nw, dwW = fr * 0.8, q, Lw, Rw;
        for (q = 1; q < nw; q++) bar(-iw / 2 + q * pwW, 0, dwW, ih);       /* mullions */
        for (q = 0; q < nw; q++) {
          Lw = (q === 0) ? -iw / 2 : (-iw / 2 + q * pwW + dwW / 2);
          Rw = (q === nw - 1) ? iw / 2 : (-iw / 2 + (q + 1) * pwW - dwW / 2);
          glass((Lw + Rw) / 2, 0, Rw - Lw, ih);
        }
      } else {
        glass(0, 0, iw, ih);
      }

      /* place: along wall, centred on the wall axis (inside the wall) */
      var half = this._wallThk() / 2;
      var cx0 = wall.ax - wall.nx * half, cz0 = wall.az - wall.nz * half;  /* centreline */
      var px = cx0 + wall.ux * o.u;
      var pz = cz0 + wall.uz * o.u;
      var py = (o.sill || 0) + o.h / 2;
      grp.position.set(px, py, pz);
      grp.rotation.y = Math.atan2(wall.nx, wall.nz);   /* face outward */
      grp.userData = { opening: true, ghost: !!ghost };
      return grp;
    },

    render: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      if (this._grp && this._grp.parent) this._grp.parent.remove(this._grp);
      this._grp = new T.Group();
      this._plusMeshes = [];
      this._minusMeshes = [];
      if (STATE.view !== '2d') {
        var walls = this._walls();
        /* masonry block stage shows the bare brickwork with clean window/door
           voids — the installed frames+glass (dark) would read as black solids
           in the reveals, so skip them here; they return in the normal view. */
        if (STATE.vizStage !== 4) {
          for (var i = 0; i < STATE.openings.length; i++) {
            var o = STATE.openings[i], wl = walls[o.wallIdx];
            if (!wl) continue;
            if (o.wf != null && o.wf >= 0 && wl.floor !== o.wf) continue;   /* recess opening whose niche wall is gone/changed → drop it */
            if (this._openingHidden(o)) continue;          /* floor not built now → hidden */
            var m = this._buildMesh(T, eng.sceneGroup, wl, o, false);
            if (m) this._grp.add(m);
          }
        }
        if (STATE.vizStage !== 4) this._renderBands(T, walls);  /* per-storey colour bands — only in the default 3D view, NOT the masonry block stage (they read as a translucent box over the brickwork) */
      }
      eng.sceneGroup.add(this._grp);
    },

    /* after placing/deleting/moving: in the blocks stage rebuild fully so the
       masonry is re-cut around the opening; otherwise just re-cut the plain wall */
    _refreshAfterEdit: function () {
      if (STATE.vizStage === 4 && global.BaseRenderer && global.BaseRenderer.build) {
        global.BaseRenderer.build();
      } else {
        this._renderWalls(); this.render(); _forceRender3DFlush(1);
      }
    },

    /* perimeter wall in its own group, segmented around openings (hole + parapet
       under windows + header above). Rebuilt alone during drag → real time. */
    _renderWalls: function () {
      var T = global.THREE, eng = global.BaseEngine;
      if (!T || !eng || !eng.sceneGroup) return;
      if (this._wallGrp) {
        if (this._wallGrp.parent) this._wallGrp.parent.remove(this._wallGrp);
        this._wallGrp.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
      }
      this._wallGrp = new T.Group();
      eng.sceneGroup.add(this._wallGrp);
      if (this._wallSuppressed) return;
      if (global.BASE_BOOT && global.BASE_BOOT.structureMode === 'posts') return;
      var poly = getFootprintPolygon();
      if (!poly || poly.length < 3) return;
      var wallThk = (global.BASE_BOOT && +global.BASE_BOOT.wallThickness) || 0.30;
      var s = SHELTER_SPECS.carport;
      var wallH = _wallHeightM() + s.beam.h;
      if (!this._wallMat) this._wallMat = new T.MeshLambertMaterial({ color: 0xf1ece3 });
      var grp = this._wallGrp, mat = this._wallMat, rect4 = (poly.length === 4);
      function box(ax, az, bx, bz, y0, y1) {
        var dx = bx - ax, dz = bz - az, len = Math.hypot(dx, dz);
        if (len < 0.02 || y1 - y0 < 0.02) return;
        var m = new T.Mesh(new T.BoxGeometry(len, y1 - y0, wallThk), mat);
        m.position.set((ax + bx) / 2, (y0 + y1) / 2, (az + bz) / 2);
        var q = new T.Quaternion();
        q.setFromUnitVectors(new T.Vector3(1, 0, 0), new T.Vector3(dx, 0, dz).normalize());
        m.quaternion.copy(q);
        grp.add(m);
      }
      for (var wi = 0; wi < poly.length; wi++) {
        var wa = poly[wi], wb = poly[(wi + 1) % poly.length];
        var wdx = wb[0] - wa[0], wdz = wb[1] - wa[1], wlen = Math.hypot(wdx, wdz) || 1;
        if (wlen < 0.2) continue;
        var thr = rect4 ? (wi % 2 === 0) : true;
        var e1 = (thr ? 1 : -1) * (wallThk / 2);
        if (wlen < wallThk * 2) e1 = 0;
        var uxn = wdx / wlen, uzn = wdz / wlen;
        var endP = wlen + e1;
        /* The wall is the full [-e1,endP]×[0,wallH] panel minus the opening
           holes. Sweep horizontally between opening edges, and inside each
           vertical strip subtract the height bands of the openings covering
           it. This frames stacked openings (different storeys, same u)
           correctly — the old single-cursor pass collapsed the upper opening
           to zero width and let the lower opening's header wall cover it. */
        var rects = [];
        for (var oi = 0; oi < STATE.openings.length; oi++) {
          if (STATE.openings[oi].wallIdx !== wi) continue;
          var Oc = STATE.openings[oi];
          var rL = Math.max(-e1, Oc.u - Oc.w / 2), rR = Math.min(endP, Oc.u + Oc.w / 2);
          if (rR - rL < 0.02) continue;
          rects.push({ uL: rL, uR: rR, y0: (Oc.sill || 0), y1: (Oc.sill || 0) + Oc.h });
        }
        /* balcony recess: a balcony's OPEN edge on this wall becomes a full
           clear-height hole, so the wall recedes and the recess (its 3 inner
           walls built by _Balcony.buildWalls) is revealed in 3D. */
        try {
          var bcuts = _Balcony._openSpansOnEdge(wi, wa, wb);
          for (var bci = 0; bci < bcuts.length; bci++) {
            var bcL = Math.max(-e1, bcuts[bci].u0), bcR = Math.min(endP, bcuts[bci].u1);
            if (bcR - bcL < 0.02) continue;
            rects.push({ uL: bcL, uR: bcR, y0: bcuts[bci].y0, y1: bcuts[bci].y1 });
          }
        } catch (eBcut) {}
        var xs = [-e1, endP];
        for (var xi = 0; xi < rects.length; xi++) { xs.push(rects[xi].uL); xs.push(rects[xi].uR); }
        xs.sort(function (a, b) { return a - b; });
        for (var sj = 0; sj < xs.length - 1; sj++) {
          var xa = xs[sj], xb = xs[sj + 1];
          if (xb - xa < 0.02) continue;
          var xm = (xa + xb) / 2, holes = [];
          for (var ri = 0; ri < rects.length; ri++) {
            if (rects[ri].uL <= xm && xm <= rects[ri].uR) holes.push([rects[ri].y0, rects[ri].y1]);
          }
          holes.sort(function (a, b) { return a[0] - b[0]; });
          var merged = [];
          for (var hi = 0; hi < holes.length; hi++) {
            if (merged.length && holes[hi][0] <= merged[merged.length - 1][1] + 1e-6) {
              merged[merged.length - 1][1] = Math.max(merged[merged.length - 1][1], holes[hi][1]);
            } else merged.push([holes[hi][0], holes[hi][1]]);
          }
          var yc = 0;
          for (var mi = 0; mi < merged.length; mi++) {
            if (merged[mi][0] > yc + 0.02) box(wa[0] + uxn * xa, wa[1] + uzn * xa, wa[0] + uxn * xb, wa[1] + uzn * xb, yc, merged[mi][0]);
            yc = Math.max(yc, merged[mi][1]);
          }
          if (yc < wallH - 0.02) box(wa[0] + uxn * xa, wa[1] + uzn * xa, wa[0] + uxn * xb, wa[1] + uzn * xb, yc, wallH);
        }
      }
    },

    /* a "+" placard at the largest free gap of every wall */
    /* Hide the "+"/"−" discs on walls the camera sees from behind (their
       outward face points away), so only the discs on the walls facing the
       camera show — otherwise every wall's discs bleed through (depthTest is
       off so they draw over the house) and clutter the view. Re-run on every
       orbit change. */
    _updatePlacardFacing: function () {
      var eng = global.BaseEngine;
      if (!eng || !eng.camera) return;
      var walls = this._walls(), cam = eng.camera.position, face = [];
      for (var i = 0; i < walls.length; i++) {
        var wl = walls[i];
        if (!wl) { face.push(false); continue; }
        var mx = wl.ax + wl.ux * (wl.len / 2), mz = wl.az + wl.uz * (wl.len / 2);
        face.push(((cam.x - mx) * wl.nx + (cam.z - mz) * wl.nz) > 0);
      }
      var pm = this._plusMeshes || [], mm = this._minusMeshes || [], k;
      for (k = 0; k < pm.length; k++) pm[k].visible = !!face[pm[k].userData.plusWall];
      for (k = 0; k < mm.length; k++) {
        var wi = mm[k].userData.minusWall;
        mm[k].visible = (wi != null && face[wi] != null) ? !!face[wi] : true;
      }
    },
    _bindFacing: function () {
      if (this._facingBound) return;
      var eng = global.BaseEngine;
      if (!eng || !eng.controls || !eng.controls.addEventListener) return;
      this._facingBound = true;
      var self = this;
      eng.controls.addEventListener('change', function () { self._updatePlacardFacing(); });
    },

    _renderPlus: function (T, walls) {
      var flN = Math.max(1, STATE.floors | 0);
      for (var i = 0; i < walls.length; i++) {
        var wl = walls[i]; if (!wl || wl.len < 0.6) continue;
        for (var s = 0; s < flN; s++) {
          var u = this._largestGapU(i, wl.len, s);
          var hy = _storeyBaseY(s) + Math.min(1.4, _storeyHForFloor(s) * 0.5);
          var px = wl.ax + wl.ux * u + wl.nx * 0.06;
          var pz = wl.az + wl.uz * u + wl.nz * 0.06;
          var pl = new T.Mesh(new T.PlaneGeometry(0.85, 0.85),
            new T.MeshBasicMaterial({ map: this._plusTex(T, s), transparent: true, depthTest: false, side: T.DoubleSide }));
          pl.position.set(px, hy, pz);
          pl.rotation.y = Math.atan2(wl.nx, wl.nz);
          pl.renderOrder = 999;
          pl.userData = { plusWall: i, plusU: u, plusStorey: s };
          this._grp.add(pl);
          this._plusMeshes.push(pl);
        }
      }
    },
    /* placement guide: translucent colour band per storey on every wall, so the
       user can see which floor a tap lands on (matches _STOREY_TINT hues). */
    _BAND_RGB: [0x9a6f44, 0x2a78a0, 0x7856a8, 0xb07828],
    _renderBands: function (T, walls) {
      var flN = Math.max(1, STATE.floors | 0), top = this._eaveLevel();
      var op = this._mode ? 0.22 : 0.13;                          /* subtle by default, stronger during opening placement */
      for (var i = 0; i < walls.length; i++) {
        var wl = walls[i]; if (!wl || wl.len < 0.5) continue;
        var ang = Math.atan2(wl.nx, wl.nz);
        var cu = wl.len / 2;
        var px = wl.ax + wl.ux * cu, pz = wl.az + wl.uz * cu;
        for (var s = 0; s < flN; s++) {
          var y0 = _storeyBaseY(s), y1 = Math.min(_storeyTopY(s), top), h = y1 - y0;
          if (h < 0.1) continue;
          var col = this._BAND_RGB[s % this._BAND_RGB.length];
          /* one slightly-offset plane on each face so the band reads from any
             orbit angle (inside or outside the shell) */
          for (var f = -1; f <= 1; f += 2) {
            var band = new T.Mesh(new T.PlaneGeometry(wl.len, h),
              new T.MeshBasicMaterial({ color: col, transparent: true, opacity: op, side: T.DoubleSide, depthWrite: false }));
            band.position.set(px + wl.nx * 0.04 * f, y0 + h / 2, pz + wl.nz * 0.04 * f);
            band.rotation.y = ang;
            band.renderOrder = 6;
            band.userData = { opBand: true };
            this._grp.add(band);
          }
        }
      }
    },
    _STOREY_TINT: ['rgba(154,111,68,0.92)', 'rgba(42,120,160,0.92)', 'rgba(120,86,168,0.92)', 'rgba(176,120,40,0.92)'],
    _plusTex: function (T, storey) {
      if (!this._ptex) this._ptex = {};
      var s = (storey | 0) % this._STOREY_TINT.length;
      if (this._ptex[s]) return this._ptex[s];
      var c = document.createElement('canvas'); c.width = c.height = 128;
      var x = c.getContext('2d');
      x.fillStyle = this._STOREY_TINT[s]; x.beginPath(); x.arc(64, 64, 56, 0, 7); x.fill();
      x.strokeStyle = '#fff'; x.lineWidth = 11; x.lineCap = 'round';
      x.beginPath(); x.moveTo(64, 36); x.lineTo(64, 92); x.moveTo(36, 64); x.lineTo(92, 64); x.stroke();
      this._ptex[s] = new T.CanvasTexture(c);
      return this._ptex[s];
    },
    /* a "−" placard above every placed opening — tap deletes it (no modal) */
    _renderMinus: function (T, walls) {
      var tex = this._minusTex(T);
      for (var i = 0; i < STATE.openings.length; i++) {
        var o = STATE.openings[i], wl = walls[o.wallIdx];
        if (!wl) continue;
        if (o.wf != null && o.wf >= 0 && wl.floor !== o.wf) continue;   /* recess opening whose niche wall is gone/changed */
        var hy = (o.sill || 0) + o.h + 0.42;
        var px = wl.ax + wl.ux * o.u + wl.nx * 0.07;
        var pz = wl.az + wl.uz * o.u + wl.nz * 0.07;
        var pl = new T.Mesh(new T.PlaneGeometry(0.55, 0.55),
          new T.MeshBasicMaterial({ map: tex, transparent: true, depthTest: false, side: T.DoubleSide }));
        pl.position.set(px, hy, pz);
        pl.rotation.y = Math.atan2(wl.nx, wl.nz);
        pl.renderOrder = 1000;
        pl.userData = { minusIdx: i, minusWall: o.wallIdx };
        this._grp.add(pl);
        this._minusMeshes.push(pl);
      }
    },
    _minusTex: function (T) {
      if (this._mtex) return this._mtex;
      var c = document.createElement('canvas'); c.width = c.height = 128;
      var x = c.getContext('2d');
      x.fillStyle = 'rgba(216,35,42,0.95)'; x.beginPath(); x.arc(64, 64, 56, 0, 7); x.fill();
      x.strokeStyle = '#fff'; x.lineWidth = 12; x.lineCap = 'round';
      x.beginPath(); x.moveTo(34, 64); x.lineTo(94, 64); x.stroke();
      this._mtex = new T.CanvasTexture(c);
      return this._mtex;
    },
    _largestGapU: function (wallIdx, len, storey) {
      var occ = [];
      var loY = (storey != null) ? _storeyBaseY(storey) : -Infinity;
      var hiY = (storey != null) ? _storeyTopY(storey) : Infinity;
      for (var i = 0; i < STATE.openings.length; i++) {
        var o = STATE.openings[i]; if (o.wallIdx !== wallIdx) continue;
        var oc = (o.sill || 0) + o.h / 2;
        if (oc < loY || oc >= hiY) continue;
        occ.push([o.u - o.w / 2 - 0.2, o.u + o.w / 2 + 0.2]);
      }
      occ.sort(function (a, b) { return a[0] - b[0]; });
      var m = 0.3, cursor = m, best = len / 2, bestSize = -1;
      for (var k = 0; k <= occ.length; k++) {
        var nextStart = (k < occ.length) ? occ[k][0] : (len - m);
        var gap = nextStart - cursor;
        if (gap > bestSize) { bestSize = gap; best = (cursor + nextStart) / 2; }
        if (k < occ.length) cursor = Math.max(cursor, occ[k][1]);
      }
      return best;
    },

    _broadcast: function () {
      try { localStorage.setItem('mc:openings', JSON.stringify(STATE.openings)); } catch (e) {}
      try { localStorage.setItem('mc:openings:boq', JSON.stringify(this._boqRows())); } catch (e) {}
    },
    /* hardcoded BoQ rows, grouped by opening id — NOT linked to Central BoQ */
    _boqRows: function () {
      var map = {}, order = [];
      for (var i = 0; i < STATE.openings.length; i++) {
        var o = STATE.openings[i], id = o.sku; if (!id) continue;
        if (this._openingHidden(o)) continue;            /* hidden floor → not in the budget */
        if (!map[id]) { map[id] = { boq: id, cat: o.cat || '', w: o.w, h: o.h, qty: 0, label: _opLabel(o) }; order.push(id); }
        map[id].qty++;
      }
      return order.map(function (id) { return map[id]; });
    },

    /* ---- catalogue drawer ---- */
    _injectIcon: function () {
      if (this._iconEl) return;
      var self = this;
      /* attach to the right control rail next to the existing buttons
         (cf-btn-view / share / ar …); clone one for matching styling */
      var anchor = document.getElementById('cf-btn-share') ||
                   document.getElementById('cf-btn-ar') ||
                   document.getElementById('cf-btn-view') ||
                   document.getElementById('cf-btn-pdf');
      if (anchor && anchor.parentNode) {
        /* build a FRESH button (never clone share — that carried its click
           behaviour); copy only visual metrics so it fits the rail */
        var cs = (global.getComputedStyle ? global.getComputedStyle(anchor) : null);
        var b = document.createElement('button');
        b.type = 'button';
        b.id = 'cf-openings-icon';
        b.title = 'Windows & doors';
        var sz = anchor.offsetWidth || 44, hz = anchor.offsetHeight || 44;
        b.style.cssText =
          'width:' + sz + 'px;height:' + hz + 'px;padding:0;cursor:pointer;' +
          'display:flex;align-items:center;justify-content:center;color:#3a3f45;' +
          (cs ? ('border-radius:' + cs.borderRadius + ';background:' + (cs.backgroundColor === 'rgba(0, 0, 0, 0)' ? '#fff' : cs.backgroundColor) + ';margin:' + cs.margin + ';box-shadow:' + (cs.boxShadow !== 'none' ? cs.boxShadow : '0 1px 4px rgba(0,0,0,.15)') + ';border:1px solid rgba(0,0,0,.08);')
              : 'border-radius:12px;background:#fff;margin:6px 0;box-shadow:0 1px 4px rgba(0,0,0,.15);border:1px solid rgba(0,0,0,.08);');
        b.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="4" y="3" width="16" height="18" rx="1"/><line x1="12" y1="3" x2="12" y2="21"/><line x1="4" y1="12" x2="20" y2="12"/><circle cx="19" cy="19" r="5" fill="#9a6f44" stroke="#fff" stroke-width="1.5"/><line x1="19" y1="16.5" x2="19" y2="21.5" stroke="#fff"/><line x1="16.5" y1="19" x2="21.5" y2="19" stroke="#fff"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self._onIconClick(); });
        anchor.parentNode.insertBefore(b, anchor.nextSibling);
        this._iconEl = b;
        return;
      }
      /* fallback: floating button if the rail isn't found */
      var fb = document.createElement('button');
      fb.id = 'cf-openings-icon';
      fb.title = 'Windows & doors';
      fb.style.cssText = 'position:fixed;right:18px;top:50%;transform:translateY(120px);z-index:9100;width:48px;height:48px;border-radius:50%;border:none;background:#9a6f44;color:#fff;box-shadow:0 3px 10px rgba(0,0,0,.3);cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:24px;';
      fb.textContent = '+';
      fb.addEventListener('click', function (e) { e.stopPropagation(); self._onIconClick(); });
      document.body.appendChild(fb);
      this._iconEl = fb;
    },

    _onIconClick: function () { this._setMode(!this._mode); },

    _setMode: function (on) {
      this._mode = on;
      this._selIdx = -1;
      if (on && STATE.view === '2d') { try { toggleView(); } catch (e) {} }  /* add window/door → 3D */
      if (on) { this._openDrawer(); }
      else { this._armed = null; this._closeDrawer(); }
      this.render();
      _forceRender3DFlush(1);
      this._setIconActive(on);
    },
    _setIconActive: function (on) {
      var b = this._iconEl; if (!b) return;
      if (on) {
        if (this._iconBg == null) this._iconBg = b.style.background;
        b.style.background = '#D2A878';
        b.style.color = '#fff';
        b.style.borderColor = '#D2A878';
      } else {
        b.style.background = (this._iconBg != null ? this._iconBg : '#fff');
        b.style.color = '#3a3f45';
        b.style.borderColor = 'rgba(0,0,0,.08)';
      }
    },

    /* drawer built on the theme's side-panel component (same as the other
       drawers): mount once, open via .active + body.open-cc, Windows/Doors
       tabs, tile grid; picking places at the pending slot and closes */
    _DRAWER_ID: 'cf-openings-drawer',
    _mountDrawer: function () {
      if (document.getElementById(this._DRAWER_ID)) return;
      if (!document.getElementById('cf-openings-tabs-css')) {
        var stb = document.createElement('style');
        stb.id = 'cf-openings-tabs-css';
        stb.textContent = '.openings-tabs{scrollbar-width:none;-ms-overflow-style:none;}.openings-tabs::-webkit-scrollbar{display:none;width:0;height:0;}';
        document.head.appendChild(stb);
      }
      var self = this;
      var T = (global.BASE_BOOT || {}).i18n || {};
      function tt(k, f) { var v = T[k]; return (typeof v === 'string' && v && v.indexOf('Translation missing') === -1) ? v : f; }
      var wrap = document.createElement('div');
      wrap.innerHTML = [
        '<div class="side-panel configurator-asset-drawer openings-drawer" id="' + this._DRAWER_ID + '" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="cf-openings-title">',
        '  <div class="side-panel-inner">',
        '    <div class="side-panel-header">',
        '      <div>',
        '        <span class="drawer-header-content">',
        '          <span class="asset-drawer-title" id="cf-openings-title">' + _esc(tt('mcOpenings', 'Windows & doors')) + '</span>',
        '          <span class="asset-drawer-subtitle" data-op-sub>—</span>',
        '        </span>',
        '        <side-panel-close class="side-panel-close" data-openings-close aria-label="' + _esc(tt('mcClose', 'Close')) + '">',
        '          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
        '        </side-panel-close>',
        '      </div>',
        '    </div>',
        '    <div class="side-panel-content side-panel-content--has-tabs" style="padding:0;">',
        '      <div class="share-drawer-tabs openings-tabs" role="tablist" style="display:flex;gap:4px;padding:20px 24px 0;border-bottom:1px solid #e3ddd2;overflow-x:auto;-webkit-overflow-scrolling:touch;">',
        OPENING_CATS.map(function (c, idx) {
          var on = idx === 0;
          return '<button type="button" role="tab" class="share-drawer-tab' + (on ? ' tab-active' : '') + '" data-op-tab="' + c.id + '" style="flex:0 0 auto;white-space:nowrap;padding:12px 6px;margin-bottom:-1px;border:none;background:transparent;cursor:pointer;font:500 14px Montserrat,sans-serif;color:' + (on ? '#2c2d2e' : '#8a7c68') + ';border-bottom:2px solid ' + (on ? '#3f3222' : 'transparent') + ';">' + _esc(tt(c.nameKey, c.nameEn)) + '</button>';
        }).join(''),
        '      </div>',
        '      <div class="share-drawer-panel tab-active" style="padding:14px 24px 20px;">',
        '        <div class="op-roof-note" data-op-roofnote style="display:none;font:500 13px Montserrat,sans-serif;color:#8a7c68;margin-bottom:10px;"></div>',
        '        <div class="op-width-filter" data-op-filter style="display:none;flex-wrap:wrap;gap:6px;margin-bottom:14px;"></div>',
        '        <div class="openings-grid" data-op-grid style="display:grid;grid-template-columns:repeat(auto-fill,minmax(132px,1fr));gap:10px;"></div>',
        '      </div>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');
      var panel = wrap.firstElementChild;
      document.body.appendChild(panel);
      var closeEl = panel.querySelector('[data-openings-close]');
      if (closeEl) closeEl.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self._setMode(false); });
      /* clicking the dimmed area (the panel outside its inner) cancels back to default */
      panel.addEventListener('click', function (e) { if (e.target === panel) self._setMode(false); });
      panel.querySelectorAll('[data-op-tab]').forEach(function (tb) {
        tb.addEventListener('click', function () { self._setTab(tb.getAttribute('data-op-tab')); });
      });
    },
    _setTab: function (catId) {
      var panel = document.getElementById(this._DRAWER_ID); if (!panel) return;
      var self = this;
      panel.querySelectorAll('[data-op-tab]').forEach(function (tb) {
        var on = tb.getAttribute('data-op-tab') === catId;
        tb.classList.toggle('tab-active', on);
        tb.style.background = 'transparent';
        tb.style.color = on ? '#2c2d2e' : '#8a7c68';
        tb.style.borderBottomColor = on ? '#3f3222' : 'transparent';
      });
      this._tab = catId;
      var isRoof = catId === 'roof';
      var note = panel.querySelector('[data-op-roofnote]');
      if (note) { note.style.display = isRoof ? 'block' : 'none'; note.textContent = isRoof ? _optt('mcOpRoofSoon', 'Placement on the roof slope — coming soon.') : ''; }
      var grid = panel.querySelector('[data-op-grid]'); if (!grid) return;
      var items = _opList(catId);

      /* width filter — windows only (many sizes) */
      var fEl = panel.querySelector('[data-op-filter]');
      if (fEl) {
        if (catId === 'window') {
          var widths = [], seen = {};
          items.forEach(function (it) { var key = it.w.toFixed(4); if (!seen[key]) { seen[key] = 1; widths.push(it.w); } });
          widths.sort(function (a, b) { return a - b; });
          if (this._winW != null && widths.indexOf(this._winW) < 0) this._winW = null;
          fEl.style.display = 'flex';
          fEl.innerHTML = '';
          var mkChip = function (val, lab) {
            var on = (self._winW == null && val == null) || (val != null && self._winW != null && Math.abs(val - self._winW) < 1e-4);
            var c = document.createElement('button');
            c.type = 'button';
            c.textContent = lab;
            c.style.cssText = 'border:1px solid ' + (on ? '#3f3222' : '#e3ddd2') + ';background:' + (on ? '#3f3222' : '#fff') + ';color:' + (on ? '#fff' : '#6b6051') + ';border-radius:999px;padding:6px 12px;cursor:pointer;font:600 12px Montserrat,sans-serif;';
            c.addEventListener('click', function () { self._winW = val; self._setTab('window'); });
            return c;
          };
          fEl.appendChild(mkChip(null, _optt('mcOpAllWidths', 'All widths')));
          widths.forEach(function (w) {
            var lab = STATE.isMetric ? (Math.round(w * 1000) + ' mm') : (Math.round(w / _IN) + '\u2033');
            fEl.appendChild(mkChip(w, lab));
          });
          if (this._winW != null) items = items.filter(function (it) { return Math.abs(it.w - self._winW) < 1e-4; });
        } else {
          fEl.style.display = 'none';
          fEl.innerHTML = '';
        }
      }

      grid.innerHTML = '';
      items.forEach(function (it) {
        var tile = document.createElement('button');
        tile.type = 'button';
        tile.style.cssText = 'border:1px solid #e3ddd2;background:#faf7f1;border-radius:12px;padding:10px;cursor:' + (isRoof ? 'default' : 'pointer') + ';text-align:left;display:flex;flex-direction:column;gap:6px;' + (isRoof ? 'opacity:.7;' : '');
        tile.innerHTML =
          '<div style="height:62px;display:flex;align-items:center;justify-content:center;">' + _opThumb(it, catId) + '</div>' +
          '<div style="font:700 12px Montserrat,sans-serif;color:#333;">' + _esc(_opLabel(it)) + '</div>';
        tile.addEventListener('click', function () {
          if (isRoof) return;                 /* roof placement deferred */
          self._arm(it.id);                   /* arm → tap a wall to place */
        });
        grid.appendChild(tile);
      });
    },
    _openDrawer: function () {
      this._mountDrawer();
      var panel = document.getElementById(this._DRAWER_ID); if (!panel) return;
      this._setTab(this._tab || 'window');
      panel.classList.add('active');
      document.body.classList.add('open-cc');
    },
    _closeDrawer: function () {
      var panel = document.getElementById(this._DRAWER_ID);
      if (panel) panel.classList.remove('active');
      document.body.classList.remove('open-cc');
    },

    /* pick from the drawer → arm this SKU, close the drawer, keep the mode on.
       The model stays fully interactive (orbit/zoom); a clean tap on a wall
       drops the armed unit. Stays armed so several can be placed in a row. */
    _arm: function (id) {
      this._armed = id;
      this._closeDrawer();      /* hide the drawer, keep the mode + bands for the tap */
      this.render();
      _forceRender3DFlush(1);
    },

    /* place the armed unit where the user tapped: u along the wall + the storey
       inferred from the tap height, sill snapped to that storey's standard
       (fine-tune by dragging afterwards). Nudges clear of an overlapping unit.
       One placement returns to the default state — icon off, colour bands gone;
       tapping the icon again re-opens the drawer for the next unit. */
    _placeAtHit: function (hit, id) {
      var it = _catItem(id); if (!it || !hit || !hit.wall) return;
      var flN = Math.max(1, STATE.floors | 0), eave = this._eaveLevel();
      var floor = _floorOfY(hit.y + 1e-3);
      var sill = Math.max(0, Math.min(eave - it.h - 0.02, (it.sill || 0) + _storeyBaseY(floor)));
      var lo = it.w / 2 + 0.1, hiU = hit.wall.len - it.w / 2 - 0.1;
      if (hiU < lo) return;                                       /* wall too short → ignore tap */
      var uu = Math.max(lo, Math.min(hiU, this._snapU(hit.u, it.w)));
      var wi = hit.wallIdx;
      function clashTo(u) {
        for (var i = 0; i < STATE.openings.length; i++) {
          var e = STATE.openings[i]; if (e.wallIdx !== wi) continue;
          var vlo = Math.max(sill, e.sill || 0), vhi = Math.min(sill + it.h, (e.sill || 0) + e.h);
          if (vhi - vlo <= 0.02) continue;                       /* different height band */
          var gap = it.w / 2 + e.w / 2 + 0.08;
          if (Math.abs(u - e.u) < gap) return e.u + (u >= e.u ? gap : -gap);
        }
        return null;
      }
      for (var pass = 0; pass < 4; pass++) { var to = clashTo(uu); if (to == null) break; uu = Math.max(lo, Math.min(hiU, to)); }
      STATE.openings.push({ sku: it.id, cat: it.cat, wallIdx: wi, u: uu, w: it.w, h: it.h, sill: sill, type: it.kind, wf: (hit.wall.floor == null ? -1 : hit.wall.floor) });
      this._broadcast();
      this._armed = null;       /* one shot → back to default */
      this._mode = false;
      this._setIconActive(false);
      this._refreshAfterEdit();                                  /* re-cut wall + render, no bands */
    },

    _placeAt: function (wallIdx, u, id, storey) {
      var it = _catItem(id); if (!it) return;
      var walls = this._walls(), wl = walls[wallIdx];
      var uu = this._snapU(u, it.w);
      if (wl) uu = Math.max(it.w / 2 + 0.1, Math.min(wl.len - it.w / 2 - 0.1, uu));
      var sill = (it.sill || 0) + _storeyBaseY(storey | 0);
      var eave = this._eaveLevel();
      sill = Math.max(0, Math.min(eave - it.h - 0.02, sill));
      STATE.openings.push({ sku: it.id, cat: it.cat, wallIdx: wallIdx, u: uu, w: it.w, h: it.h, sill: sill, type: it.kind, wf: (wl && wl.floor != null ? wl.floor : -1) });
      this._broadcast();
      this._refreshAfterEdit();
    },
    _rebuildHouse: function () {
      try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
      _forceRender3DFlush(1);
    },
    /* coalesced to one rebuild per animation frame — used during drag so the
       wall hole follows the window in real time without flooding the tablet. */
    _rebuildHouseRAF: function () {
      var self = this;
      if (self._rbPending) return;
      self._rbPending = true;
      var raf = global.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      raf(function () {
        self._rbPending = false;
        try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (e) {}
      });
    },
    /* horizontal module = half the masonry block (mc:grid.unit, mm canonical);
       fallback ½ default block (125 mm metric / 4″ imperial). */
    _blockModuleM: function () {
      try {
        var g = JSON.parse(localStorage.getItem('mc:grid') || 'null');
        if (g && g.unit > 0) return (g.unit / 1000) / 2;
      } catch (e) {}
      return STATE.isMetric ? 0.125 : (4 * 0.0254);
    },
    /* snap so the opening EDGES land on half-block joints (width is already a
       block multiple → both edges align → masonry needs no extra cuts). */
    _snapU: function (u, w) {
      var m = this._blockModuleM();
      if (!(m > 0)) return u;
      var left = Math.round((u - w / 2) / m) * m;
      return left + w / 2;
    },

    _broadcastSafe: function () { try { this._broadcast(); } catch (e) {} },

    _raycastMeshes: function (cx, cy, objs) {
      var eng = global.BaseEngine, T = global.THREE;
      if (!eng || !eng.camera || !eng.renderer || !T || !objs || !objs.length) return null;
      var vis = objs.filter(function (o) { return o && o.visible; });
      if (!vis.length) return null;
      var rect = eng.renderer.domElement.getBoundingClientRect();
      var ndc = new T.Vector2(((cx - rect.left) / rect.width) * 2 - 1, -((cy - rect.top) / rect.height) * 2 + 1);
      var ray = new T.Raycaster(); ray.setFromCamera(ndc, eng.camera);
      var hits = ray.intersectObjects(vis, true);
      return hits.length ? hits[0].object : null;
    },

    /* default 3D view: drag an existing unit by grabbing it directly (orbit/zoom
       stays live everywhere else). With the icon on you also place (armed → tap a
       wall) and edit (tap a unit → popup). The masonry block stage disables
       dragging (bricks can't be re-cut every frame); place/edit still rebuild. */
    _bindPointer: function () {
      var self = this, eng = global.BaseEngine;
      var canvas = eng && eng.renderer && eng.renderer.domElement;
      if (!canvas) { setTimeout(function () { self._bindPointer(); }, 300); return; }
      var downX = 0, downY = 0, moved = false;
      canvas.addEventListener('pointerdown', function (ev) {
        if (STATE.view === '2d') return;
        downX = ev.clientX; downY = ev.clientY; moved = false;
        if (STATE.vizStage === 4) return;                  /* no dragging over brickwork */
        var hit = self._hitWall(ev.clientX, ev.clientY);
        if (!hit) return;
        var idx = self._openingAtHit(hit);                 /* grab only when tapping on a unit */
        if (idx >= 0) { self._selIdx = idx; self._dragging = true; if (eng.controls) eng.controls.enabled = false; }
      });
      canvas.addEventListener('pointermove', function (ev) {
        if (STATE.view === '2d') return;
        if (Math.abs(ev.clientX - downX) > 5 || Math.abs(ev.clientY - downY) > 5) moved = true;
        if (self._dragging && self._selIdx >= 0) {
          var hit = self._hitWall(ev.clientX, ev.clientY);
          if (hit) {
            var o = STATE.openings[self._selIdx];
            o.wallIdx = hit.wallIdx;
            o.wf = (hit.wall.floor == null ? -1 : hit.wall.floor);   /* keep niche/footprint binding in sync while dragging */
            var su = self._snapU(hit.u, o.w);
            o.u = Math.max(o.w / 2 + 0.1, Math.min(hit.wall.len - o.w / 2 - 0.1, su));
            if (o.type === 'window') {         /* only windows move vertically */
              var eave = self._eaveLevel();
              var raw = hit.y - o.h / 2;        /* centre on the pointer */
              var step = STATE.isMetric ? 0.05 : 0.0254;   /* 50 mm | 1 inch */
              raw = Math.round(raw / step) * step;
              o.sill = Math.max(0, Math.min(eave - o.h - 0.02, raw));
              var txt = STATE.isMetric
                ? (Math.round(o.sill * 1000) + ' mm')
                : (Math.round(o.sill / 0.0254) + '\u2033');
              self._sillPill(true, txt, ev.clientX, ev.clientY);
            }
            self._renderWalls();          /* re-cut wall only → real time */
            self.render();
            _forceRender3DFlush(0);
          }
        }
      });
      canvas.addEventListener('pointerup', function (ev) {
        if (STATE.view === '2d') return;
        self._sillPill(false);
        var wasDragging = self._dragging, sel = self._selIdx;
        self._dragging = false;
        if (eng.controls) eng.controls.enabled = true;
        if (wasDragging) {
          if (moved) { self._broadcastSafe(); self._refreshAfterEdit(); }   /* repositioned */
          else if (self._mode) { self._openPopup(sel); }                    /* clean tap on a unit (icon on) → popup */
          return;                                                            /* default view: clean tap on a unit does nothing */
        }
        if (moved) return;                                                   /* orbit / zoom */
        if (!self._mode) return;                                             /* default view: empty tap does nothing */
        /* icon on, clean tap that didn't grab (empty, near a unit, or stage 4) */
        var hit = self._hitWall(ev.clientX, ev.clientY);
        if (!hit) return;
        var onUnit = self._openingAtHit(hit);
        if (onUnit >= 0) { self._openPopup(onUnit); return; }                /* e.g. stage 4 tap on a unit → popup */
        if (self._armed) { self._placeAtHit(hit, self._armed); return; }     /* empty/near → place the armed unit */
      });
      canvas.addEventListener('pointercancel', function () {
        if (self._dragging) { self._dragging = false; if (eng.controls) eng.controls.enabled = true; self._sillPill(false); }
      });
    },

    _deleteOpening: function (idx) {
      if (idx == null || idx < 0 || idx >= STATE.openings.length) return;
      STATE.openings.splice(idx, 1);
      this._selIdx = -1;
      this._broadcast();
      this._refreshAfterEdit();
    },

    _sillPill: function (show, text, x, y) {
      if (!show) { if (this._pill) { this._pill.style.display = 'none'; } return; }
      if (!this._pill) {
        var p = document.createElement('div');
        p.style.cssText = 'position:fixed;z-index:9400;pointer-events:none;background:#3a3f45;color:#fff;padding:5px 9px;border-radius:8px;font:700 12px Montserrat,sans-serif;box-shadow:0 2px 8px rgba(0,0,0,.3);white-space:nowrap;';
        document.body.appendChild(p);
        this._pill = p;
      }
      this._pill.textContent = _optt('mcOpSill', 'Sill') + ' ' + text;
      this._pill.style.display = 'block';
      this._pill.style.left = (x + 14) + 'px';
      this._pill.style.top = (y - 30) + 'px';
    },

    _nearestOpening: function (hit) {
      var best = -1, bd = 0.6;
      for (var i = 0; i < STATE.openings.length; i++) {
        var o = STATE.openings[i]; if (o.wallIdx !== hit.wallIdx) continue;
        var d = Math.abs(o.u - hit.u);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    },
    /* the unit whose rectangle the hit point lands inside (small margin) — used
       to grab for dragging, so a tap must land on a unit (keeps orbit free). */
    _openingAtHit: function (hit) {
      if (!hit) return -1;
      var m = 0.12;
      for (var i = 0; i < STATE.openings.length; i++) {
        var o = STATE.openings[i]; if (o.wallIdx !== hit.wallIdx) continue;
        if (Math.abs(o.u - hit.u) > o.w / 2 + m) continue;
        var s = o.sill || 0;
        if (hit.y < s - m || hit.y > s + o.h + m) continue;
        return i;
      }
      return -1;
    },

    _hitWall: function (clientX, clientY) {
      var eng = global.BaseEngine, T = global.THREE;
      if (!eng || !eng.camera || !eng.renderer || !T) return null;
      var rect = eng.renderer.domElement.getBoundingClientRect();
      var ndc = new T.Vector2(((clientX - rect.left) / rect.width) * 2 - 1, -((clientY - rect.top) / rect.height) * 2 + 1);
      var ray = new T.Raycaster(); ray.setFromCamera(ndc, eng.camera);
      var walls = this._walls(), eave = this._eaveLevel(), best = null, bestT = Infinity;
      var half = this._wallThk() / 2;
      for (var i = 0; i < walls.length; i++) {
        var wl = walls[i]; if (!wl) continue;
        var nrm = new T.Vector3(wl.nx, 0, wl.nz);
        var p0 = new T.Vector3(wl.ax, 0, wl.az);
        var denom = ray.ray.direction.dot(nrm);
        if (Math.abs(denom) < 1e-6) continue;
        var tHit = p0.clone().sub(ray.ray.origin).dot(nrm) / denom;
        if (tHit < 0 || tHit > bestT) continue;
        var hit = ray.ray.origin.clone().add(ray.ray.direction.clone().multiplyScalar(tHit));
        var u = (hit.x - wl.ax) * wl.ux + (hit.z - wl.az) * wl.uz;
        if (u < 0 || u > wl.len) continue;
        if (hit.y < 0 || hit.y > eave) continue;
        /* a recess wall only exists within its own storey's height band */
        if (hit.y < (wl.y0 || 0) - 0.02 || (wl.y1 != null && wl.y1 !== Infinity && hit.y > wl.y1 + 0.02)) continue;
        /* a footprint edge is OPEN where the balcony cuts it on this floor → no wall to host an opening there */
        if (wl.srcEdge >= 0) {
          var hf = _floorOfY(hit.y + 1e-3);
          if (_Balcony._inRect(hit.x, hit.z, hf, half + 0.2)) continue;
        }
        bestT = tHit; best = { wallIdx: i, u: u, wall: wl, y: hit.y };
      }
      return best;
    },

    _openPopup: function (idx) {
      if (idx < 0 || idx >= STATE.openings.length) return;
      var self = this, o = STATE.openings[idx], it = _catItem(o.sku);
      if (this._popEl) { this._popEl.remove(); this._popEl = null; }
      var ov = document.createElement('div');
      ov.style.cssText = 'position:fixed;inset:0;z-index:9300;background:rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;padding:16px;';
      ov.addEventListener('click', function () { self._closePopup(); });
      var card = document.createElement('div');
      card.style.cssText = 'background:#fff;border-radius:14px;width:100%;max-width:320px;padding:16px;font-family:Montserrat,system-ui,sans-serif;';
      card.addEventListener('click', function (e) { e.stopPropagation(); });
      card.innerHTML = '<div style="font:700 15px Montserrat,sans-serif;color:#222;margin-bottom:10px;">' + _esc(_opLabel(it)) + '</div>';
      if (it.kind === 'window') {
        var lab = document.createElement('div');
        lab.style.cssText = 'font:600 12px Montserrat,sans-serif;color:#444;margin-bottom:4px;';
        var sill = document.createElement('input');
        sill.type = 'range'; sill.min = '0'; sill.max = '1.6';
        sill.step = String(STATE.isMetric ? 0.05 : 0.0254); sill.value = String(o.sill);
        sill.style.cssText = 'width:100%;accent-color:#9a6f44;';
        function lp() {
          lab.textContent = _optt('mcOpSill','Sill') + ': ' + (STATE.isMetric
            ? (Math.round(o.sill * 1000) + ' mm')
            : (Math.round(o.sill / 0.0254) + '\u2033'));
        }
        lp();
        sill.addEventListener('input', function () { o.sill = +sill.value; lp(); self.render(); _forceRender3DFlush(0); });
        card.appendChild(lab); card.appendChild(sill);
      }
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;gap:8px;margin-top:14px;';
      var del = document.createElement('button');
      del.textContent = _optt('mcOpDelete', 'Delete');
      del.style.cssText = 'flex:1;padding:11px;border:none;background:#c0392b;color:#fff;border-radius:10px;font:700 12px Montserrat,sans-serif;cursor:pointer;';
      del.addEventListener('click', function () {
        STATE.openings.splice(idx, 1); self._broadcastSafe(); self.render(); _forceRender3DFlush(1); self._closePopup();
      });
      var done = document.createElement('button');
      done.textContent = _optt('mcOpDone', 'Done');
      done.style.cssText = 'flex:1;padding:11px;border:1px solid #ddd;background:#fff;color:#555;border-radius:10px;font:700 12px Montserrat,sans-serif;cursor:pointer;';
      done.addEventListener('click', function () { self._broadcastSafe(); self._closePopup(); });
      row.appendChild(del); row.appendChild(done);
      card.appendChild(row);
      ov.appendChild(card);
      document.body.appendChild(ov);
      this._popEl = ov;
    },
    _closePopup: function () {
      if (this._popEl && this._popEl.parentNode) this._popEl.parentNode.removeChild(this._popEl);
      this._popEl = null;
    }
  };

  function boot() {
    if (global.__BASE_BOOTED__) return;
    global.__BASE_BOOTED__ = true;
    var attempts = 0;
    function tryBoot() {
      if (!global.THREE || !(global.THREE.OrbitControls || global.OrbitControls)) {
        if (++attempts > 100) {
          _dbg('boot aborted: THREE / OrbitControls never loaded after 5s');
          global.__BASE_BOOTED__ = false;
          return;
        }
        setTimeout(tryBoot, 50);
        return;
      }
      if (global.BaseEngine && global.BaseEngine.init) global.BaseEngine.init();
      _readShopifyVariantFromURL();
      _ProjectStore.init();
      _restoreFromProjectStore();
      wireSidebar();
      rebuildDragHandles();
      selectVariant(STATE.variant, true);
      var wrap = document.getElementById('cf-wrap-base');
      if (wrap) wrap.classList.add(STATE.view === '2d' ? 'cf-view-2d' : 'cf-view-3d');
      if (global.BaseEngine && global.BaseEngine._gridHelper) {
        _applyGridVisibility(global.BaseEngine);
      }
      refreshUI();
      if (global.BaseEngine && global.BaseEngine.fitCameraToFootprint) {
        global.BaseEngine.fitCameraToFootprint();
      }
      _initMap();
      setTimeout(_updateMapLockButton, 300);
      _AssetDrawer.init();
      try { _Openings._ensure(); } catch (eOp) {}
      try { _Floorplan._ensure(); } catch (eFp) {}
      try { _Partitions._ensure(); } catch (ePt) {}
      try { _Balcony._ensure(); } catch (eBc) {}
      try { _Partitions._restore(); } catch (ePr) {}    /* bring back saved partitions + underlay */
      try { _Floorplan._restore(); } catch (eFr) {}
      _scheduleOnboardModal();
      _dbg('boot complete, version=' + VERSION);
    }
    tryBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('cf-wrap-base')) boot();
    });
  } else {
    if (document.getElementById('cf-wrap-base')) boot();
  }

  function _openPdfSocialModal() {
    var BOOT = global.BASE_BOOT || {};
    if (!BOOT.hasOwnership) {
      var T = BOOT.i18n || {};
      var productUrl = '/products/' + (BOOT.productHandle || 'foundations');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }
    var modal = document.getElementById('cf-pdf-modal');
    if (!modal) {
      exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
      return;
    }
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      var closeEl = e.target.closest('[data-cf-pdf-close]');
      if (closeEl) {
        e.preventDefault();
        close();
        return;
      }
      var goEl = e.target.closest('[data-cf-pdf-go]');
      if (goEl) {
        e.preventDefault();
        var url = goEl.getAttribute('href');
        close();
        if (url) {
          try {
            var w = window.open(url, '_blank', 'noopener,noreferrer');
            if (w) w.opener = null;
          } catch (_) {
            window.open(url, '_blank');
          }
        }
        setTimeout(function () {
          exportPdf().catch(function (err) { console.error('[exportPdf]', err); });
        }, 60);
      }
    }
    modal.addEventListener('click', onClick);
  }

  var ONBOARD_THROTTLE_DAYS = 30;
  var ONBOARD_DELAY_MS = 15000;

  function _onboardStorageKey() {
    var BOOT = global.BASE_BOOT || {};
    var pid = BOOT.productId || BOOT.productHandle || 'default';
    return 'cf-onboard-shared-budget-' + pid;
  }

  function _onboardShouldShow() {
    try {
      var raw = localStorage.getItem(_onboardStorageKey());
      if (!raw) return true;
      var ts = parseInt(raw, 10);
      if (!ts || isNaN(ts)) return true;
      var ageMs = Date.now() - ts;
      var maxAge = ONBOARD_THROTTLE_DAYS * 24 * 60 * 60 * 1000;
      return ageMs > maxAge;
    } catch (_) { return true; }
  }

  function _onboardMarkSeen() {
    try { localStorage.setItem(_onboardStorageKey(), String(Date.now())); }
    catch (_) {}
  }

  function _onboardUserHasOwnBudget() {

    try {
      if (global.__cfBudgetUserTouched) return true;
      if (global.SharedBudgetUserEngaged) return true;
      var BOOT = global.BASE_BOOT || {};
      var pid = BOOT.productId;
      if (pid) {
        if (localStorage.getItem('cf-budget-touched-' + pid)) return true;
      }
    } catch (_) {}
    return false;
  }

  function _openOnboardModal() {
    var modal = document.getElementById('cf-onboard-modal');
    if (!modal) return;
    modal.hidden = false;

    var de = document.documentElement, bd = document.body;
    var prevHtmlOv = de ? de.style.overflow : '';
    var prevBodyOv = bd ? bd.style.overflow : '';
    var prevBodyTA = bd ? bd.style.touchAction : '';
    if (de) de.style.overflow = 'hidden';
    if (bd) { bd.style.overflow = 'hidden'; bd.style.touchAction = 'none'; }

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
      if (de) de.style.overflow = prevHtmlOv;
      if (bd) { bd.style.overflow = prevBodyOv; bd.style.touchAction = prevBodyTA; }
      _onboardMarkSeen();
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-onboard-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-cf-onboard-go]')) {
        e.preventDefault();
        close();

        setTimeout(function () {
          try { openBudgetDrawer(); }
          catch (err) { console.warn('[onboard] open budget drawer failed', err); }
        }, 120);
      }
    }
    modal.addEventListener('click', onClick);
  }

  function _scheduleOnboardModal() {

    if (!_onboardShouldShow()) return;
    if (_onboardUserHasOwnBudget()) return;

    var elapsed = 0;
    var tick = 1000;
    var timer = setInterval(function () {
      if (document.visibilityState === 'visible') elapsed += tick;
      if (elapsed >= ONBOARD_DELAY_MS) {
        clearInterval(timer);

        if (_onboardShouldShow() && !_onboardUserHasOwnBudget()) {
          _openOnboardModal();
        }
      }
    }, tick);
  }

  function _setArStatus(msg) {
    var el = document.getElementById('cf-ar-modal-status');
    if (el) el.textContent = msg || '';
  }

  function _setArQR(dataUrl) {
    var el = document.getElementById('cf-ar-modal-qr');
    if (!el) return;
    el.innerHTML = '';
    if (!dataUrl) return;
    var img = document.createElement('img');
    img.src = dataUrl;
    img.alt = 'AR QR code';
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.borderRadius = '8px';
    img.style.background = '#fff';
    img.style.padding = '8px';
    el.appendChild(img);
  }

  function _setArLink(viewerUrl) {
    var el = document.getElementById('cf-ar-modal-link');
    if (!el) return;
    if (viewerUrl) {
      el.style.display = 'block';
      el.innerHTML = '<a href="' + viewerUrl + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">' + viewerUrl + '</a>';
    } else {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  function _arExportScene() {

    return new Promise(function (resolve, reject) {
      var T = global.THREE;
      var Exporter = global.GLTFExporter;
      var eng = global.BaseEngine;
      if (!T || !Exporter || !eng || !eng.sceneGroup) {
        reject(new Error('THREE / GLTFExporter / scene not ready'));
        return;
      }

      var exportRoot = new T.Group();

      var cutY = 0;
      /* AR per storey: when a floor is selected, clip the scene to that storey's
         vertical band [_storeyBaseY(s), _storeyTopY(s)] (+ a little for the ceiling
         slab) and drop it to y=0, so the user can view/walk one floor at a time.
         _arFloorSel < 0 exports the whole house (clip only below grade). */
      var _flN = Math.max(1, STATE.floors | 0);
      var bandMin = cutY, bandMax = Infinity;
      if (_arFloorSel >= 0 && _arFloorSel < _flN) {
        bandMin = _storeyBaseY(_arFloorSel);
        bandMax = _storeyTopY(_arFloorSel) + 0.10;
      }

      eng.sceneGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        var t = node.userData && node.userData.assetType;

        if (t === 'section-cut-aux') return;
        if (t === 'slope-terrain') return;
        if (t === 'excavation-box') return;
        if (!node.visible) return;
        node.updateMatrixWorld(true);

        var geom = node.geometry.clone();
        geom.applyMatrix4(node.matrixWorld);

        geom.computeBoundingBox();
        if (geom.boundingBox && geom.boundingBox.max.y <= bandMin + 1e-4) return;
        if (geom.boundingBox && geom.boundingBox.min.y >= bandMax - 1e-4) return;
        var pos = geom.attributes.position, arr = pos.array;
        for (var vi = 1; vi < arr.length; vi += 3) {
          if (arr[vi] < bandMin) arr[vi] = bandMin;
          else if (arr[vi] > bandMax) arr[vi] = bandMax;
        }
        pos.needsUpdate = true;
        geom.translate(0, -bandMin, 0);
        geom.computeVertexNormals();

        var srcMat = node.material;
        var useMat;
        if (Array.isArray(srcMat)) {
          useMat = srcMat.map(function (m) { var c = m.clone(); c.side = T.FrontSide; return c; });
        } else {
          useMat = srcMat.clone(); useMat.side = T.FrontSide;
        }
        var cloned = new T.Mesh(geom, useMat);
        cloned.name = node.name || (t || 'mesh') + '_' + exportRoot.children.length;
        cloned.userData = Object.assign({}, node.userData || {});
        exportRoot.add(cloned);
      });

      if (exportRoot.children.length === 0) {
        reject(new Error('No exportable meshes in scene'));
        return;
      }

      var exporter = new Exporter();
      exporter.parse(
        exportRoot,
        function (glb) {

          if (glb instanceof ArrayBuffer) {
            resolve(glb);
          } else {
            reject(new Error('Expected GLB ArrayBuffer, got JSON'));
          }
        },
        function (err) { reject(err); },
        { binary: true }
      );
    });
  }

  async function _arUpload(glbBuffer) {
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};
    var workerUrl = BOOT.arWorkerUrl || (T.arWorkerUrl);
    if (!workerUrl) throw new Error('Worker URL missing');
    _dbg('[ar] worker URL = ' + workerUrl);

    _dbg('[ar] GET ' + workerUrl + '/upload-url');
    var r1;
    try {
      r1 = await fetch(workerUrl + '/upload-url');
    } catch (netErr) {
      _dbg('[ar] network error on /upload-url: ' + netErr);
      throw new Error('Network error: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] /upload-url response status=' + r1.status + ' ok=' + r1.ok);
    if (!r1.ok) throw new Error('upload-url failed: HTTP ' + r1.status);
    var info = await r1.json();
    _dbg('[ar] /upload-url payload: ' + JSON.stringify(info));
    if (!info || !info.uploadUrl) throw new Error('upload-url response invalid');

    _dbg('[ar] PUT ' + info.uploadUrl + ' (' + (glbBuffer.byteLength / 1024).toFixed(1) + ' KB)');
    var r2;
    try {
      r2 = await fetch(info.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'model/gltf-binary' },
        body: glbBuffer
      });
    } catch (netErr) {
      _dbg('[ar] network error on PUT: ' + netErr);
      throw new Error('Network error on PUT: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] PUT response status=' + r2.status + ' ok=' + r2.ok);
    if (!r2.ok) {
      var errBody = '';
      try { errBody = await r2.text(); } catch (_) {}
      _dbg('[ar] PUT error body: ' + errBody);
      throw new Error('PUT failed: HTTP ' + r2.status + ' ' + errBody);
    }

    return info;
  }

  function _arGenerateQR(url) {

    return new Promise(function (resolve) {
      function tryLib() {
        if (global.QRCode && global.QRCode.toDataURL) {
          global.QRCode.toDataURL(url, { width: 400, margin: 1, errorCorrectionLevel: 'M' }, function (err, dataUrl) {
            if (err || !dataUrl) {
              resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
            } else {
              resolve(dataUrl);
            }
          });
          return true;
        }
        return false;
      }
      if (tryLib()) return;

      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (tryLib()) { clearInterval(iv); return; }
        if (attempts > 20) {
          clearInterval(iv);
          resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
        }
      }, 100);
    });
  }

  /* Floor picker injected into the AR modal (the modal markup lives in the
     section, so we mount this row via JS). Only shown for multi-storey houses.
     Picking a floor re-runs the export for that storey's slice. */
  function _ensureArFloorPicker(onPick) {
    var existing = document.getElementById('cf-ar-floor-picker');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var flN = Math.max(1, STATE.floors | 0);
    if (flN < 2) return;
    var qr = document.getElementById('cf-ar-modal-qr');
    var modal = document.getElementById('cf-ar-modal');
    var anchor = qr || modal;
    if (!anchor) return;
    var i18n = (global.BASE_BOOT || {}).i18n || {};
    var host = document.createElement('div');
    host.id = 'cf-ar-floor-picker';
    host.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;justify-content:center;margin:0 auto 12px;max-width:340px;';
    function mk(label, sel) {
      var on = (_arFloorSel === sel);
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.style.cssText = 'padding:7px 13px;border-radius:999px;border:1px solid ' + (on ? '#2c2d2e' : '#d2d2d2') +
        ';background:' + (on ? '#2c2d2e' : '#fff') + ';color:' + (on ? '#fff' : '#2c2d2e') +
        ';font:600 12px/1 Montserrat,sans-serif;cursor:pointer;';
      b.addEventListener('click', function () {
        if (_arFloorSel === sel) return;
        _arFloorSel = sel;
        _ensureArFloorPicker(onPick);
        if (typeof onPick === 'function') onPick();
      });
      host.appendChild(b);
    }
    mk(i18n.arWholeHouse || 'Whole house', -1);
    for (var s = 0; s < flN; s++) mk((i18n.arFloor || 'Floor') + ' ' + (s + 1), s);
    if (qr && qr.parentNode) qr.parentNode.insertBefore(host, qr);
    else anchor.appendChild(host);
  }

  async function _openArModal() {
    var modal = document.getElementById('cf-ar-modal');
    if (!modal) return;
    var BOOT = global.BASE_BOOT || {};
    var T = BOOT.i18n || {};

    _arFloorSel = -1;   /* default to the whole house each time the modal opens */
    _setArQR(null);
    _setArLink(null);
    _setArStatus(T.arPreparing || 'Preparing scene…');
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
      var fp = document.getElementById('cf-ar-floor-picker');
      if (fp && fp.parentNode) fp.parentNode.removeChild(fp);
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-ar-close]')) {
        e.preventDefault();
        close();
      }
    }
    modal.addEventListener('click', onClick);

    async function runExport() {
      _setArQR(null);
      _setArLink(null);
      _setArStatus(T.arPreparing || 'Preparing scene…');

      var needBuild = false;
      if (STATE.view !== '3d') {
        needBuild = true;
        try {
          if (global.BaseRenderer && global.BaseRenderer._build3D) {
            var poly = getFootprintPolygon();
            if (poly && poly.length >= 3) global.BaseRenderer._build3D(poly);
          }
        } catch (e) { _dbg('[ar] 3D pre-build failed', e); }
      }

      _roofDetailExport = true;
      try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (eDb) {}
      try {
        var glb = await _arExportScene();
        _dbg('[ar] GLB size = ' + (glb.byteLength / 1024).toFixed(1) + ' KB');
        _setArStatus(T.arUploading || 'Uploading to cloud…');

        var info = await _arUpload(glb);
        _dbg('[ar] uploaded uuid=' + info.uuid + ' viewer=' + info.viewerUrl);

        var qrDataUrl = await _arGenerateQR(info.viewerUrl);
        _setArQR(qrDataUrl);
        _setArLink(info.viewerUrl);
        _setArStatus(T.arReady || 'Ready — scan with your phone');
      } catch (e) {
        console.error('[ar] export failed', e);
        _setArStatus((T.arError || 'AR export failed: ') + (e && e.message ? e.message : e));
      }
      _roofDetailExport = false;
      try { if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build(); } catch (eDb2) {}

      if (needBuild && global.BaseRenderer && global.BaseRenderer.build) {
        try { global.BaseRenderer.build(); } catch (_) {}
      }
    }

    _ensureArFloorPicker(runExport);
    await runExport();
  }

  async function exportPdf() {
    var T = (global.BASE_BOOT && global.BASE_BOOT.i18n) || {};
    if (!global.ConfiguratorPdfExporter || !global.ConfiguratorPdfExporter.export) {
      alert(T.pdfLibLoading || 'PDF library not yet loaded — try again in a moment.');
      return;
    }
    var BOOT = global.BASE_BOOT || {};
    var bridge = global.ConfiguratorBudgetBridge || null;
    var btn = document.getElementById('cf-btn-pdf');

    if (!BOOT.hasOwnership) {
      var productUrl = '/products/' + (BOOT.productHandle || 'foundations');
      var msg = T.pdfPaywallMsg || 'To download the PDF documentation, please purchase this product first.';
      var ok = window.confirm(msg + '\n\n' + (T.pdfPaywallCta || 'Go to product page?'));
      if (ok) window.location.href = productUrl;
      return;
    }

    if (btn) btn.classList.add('active');

    if (bridge && typeof bridge.isReady === 'function' && !bridge.isReady()) {
      var waited = 0;
      var pollMs = 100;
      var timeoutMs = 5000;
      while (!bridge.isReady() && waited < timeoutMs) {
        await new Promise(function (res) { setTimeout(res, pollMs); });
        waited += pollMs;
      }
      if (!bridge.isReady()) {
        if (btn) btn.classList.remove('active');
        alert(T.pdfWaitingForData || 'Configuration data is still loading. Please wait a moment and try again.');
        return;
      }
    }

    try {
      try { publishBoQToBudget(); } catch (_) {}
      if (typeof global.updateTotal === 'function') {
        try { global.updateTotal(); } catch (_) {}
      }
      await new Promise(function (res) { setTimeout(res, 600); });

      var snapshots = await _captureForPdf();
      var instances = _buildInstancePayload();
      var boqNames  = _buildBoqNamesMap(bridge);
      var boq       = _buildBoq(bridge);
      var totals    = _buildTotals(boq);
      var baseDims  = _buildBaseDimensions();
      var variantName = _variantDisplayName();

      try { console.log('[exportPdf] totals=', totals); } catch (_) {}

      var planSnap  = (snapshots || []).find(function (s) { return s && s.key === 'plan'; });
      var crossSnap = (snapshots || []).find(function (s) { return s && s.key === 'cross-section'; });
      try {
        console.log('[exportPdf] snapshots=', snapshots ? snapshots.length : 0,
                    'planSnap=', planSnap ? (planSnap.imageDataUrl ? 'OK (' + planSnap.imageDataUrl.length + ' chars)' : 'no URL') : 'missing',
                    'crossSnap=', crossSnap ? (crossSnap.imageDataUrl ? 'OK' : 'no URL') : 'missing');
      } catch (_) {}

      var assemblyPayload = await _buildAssemblyPayload(boq);
      try { console.log('[exportPdf] assemblyPayload=', assemblyPayload ? 'OK (' + assemblyPayload.legend.length + ' legend rows)' : 'none'); } catch (_) {}

      global.ConfiguratorPdfExporter.export({
        productTitle:    (BOOT.productTitle || 'Foundation') + '\n' + (variantName ? variantName.toUpperCase() : ''),
        customerName:    BOOT.customerName || null,
        coverImage:      BOOT.coverImage   || null,
        shareUrl:        _buildShareUrl(),
        totals:          totals,
        baseAssembly:     assemblyPayload,
        basePlan:         planSnap  ? { imageDataUrl: planSnap.imageDataUrl, bottomLeft: planSnap.bottomLeft || null } : null,

        baseCrossSection: null,
        baseDims:      baseDims,
        instances:     instances,
        boqNames:      boqNames,
        cutList:       [],
        boq:           boq,
        meta: {
          locale:        BOOT.locale         || 'en',
          productHandle: BOOT.productHandle  || 'foundations',
          date:          new Date(),
          variantName:   variantName,
          lvl:           STATE.lvl,
          slope: {
            active: STATE.slopeActive,
            deg:    STATE.slopeDeg
          },
          i18n: {
            pagePlanTitle:           T.pdfPagePlanTitle           || 'Plan view',
            pageCrossSectionTitle:   T.pdfPageCrossSection        || 'Cross-section',
            pageCutListTitle:        T.pdfPageCutListTitle        || 'Cut list',
            pageBoqTitle:            T.pdfPageBoqTitle            || 'Bill of Quantities',
            pageIsoTitle:            T.pdfPageIsoTitle            || '3D visualisation',
            pageOrthosTitle:         T.pdfPageOrthosTitle         || 'Engineering views',
            pageCutListVisualTitle:  T.pdfPageCutListVisualTitle  || 'Cut list — visual',
            orthoTop:                T.pdfOrthoTop                || 'Top view',
            orthoFront:              T.pdfOrthoFront              || 'Front view',
            orthoSide:               T.pdfOrthoSide               || 'Side view',
            totalsTitle:             T.pdfTotalsTitle             || 'TOTAL',
            materialsLabel:          T.pdfMaterialsLabel          || 'Materials',
            executionLabel:          T.pdfExecutionLabel          || 'Execution',
            grandTotalLabel:         T.pdfGrandTotalLabel         || 'GRAND TOTAL',
            noCutsMessage:           T.pdfNoCutsMessage           || 'No cuttable items for this foundation type.',
            noModelData:             T.pdfNoModelData             || 'No 3D model data available.',
            continued:               T.pdfContinued               || '(continued)',
            pcs:                     T.pdfPcs                     || 'pcs',
            deckingLabel:            T.pdfDeckingLabel            || 'decking',
            slopeLabel:              T.pdfSlopeLabel              || 'Slope',
            lvlLabel:                T.pdfLvlLabel                || 'Reinforcement level',
            lvlNames: {
              1: T.pdfLvl1 || 'Standard',
              2: T.pdfLvl2 || 'Reinforced',
              3: T.pdfLvl3 || 'Robust'
            },
            boq: {
              headerCode:      T.pdfBoqHeaderCode      || 'Code',
              headerName:      T.pdfBoqHeaderName      || 'Description',
              headerQty:       T.pdfBoqHeaderQty       || 'Qty',
              headerUnitPrice: T.pdfBoqHeaderUnitPrice || 'Unit price',
              headerTotal:     T.pdfBoqHeaderTotal     || 'Total',
              grandTotal:      T.pdfBoqGrandTotal      || 'Grand total'
            },
            cutList: {
              headerPart:   T.pdfCutHeaderPart   || 'Part',
              headerDesc:   T.pdfCutHeaderDesc   || 'Description',
              headerLength: T.pdfCutHeaderLength || 'Length',
              headerQty:    T.pdfCutHeaderQty    || 'Qty'
            }
          }
        }
      });
    } catch (e) {
      console.error('[exportPdf]', e);
      alert((T.pdfFailed || 'PDF export failed: ') + (e && e.message ? e.message : 'unknown error'));
    } finally {
      if (btn) btn.classList.remove('active');
    }
  }

  async function _captureForPdf() {
    var T = global.THREE;
    var eng = global.BaseEngine;
    if (!T || !eng || !eng.scene || !eng.renderer) return [];

    var poly = getFootprintPolygon();
    if (!poly || poly.length < 3) return [];

    var prevStage = STATE.vizStage;
    var prevView  = STATE.view;
    var prevSlope = STATE.slopeActive;
    var prevOrthoD = eng._currentOrthoD;
    var prevCamLeft = eng.cameraOrtho ? eng.cameraOrtho.left : null;
    var prevCamRight = eng.cameraOrtho ? eng.cameraOrtho.right : null;
    var prevCamTop = eng.cameraOrtho ? eng.cameraOrtho.top : null;
    var prevCamBottom = eng.cameraOrtho ? eng.cameraOrtho.bottom : null;
    var prevMapZoom = (_MapManager && _MapManager.map) ? _MapManager.map.getZoom() : null;
    var wrap = document.getElementById('cf-wrap-base');
    STATE.vizStage = 1;
    STATE.view = '2d';
    STATE.slopeActive = false;
    if (wrap) {
      wrap.classList.add('cf-view-2d');
      wrap.classList.remove('cf-view-3d');
      wrap.classList.add('cf-stage-view');
    }

    if (eng.fitCameraToFootprint) eng.fitCameraToFootprint();
    if (_MapManager && _MapManager.map && _MapManager._syncMapTo2D) {
      _MapManager._syncMapTo2D(false);
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();
    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    await new Promise(function (res) { setTimeout(res, 600); });

    if (_BaseDimensions && _BaseDimensions.refresh) _BaseDimensions.refresh();

    var threeCanvas = eng.renderer.domElement;
    var mapCanvas = null;
    try {
      var mapEl = document.getElementById('cf-mapbox');
      if (mapEl) {
        var mapboxCanvas = mapEl.querySelector('canvas');
        if (mapboxCanvas) mapCanvas = mapboxCanvas;
      }
    } catch (_) {}

    var wrapRect = wrap ? wrap.getBoundingClientRect() : null;
    var threeRect = threeCanvas.getBoundingClientRect();
    var refRect = wrapRect || threeRect;

    var W_PX = 1600;
    var srcW = refRect.width || 1;
    var srcH = refRect.height || 1;
    var H_PX = Math.round(W_PX * srcH / srcW);
    var scale = W_PX / srcW;

    var tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = W_PX;
    tmpCanvas.height = H_PX;
    var ctx = tmpCanvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W_PX, H_PX);

    var mapDrew = false;
    if (mapCanvas) {
      try {
        if (_MapManager && _MapManager.map && _MapManager.map.triggerRepaint) {
          _MapManager.map.triggerRepaint();
        }
        await new Promise(function (res) { setTimeout(res, 250); });
        var mapElRect = mapEl.getBoundingClientRect();
        var mx = (mapElRect.left - refRect.left) * scale;
        var my = (mapElRect.top  - refRect.top)  * scale;
        var mw = mapElRect.width  * scale;
        var mh = mapElRect.height * scale;
        ctx.globalAlpha = 0.7;
        ctx.drawImage(mapCanvas, mx, my, mw, mh);
        ctx.globalAlpha = 1.0;
        mapDrew = true;
      } catch (e) { console.warn('[exportPdf] map composite failed', e); }
    }

    var sceneDrew = false;
    try {
      eng.renderer.render(eng.scene, eng.camera);
      var cx = (threeRect.left - refRect.left) * scale;
      var cy = (threeRect.top  - refRect.top)  * scale;
      var cw = threeRect.width  * scale;
      var ch = threeRect.height * scale;
      ctx.drawImage(threeCanvas, cx, cy, cw, ch);
      sceneDrew = true;
    } catch (e) { console.warn('[exportPdf] scene composite failed', e); }

    var dimLabelData = [];
    try {
      var labels = document.querySelectorAll('.cf-base-dim-label, .cf-dim-chip');
      var labelsVisible = 0;

      var svgEl = document.getElementById('cf-base-dims-svg');
      if (svgEl) {
        try {
          var svgClone = svgEl.cloneNode(true);
          svgClone.style.display = '';
          var svgRect = svgEl.getBoundingClientRect();
          if (svgRect.width && svgRect.height) {
            var svgStr = new XMLSerializer().serializeToString(svgClone);
            var svgBlob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
            var svgUrl = URL.createObjectURL(svgBlob);
            var svgImg = new Image();
            await new Promise(function (res) {
              svgImg.onload = function () { res(); };
              svgImg.onerror = function () { res(); };
              svgImg.src = svgUrl;
            });
            var sx2 = (svgRect.left - refRect.left) * scale;
            var sy2 = (svgRect.top  - refRect.top)  * scale;
            var sw2 = svgRect.width  * scale;
            var sh2 = svgRect.height * scale;
            try { ctx.drawImage(svgImg, sx2, sy2, sw2, sh2); } catch (_) {}
            URL.revokeObjectURL(svgUrl);
          }
        } catch (e) { console.warn('[exportPdf] svg dims composite failed', e); }
      }

      for (var li = 0; li < labels.length; li++) {
        var lel = labels[li];
        var computed = window.getComputedStyle(lel);
        if (computed.display === 'none' || computed.visibility === 'hidden') continue;
        labelsVisible++;
        var lr = lel.getBoundingClientRect();
        if (!lr.width || !lr.height) continue;
        var lcx = ((lr.left + lr.width / 2)  - refRect.left) * scale;
        var lcy = ((lr.top  + lr.height / 2) - refRect.top)  * scale;
        var txt = (lel.textContent || '').trim();
        if (!txt) continue;
        dimLabelData.push({ cx: lcx, cy: lcy, text: txt });
      }
      try { console.log('[exportPdf] labels collected:', { found: labels.length, visible: labelsVisible, queued: dimLabelData.length, svgEl: !!svgEl }); } catch (_) {}
    } catch (e) { console.warn('[exportPdf] labels collect failed', e); }

    try {
      console.log('[exportPdf] composite: mapDrew=' + mapDrew + ' sceneDrew=' + sceneDrew + ' size=' + W_PX + 'x' + H_PX);
    } catch (_) {}

    var xMin = Infinity, xMax = -Infinity, zMin = Infinity, zMax = -Infinity;
    for (var i = 0; i < poly.length; i++) {
      if (poly[i][0] < xMin) xMin = poly[i][0];
      if (poly[i][0] > xMax) xMax = poly[i][0];
      if (poly[i][1] < zMin) zMin = poly[i][1];
      if (poly[i][1] > zMax) zMax = poly[i][1];
    }
    var bbL = xMax - xMin;
    var bbW = zMax - zMin;

    var cropCanvas = tmpCanvas;
    var cropX = 0, cropY = 0, cropW = W_PX, cropH = H_PX;
    try {
      var corners = [
        _worldToScreen(xMin, zMin),
        _worldToScreen(xMax, zMin),
        _worldToScreen(xMax, zMax),
        _worldToScreen(xMin, zMax)
      ];
      var sxMin = Infinity, sxMax = -Infinity, syMin = Infinity, syMax = -Infinity;
      var ok = true;
      for (var ci = 0; ci < corners.length; ci++) {
        if (!corners[ci]) { ok = false; break; }
        var cpx = corners[ci].left * scale;
        var cpy = corners[ci].top  * scale;
        if (cpx < sxMin) sxMin = cpx;
        if (cpx > sxMax) sxMax = cpx;
        if (cpy < syMin) syMin = cpy;
        if (cpy > syMax) syMax = cpy;
      }
      if (ok && isFinite(sxMin) && isFinite(syMin)) {
        var polyW = sxMax - sxMin;
        var polyH = syMax - syMin;
        var polyCx = (sxMin + sxMax) / 2;
        var polyCy = (syMin + syMax) / 2;

        var TARGET_FILL = 0.48;
        var PAGE_AR = 297 / 210;
        var cwByX = polyW / TARGET_FILL;
        var cwByY = (polyH / TARGET_FILL) * PAGE_AR;
        var cw = Math.max(cwByX, cwByY);
        var ch = cw / PAGE_AR;

        var cx = polyCx - cw / 2;
        var cy = polyCy - ch / 2;
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cx + cw > W_PX) cx = W_PX - cw;
        if (cy + ch > H_PX) cy = H_PX - ch;
        if (cw > W_PX) { cw = W_PX; cx = 0; }
        if (ch > H_PX) { ch = H_PX; cy = 0; }

        var OUT_W = 1600;
        var OUT_H = Math.round(OUT_W / PAGE_AR);
        var croppedCanvas = document.createElement('canvas');
        croppedCanvas.width  = OUT_W;
        croppedCanvas.height = OUT_H;
        var cctx = croppedCanvas.getContext('2d');
        cctx.fillStyle = '#ffffff';
        cctx.fillRect(0, 0, OUT_W, OUT_H);
        cctx.drawImage(tmpCanvas, cx, cy, cw, ch, 0, 0, OUT_W, OUT_H);

        cropCanvas = croppedCanvas;
        cropX = cx; cropY = cy; cropW = cw; cropH = ch;
        try {
          console.log('[exportPdf] crop:', { polyW: Math.round(polyW), polyH: Math.round(polyH), cropW: Math.round(cw), cropH: Math.round(ch), fillX: (polyW/cw).toFixed(2), fillY: (polyH/ch).toFixed(2) });
        } catch (_) {}
      }
    } catch (e) { console.warn('[exportPdf] crop failed', e); }

    try {
      var cctx2 = cropCanvas.getContext('2d');
      var outW = cropCanvas.width;
      var outH = cropCanvas.height;
      var LABEL_FONT_PX = 18;
      var LABEL_PAD_X = 7;
      var LABEL_PAD_Y = 4;

      cctx2.font = '600 ' + LABEL_FONT_PX + 'px Montserrat, sans-serif';
      cctx2.textAlign = 'center';
      cctx2.textBaseline = 'middle';

      var placed = [];
      for (var di = 0; di < dimLabelData.length; di++) {
        var d = dimLabelData[di];
        var oxLabel = (d.cx - cropX) / cropW * outW;
        var oyLabel = (d.cy - cropY) / cropH * outH;
        if (oxLabel < -50 || oxLabel > outW + 50) continue;
        if (oyLabel < -50 || oyLabel > outH + 50) continue;
        var tw2 = cctx2.measureText(d.text).width;
        var th2 = LABEL_FONT_PX;
        placed.push({
          text: d.text,
          cx: oxLabel, cy: oyLabel,
          w: tw2 + LABEL_PAD_X * 2,
          h: th2 + LABEL_PAD_Y * 2
        });
      }

      function rectsOverlap(a, b) {
        return Math.abs(a.cx - b.cx) < (a.w + b.w) / 2 - 1 &&
               Math.abs(a.cy - b.cy) < (a.h + b.h) / 2 - 1;
      }
      for (var iter = 0; iter < 8; iter++) {
        var anyMove = false;
        for (var ai = 0; ai < placed.length; ai++) {
          for (var bi = ai + 1; bi < placed.length; bi++) {
            var A = placed[ai], B = placed[bi];
            if (!rectsOverlap(A, B)) continue;
            var dx = B.cx - A.cx;
            var dy = B.cy - A.cy;
            var overlapX = (A.w + B.w) / 2 - Math.abs(dx);
            var overlapY = (A.h + B.h) / 2 - Math.abs(dy);
            if (overlapX < overlapY) {
              var nudge = overlapX / 2 + 1;
              if (dx >= 0) { A.cx -= nudge; B.cx += nudge; }
              else         { A.cx += nudge; B.cx -= nudge; }
            } else {
              var nudgeY = overlapY / 2 + 1;
              if (dy >= 0) { A.cy -= nudgeY; B.cy += nudgeY; }
              else         { A.cy += nudgeY; B.cy -= nudgeY; }
            }
            anyMove = true;
          }
        }
        if (!anyMove) break;
      }

      for (var pi = 0; pi < placed.length; pi++) {
        var P = placed[pi];
        var bx = P.cx - P.w / 2;
        var by = P.cy - P.h / 2;
        cctx2.fillStyle = '#ffffff';
        cctx2.fillRect(bx, by, P.w, P.h);
        cctx2.strokeStyle = '#999';
        cctx2.lineWidth = 0.7;
        cctx2.strokeRect(bx, by, P.w, P.h);
        cctx2.fillStyle = '#1a1a1a';
        cctx2.fillText(P.text, P.cx, P.cy);
      }
      try { console.log('[exportPdf] labels drawn post-crop:', placed.length); } catch (_) {}
    } catch (e) { console.warn('[exportPdf] labels post-crop draw failed', e); }

    var planImg = cropCanvas.toDataURL('image/png');

    var bottomLeft = null;
    try {
      var blScreen = _worldToScreen(xMin, zMax);
      if (blScreen) {

        var blCanvasX = blScreen.left * scale;
        var blCanvasY = blScreen.top  * scale;
        var blCropX = (blCanvasX - cropX) / cropW;
        var blCropY = (blCanvasY - cropY) / cropH;
        var bottomLeftGps = null;
        if (_MapManager && _MapManager.map && mapEl) {
          var mapRect = mapEl.getBoundingClientRect();
          var pixelInMap = [
            (blScreen.left + refRect.left) - mapRect.left,
            (blScreen.top  + refRect.top)  - mapRect.top
          ];
          try {
            var lngLat = _MapManager.map.unproject(pixelInMap);
            if (lngLat) bottomLeftGps = { lng: lngLat.lng, lat: lngLat.lat };
          } catch (e) { console.warn('[exportPdf] unproject failed', e); }
        }
        bottomLeft = {
          worldX: xMin, worldZ: zMax,
          normX: Math.max(0, Math.min(1, blCropX)),
          normY: Math.max(0, Math.min(1, blCropY)),
          gps:   bottomLeftGps
        };
        try { console.log('[exportPdf] bottomLeft=', bottomLeft); } catch (_) {}
      }
    } catch (e) { console.warn('[exportPdf] bottom-left calc failed', e); }

    STATE.vizStage = prevStage;
    STATE.view = prevView;
    STATE.slopeActive = prevSlope;
    if (wrap) {
      wrap.classList.toggle('cf-stage-view', prevStage === 1);
      wrap.classList.toggle('cf-view-2d', prevView === '2d');
      wrap.classList.toggle('cf-view-3d', prevView === '3d');
    }

    if (eng.cameraOrtho && prevCamLeft !== null) {
      eng.cameraOrtho.left   = prevCamLeft;
      eng.cameraOrtho.right  = prevCamRight;
      eng.cameraOrtho.top    = prevCamTop;
      eng.cameraOrtho.bottom = prevCamBottom;
      eng.cameraOrtho.updateProjectionMatrix();
      eng._currentOrthoD = prevOrthoD;
    }
    if (_MapManager && _MapManager.map && prevMapZoom !== null) {
      try { _MapManager.map.setZoom(prevMapZoom); } catch (_) {}
    }
    if (global.BaseRenderer && global.BaseRenderer.build) global.BaseRenderer.build();
    if (_VisualizationManager && _VisualizationManager.apply) _VisualizationManager.apply();

    return [
      {
        key: 'plan',
        label: '',
        imageDataUrl: planImg,
        worldW: bbL, worldH: bbW,
        aspect: W_PX / H_PX,
        bottomLeft: bottomLeft
      }
    ];
  }

  function _buildInstancePayload() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    return {
      polygon:    poly,
      bboxL:      bb.L,
      bboxW:      bb.W,
      area:       computeArea(),
      perimeter:  computePerimeter(),
      variant:    STATE.variant,
      variantKey: _currentVariantKey(),
      lvl:        STATE.lvl,
      slope:      { active: STATE.slopeActive, deg: STATE.slopeDeg },
      isMetric:   STATE.isMetric
    };
  }

  function _buildBoqNamesMap(bridge) {
    var rows = computeBoQ();
    var out = {};
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      if (!code) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      out[code] = (item && item.name) || code;
    }
    return out;
  }


  function _buildAssemblyPayload(boqRows) {
    return Promise.resolve([]);
  }

  function _buildBoq(bridge) {
    var rows = computeBoQ();
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i][0];
      var qtyMetric = rows[i][1];
      if (qtyMetric == null) continue;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      var localUnit = item ? (STATE.isMetric ? item.unitMetric : item.unitImperial) : null;
      var displayQty = STATE.isMetric ? qtyMetric : (rows[i][2] != null ? rows[i][2] : qtyMetric);
      var userPrice = bridge && bridge.getUserPrice ? bridge.getUserPrice(code) : null;
      var unitPrice = userPrice && typeof userPrice.price === 'number' ? userPrice.price : null;
      var total = (unitPrice != null) ? unitPrice * displayQty : null;
      out.push({
        code:      code,
        name:      (item && item.name) || code,
        qty:       displayQty,
        unit:      localUnit || (STATE.isMetric ? 'pcs' : 'pcs'),
        unitPrice: unitPrice,
        total:     total
      });
    }
    return out;
  }

  function _buildTotals(boqRows) {
    function $idText(id) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    function $domText(selector) {
      var el = document.querySelector(selector);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    var fmtPrice = (typeof global.formatPrice === 'function')
      ? global.formatPrice
      : function (n) { return Math.round(+n || 0).toLocaleString() + ' ' +
            ((global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'); };

    var totalText    = $idText('cf-bw-total');
    var materialText = $idText('cf-bw-material');
    var execText     = $idText('cf-bw-execution');
    var timeText     = $idText('cf-bw-time');
    var capacityText = $idText('cf-bw-capacity');

    if (!totalText)    totalText    = $domText('[data-budget-total-cost]');
    if (!materialText) materialText = $domText('[data-budget-total-material]');
    if (!execText)     execText     = $domText('[data-budget-total-execution]');
    if (!timeText)     timeText     = $domText('[data-budget-total-time]');

    if (!materialText && typeof global.lastMaterialsTotal === 'number') {
      materialText = fmtPrice(global.lastMaterialsTotal);
    }
    if (!execText && typeof global.lastDeliveryTotal === 'number') {
      execText = fmtPrice(global.lastDeliveryTotal);
    }
    if (!totalText) {
      var mNum = (typeof global.lastMaterialsTotal === 'number') ? global.lastMaterialsTotal : 0;
      var eNum = (typeof global.lastDeliveryTotal  === 'number') ? global.lastDeliveryTotal  : 0;
      if (mNum || eNum) totalText = fmtPrice(mNum + eNum);
    }
    if (!timeText && typeof global.lastDurationTotal === 'number') {
      var mins = global.lastDurationTotal;
      timeText = (mins >= 60)
        ? (Math.round(mins / 60 * 10) / 10) + ' h'
        : Math.round(mins) + ' min';
    }

    if (!materialText) {
      var matSum = 0;
      if (Array.isArray(boqRows)) {
        boqRows.forEach(function (r) { if (r.total != null) matSum += r.total; });
      }
      if (matSum) materialText = fmtPrice(matSum);
    }
    if (!totalText && materialText) totalText = materialText;

    if (!capacityText) {
      try {
        var excavM3 = 0;
        if (Array.isArray(boqRows)) {
          for (var i = 0; i < boqRows.length; i++) {
            if (boqRows[i].code === 'FEE00001') { excavM3 = boqRows[i].qty || 0; break; }
          }
        }
        if (excavM3) {
          capacityText = STATE.isMetric
            ? excavM3.toFixed(1) + ' m³'
            : (excavM3 * 35.3147).toFixed(1) + ' ft³';
        }
      } catch (e) {}
    }

    return {
      texts: {
        total:    totalText    || '',
        material: materialText || '',
        execution: execText    || '',
        time:     timeText     || '',
        capacity: capacityText || ''
      },
      materials: { count: 0, value: 0 },
      execution: { count: 0, value: 0, hours: 0 },
      total:     0,
      area:      computeArea(),
      perimeter: computePerimeter(),
      currency:  (global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD'
    };
  }

  function _buildBaseDimensions() {
    var poly = getFootprintPolygon();
    var bb = getBBox();
    var edges = [];
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var dx = b[0] - a[0], dz = b[1] - a[1];
      edges.push({
        index: i,
        a: { x: a[0], z: a[1] },
        b: { x: b[0], z: b[1] },
        length: Math.sqrt(dx * dx + dz * dz)
      });
    }
    return {
      vertices: poly.map(function (p) { return { x: p[0], z: p[1] }; }),
      edges:    edges,
      bboxL:    bb.L,
      bboxW:    bb.W
    };
  }

  function _buildShareUrl() {
    var boot = global.BASE_BOOT || {};
    var handle = boot.productHandle || 'foundations';
    var origin = (location && location.origin) || '';
    var url = origin + '/products/' + handle;
    if (boot.variants && boot.variants.length && STATE.variant) {
      var v = boot.variants[STATE.variant - 1];
      if (v && v.id) url += '?variant=' + v.id;
    }
    return url;
  }

  function _variantDisplayName() {
    var boot = global.BASE_BOOT || {};
    var T = boot.i18n || {};
    var key = 'shelter_v' + STATE.variant;
    return T[key] || (SHELTER_FALLBACK_NAMES[STATE.variant - 1] || ('Shelter ' + STATE.variant));
  }

  global.BaseLib = {
    __version:        VERSION,
    exportPdf:        exportPdf,
    STATE:            STATE,
    DEFAULTS:         DEFAULTS,
    VARIANT_DEFAULTS: VARIANT_DEFAULTS,
    boot:             boot,
    refreshUI:        refreshUI,
    reset:            reset,
    undo:             undo,
    cycleLvl:         cycleLvl,
    UndoHistory:      _UndoHistory,
    toggleUnits:      toggleUnits,
    toggleView:       toggleView,
    selectVariant:    selectVariant,
    nextVariant:      nextVariant,
    prevVariant:      prevVariant,
    getBlockCount:    getBlockCount,
    openBudgetDrawer: openBudgetDrawer,
    share:            share,
    publishBoQToBudget: publishBoQToBudget,
    computeBoQ:       computeBoQ,
    getFootprintPolygon: getFootprintPolygon,
    computeArea:      computeArea,
    computePerimeter: computePerimeter,
    VisualizationManager: _VisualizationManager,
    CornerInserter:   _CornerInserter,
    AssetDrawer:      _AssetDrawer,
    ProjectStore:     _ProjectStore
  };

  global.PoolLib = global.BaseLib;
  global.ShelterLib = global.BaseLib;

  try {
    var _LOG1 = (global.Configurator && global.Configurator.log) ? global.Configurator.log : global.console;
    if (_LOG1 && _LOG1.log) _LOG1.log('[shelter-lib] eval COMPLETE, BaseLib=' + (typeof global.BaseLib));
  } catch (e) {}

})(window);